import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  LenientFloat: any;
  LenientInt: any;
  LenientString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
};

/** An enumeration. */
export enum AcceptanceAdvanceBankStatus {
  Accepted = 'ACCEPTED',
  AcceptedByAbs = 'ACCEPTED_BY_ABS',
  Acceptexpire = 'ACCEPTEXPIRE',
  Checkerror = 'CHECKERROR',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Implemented = 'IMPLEMENTED',
  Invalideds = 'INVALIDEDS',
  Partsigned = 'PARTSIGNED',
  Recall = 'RECALL',
  Refusedbyabs = 'REFUSEDBYABS',
  Refusedbybank = 'REFUSEDBYBANK',
  Requisiteerror = 'REQUISITEERROR',
  Signed = 'SIGNED'
}

/** An enumeration. */
export enum AcceptanceAdvanceStatus {
  Active = 'ACTIVE',
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Pending = 'PENDING'
}

export type AcceptanceAdvanceType = {
  __typename?: 'AcceptanceAdvanceType';
  cancellationReason?: Maybe<AcceptanceCancellationReason>;
  errorViewedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  payerAccount: Scalars['String'];
  payerInn?: Maybe<Scalars['String']>;
  payerName?: Maybe<Scalars['String']>;
  status: AcceptanceAdvanceStatus;
  userId?: Maybe<Scalars['ID']>;
};

export type AcceptanceAdvancedStartSigningInput = {
  companyId: Scalars['ID'];
  uriForReturn: Scalars['String'];
};

export type AcceptanceAdvancedStartSigningMutation = {
  __typename?: 'AcceptanceAdvancedStartSigningMutation';
  confirmLink: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum AcceptanceCancellationReason {
  CredentialsMismatch = 'CREDENTIALS_MISMATCH',
  PaymentMethodChange = 'PAYMENT_METHOD_CHANGE'
}

export type AccountManagersQueryFilter = {
  accountManagerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type AccountManagersQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type AccountManagersQueryPaginationType = {
  __typename?: 'AccountManagersQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<UserExtendType>;
};

export enum AccountManagersQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type AdCampaignExcludeFromBrandMutation = {
  __typename?: 'AdCampaignExcludeFromBrandMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignExcludeFromBrandMutationInput = {
  adCampaignId: Scalars['ID'];
};

export type AdCampaignIncludeToBrandMutation = {
  __typename?: 'AdCampaignIncludeToBrandMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignIncludeToBrandMutationInput = {
  adCampaignId: Scalars['ID'];
  brandAdCampaignId: Scalars['ID'];
};

/** An enumeration. */
export enum AdCampaignMediaTypeEnum {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type AdCampaignPointFilter = {
  excludePointIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeQuery?: InputMaybe<Scalars['String']>;
  excludeTagIds?: InputMaybe<Array<Scalars['ID']>>;
  initialPointIds?: InputMaybe<Array<Scalars['ID']>>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AdCampaignPromoType = {
  __typename?: 'AdCampaignPromoType';
  adcompany: AdCampaignType;
  created: Scalars['DateTime'];
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  order: Scalars['Int'];
  playDuration?: Maybe<Scalars['Int']>;
  promo: MediafileObjectType;
  time?: Maybe<Scalars['Time']>;
  withSound?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureChangePromosMutation = {
  __typename?: 'AdCampaignPureChangePromosMutation';
  adCompany?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureChangePromosMutationInput = {
  adCompanyId: Scalars['ID'];
  adPromos: Array<InputMaybe<PromoAdInput>>;
};

export type AdCampaignPureCreateMutation = {
  __typename?: 'AdCampaignPureCreateMutation';
  adCompany?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureCreateMutationInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  days: Array<Scalars['Int']>;
  endCompany?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  infinitely?: InputMaybe<Scalars['Boolean']>;
  interval?: InputMaybe<Scalars['Int']>;
  mediaType?: InputMaybe<AdCampaignMediaTypeEnum>;
  oneDay?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Scalars['Int']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  prevMediafileRequired?: InputMaybe<Scalars['Boolean']>;
  promos: Array<InputMaybe<PromoAdInput>>;
  startCompany?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  title: Scalars['String'];
  type: AdCampaignTypeEnum;
};

export type AdCampaignPureEnableMutation = {
  __typename?: 'AdCampaignPureEnableMutation';
  adCompany?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureEnableMutationInput = {
  adCompanyId: Scalars['ID'];
  enable: Scalars['Boolean'];
};

export type AdCampaignPureLogsType = {
  __typename?: 'AdCampaignPureLogsType';
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONString']>;
  diffWithPrevious?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
  userName?: Maybe<Scalars['String']>;
};

export type AdCampaignPureQueryLogsInput = {
  adCampaignId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type AdCampaignPureRemoveMutation = {
  __typename?: 'AdCampaignPureRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureRemoveMutationInput = {
  adCompanyId: Scalars['ID'];
};

export type AdCampaignPureSetCompanyTagsMutation = {
  __typename?: 'AdCampaignPureSetCompanyTagsMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureSetCompanyTagsMutationInput = {
  adCampaignId: Scalars['ID'];
  tagNames: Array<Scalars['String']>;
};

export type AdCampaignPureSetPointsMutation = {
  __typename?: 'AdCampaignPureSetPointsMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureSetPointsMutationInput = {
  adcampaignId: Scalars['ID'];
  companyIds?: InputMaybe<Array<Scalars['ID']>>;
  excludePointIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<AdCampaignPointFilter>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  setAllPoints?: InputMaybe<Scalars['Boolean']>;
};

export type AdCampaignPureType = {
  __typename?: 'AdCampaignPureType';
  adPromos: Array<AdPromoPureType>;
  brand?: Maybe<BrandType>;
  brandAdCampaign?: Maybe<AdCampaignPureType>;
  childrenCount: Scalars['Int'];
  company?: Maybe<UserCompanyPureType>;
  durationPromos?: Maybe<Scalars['Int']>;
  enable: Scalars['Boolean'];
  id: Scalars['ID'];
  infinitely: Scalars['Boolean'];
  interval: Scalars['Int'];
  mediaType: AdCampaignMediaTypeEnum;
  oneDay: Scalars['Boolean'];
  period: Scalars['Int'];
  points: Array<PointPureType>;
  pointsCount: Scalars['Int'];
  prevMediafileRequired: Scalars['Boolean'];
  promos: Array<PromoPureType>;
  replicationRole: ReplicationRole;
  slavesPointsCount: Scalars['Int'];
  tags?: Maybe<Array<CompanyTagPureType>>;
  timingSettings: AdCampaignTimingSettingsType;
  title: Scalars['String'];
  type: AdCampaignTypeEnum;
  user?: Maybe<UserExtendPureType>;
};

export type AdCampaignPureUpdateMutation = {
  __typename?: 'AdCampaignPureUpdateMutation';
  adCompany?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignPureUpdateMutationInput = {
  adCompanyId: Scalars['ID'];
  companyId?: InputMaybe<Scalars['ID']>;
  days?: InputMaybe<Array<Scalars['Int']>>;
  endCompany?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  infinitely?: InputMaybe<Scalars['Boolean']>;
  interval?: InputMaybe<Scalars['Int']>;
  oneDay?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Scalars['Int']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  prevMediafileRequired?: InputMaybe<Scalars['Boolean']>;
  setAllPoints?: InputMaybe<Scalars['Boolean']>;
  startCompany?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdCampaignTypeEnum>;
};

export type AdCampaignQueryFilter = {
  brandAdId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companyTagIds?: InputMaybe<Array<Scalars['ID']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  mediaType?: InputMaybe<Array<InputMaybe<AdCampaignMediaTypeEnum>>>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  replicationRoles?: InputMaybe<Array<ReplicationRole>>;
  statuses?: InputMaybe<Array<InputMaybe<AdCampaignStatusesEnum>>>;
  streamId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Array<InputMaybe<AdCampaignTypeEnum>>>;
  userId?: InputMaybe<Scalars['ID']>;
  videoStreamId?: InputMaybe<Scalars['ID']>;
  withPromo?: InputMaybe<Scalars['Boolean']>;
};

export type AdCampaignQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum AdCampaignQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type AdCampaignRenameMutation = {
  __typename?: 'AdCampaignRenameMutation';
  adCompany?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignRenameMutationInput = {
  adCompanyId: Scalars['ID'];
  title: Scalars['String'];
};

export type AdCampaignReportPureCreateMutation = {
  __typename?: 'AdCampaignReportPureCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AdCampaignReportPureMutationInput = {
  adcampaignIds: Array<Scalars['ID']>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  recipientEmail?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum AdCampaignStatusesEnum {
  Active = 'Active',
  Passed = 'Passed',
  Planned = 'Planned',
  Stopped = 'Stopped'
}

export type AdCampaignTimingSettingsType = {
  __typename?: 'AdCampaignTimingSettingsType';
  dayEndTime?: Maybe<Scalars['Time']>;
  dayStartTime?: Maybe<Scalars['Time']>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  weekdays: WeekDayMapType;
};

export type AdCampaignType = {
  __typename?: 'AdCampaignType';
  adCompaignPromos?: Maybe<Array<Maybe<AdCampaignPromoType>>>;
  company?: Maybe<UserCompanyType>;
  created: Scalars['DateTime'];
  days?: Maybe<Scalars['JSONString']>;
  enable: Scalars['Boolean'];
  endCompany?: Maybe<Scalars['DateTime']>;
  endDayTime?: Maybe<Scalars['Time']>;
  id?: Maybe<Scalars['Int']>;
  infinitely: Scalars['Boolean'];
  interval: Scalars['Int'];
  isActive: Scalars['Boolean'];
  mediaType: AdcompanyAdCompanyMediaTypeChoices;
  modified: Scalars['DateTime'];
  oneDay: Scalars['Boolean'];
  period: Scalars['Int'];
  point: Array<PointPublicType>;
  points?: Maybe<Array<Maybe<PointType>>>;
  prevMediafileRequired: Scalars['Boolean'];
  promo: Array<MediafileObjectType>;
  promoadcompanySet: Array<AdCampaignPromoType>;
  promos?: Maybe<Array<Maybe<PromoObjectType>>>;
  startCompany?: Maybe<Scalars['DateTime']>;
  startDayTime?: Maybe<Scalars['Time']>;
  streams?: Maybe<Array<Maybe<StreamType>>>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  user: UserExtendType;
  values?: Maybe<Array<Maybe<ValueObjectType>>>;
};

/** An enumeration. */
export enum AdCampaignTypeEnum {
  ExactTime = 'EXACT_TIME',
  Groups = 'GROUPS',
  Instant = 'INSTANT',
  Interval = 'INTERVAL',
  Period = 'PERIOD'
}

export type AdCampaignsQueryPaginationType = {
  __typename?: 'AdCampaignsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<AdCampaignPureType>>;
  statusesInfo?: Maybe<AdCampaignsStatusesPureType>;
};

export type AdCampaignsStatusesPureType = {
  __typename?: 'AdCampaignsStatusesPureType';
  active?: Maybe<Scalars['Int']>;
  passed?: Maybe<Scalars['Int']>;
  planned?: Maybe<Scalars['Int']>;
  stopped?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum AdOverlapResolution {
  Drop = 'DROP',
  Shift = 'SHIFT'
}

export type AdPromoPureType = {
  __typename?: 'AdPromoPureType';
  /** @deprecated Use promo.duration instead */
  duration: Scalars['Int'];
  /** @deprecated Use promo.sourcefiles instead */
  filename: Scalars['String'];
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  /** @deprecated Use promo.performer_title instead */
  performerTitle: Scalars['String'];
  /** @deprecated Use video_promo.play_duration instead */
  playDuration?: Maybe<Scalars['Int']>;
  promo: MediafilePureType;
  /** @deprecated Use promo.id instead */
  promoId: Scalars['ID'];
  time?: Maybe<Scalars['Time']>;
  /** @deprecated Use promo.title instead */
  title: Scalars['String'];
  videoPromo?: Maybe<VideoMediafileType>;
  /** @deprecated Use video_promo.with_sound instead */
  withSound?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum AdcampaignPlaybackReportType {
  AudioAds = 'AUDIO_ADS',
  Undefined = 'UNDEFINED',
  VideoAds = 'VIDEO_ADS',
  VideoWaves = 'VIDEO_WAVES'
}

/** An enumeration. */
export enum AdcampaignPlaybackReportTypeForInput {
  AudioAds = 'audio_ads',
  VideoAds = 'video_ads',
  VideoWaves = 'video_waves'
}

export type AdcampaignsStatusesCountType = {
  __typename?: 'AdcampaignsStatusesCountType';
  disabledCount?: Maybe<Scalars['Int']>;
  enabledCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum AdcompanyAdCompanyMediaTypeChoices {
  /** audio */
  Audio = 'AUDIO',
  /** video */
  Video = 'VIDEO'
}

export type AddDiscountToOrganizationMutation = {
  __typename?: 'AddDiscountToOrganizationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddDiscountToOrganizationMutationInput = {
  discountTemplateId: Scalars['ID'];
  endDate: Scalars['Date'];
  organizationId: Scalars['ID'];
  startDate: Scalars['Date'];
};

export type AdditionalFeatureObjectTpye = {
  __typename?: 'AdditionalFeatureObjectTpye';
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  type: UserAdditionalFeatureTypeChoices;
};

export type AddressDataInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  fiasId?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type AddressDataType = {
  __typename?: 'AddressDataType';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fiasId?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AdminStartVideoDemoPeriodMutation = {
  __typename?: 'AdminStartVideoDemoPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type AdminStartVideoDemoPeriodMutationInput = {
  companyId: Scalars['ID'];
  demoPeriodLength: Scalars['Int'];
};

export type AmoCrmLeadType = {
  __typename?: 'AmoCRMLeadType';
  accountId: Scalars['Int'];
  companyId: Scalars['Int'];
  companyName: Scalars['String'];
  companyTranslate: Scalars['String'];
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  isActive: Scalars['Boolean'];
  leadId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  nameTranslate: Scalars['String'];
  needToUpdate: Scalars['Boolean'];
  streamLeads: Array<StreamType>;
  support: Scalars['Boolean'];
  user?: Maybe<UserExtendType>;
  userCompany?: Maybe<UserCompanyType>;
};

export type AmoLeadToCompanyUrlInput = {
  amoLeadUrl: Scalars['String'];
};

export type AmoLeadToCompanyUrlMutation = {
  __typename?: 'AmoLeadToCompanyUrlMutation';
  amoCompanyUrl?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AmoSyncDataMutation = {
  __typename?: 'AmoSyncDataMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AmoSyncDataMutationInput = {
  companyId: Scalars['ID'];
};

export type AmplifyOptionsPureType = {
  __typename?: 'AmplifyOptionsPureType';
  amplifyInstant?: Maybe<Scalars['Float']>;
  amplifyMediafile: Scalars['Float'];
  amplifyPromo: Scalars['Float'];
};

export type ApplyPrimeDiscountToCompanyMutation = {
  __typename?: 'ApplyPrimeDiscountToCompanyMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ApplyPrimeDiscountToCompanyMutationInput = {
  companyId: Scalars['ID'];
};

export type ArchiveUploadMutation = {
  __typename?: 'ArchiveUploadMutation';
  archiveFile?: Maybe<EmenuArchiveType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ArchiveUploadMutationInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type AsyncTaskProgressType = {
  __typename?: 'AsyncTaskProgressType';
  current?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type AttributeObjectPureType = {
  __typename?: 'AttributeObjectPureType';
  attributeValue?: Maybe<Array<Maybe<ValueObjectPureType>>>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type AttributeObjectType = {
  __typename?: 'AttributeObjectType';
  attributeValue: Array<ValueObjectType>;
  color: Scalars['String'];
  created: Scalars['DateTime'];
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
};

export type AttributesQueryListType = {
  __typename?: 'AttributesQueryListType';
  result: Array<AttributeObjectPureType>;
};

export type AuthorizationCodeCreateMutation = {
  __typename?: 'AuthorizationCodeCreateMutation';
  codeData?: Maybe<AuthorizationCodePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AuthorizationCodeCreateMutationInput = {
  phone: Scalars['String'];
};

export type AuthorizationCodePureType = {
  __typename?: 'AuthorizationCodePureType';
  created?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  phone: Scalars['String'];
};

export type BillingDisableMutation = {
  __typename?: 'BillingDisableMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BillingDisableMutationInput = {
  companyId: Scalars['ID'];
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BillingEnableMutation = {
  __typename?: 'BillingEnableMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BillingEnableMutationInput = {
  companyId: Scalars['ID'];
  /** Подтверждение удаления данных прежнего способа оплаты при смене. */
  confirmRemoveOldPaymentData?: InputMaybe<Scalars['Boolean']>;
  nextRenewAt: Scalars['DateTime'];
  /** Способ оплаты. По умолчанию — карта (ЮKassa). */
  paymentKind?: InputMaybe<PaymentKind>;
  /** If not provided set all active company points */
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BrandAdCampaignCreateMutation = {
  __typename?: 'BrandAdCampaignCreateMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAdCampaignCreateMutationInput = {
  brandId: Scalars['ID'];
  days: Array<Scalars['Int']>;
  endCompany?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  infinitely?: InputMaybe<Scalars['Boolean']>;
  interval?: InputMaybe<Scalars['Int']>;
  mediaType?: InputMaybe<AdCampaignMediaTypeEnum>;
  oneDay?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Scalars['Int']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  prevMediafileRequired?: InputMaybe<Scalars['Boolean']>;
  promos: Array<InputMaybe<PromoAdInput>>;
  startCompany?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  title: Scalars['String'];
  type: AdCampaignTypeEnum;
};

export type BrandAdCampaignMultiEnableMutation = {
  __typename?: 'BrandAdCampaignMultiEnableMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAdCampaignMultiEnableMutationInput = {
  adCampaignIds: Array<Scalars['ID']>;
  enable: Scalars['Boolean'];
};

export type BrandAdCampaignRemoveMutation = {
  __typename?: 'BrandAdCampaignRemoveMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAdCampaignRemoveMutationInput = {
  adCampaignId: Scalars['ID'];
};

export type BrandAdCampaignUpdateMutation = {
  __typename?: 'BrandAdCampaignUpdateMutation';
  adCampaign?: Maybe<AdCampaignPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAdCampaignUpdateMutationInput = {
  adCompanyId: Scalars['ID'];
  days?: InputMaybe<Array<Scalars['Int']>>;
  endCompany?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  infinitely?: InputMaybe<Scalars['Boolean']>;
  interval?: InputMaybe<Scalars['Int']>;
  oneDay?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<Scalars['Int']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  prevMediafileRequired?: InputMaybe<Scalars['Boolean']>;
  promos: Array<InputMaybe<PromoAdInput>>;
  startCompany?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AdCampaignTypeEnum>;
};

export type BrandAdCampaignsBindToPointsMutation = {
  __typename?: 'BrandAdCampaignsBindToPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAdCampaignsBindToPointsMutationInput = {
  adCampaignIds: Array<Scalars['ID']>;
  pointsIds: Array<Scalars['ID']>;
};

export type BrandAddCompaniesMutation = {
  __typename?: 'BrandAddCompaniesMutation';
  brand?: Maybe<BrandType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandAddCompaniesMutationInput = {
  brandId: Scalars['ID'];
  companiesIds: Array<Scalars['ID']>;
};

export type BrandCreateMutation = {
  __typename?: 'BrandCreateMutation';
  brand?: Maybe<BrandType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandCreateMutationInput = {
  accountManagerId: Scalars['ID'];
  businessSize: BusinessSize;
  companies: Array<Scalars['ID']>;
  country: Country;
  name: Scalars['String'];
};

export type BrandPaginationQueryFilter = {
  accountManagerIds?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessSize?: InputMaybe<Array<BusinessSize>>;
  companyId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Country>>;
  query?: InputMaybe<Scalars['String']>;
};

export type BrandPaginationQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum BrandPaginationQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type BrandPaginationQueryType = {
  __typename?: 'BrandPaginationQueryType';
  paginationInfo: PaginationInfoType;
  result: Array<BrandType>;
};

export type BrandPointsChangeSleepSettingsFilter = {
  all?: InputMaybe<Scalars['Boolean']>;
  pointsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type BrandPointsChangeSleepSettingsMutation = {
  __typename?: 'BrandPointsChangeSleepSettingsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandPointsChangeSleepSettingsMutationInput = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<BrandPointsChangeSleepSettingsFilter>;
  sleepMode: Scalars['Boolean'];
  sleepSettings?: InputMaybe<Array<InputMaybe<SleepSettingDayInput>>>;
};

export type BrandPointsChangeStreamMutation = {
  __typename?: 'BrandPointsChangeStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandPointsChangeStreamMutationFilter = {
  all?: InputMaybe<Scalars['Boolean']>;
  pointsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BrandPointsChangeStreamMutationInput = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<BrandPointsChangeStreamMutationFilter>;
  streamId: Scalars['ID'];
};

export type BrandPointsEnableMutation = {
  __typename?: 'BrandPointsEnableMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandPointsEnableMutationFilter = {
  all?: InputMaybe<Scalars['Boolean']>;
  pointsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BrandPointsEnableMutationInput = {
  brandId: Scalars['ID'];
  enable: Scalars['Boolean'];
  filters?: InputMaybe<BrandPointsEnableMutationFilter>;
  origin?: InputMaybe<Scalars['String']>;
};

export type BrandRemoveCompaniesMutation = {
  __typename?: 'BrandRemoveCompaniesMutation';
  brand?: Maybe<BrandType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandRemoveCompaniesMutationInput = {
  brandId: Scalars['ID'];
  companiesIds: Array<Scalars['ID']>;
};

export type BrandStreamCopyWithPointsInput = {
  brandId: Scalars['ID'];
  streamIdToCopy: Scalars['ID'];
  streamTaskId?: InputMaybe<Scalars['ID']>;
  streamTitle?: InputMaybe<Scalars['String']>;
};

export type BrandStreamCopyWithPointsMutation = {
  __typename?: 'BrandStreamCopyWithPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandType = {
  __typename?: 'BrandType';
  accountManager?: Maybe<UserExtendPureType>;
  adCampaignsCount: Scalars['Int'];
  brandAdCampaignsCount: Scalars['Int'];
  businessSize: BusinessSize;
  companies: Array<UserCompanyPureType>;
  companiesCount: Scalars['Int'];
  country: Country;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pointsCount: Scalars['Int'];
};

export type BrandUpdateMutation = {
  __typename?: 'BrandUpdateMutation';
  brand?: Maybe<BrandType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type BrandUpdateMutationInput = {
  accountManagerId?: InputMaybe<Scalars['ID']>;
  brandId: Scalars['ID'];
  businessSize?: InputMaybe<BusinessSize>;
  country?: InputMaybe<Country>;
  name?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum BusinessSize {
  Ent = 'ENT',
  Smb = 'SMB'
}

export type BusinessSpherePureType = {
  __typename?: 'BusinessSpherePureType';
  background?: Maybe<Scalars['String']>;
  cover?: Maybe<CoverFilePureType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type BusinessSpheresQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type BusinessSpheresQueryPaginationType = {
  __typename?: 'BusinessSpheresQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<BusinessSpherePureType>>;
};

export enum BusinessSpheresQuerySort {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum CacheMode {
  FullCache = 'FULL_CACHE',
  NoCache = 'NO_CACHE',
  ProgressiveCache = 'PROGRESSIVE_CACHE'
}

export type CancelDiscountForOrganizationMutation = {
  __typename?: 'CancelDiscountForOrganizationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelDiscountForOrganizationMutationInput = {
  organizationDiscountId: Scalars['ID'];
};

export type CaptchaSettingsType = {
  __typename?: 'CaptchaSettingsType';
  countries: Array<Maybe<Country>>;
  enabled: Scalars['Boolean'];
};

export type CellType = {
  __typename?: 'CellType';
  encrypted?: Maybe<Scalars['Boolean']>;
  encryptionType?: Maybe<Scalars['String']>;
  identity?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  signal?: Maybe<Scalars['Int']>;
  ssid?: Maybe<Scalars['String']>;
};

export type CertLetterForPointMutation = {
  __typename?: 'CertLetterForPointMutation';
  downloadLink?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CertLetterForPointMutationInput = {
  companyId: Scalars['ID'];
  createForAll?: InputMaybe<Scalars['Boolean']>;
  pointIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CertificatePointsQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type CertificatePointsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type CertificatePointsQueryPaginationType = {
  __typename?: 'CertificatePointsQueryPaginationType';
  certificatePointsCount: Scalars['Int'];
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PointPureType>>;
};

export type ChangeWifiSettingsMutationInput = {
  id: Scalars['ID'];
  wifiPassword: Scalars['String'];
  wifiPoint: Scalars['String'];
};

export type CheckCountriesAvailabilityChangeQueryInput = {
  streamDraftId: Scalars['ID'];
};

export type CheckCountriesAvailabilityChangeResultType = {
  __typename?: 'CheckCountriesAvailabilityChangeResultType';
  affectedStreamsCount: Scalars['Int'];
  excludedCountries: Array<CountryType>;
  rightholders: Array<RightholderValuePureType>;
};

export type ClearMusicBoxMutation = {
  __typename?: 'ClearMusicBoxMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CollectionFilteredByStreamType = {
  __typename?: 'CollectionFilteredByStreamType';
  id: Scalars['ID'];
  subcollections: Array<SubCollectionFilteredByStreamType>;
  title: Scalars['String'];
};

export type CollectionsPaginationType = {
  __typename?: 'CollectionsPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<LibraryCollectionPureType>>;
};

export type CommonSettingsType = {
  __typename?: 'CommonSettingsType';
  withForkScreenAndroid?: Maybe<Scalars['Boolean']>;
  withForkScreenIos?: Maybe<Scalars['Boolean']>;
};

export type CompanyApiTokenType = {
  __typename?: 'CompanyAPITokenType';
  company: UserCompanyType;
  created: Scalars['DateTime'];
  createdBy?: Maybe<UserExtendType>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isValid?: Maybe<Scalars['Boolean']>;
  jti: Scalars['UUID'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  revokedBy?: Maybe<UserExtendType>;
  revokedReason: Scalars['String'];
};

export type CompanyApiTokensPaginationType = {
  __typename?: 'CompanyAPITokensPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<CompanyApiTokenType>;
};

export type CompanyAdCampaignsByDaysEarlyReportInput = {
  adcampaignReportType: AdcampaignPlaybackReportTypeForInput;
  companyId: Scalars['ID'];
  dateRange: DateTimeRange;
  emailsTo: Array<Scalars['String']>;
  pointIds: Array<Scalars['Int']>;
  promoSelectionDraftId: Scalars['ID'];
};

export type CompanyAdCampaignsByDaysEarlyReportMutation = {
  __typename?: 'CompanyAdCampaignsByDaysEarlyReportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  isCreated: Scalars['Boolean'];
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyAdCampaignsEarlyReportInput = {
  adcampaignReportType: AdcampaignPlaybackReportTypeForInput;
  companyId: Scalars['ID'];
  dateRange: DateTimeRange;
  emailsTo: Array<Scalars['String']>;
  pointIds?: InputMaybe<Array<Scalars['Int']>>;
  promoSelectionDraftId?: InputMaybe<Scalars['ID']>;
};

export type CompanyAdCampaignsEarlyReportMutation = {
  __typename?: 'CompanyAdCampaignsEarlyReportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  isCreated: Scalars['Boolean'];
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum CompanyAmoTaskRequestStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Sended = 'SENDED'
}

export type CompanyApiTokensQueryFilter = {
  companyId: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
};

export type CompanyApiTokensQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum CompanyApiTokensQuerySort {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type CompanyChangeUserMutation = {
  __typename?: 'CompanyChangeUserMutation';
  company?: Maybe<UserCompanyPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyChangeUserMutationInput = {
  companyId: Scalars['ID'];
  role?: InputMaybe<UserCompanyRole>;
  unsetUserFromAnotherCompanies?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type CompanyCheckListToDeactivatePureType = {
  __typename?: 'CompanyCheckListToDeactivatePureType';
  billingIsDisabled: Scalars['Boolean'];
  hasNoAdCompanies: Scalars['Boolean'];
  hasNoInvoices: Scalars['Boolean'];
  hasNoPoints: Scalars['Boolean'];
  hasNoStreams: Scalars['Boolean'];
  hasNoUsers: Scalars['Boolean'];
  hasNoVideoStreams: Scalars['Boolean'];
  hasNoYclientsIntegration: Scalars['Boolean'];
};

/** An enumeration. */
export enum CompanyContractKind {
  Base = 'BASE',
  Offerta = 'OFFERTA'
}

export type CompanyContractMigrationType = {
  __typename?: 'CompanyContractMigrationType';
  contractType: CompanyContractKind;
  id: Scalars['ID'];
  manager?: Maybe<UserExtendPureType>;
  offerReason?: Maybe<CompanyContractOfferReason>;
  offerType?: Maybe<CompanyContractOfferType>;
  offerUrl: Scalars['String'];
  status: ContractMigrationStatusEnum;
  user?: Maybe<UserExtendPureType>;
};

/** An enumeration. */
export enum CompanyContractOfferReason {
  LkRegistration = 'LK_REGISTRATION',
  OrganizationTypeChange = 'ORGANIZATION_TYPE_CHANGE',
  PricePlanChange = 'PRICE_PLAN_CHANGE',
  TransferToOfferta = 'TRANSFER_TO_OFFERTA'
}

/** An enumeration. */
export enum CompanyContractOfferType {
  LegalIndividual = 'LEGAL_INDIVIDUAL',
  Popular = 'POPULAR',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type CompanyContractPaymentTermsType = {
  __typename?: 'CompanyContractPaymentTermsType';
  amount?: Maybe<Scalars['Float']>;
  payFrequencyMonth?: Maybe<Scalars['Int']>;
};

export type CompanyContractPureType = {
  __typename?: 'CompanyContractPureType';
  billingEnabled: Scalars['Boolean'];
  company: UserCompanyPureType;
  created: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isConfirmed: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  offerReason?: Maybe<CompanyContractOfferReason>;
  offerType?: Maybe<CompanyContractOfferType>;
  offerUrl: Scalars['String'];
  paymentTerms?: Maybe<CompanyContractPaymentTermsType>;
  status: CompanyContractStatusEnum;
  typeContract: CompanyContractKind;
};

/** An enumeration. */
export enum CompanyContractStatusEnum {
  Actual = 'ACTUAL',
  Suspended = 'SUSPENDED'
}

export type CompanyContractType = {
  __typename?: 'CompanyContractType';
  billingEnabled: Scalars['Boolean'];
  company: UserCompanyType;
  created: Scalars['DateTime'];
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  offerReason?: Maybe<UserCompanyContractOfferReasonChoices>;
  offerType?: Maybe<UserCompanyContractOfferTypeChoices>;
  offerUrl: Scalars['String'];
  paymentState?: Maybe<Scalars['String']>;
  status: UserCompanyContractStatusChoices;
  typeContract: UserCompanyContractTypeContractChoices;
  user?: Maybe<UserExtendType>;
};

export type CompanyCreateAmoTaskToBillPureMutation = {
  __typename?: 'CompanyCreateAmoTaskToBillPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyCreateAmoTaskToBillPureMutationInput = {
  companyId: Scalars['ID'];
};

export type CompanyCreateAudioDeviceRequestMutation = {
  __typename?: 'CompanyCreateAudioDeviceRequestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyCreateDeviceRequestPureMutation = {
  __typename?: 'CompanyCreateDeviceRequestPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyCreateDeviceRequestPureMutationInput = {
  companyId: Scalars['ID'];
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  pointId?: InputMaybe<Scalars['ID']>;
};

export type CompanyCreateVideoDeviceRequestMutation = {
  __typename?: 'CompanyCreateVideoDeviceRequestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyDeactivateMutation = {
  __typename?: 'CompanyDeactivateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyDeactivateMutationInput = {
  companyId: Scalars['ID'];
};

export type CompanyDeviceRequestPureType = {
  __typename?: 'CompanyDeviceRequestPureType';
  companyId: Scalars['ID'];
  deviceType?: Maybe<DeviceTypes>;
  lastRequestDate: Scalars['DateTime'];
  pointId?: Maybe<Scalars['ID']>;
  requestType?: Maybe<RequestDeviceType>;
  status: CompanyAmoTaskRequestStatus;
};

export type CompanyFeaturesBulkUpdateMutation = {
  __typename?: 'CompanyFeaturesBulkUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyFeaturesBulkUpdateMutationInput = {
  companiesFeatures: Array<InputMaybe<CompanyFeaturesInput>>;
};

export type CompanyFeaturesInput = {
  companyId: Scalars['ID'];
  isAddressesGroupsAvailable?: InputMaybe<Scalars['Boolean']>;
  isBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  isBusinessProfileAvailable?: InputMaybe<Scalars['Boolean']>;
  isCertLetterAvailable?: InputMaybe<Scalars['Boolean']>;
  isChangePricePlanAvailable?: InputMaybe<Scalars['Boolean']>;
  isInstantAdcampaignAvailable?: InputMaybe<Scalars['Boolean']>;
  isOffertaChanged?: InputMaybe<Scalars['Boolean']>;
  isVideoAdsAvailable?: InputMaybe<Scalars['Boolean']>;
  isVideoAvailable?: InputMaybe<Scalars['Boolean']>;
};

export type CompanyFilespacePureType = {
  __typename?: 'CompanyFilespacePureType';
  quota: Scalars['Int'];
  spaceUsed: Scalars['Int'];
};

export type CompanyPlaybackEarlyReportMutation = {
  __typename?: 'CompanyPlaybackEarlyReportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  reportAlreadyExist: Scalars['Boolean'];
};

export type CompanyPlaybackEarlyReportMutationInput = {
  companyId: Scalars['ID'];
  emailsTo: Array<Scalars['String']>;
  pointIds?: InputMaybe<Array<Scalars['Int']>>;
  rightholderId: Scalars['ID'];
};

export type CompanyPlaybackReportSettingsFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type CompanyPlaybackReportSettingsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type CompanyPlaybackReportSettingsPaginationPureType = {
  __typename?: 'CompanyPlaybackReportSettingsPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<CompanyPlaybackReportSettingsPureType>;
};

export type CompanyPlaybackReportSettingsPureType = {
  __typename?: 'CompanyPlaybackReportSettingsPureType';
  emailsTo: Array<Scalars['String']>;
  emptyReportTitle: Scalars['String'];
  helpLink: Scalars['String'];
  id: Scalars['ID'];
  isGenerateReport: Scalars['Boolean'];
  reportType: PlaybackReportType;
  rightholderId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CompanyPlaybackReportSettingsType = {
  __typename?: 'CompanyPlaybackReportSettingsType';
  emptyReportTitle: Scalars['String'];
  helpLink: Scalars['String'];
  isGenerateReport: Scalars['Boolean'];
  reportType: PlaybackReportType;
  rightholderId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type CompanyPlaybackReportSettingsUpdateMutation = {
  __typename?: 'CompanyPlaybackReportSettingsUpdateMutation';
  companyPlaybackReportSettings?: Maybe<CompanyPlaybackReportSettingsPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyPlaybackReportSettingsUpdateMutationInput = {
  emailsTo: Array<Scalars['String']>;
  reportSettingsId: Scalars['ID'];
};

export type CompanyPlaybackReportType = {
  __typename?: 'CompanyPlaybackReportType';
  adcampaignReportType: AdcampaignPlaybackReportType;
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  id: Scalars['ID'];
  reportFileUri?: Maybe<Scalars['String']>;
  reportSettingsId?: Maybe<Scalars['ID']>;
  reportType: PlaybackReportType;
  rightholderId?: Maybe<Scalars['ID']>;
  status: PlaybackReportStatus;
  title: Scalars['String'];
};

export type CompanyPlaybackReportsQueryFilter = {
  adcampaignReportTypes?: InputMaybe<Array<InputMaybe<AdcampaignPlaybackReportType>>>;
  query?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<PlaybackReportType>;
  rightholderId?: InputMaybe<Scalars['ID']>;
};

export type CompanyReferralPureType = {
  __typename?: 'CompanyReferralPureType';
  registeredUsers?: Maybe<Array<Maybe<UserExtendPureType>>>;
  uuid: Scalars['String'];
};

export type CompanyRemoveCardMutation = {
  __typename?: 'CompanyRemoveCardMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyRemoveCardMutationInput = {
  companyId: Scalars['ID'];
};

export type CompanyRemoveUserMutation = {
  __typename?: 'CompanyRemoveUserMutation';
  company?: Maybe<UserCompanyPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyRemoveUserMutationInput = {
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CompanyReportRequestMutation = {
  __typename?: 'CompanyReportRequestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyReportRequestMutationInput = {
  country?: InputMaybe<Country>;
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};

export type CompanySetPricePlanMutation = {
  __typename?: 'CompanySetPricePlanMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanySetPricePlanMutationInput = {
  companyId: Scalars['ID'];
  pricePlanId: Scalars['ID'];
  pricePlanPeriodId?: InputMaybe<Scalars['ID']>;
};

export type CompanySetPricePlanPeriodMutation = {
  __typename?: 'CompanySetPricePlanPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanySetPricePlanPeriodMutationInput = {
  companyId: Scalars['ID'];
  pricePlanPeriodId: Scalars['ID'];
};

export type CompanySetShowSberIdButtonMutation = {
  __typename?: 'CompanySetShowSberIdButtonMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanySetShowSberIdButtonMutationInput = {
  companyId: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type CompanyTagPureType = {
  __typename?: 'CompanyTagPureType';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type CompanyTagQueryFilter = {
  brandCompaniesIds?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CompanyTagQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type CompanyTagQueryPaginationType = {
  __typename?: 'CompanyTagQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<CompanyTagPureType>>;
};

export type CompanyTemplateStreamsType = {
  __typename?: 'CompanyTemplateStreamsType';
  streamsRecommend: Array<StreamPureType>;
  streamsTop: Array<StreamPureType>;
};

export type CompanyThematicBlockPureUpdateMutation = {
  __typename?: 'CompanyThematicBlockPureUpdateMutation';
  companyThematicBlock?: Maybe<CompanyThematicContentBlockPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyThematicBlockPureUpdateMutationInput = {
  addToAllStreams?: InputMaybe<Scalars['Boolean']>;
  companyThematicBlockId: Scalars['ID'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  streamsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CompanyThematicContentBlockPureType = {
  __typename?: 'CompanyThematicContentBlockPureType';
  company: UserCompanyPureType;
  eventTitle: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  playFromDate: Scalars['Date'];
  playToDate: Scalars['Date'];
  streamsIdsWithThematic: Array<Scalars['ID']>;
  thematicContentBlock: ThematicContentBlockPureType;
  title: Scalars['String'];
};

export type CompanyTransferStreamsMutation = {
  __typename?: 'CompanyTransferStreamsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyTransferStreamsMutationInput = {
  companyId: Scalars['ID'];
  streamsIds: Array<Scalars['ID']>;
};

export type CompanyValidateMutation = {
  __typename?: 'CompanyValidateMutation';
  company: UserCompanyPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CompanyValidateMutationInput = {
  companyId: Scalars['ID'];
};

export enum ConnectionProcessStatusType {
  Finish = 'FINISH',
  Init = 'INIT',
  Sent = 'SENT'
}

export type ConnectionStatusType = {
  __typename?: 'ConnectionStatusType';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ConnectionType = {
  __typename?: 'ConnectionType';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ConnectionTypes {
  Both = 'BOTH',
  Down = 'DOWN',
  Eth = 'ETH',
  Wifi = 'WIFI'
}

export type ContentBlockDraftPureType = {
  __typename?: 'ContentBlockDraftPureType';
  days?: Maybe<Scalars['JSONString']>;
  duration: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  endDayTime?: Maybe<Scalars['Time']>;
  id: Scalars['ID'];
  isSpecial: Scalars['Boolean'];
  mediafiles?: Maybe<Array<MediafilePureType>>;
  mediafilesAddedAt: Array<MediafileAddedAtType>;
  mediafilesCount: Scalars['Int'];
  originalId?: Maybe<Scalars['ID']>;
  pattern?: Maybe<Array<Array<Scalars['ID']>>>;
  rightholderName: Scalars['String'];
  rightholders: Array<RightholderValuePureType>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDayTime?: Maybe<Scalars['Time']>;
  title: Scalars['String'];
};

export type ContentBlockMediaUploadMutation = {
  __typename?: 'ContentBlockMediaUploadMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ContentBlockMediaUploadMutationInput = {
  diskUrl: Scalars['String'];
  rightholderId: Scalars['ID'];
  valuesIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ContentBlockPureCopyAsTemplateMutation = {
  __typename?: 'ContentBlockPureCopyAsTemplateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  templateBlock?: Maybe<ContentBlockPureType>;
};

export type ContentBlockPureCopyAsTemplateMutationInput = {
  contentBlockId: Scalars['ID'];
  templateTitle: Scalars['String'];
};

export type ContentBlockPureType = {
  __typename?: 'ContentBlockPureType';
  activeNow?: Maybe<Scalars['Boolean']>;
  copyFromId?: Maybe<Scalars['ID']>;
  days?: Maybe<Scalars['JSONString']>;
  demo?: Maybe<MediafilePureType>;
  duration: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Wrong name (use end_date) */
  endDay?: Maybe<Scalars['Date']>;
  endDayTime?: Maybe<Scalars['Time']>;
  id: Scalars['ID'];
  /** @deprecated Not used */
  inactiveMediafileIds?: Maybe<Array<Scalars['ID']>>;
  isAutoLoad: Scalars['Boolean'];
  isSpecial: Scalars['Boolean'];
  isThematic: Scalars['Boolean'];
  mediafileIds: Array<Scalars['ID']>;
  mediafiles?: Maybe<Array<MediafilePureType>>;
  mediafilesAddedAt: Array<MediafileAddedAtType>;
  mediafilesCount: Scalars['Int'];
  order?: Maybe<Scalars['Int']>;
  pattern?: Maybe<Array<Array<Scalars['ID']>>>;
  rightholderName: Scalars['String'];
  rightholders: Array<RightholderValuePureType>;
  rules?: Maybe<Scalars['JSONString']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** @deprecated Wrong name (use start_date) */
  startDay?: Maybe<Scalars['Date']>;
  startDayTime?: Maybe<Scalars['Time']>;
  /** @deprecated Not used */
  streamIds?: Maybe<Array<Scalars['ID']>>;
  thematicEnd?: Maybe<Scalars['Date']>;
  thematicStart?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
  /** @deprecated Not used */
  values?: Maybe<Array<Maybe<ValueObjectPureType>>>;
  /** @deprecated Not used */
  valuesByGroups?: Maybe<Array<Maybe<ValuesByGroupsPure>>>;
};

export type ContentBlockQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
  rightholder?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  specific?: InputMaybe<Array<InputMaybe<ContentBlockSpecific>>>;
  template?: InputMaybe<Scalars['Boolean']>;
};

export type ContentBlockQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type ContentBlockQueryPaginationType = {
  __typename?: 'ContentBlockQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<ContentBlockPureType>;
};

export enum ContentBlockQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export enum ContentBlockSpecific {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  Thematic = 'THEMATIC'
}

export type ContentBlockType = {
  __typename?: 'ContentBlockType';
  activeNow?: Maybe<Scalars['Boolean']>;
  contentblockSet: Array<ContentBlockType>;
  copyFrom?: Maybe<ContentBlockType>;
  created: Scalars['DateTime'];
  days?: Maybe<Scalars['JSONString']>;
  demo?: Maybe<MediafileObjectType>;
  endDate?: Maybe<Scalars['DateTime']>;
  endDayTime?: Maybe<Scalars['Time']>;
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isAutoLoad: Scalars['Boolean'];
  isSpecial: Scalars['Boolean'];
  isTemplate: Scalars['Boolean'];
  isThematic: Scalars['Boolean'];
  mediafile: Array<MediafileObjectType>;
  mediafileIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  modified: Scalars['DateTime'];
  order?: Maybe<Scalars['Int']>;
  pattern?: Maybe<Scalars['JSONString']>;
  rightholder?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['JSONString']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startDayTime?: Maybe<Scalars['Time']>;
  stream: Array<StreamType>;
  /** @deprecated Not used */
  streamIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  thematicEnd?: Maybe<Scalars['Date']>;
  thematicStart?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
  /** @deprecated Not used */
  values?: Maybe<Array<Maybe<ValueObjectType>>>;
  /** @deprecated Not used */
  valuesByGroups?: Maybe<Array<Maybe<ValuesByGroups>>>;
};

export type ContractAcceptMigrationMutation = {
  __typename?: 'ContractAcceptMigrationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ContractAcceptMigrationMutationInput = {
  companyId: Scalars['ID'];
};

export type ContractInitMigrationMutation = {
  __typename?: 'ContractInitMigrationMutation';
  contractMigration: CompanyContractMigrationType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ContractInitMigrationMutationInput = {
  companyId: Scalars['ID'];
  contractType: CompanyContractKind;
};

/** An enumeration. */
export enum ContractMigrationStatusEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Initiated = 'INITIATED'
}

export type ContractUpdatePaymentTermsMutation = {
  __typename?: 'ContractUpdatePaymentTermsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ContractUpdatePaymentTermsMutationInput = {
  amount: Scalars['LenientFloat'];
  contractId: Scalars['ID'];
  payFrequencyMonth: Scalars['LenientInt'];
};

/** An enumeration. */
export enum Country {
  All = 'ALL',
  By = 'BY',
  Kz = 'KZ',
  Ru = 'RU'
}

export type CountryType = {
  __typename?: 'CountryType';
  code: Scalars['String'];
  title: Scalars['String'];
};

export type CoverFilePureType = {
  __typename?: 'CoverFilePureType';
  fullhdFilename: Scalars['String'];
  fullhdUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  miniatureFilename?: Maybe<Scalars['String']>;
  miniatureUri?: Maybe<Scalars['String']>;
};

export type CreateSlaveStreamPureMutation = {
  __typename?: 'CreateSlaveStreamPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateSlaveStreamPureMutationInput = {
  masterStreamId: Scalars['ID'];
  slaveStreamId: Scalars['ID'];
};

export type CreateStreamCopyAndSetToPointsMutation = {
  __typename?: 'CreateStreamCopyAndSetToPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateStreamCopyAndSetToPointsMutationInput = {
  asReplica?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['ID'];
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  streamId: Scalars['ID'];
  streamTaskId?: InputMaybe<Scalars['ID']>;
  streamTitle?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum Currencies {
  Byn = 'BYN',
  Eur = 'EUR',
  Gbp = 'GBP',
  Rub = 'RUB',
  Usd = 'USD'
}

export type CurrentLogoutUser = {
  __typename?: 'CurrentLogoutUser';
  deleted: Scalars['Boolean'];
};

export type DateTimeRange = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
};

export type DateTimeRangeType = {
  __typename?: 'DateTimeRangeType';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DeviceBindToStreamMutation = {
  __typename?: 'DeviceBindToStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceBusinessSpheresQueryPaginationType = {
  __typename?: 'DeviceBusinessSpheresQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<BusinessSpherePureType>>;
};

export type DeviceDislikeStreamMediafilePureMutation = {
  __typename?: 'DeviceDislikeStreamMediafilePureMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  likes: Array<DeviceStreamLike>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceDislikeStreamMediafilePureMutationInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceLibraryRecommendedCollectionPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type DeviceLibraryRecommendedSubCollectionsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type DeviceLikeStreamMediafilePureMutation = {
  __typename?: 'DeviceLikeStreamMediafilePureMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  likes: Array<DeviceStreamLike>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceLikeStreamMediafilePureMutationInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceMediafileObjectType = {
  __typename?: 'DeviceMediafileObjectType';
  /** CRC32 hash of provided mediafile, for now works either for original or loudnorm formats */
  crcHash?: Maybe<Scalars['String']>;
  cueIn?: Maybe<Scalars['Float']>;
  cueOut?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Int']>;
  fadeIn?: Maybe<Scalars['Float']>;
  fadeOut?: Maybe<Scalars['Float']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  performerTitle?: Maybe<Scalars['String']>;
  rightholder?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  startNext?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type DeviceMetadataTimingsType = {
  __typename?: 'DeviceMetadataTimingsType';
  mediafilesFetchElapsedTime: Scalars['Float'];
  settingsFetchElapsedTime: Scalars['Float'];
};

export type DevicePlayingSendStates = {
  __typename?: 'DevicePlayingSendStates';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePointDislikeMediafileMutation = {
  __typename?: 'DevicePointDislikeMediafileMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePointHistoryPurePaginationType = {
  __typename?: 'DevicePointHistoryPurePaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<PointPureHistoryItem>;
};

export type DevicePureChangeWifiSettingsMutation = {
  __typename?: 'DevicePureChangeWifiSettingsMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureChangeWifiSettingsMutationInput = {
  deviceId: Scalars['ID'];
  wifiPassword: Scalars['String'];
  wifiSsid: Scalars['String'];
};

export type DevicePureDeleteStreamMutation = {
  __typename?: 'DevicePureDeleteStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureDeleteStreamMutationInput = {
  streamId: Scalars['ID'];
};

export type DevicePureHistoryImportInput = {
  historyItems: Array<DevicePureHistoryItemInput>;
};

export type DevicePureHistoryItemInput = {
  adcampaignId?: InputMaybe<Scalars['ID']>;
  mediafile: DevicePureHistoryItemMediafileInput;
  playtime: DevicePureHistoryItemPlaytimeInput;
  pointId: Scalars['ID'];
  rotationId: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
};

export type DevicePureHistoryItemMediafileInput = {
  mediafileFilename?: InputMaybe<Scalars['String']>;
  mediafileId: Scalars['ID'];
  mediafilePerformerTitle: Scalars['String'];
  mediafileRightholder: Scalars['Int'];
  mediafileTitle: Scalars['String'];
  mediafileType: Scalars['Int'];
};

export type DevicePureHistoryItemPlaytimeInput = {
  onAir: Scalars['DateTime'];
  playtime: Scalars['DateTime'];
};

export type DevicePureImportHistoryMutation = {
  __typename?: 'DevicePureImportHistoryMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureReplaceDesktopboxMutation = {
  __typename?: 'DevicePureReplaceDesktopboxMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  oldDevice?: Maybe<PlayerDevicePureType>;
};

export type DevicePureReplaceDesktopboxMutationInput = {
  hardwareIdNew: Scalars['ID'];
  hardwareIdOld: Scalars['ID'];
};

export type DevicePureReportPlayStateInput = {
  currentVersion?: InputMaybe<Scalars['String']>;
  formFactor?: InputMaybe<Scalars['String']>;
  hostname?: InputMaybe<Scalars['String']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  macAddress?: InputMaybe<Scalars['String']>;
  mmIdentifier?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  state: PlayingStates;
  updateChannel?: InputMaybe<Scalars['String']>;
};

export type DevicePureReportPlayStateMutation = {
  __typename?: 'DevicePureReportPlayStateMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureSetDebugModeMutation = {
  __typename?: 'DevicePureSetDebugModeMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureSetDebugModeMutationInput = {
  debugMode: Scalars['Boolean'];
  deviceId: Scalars['ID'];
};

export type DevicePureSetHardwareMutation = {
  __typename?: 'DevicePureSetHardwareMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureSetHardwareMutationInput = {
  deviceId: Scalars['ID'];
  hardwareId: Scalars['ID'];
};

export type DevicePureSetLogLevelInput = {
  deviceId: Scalars['ID'];
  logLevel?: InputMaybe<LogLevels>;
};

export type DevicePureSetLogLevelMutation = {
  __typename?: 'DevicePureSetLogLevelMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureSetRequiredVersionMutation = {
  __typename?: 'DevicePureSetRequiredVersionMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicePureSetRequiredVersionMutationInput = {
  playerId: Scalars['ID'];
  versionId: Scalars['ID'];
};

export type DevicePureStartSavedStreamMutation = {
  __typename?: 'DevicePureStartSavedStreamMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  metadata: PlayerDeviceGenerationSettingsQueryPureType;
  ok?: Maybe<Scalars['Boolean']>;
  timings: DeviceMetadataTimingsType;
};

export type DevicePureStartSavedStreamMutationInput = {
  streamId: Scalars['ID'];
  version?: InputMaybe<GenerationSettingsVersion>;
};

export type DevicePureStartTemplateStreamMutation = {
  __typename?: 'DevicePureStartTemplateStreamMutation';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  metadata: PlayerDeviceGenerationSettingsQueryPureType;
  ok?: Maybe<Scalars['Boolean']>;
  timings: DeviceMetadataTimingsType;
};

export type DevicePureStartTemplateStreamMutationInput = {
  streamId: Scalars['ID'];
  version?: InputMaybe<GenerationSettingsVersion>;
};

export type DeviceRecalcMediafileCrcHashMutation = {
  __typename?: 'DeviceRecalcMediafileCrcHashMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  mediafile?: Maybe<DeviceMediafileObjectType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceRestoreDislikedMediafilePureMutation = {
  __typename?: 'DeviceRestoreDislikedMediafilePureMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  likes: Array<DeviceStreamLike>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceRestoreDislikedMediafilePureMutationInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceRestoreLikedMediafilePureMutation = {
  __typename?: 'DeviceRestoreLikedMediafilePureMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  likes: Array<DeviceStreamLike>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceRestoreLikedMediafilePureMutationInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceSetAdditionalFeatures = {
  __typename?: 'DeviceSetAdditionalFeatures';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeviceStateType = {
  __typename?: 'DeviceStateType';
  additionalData?: Maybe<Scalars['JSONString']>;
  device?: Maybe<PlayerDevicePureType>;
  downloadQueueSize?: Maybe<Scalars['Int']>;
  freeSpace?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  memorySize?: Maybe<Scalars['Int']>;
  memoryUsage?: Maybe<Scalars['Int']>;
  modified?: Maybe<Scalars['DateTime']>;
  playbackStatus: Scalars['String'];
  temperature?: Maybe<Scalars['Float']>;
  totalSpace?: Maybe<Scalars['Int']>;
};

export type DeviceStreamDislike = {
  __typename?: 'DeviceStreamDislike';
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceStreamGroupsQueryPaginationType = {
  __typename?: 'DeviceStreamGroupsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<StreamPureTemplateGroupType>>;
};

export type DeviceStreamLike = {
  __typename?: 'DeviceStreamLike';
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type DeviceStreamMediafilesEventsFilter = {
  eventType?: InputMaybe<MediafileEventTypes>;
  streamId: Scalars['ID'];
};

export type DeviceStreamMediafilesEventsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum DeviceStreamMediafilesEventsSort {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC'
}

export type DeviceStreamMediafilesFilter = {
  streamId: Scalars['ID'];
};

export type DeviceStreamMediafilesPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type DeviceStreamMediafilesPaginationType = {
  __typename?: 'DeviceStreamMediafilesPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<MediafilePureType>;
};

export type DeviceStreamMediafilesRandomQueryPurePaginationType = {
  __typename?: 'DeviceStreamMediafilesRandomQueryPurePaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<MediafilePureType>;
};

export enum DeviceStreamMediafilesSort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type DeviceStreamPureUpdateMutation = {
  __typename?: 'DeviceStreamPureUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type DeviceStreamPureUpdateMutationInput = {
  description?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

/** Deprecated. Use StreamSearchTagAttributeType */
export type DeviceStreamSearchTagAttributePureType = {
  __typename?: 'DeviceStreamSearchTagAttributePureType';
  children: Array<Maybe<DeviceStreamSearchTagPureType>>;
  color: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** Deprecated. Use SearchTagsType */
export type DeviceStreamSearchTagPureType = {
  __typename?: 'DeviceStreamSearchTagPureType';
  color: Scalars['String'];
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type DeviceStreamsPagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type DeviceStreamsQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
};

export type DeviceStreamsQueryPaginationType = {
  __typename?: 'DeviceStreamsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<StreamPureType>>;
};

export enum DeviceStreamsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type DeviceTemplateStreamsPagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type DeviceTemplateStreamsQueryFilter = {
  businessSpheresIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  searchTagsIds?: InputMaybe<Array<Scalars['ID']>>;
  templateGroupsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum DeviceTemplateStreamsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type DeviceToggleDebugMode = {
  __typename?: 'DeviceToggleDebugMode';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum DeviceTypes {
  AliceSpeaker = 'ALICE_SPEAKER',
  Android = 'ANDROID',
  Androidbox = 'ANDROIDBOX',
  BoomSpeaker = 'BOOM_SPEAKER',
  Desktop = 'DESKTOP',
  Desktopbox = 'DESKTOPBOX',
  Ios = 'IOS',
  Musicbox = 'MUSICBOX',
  Netcore = 'NETCORE',
  Pavo = 'PAVO',
  Webplayer = 'WEBPLAYER'
}

/** Mutation used by web player only to handle updates */
export type DeviceUpdatePlayerVersionMutation = {
  __typename?: 'DeviceUpdatePlayerVersionMutation';
  device: PlayerDeviceType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  requiredVersionUrl?: Maybe<Scalars['String']>;
};

/** Mutation used by web player 3 to handle updates. */
export type DeviceUpdateWebPlayer3VersionMutation = {
  __typename?: 'DeviceUpdateWebPlayer3VersionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  requiredVersion?: Maybe<Scalars['String']>;
  requiredVersionLink?: Maybe<Scalars['String']>;
  updateChannel?: Maybe<Scalars['String']>;
};

export type DevicesGroupCreateMutation = {
  __typename?: 'DevicesGroupCreateMutation';
  anotherDevicesGroupIdsWithActiveScheduler?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  devicesGroup?: Maybe<DevicesGroupType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicesGroupCreateMutationInput = {
  companyId: Scalars['ID'];
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  force?: InputMaybe<Scalars['Boolean']>;
  masterVideoStreamId?: InputMaybe<Scalars['ID']>;
  schedulerMode?: InputMaybe<DevicesGroupSchedulerMode>;
  title: Scalars['String'];
};

export type DevicesGroupDeleteMutation = {
  __typename?: 'DevicesGroupDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicesGroupDeleteMutationInput = {
  devicesGroupId: Scalars['ID'];
};

export type DevicesGroupLogsPureQueryFilter = {
  devicesGroupId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type DevicesGroupLogsPureQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type DevicesGroupLogsPureQueryPaginationType = {
  __typename?: 'DevicesGroupLogsPureQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<DevicesGroupLogsPureType>;
};

export type DevicesGroupLogsPureType = {
  __typename?: 'DevicesGroupLogsPureType';
  created: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  diffWithPrevious?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logModel?: Maybe<DevicesGroupType>;
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
};

export type DevicesGroupPaginationPureType = {
  __typename?: 'DevicesGroupPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<DevicesGroupType>;
  statusesInfo?: Maybe<DevicesGroupStatusesPureType>;
};

export type DevicesGroupQueryFilter = {
  companyId?: InputMaybe<Scalars['ID']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<DevicesGroupStatuses>>>;
  videoStreamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DevicesGroupQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum DevicesGroupQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

/** An enumeration. */
export enum DevicesGroupSchedulerMode {
  Off = 'off',
  PlayDurationAlignment = 'play_duration_alignment',
  ValidationOnly = 'validation_only'
}

/** An enumeration. */
export enum DevicesGroupStatuses {
  Invalid = 'invalid',
  Valid = 'valid'
}

export type DevicesGroupStatusesPureType = {
  __typename?: 'DevicesGroupStatusesPureType';
  invalid?: Maybe<Scalars['Int']>;
  valid?: Maybe<Scalars['Int']>;
};

export type DevicesGroupType = {
  __typename?: 'DevicesGroupType';
  company: UserCompanyPureType;
  devices?: Maybe<Array<PlayerDeviceType>>;
  id: Scalars['ID'];
  invalidVideoStreams?: Maybe<Array<VideoStreamType>>;
  isValid: Scalars['Boolean'];
  masterVideoStream?: Maybe<VideoStreamType>;
  schedulerMode: DevicesGroupSchedulerMode;
  title: Scalars['String'];
  validationError?: Maybe<Scalars['String']>;
  videoStreamCount: Scalars['Int'];
};

export type DevicesGroupUpdateMutation = {
  __typename?: 'DevicesGroupUpdateMutation';
  anotherDevicesGroupIdsWithActiveScheduler?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  devicesGroup?: Maybe<DevicesGroupType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DevicesGroupUpdateMutationInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  devicesGroupId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  masterVideoStreamId?: InputMaybe<Scalars['ID']>;
  schedulerMode?: InputMaybe<DevicesGroupSchedulerMode>;
  title?: InputMaybe<Scalars['String']>;
};

export type DictionaryMostRotated = {
  __typename?: 'DictionaryMostRotated';
  count?: Maybe<Scalars['Int']>;
  mediafileId?: Maybe<Scalars['Int']>;
};

export type DiscountTemplatePureType = {
  __typename?: 'DiscountTemplatePureType';
  id: Scalars['ID'];
  invoiceWithDiscountLimit: Scalars['Int'];
  licenseWithDiscountLimit: Scalars['Int'];
  manager?: Maybe<UserExtendPureType>;
  payFrequencyMonth: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
  value: Scalars['Int'];
  valueType: DiscountValueType;
};

/** An enumeration. */
export enum DiscountValueType {
  Amount = 'AMOUNT',
  FixedAmountPerLicense = 'FIXED_AMOUNT_PER_LICENSE',
  Percent = 'PERCENT'
}

export type DomainEventPaginationPureType = {
  __typename?: 'DomainEventPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<DomainEventPureType>;
};

export type DomainEventPureType = {
  __typename?: 'DomainEventPureType';
  company?: Maybe<UserCompanyPureType>;
  eventPayload?: Maybe<Scalars['JSONString']>;
  eventRaisedAt: Scalars['DateTime'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<InvoicePureType>;
  points?: Maybe<Array<LicensePureType>>;
  pointsCount?: Maybe<Scalars['Int']>;
  pricePlan?: Maybe<PricePlanPureType>;
  user?: Maybe<UserExtendPureType>;
};

export type DomainEventsQueryFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DomainEventsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum DomainEventsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type E2ECreateDevice = {
  __typename?: 'E2ECreateDevice';
  device?: Maybe<PlayerDevicePureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type E2ERemoveUserByEmailMutation = {
  __typename?: 'E2ERemoveUserByEmailMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type E2ERemoveUserByPhoneMutation = {
  __typename?: 'E2ERemoveUserByPhoneMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type E2EUserSetGroupsMutation = {
  __typename?: 'E2EUserSetGroupsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuArchiveType = {
  __typename?: 'EmenuArchiveType';
  companyId: Scalars['ID'];
  file: SourcefileType;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type EmenuCreateMutation = {
  __typename?: 'EmenuCreateMutation';
  emenu?: Maybe<EmenuMediafileType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuCreateMutationInput = {
  companyId: Scalars['ID'];
  emenuMediafileItems: Array<EmenuMediafileItemInput>;
  generationDuration: Scalars['Int'];
  name: Scalars['String'];
  templateArchiveId: Scalars['ID'];
  templateOrientation?: InputMaybe<EmenuTemplateOrientation>;
};

export type EmenuDeleteMutation = {
  __typename?: 'EmenuDeleteMutation';
  bindInfo?: Maybe<EmenuMediafileDeleteBindInfoType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuDeleteMutationInput = {
  emenuId: Scalars['ID'];
  forceDelete?: InputMaybe<Scalars['Boolean']>;
};

export type EmenuGenerationPaginationPureType = {
  __typename?: 'EmenuGenerationPaginationPureType';
  emenuId: Scalars['ID'];
  emenuName: Scalars['String'];
  paginationInfo: PaginationInfoType;
  result: Array<EmenuGenerationType>;
};

export type EmenuGenerationQueryFilter = {
  emenuId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type EmenuGenerationQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type EmenuGenerationType = {
  __typename?: 'EmenuGenerationType';
  generatedMediafile?: Maybe<MediafilePureType>;
  lastGenerationAt?: Maybe<Scalars['DateTime']>;
  point: PointPureType;
  status: EmenuVideoGenerationStatus;
  videoStream?: Maybe<VideoStreamType>;
};

export type EmenuMediafileBindInfoType = {
  __typename?: 'EmenuMediafileBindInfoType';
  bindedToPointsCount: Scalars['Int'];
  bindedToVideoStreamsCount: Scalars['Int'];
};

export type EmenuMediafileDeleteBindInfoType = {
  __typename?: 'EmenuMediafileDeleteBindInfoType';
  bindedToVideoStreamsCount: Scalars['Int'];
  emenuMediafileId: Scalars['ID'];
};

export type EmenuMediafileInput = {
  emenuMediafileId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  order: Scalars['Int'];
  playCount?: InputMaybe<Scalars['Int']>;
  playDuration: Scalars['Int'];
  title: Scalars['String'];
};

export type EmenuMediafileItemInput = {
  sku: Scalars['String'];
};

export type EmenuMediafileItemType = {
  __typename?: 'EmenuMediafileItemType';
  sku: Scalars['String'];
};

export type EmenuMediafilePaginationPureType = {
  __typename?: 'EmenuMediafilePaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<EmenuMediafileType>;
};

export type EmenuMediafileType = {
  __typename?: 'EmenuMediafileType';
  bindInfo: EmenuMediafileBindInfoType;
  company: UserCompanyPureType;
  generationDuration: Scalars['Int'];
  id: Scalars['ID'];
  items: Array<EmenuMediafileItemType>;
  name: Scalars['String'];
  templateArchive?: Maybe<EmenuArchiveType>;
  templateOrientation: EmenuTemplateOrientation;
};

export type EmenuPointClientIdCreateMutation = {
  __typename?: 'EmenuPointClientIdCreateMutation';
  emenuPointClientId?: Maybe<EmenuPointClientIdType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuPointClientIdCreateMutationInput = {
  externalPointId?: InputMaybe<Scalars['Int']>;
  pointId: Scalars['ID'];
};

export type EmenuPointClientIdDeleteMutation = {
  __typename?: 'EmenuPointClientIdDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuPointClientIdDeleteMutationInput = {
  pointId: Scalars['ID'];
};

export type EmenuPointClientIdPaginationPureType = {
  __typename?: 'EmenuPointClientIdPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<EmenuPointClientIdType>;
};

export type EmenuPointClientIdQueryFilter = {
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type EmenuPointClientIdQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum EmenuPointClientIdQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type EmenuPointClientIdType = {
  __typename?: 'EmenuPointClientIdType';
  externalPointId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  point: PointPureType;
};

export type EmenuPointClientIdUpdateMutation = {
  __typename?: 'EmenuPointClientIdUpdateMutation';
  emenuPointClientId?: Maybe<EmenuPointClientIdType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuPointClientIdUpdateMutationInput = {
  externalPointId?: InputMaybe<Scalars['Int']>;
  pointId: Scalars['ID'];
};

export type EmenuPointItemType = {
  __typename?: 'EmenuPointItemType';
  endDate?: Maybe<Scalars['DateTime']>;
  price: Scalars['Int'];
  sku: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type EmenuPointPaginationPureType = {
  __typename?: 'EmenuPointPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<EmenuPointType>;
};

export type EmenuPointQueryFilter = {
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type EmenuPointQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum EmenuPointQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type EmenuPointType = {
  __typename?: 'EmenuPointType';
  company: UserCompanyPureType;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  items: Array<EmenuPointItemType>;
  pointId: Scalars['Int'];
};

export type EmenuQueryFilter = {
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type EmenuQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum EmenuQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type EmenuSkusQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum EmenuTemplateOrientation {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type EmenuUpdateMutation = {
  __typename?: 'EmenuUpdateMutation';
  emenu?: Maybe<EmenuMediafileType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type EmenuUpdateMutationInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  emenuId: Scalars['ID'];
  emenuMediafileItems?: InputMaybe<Array<EmenuMediafileItemInput>>;
  generationDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  templateArchiveId?: InputMaybe<Scalars['ID']>;
  templateOrientation?: InputMaybe<EmenuTemplateOrientation>;
};

/** An enumeration. */
export enum EmenuVideoGenerationStatus {
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type ExculdeStreamFromReplicationPureMutation = {
  __typename?: 'ExculdeStreamFromReplicationPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ExculdeStreamFromReplicationPureMutationInput = {
  streamId: Scalars['ID'];
};

export type ExtendSubscriptionMutation = {
  __typename?: 'ExtendSubscriptionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ExtendSubscriptionMutationInput = {
  companyId: Scalars['ID'];
  licensesIds: Array<Scalars['ID']>;
};

export type ExtendSubscriptionRequestMutation = {
  __typename?: 'ExtendSubscriptionRequestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ExtendSubscriptionRequestMutationInput = {
  pointId: Scalars['ID'];
};

export type ExtendTrialPeriodMutation = {
  __typename?: 'ExtendTrialPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ExtendTrialPeriodMutationInput = {
  companyId: Scalars['ID'];
  days: Scalars['Int'];
};

export type ExtendVideoDemoPeriodMutation = {
  __typename?: 'ExtendVideoDemoPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ExtendVideoDemoPeriodMutationInput = {
  companyId: Scalars['ID'];
  days: Scalars['Int'];
};

export type FileObjectType = {
  __typename?: 'FileObjectType';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FinishTrialPeriodMutation = {
  __typename?: 'FinishTrialPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinishTrialPeriodMutationInput = {
  companyId: Scalars['ID'];
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GenerateApiTokenCreateMutation = {
  __typename?: 'GenerateApiTokenCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  tokenInfo?: Maybe<CompanyApiTokenType>;
};

export type GenerateApiTokenCreateMutationInput = {
  companyId: Scalars['ID'];
  expiresInDays?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type GenerationOptionsPureType = {
  __typename?: 'GenerationOptionsPureType';
  fileFormat?: Maybe<Scalars['String']>;
  immutableLink: Scalars['Boolean'];
  minCount?: Maybe<Scalars['Int']>;
  normalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum GenerationSettingsVersion {
  Version_1 = 'VERSION_1'
}

export type GroupFilteredByStreamType = {
  __typename?: 'GroupFilteredByStreamType';
  collections: Array<CollectionFilteredByStreamType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type InvitationsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type InvitationsQueryFilter = {
  companyId: Scalars['ID'];
  createdById?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export enum InvitationsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type InvoicePureType = {
  __typename?: 'InvoicePureType';
  amount: Scalars['Float'];
  cancellationReason?: Maybe<Scalars['String']>;
  company: UserCompanyPureType;
  contract: CompanyContractPureType;
  created: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  id: Scalars['ID'];
  isActual: Scalars['Boolean'];
  licenseCount: Scalars['Int'];
  payPeriod: DateTimeRangeType;
  paymentKind?: Maybe<PaymentKind>;
  paymentScheme?: Maybe<PaymentScheme>;
  points: Array<PointPureType>;
  priceAmount: Scalars['Float'];
  pricePlan?: Maybe<PricePlanPureType>;
  pricePlanPeriod?: Maybe<PricePlanPeriodPureType>;
  status: InvoiceState;
  successPaymentYookassaId?: Maybe<Scalars['String']>;
  type: InvoiceType;
};

/** An enumeration. */
export enum InvoiceState {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Grace = 'GRACE',
  Paid = 'PAID',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum InvoiceType {
  Adjustment = 'ADJUSTMENT',
  Oneshoot = 'ONESHOOT',
  Periodic = 'PERIODIC'
}

export type InvoicesPaginationType = {
  __typename?: 'InvoicesPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<InvoicePureType>;
};

export type InvoicesQueryFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contractId?: InputMaybe<Scalars['ID']>;
  paymentKind?: InputMaybe<PaymentKind>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InvoiceState>>;
};

export type InvoicesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum InvoicesQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type InvoicesReportRequestInput = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  paymentKind?: InputMaybe<PaymentKind>;
};

export type InvoicesReportRequestMutation = {
  __typename?: 'InvoicesReportRequestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type JwtTokenAuthPureMutationInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type JwtTokenAuthWithCodePureMutation = {
  __typename?: 'JwtTokenAuthWithCodePureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: TokenPureType;
  user: UserExtendPureType;
};

export type JwtTokenAuthWithCodePureMutationInput = {
  code: Scalars['String'];
  username: Scalars['String'];
};

export type LaunchSubscriptionMutation = {
  __typename?: 'LaunchSubscriptionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LaunchSubscriptionMutationInput = {
  companyId: Scalars['ID'];
  licensesIds: Array<Scalars['ID']>;
};

export type LaunchSubscriptionWithConfirmMutation = {
  __typename?: 'LaunchSubscriptionWithConfirmMutation';
  confirmLink: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LaunchSubscriptionWithConfirmMutationInput = {
  companyId: Scalars['ID'];
  licensesIds?: InputMaybe<Array<Scalars['ID']>>;
  uriForReturn: Scalars['String'];
};

export type LibrariesPaginationPureType = {
  __typename?: 'LibrariesPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<LibraryPureType>;
};

export type LibrariesPureQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
};

export type LibrariesPureQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum LibrariesPureQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type LibraryBusinessSphereRecommendationDraftType = {
  __typename?: 'LibraryBusinessSphereRecommendationDraftType';
  businessSphere: BusinessSpherePureType;
  currentRightholders: Array<Scalars['Int']>;
  libraryDraft: LibraryDraftPureType;
  streamsNumber: Scalars['Int'];
  subcollections: Array<LibrarySubCollectionRecommendationDraftType>;
  subcollectionsNumber: Scalars['Int'];
};

export type LibraryBusinessSphereRecommendationType = {
  __typename?: 'LibraryBusinessSphereRecommendationType';
  businessSphere: BusinessSpherePureType;
  currentRightholders: Array<Scalars['Int']>;
  library: LibraryPureType;
  streamsNumber: Scalars['Int'];
  subcollections: Array<LibrarySubCollectionRecommendationType>;
  subcollectionsNumber: Scalars['Int'];
};

export type LibraryBusinessSphereRecommendationsDraftFilter = {
  businessSpheresIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  libraryDraftId: Scalars['ID'];
};

export type LibraryBusinessSphereRecommendationsFilter = {
  businessSpheresIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  libraryId: Scalars['ID'];
};

export type LibraryCollectionDraftPureQueryFilter = {
  collectionDraftId: Scalars['ID'];
};

export type LibraryCollectionDraftPureType = {
  __typename?: 'LibraryCollectionDraftPureType';
  currentRightholders: Array<Scalars['Int']>;
  groupDraft: LibraryGroupDraftPureType;
  id: Scalars['ID'];
  libraryDraft: LibraryDraftPureType;
  order: Scalars['Int'];
  poster: LibraryPosterPureType;
  streams: Array<LibraryStreamDraftPureType>;
  streamsNumber: Scalars['Int'];
  subcollections: Array<LibrarySubCollectionDraftPureType>;
  subcollectionsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibraryCollectionPureQueryFilter = {
  collectionId: Scalars['ID'];
};

export type LibraryCollectionPureType = {
  __typename?: 'LibraryCollectionPureType';
  currentRightholders: Array<Scalars['Int']>;
  group: LibraryGroupPureType;
  id: Scalars['ID'];
  library: LibraryPureType;
  order: Scalars['Int'];
  poster: LibraryPosterPureType;
  streams: Array<LibraryStreamPureType>;
  streamsNumber: Scalars['Int'];
  subcollections: Array<LibrarySubCollectionPureType>;
  subcollectionsNumber: Scalars['Int'];
  title: Scalars['String'];
};

export type LibraryCollectionsSearchQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  textQuery: Scalars['String'];
};

export type LibraryCollectionsSearchQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type LibraryDeleteMutation = {
  __typename?: 'LibraryDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDeleteMutationInput = {
  libraryId: Scalars['ID'];
};

export type LibraryDraftAddStreamsMutation = {
  __typename?: 'LibraryDraftAddStreamsMutation';
  errorStreams: Array<StreamPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  rightholderConflictStreams: Array<StreamPureType>;
};

export type LibraryDraftAddStreamsMutationInput = {
  streamIds: Array<InputMaybe<Scalars['ID']>>;
  subcollectionDraftId: Scalars['ID'];
};

export type LibraryDraftCancelMutation = {
  __typename?: 'LibraryDraftCancelMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftCancelMutationInput = {
  libraryDraftId: Scalars['ID'];
};

export type LibraryDraftChangeCollectionOrderMutation = {
  __typename?: 'LibraryDraftChangeCollectionOrderMutation';
  collection: LibraryCollectionDraftPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftChangeCollectionOrderMutationInput = {
  collectionDraftId: Scalars['ID'];
  groupDraftId: Scalars['ID'];
  newOrder: Scalars['Int'];
};

export type LibraryDraftChangeGroupOrderMutation = {
  __typename?: 'LibraryDraftChangeGroupOrderMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  group: LibraryGroupDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftChangeGroupOrderMutationInput = {
  groupDraftId: Scalars['ID'];
  libraryDraftId: Scalars['ID'];
  newOrder: Scalars['Int'];
};

export type LibraryDraftChangeOrderMutation = {
  __typename?: 'LibraryDraftChangeOrderMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftChangeOrderMutationInput = {
  newOrder: Scalars['Int'];
  streamDraftId: Scalars['ID'];
  subcollectionDraftId: Scalars['ID'];
};

export type LibraryDraftChangePosterCollectionMutation = {
  __typename?: 'LibraryDraftChangePosterCollectionMutation';
  collection: LibraryCollectionDraftPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftChangePosterCollectionMutationInput = {
  collectionDraftId: Scalars['ID'];
  image: Scalars['Upload'];
};

export type LibraryDraftChangeSubCollectionOrderMutation = {
  __typename?: 'LibraryDraftChangeSubCollectionOrderMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  subcollection: LibrarySubCollectionDraftPureType;
};

export type LibraryDraftChangeSubCollectionOrderMutationInput = {
  collectionDraftId: Scalars['ID'];
  newOrder: Scalars['Int'];
  subcollectionDraftId: Scalars['ID'];
};

export type LibraryDraftCopySubCollectionMutation = {
  __typename?: 'LibraryDraftCopySubCollectionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  subcollection: LibrarySubCollectionDraftPureType;
};

export type LibraryDraftCopySubCollectionMutationInput = {
  description: Scalars['String'];
  subcollectionDraftId: Scalars['ID'];
  title: Scalars['String'];
};

export type LibraryDraftCreateCollectionPureMutation = {
  __typename?: 'LibraryDraftCreateCollectionPureMutation';
  collection: LibraryCollectionDraftPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftCreateCollectionPureMutationInput = {
  groupDraftId: Scalars['ID'];
  image: Scalars['Upload'];
  title: Scalars['String'];
};

export type LibraryDraftCreateGroupPureMutation = {
  __typename?: 'LibraryDraftCreateGroupPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  group: LibraryGroupDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftCreateGroupPureMutationInput = {
  libraryDraftId: Scalars['ID'];
  title: Scalars['String'];
};

export type LibraryDraftCreateSubCollectionMutation = {
  __typename?: 'LibraryDraftCreateSubCollectionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  subcollection: LibrarySubCollectionDraftPureType;
};

export type LibraryDraftCreateSubCollectionMutationInput = {
  collectionDraftId: Scalars['ID'];
  description: Scalars['String'];
  title: Scalars['String'];
};

export type LibraryDraftDiscommendSubCollectionsInput = {
  businessSphereId: Scalars['ID'];
  libraryDraftId: Scalars['ID'];
  subcollectionDraftsIds: Array<Scalars['ID']>;
};

export type LibraryDraftDiscommendSubCollectionsMutation = {
  __typename?: 'LibraryDraftDiscommendSubCollectionsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryRecommendations: LibraryBusinessSphereRecommendationDraftType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftPublishPureMutation = {
  __typename?: 'LibraryDraftPublishPureMutation';
  errorStreams: Array<StreamPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  library?: Maybe<LibraryPureType>;
  ok?: Maybe<Scalars['Boolean']>;
  rightholderConflictStreams: Array<StreamPureType>;
};

export type LibraryDraftPublishPureMutationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  libraryDraftId: Scalars['ID'];
};

export type LibraryDraftPureQueryFilter = {
  libraryDraftId: Scalars['ID'];
};

export type LibraryDraftPureType = {
  __typename?: 'LibraryDraftPureType';
  businessSpheresWithoutRecsNumber: Scalars['Int'];
  collectionsNumber: Scalars['Int'];
  currentRightholders: Array<Scalars['Int']>;
  groups: Array<LibraryGroupDraftPureType>;
  groupsNumber: Scalars['Int'];
  id: Scalars['ID'];
  originId?: Maybe<Scalars['ID']>;
  rightholders: Array<Scalars['Int']>;
  streamsNumber: Scalars['Int'];
  subcollectionsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibraryDraftRecommendSubCollectionsInput = {
  businessSphereId: Scalars['ID'];
  libraryDraftId: Scalars['ID'];
  subcollectionDraftsIds: Array<Scalars['ID']>;
};

export type LibraryDraftRecommendSubCollectionsMutation = {
  __typename?: 'LibraryDraftRecommendSubCollectionsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryRecommendations: LibraryBusinessSphereRecommendationDraftType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftRecommendationsChangeOrderInput = {
  businessSphereId: Scalars['ID'];
  libraryDraftId: Scalars['ID'];
  order: Scalars['Int'];
  subcollectionDraftId: Scalars['ID'];
};

export type LibraryDraftRecommendationsChangeOrderMutation = {
  __typename?: 'LibraryDraftRecommendationsChangeOrderMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryRecommendations: LibraryBusinessSphereRecommendationDraftType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftRemoveCollectionMutation = {
  __typename?: 'LibraryDraftRemoveCollectionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  removedCollectionTitles: Array<Scalars['String']>;
};

export type LibraryDraftRemoveCollectionMutationInput = {
  collectionDraftIds: Array<InputMaybe<Scalars['ID']>>;
  groupDraftId: Scalars['ID'];
};

export type LibraryDraftRemoveGroupMutation = {
  __typename?: 'LibraryDraftRemoveGroupMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  removedGroupTitles: Array<Scalars['String']>;
};

export type LibraryDraftRemoveGroupMutationInput = {
  groupDraftIds: Array<InputMaybe<Scalars['ID']>>;
  libraryDraftId: Scalars['ID'];
};

export type LibraryDraftRemoveStreamsMutation = {
  __typename?: 'LibraryDraftRemoveStreamsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  removedStreams: Array<StreamPureType>;
};

export type LibraryDraftRemoveStreamsMutationInput = {
  streamDraftIds: Array<InputMaybe<Scalars['ID']>>;
  subcollectionDraftId: Scalars['ID'];
};

export type LibraryDraftRemoveSubCollectionMutation = {
  __typename?: 'LibraryDraftRemoveSubCollectionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  removedSubcollectionTitles: Array<Scalars['String']>;
};

export type LibraryDraftRemoveSubCollectionMutationInput = {
  collectionDraftId: Scalars['ID'];
  subcollectionDraftIds: Array<InputMaybe<Scalars['ID']>>;
};

export type LibraryDraftRenameCollectionMutation = {
  __typename?: 'LibraryDraftRenameCollectionMutation';
  collection: LibraryCollectionDraftPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftRenameCollectionMutationInput = {
  collectionDraftId: Scalars['ID'];
  newTitle: Scalars['String'];
};

export type LibraryDraftRenameGroupMutation = {
  __typename?: 'LibraryDraftRenameGroupMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  group: LibraryGroupDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftRenameGroupMutationInput = {
  groupDraftId: Scalars['ID'];
  newTitle: Scalars['String'];
};

export type LibraryDraftRenameMutation = {
  __typename?: 'LibraryDraftRenameMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryDraft: LibraryDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryDraftRenameMutationInput = {
  libraryDraftId: Scalars['ID'];
  newTitle: Scalars['String'];
};

export type LibraryDraftUpdateSubCollectionMutation = {
  __typename?: 'LibraryDraftUpdateSubCollectionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  subcollection: LibrarySubCollectionDraftPureType;
};

export type LibraryDraftUpdateSubCollectionMutationInput = {
  description: Scalars['String'];
  subcollectionDraftId: Scalars['ID'];
  title: Scalars['String'];
};

export type LibraryDraftsPaginationPureType = {
  __typename?: 'LibraryDraftsPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<LibraryDraftPureType>;
};

export type LibraryDraftsPureQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
};

export type LibraryDraftsPureQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum LibraryDraftsPureQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type LibraryFilteredByStreamType = {
  __typename?: 'LibraryFilteredByStreamType';
  groups: Array<GroupFilteredByStreamType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type LibraryGroupDraftPureQueryFilter = {
  groupDraftId: Scalars['ID'];
};

export type LibraryGroupDraftPureType = {
  __typename?: 'LibraryGroupDraftPureType';
  collections: Array<LibraryCollectionDraftPureType>;
  collectionsNumber: Scalars['Int'];
  currentRightholders: Array<Scalars['Int']>;
  id: Scalars['ID'];
  libraryDraft: LibraryDraftPureType;
  order: Scalars['Int'];
  streamsNumber: Scalars['Int'];
  subcollectionsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibraryGroupPureQueryFilter = {
  groupId: Scalars['ID'];
};

export type LibraryGroupPureType = {
  __typename?: 'LibraryGroupPureType';
  collections: Array<LibraryCollectionPureType>;
  collectionsNumber: Scalars['Int'];
  currentRightholders: Array<Scalars['Int']>;
  id: Scalars['ID'];
  library: LibraryPureType;
  order: Scalars['Int'];
  streamsNumber: Scalars['Int'];
  subcollectionsNumber: Scalars['Int'];
  title: Scalars['String'];
};

export enum LibraryObjectType {
  Collection = 'COLLECTION',
  Group = 'GROUP',
  Library = 'LIBRARY',
  Subcollection = 'SUBCOLLECTION'
}

export type LibraryPosterPureType = {
  __typename?: 'LibraryPosterPureType';
  id: Scalars['ID'];
  uri: Scalars['String'];
};

export type LibraryPureQueryFilter = {
  libraryId: Scalars['ID'];
};

export type LibraryPureType = {
  __typename?: 'LibraryPureType';
  collectionsNumber: Scalars['Int'];
  currentRightholders: Array<Scalars['Int']>;
  draft?: Maybe<LibraryDraftPureType>;
  groups: Array<LibraryGroupPureType>;
  groupsNumber: Scalars['Int'];
  id: Scalars['ID'];
  isDeleteAllowed: Scalars['Boolean'];
  rightholders: Array<Scalars['Int']>;
  streamsNumber: Scalars['Int'];
  subcollectionsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibraryRecommendedCollectionPagination = {
  __typename?: 'LibraryRecommendedCollectionPagination';
  paginationInfo: PaginationInfoType;
  result: Array<LibraryRecommendedCollectionType>;
};

export type LibraryRecommendedCollectionType = {
  __typename?: 'LibraryRecommendedCollectionType';
  businessSphereId: Scalars['ID'];
  collection: LibraryCollectionPureType;
  order: Scalars['Int'];
};

export type LibraryStrartCreatePureMutation = {
  __typename?: 'LibraryStrartCreatePureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryDraft: LibraryDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryStrartCreatePureMutationInput = {
  rightholders: Array<Scalars['ID']>;
  title: Scalars['String'];
};

export type LibraryStrartEditPureMutation = {
  __typename?: 'LibraryStrartEditPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  libraryDraft: LibraryDraftPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LibraryStrartEditPureMutationInput = {
  libraryId: Scalars['ID'];
};

export type LibraryStreamDraftPureType = {
  __typename?: 'LibraryStreamDraftPureType';
  collectionDraft: LibraryCollectionDraftPureType;
  groupDraft: LibraryGroupDraftPureType;
  id: Scalars['ID'];
  libraryDraft: LibraryDraftPureType;
  order: Scalars['Int'];
  stream: StreamPureType;
  timestamp: Scalars['DateTime'];
};

export type LibraryStreamPaginationType = {
  __typename?: 'LibraryStreamPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<LibraryStreamPureType>;
};

export type LibraryStreamPureType = {
  __typename?: 'LibraryStreamPureType';
  collection: LibraryCollectionPureType;
  group: LibraryGroupPureType;
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  library: LibraryPureType;
  order: Scalars['Int'];
  stream: StreamPureType;
};

export type LibraryStreamsSearchQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  searchTagsIds?: InputMaybe<Array<Scalars['ID']>>;
  textQuery?: InputMaybe<Scalars['String']>;
};

export type LibraryStreamsSearchQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type LibrarySubCollectionDraftPureQueryFilter = {
  subcollectionDraftId: Scalars['ID'];
};

export type LibrarySubCollectionDraftPureType = {
  __typename?: 'LibrarySubCollectionDraftPureType';
  collectionDraft: LibraryGroupDraftPureType;
  currentRightholders: Array<Scalars['Int']>;
  description: Scalars['String'];
  groupDraft: LibraryGroupDraftPureType;
  id: Scalars['ID'];
  libraryDraft: LibraryDraftPureType;
  order: Scalars['Int'];
  streams: Array<LibraryStreamDraftPureType>;
  streamsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibrarySubCollectionPureQueryFilter = {
  subcollectionId: Scalars['ID'];
};

export type LibrarySubCollectionPureType = {
  __typename?: 'LibrarySubCollectionPureType';
  collection: LibraryCollectionPureType;
  currentRightholders: Array<Scalars['Int']>;
  description: Scalars['String'];
  group: LibraryGroupPureType;
  id: Scalars['ID'];
  library: LibraryPureType;
  order: Scalars['Int'];
  streams: Array<LibraryStreamPureType>;
  streamsNumber: Scalars['Int'];
  timestamp: Scalars['DateTime'];
  title: Scalars['String'];
};

export type LibrarySubCollectionRecommendationDraftType = {
  __typename?: 'LibrarySubCollectionRecommendationDraftType';
  order: Scalars['Int'];
  subcollection: LibrarySubCollectionDraftPureType;
};

export type LibrarySubCollectionRecommendationType = {
  __typename?: 'LibrarySubCollectionRecommendationType';
  order: Scalars['Int'];
  subcollection: LibrarySubCollectionPureType;
};

export type LibrarySubCollectionsDraftsFilter = {
  libraryDraftId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  searchByCollection?: InputMaybe<Scalars['String']>;
  searchBySubcollection?: InputMaybe<Scalars['String']>;
};

export type LibrarySubCollectionsDraftsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum LibrarySubCollectionsDraftsSort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type LibraryUpdateInput = {
  availableRightholdersIds?: InputMaybe<Array<Scalars['ID']>>;
  libraryId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type LibraryUpdateMutation = {
  __typename?: 'LibraryUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  library: LibraryPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum LicensePaymentState {
  Grace = 'GRACE',
  Paid = 'PAID',
  Trial = 'TRIAL',
  Unpaid = 'UNPAID',
  WaitPayment = 'WAIT_PAYMENT'
}

export type LicensePaymentStatusCountType = {
  __typename?: 'LicensePaymentStatusCountType';
  grace: Scalars['Int'];
  paid: Scalars['Int'];
  trial: Scalars['Int'];
  unpaid: Scalars['Int'];
};

export type LicensePureType = {
  __typename?: 'LicensePureType';
  autoRenewal: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['DateTime']>;
  paymentState: LicensePaymentState;
  point?: Maybe<PointPureType>;
};

export type LicenseType = {
  __typename?: 'LicenseType';
  daysLeft?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LicensesPaginationType = {
  __typename?: 'LicensesPaginationType';
  countLicensesByStatus: LicensePaymentStatusCountType;
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<LicensePureType>>;
};

export type LicensesQueryFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  paymentState?: InputMaybe<LicensePaymentState>;
  query?: InputMaybe<Scalars['String']>;
};

export type LicensesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum LicensesQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type LicensesResumeAutoRenewalMutation = {
  __typename?: 'LicensesResumeAutoRenewalMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LicensesResumeAutoRenewalMutationInput = {
  companyId: Scalars['ID'];
  licensesIds: Array<Scalars['ID']>;
};

export type LicensesSuspendAutoRenewalMutation = {
  __typename?: 'LicensesSuspendAutoRenewalMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type LicensesSuspendAutoRenewalMutationInput = {
  companyId: Scalars['ID'];
  licensesIds: Array<Scalars['ID']>;
};

/** An enumeration. */
export enum LogLevels {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type MmClientObjectPureType = {
  __typename?: 'MMClientObjectPureType';
  id: Scalars['ID'];
  mmId: Scalars['ID'];
  registry?: Maybe<MmClientRegistryPure>;
  title: Scalars['String'];
};

export enum MmClientRegistryPure {
  Beta = 'BETA',
  By = 'BY',
  ByUa = 'BY_UA',
  Demo = 'DEMO',
  Dev = 'DEV',
  Letual = 'LETUAL',
  Rus = 'RUS',
  Ua = 'UA'
}

export type MmClientSearchType = {
  __typename?: 'MMClientSearchType';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  result?: Maybe<Array<MmClientObjectPureType>>;
  totalCount: Scalars['Int'];
};

export type MmDisableSyncForBlockMutation = {
  __typename?: 'MMDisableSyncForBlockMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MmForceSyncBlockMutation = {
  __typename?: 'MMForceSyncBlockMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MmIntegrationRegistryPureStatus = {
  __typename?: 'MMIntegrationRegistryPureStatus';
  blockProxyId: Scalars['ID'];
  client: MmClientObjectPureType;
  contentBlock: ContentBlockPureType;
  contentBlockSynced: Scalars['Boolean'];
  registry: Scalars['String'];
  syncError: Scalars['Boolean'];
  syncErrorMessage?: Maybe<Scalars['String']>;
  syncPercent: Scalars['Int'];
};

export type MmSyncModeOnForBlockMutation = {
  __typename?: 'MMSyncModeOnForBlockMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MmSyncModeOnForBlockMutationInput = {
  clientId: Scalars['ID'];
  contentBlockId: Scalars['ID'];
};

export type MmSyncMutationInput = {
  proxyBlockId: Scalars['ID'];
};

export type MarkAcceptanceErrorAsViewedInput = {
  acceptanceId: Scalars['ID'];
  companyId: Scalars['ID'];
};

export type MarkAcceptanceErrorAsViewedMutation = {
  __typename?: 'MarkAcceptanceErrorAsViewedMutation';
  acceptance?: Maybe<AcceptanceAdvanceType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MediafileAddedAtType = {
  __typename?: 'MediafileAddedAtType';
  addedAt: Scalars['DateTime'];
  mediafileId: Scalars['ID'];
};

export type MediafileApprovalPaginationType = {
  __typename?: 'MediafileApprovalPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<MediafileApprovalType>;
};

export type MediafileApprovalType = {
  __typename?: 'MediafileApprovalType';
  eventId?: Maybe<Scalars['ID']>;
  eventType?: Maybe<MediafileEventTypes>;
  mediafile: MediafilePureType;
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** An enumeration. */
export enum MediafileEventTypes {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type MediafileObjectType = {
  __typename?: 'MediafileObjectType';
  bpm: Scalars['Int'];
  contentType?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  cueIn?: Maybe<Scalars['Float']>;
  cueOut?: Maybe<Scalars['Float']>;
  duration: Scalars['Int'];
  fadeIn?: Maybe<Scalars['Float']>;
  fadeOut?: Maybe<Scalars['Float']>;
  filename?: Maybe<Scalars['String']>;
  histogram?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  marksJson?: Maybe<Scalars['JSONString']>;
  mediafileValue?: Maybe<Array<Maybe<ValueObjectType>>>;
  performerTitle: Scalars['String'];
  redactors?: Maybe<Array<Maybe<Scalars['String']>>>;
  rightholder?: Maybe<Scalars['Int']>;
  rightholderName?: Maybe<Scalars['String']>;
  rms: Scalars['Int'];
  size?: Maybe<Scalars['Int']>;
  tagged?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type MediafilePublicObjectType = {
  __typename?: 'MediafilePublicObjectType';
  duration: Scalars['Int'];
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mediafileValue?: Maybe<Array<Maybe<ValueObjectType>>>;
  performerTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type MediafilePureType = {
  __typename?: 'MediafilePureType';
  bpm: Scalars['String'];
  company?: Maybe<UserCompanyPureType>;
  duration: Scalars['Int'];
  explicit: Scalars['Boolean'];
  filename: Scalars['String'];
  genres: Scalars['String'];
  hasVector: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDeleting: Scalars['Boolean'];
  maxQuality?: Maybe<Scalars['Int']>;
  performerTitle: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  rightholder: RightholderValuePureType;
  rightholderName: Scalars['String'];
  rms: Scalars['String'];
  sourcefiles: Array<SourcefileType>;
  tagged: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['Int'];
  uri: Scalars['String'];
  valueIds: Array<Scalars['ID']>;
  values: Array<ValueObjectPureType>;
  valuesExtend: Array<MediafileValueType>;
  valuesNames: Array<Scalars['String']>;
};

export type MediafilePureUpdateMutation = {
  __typename?: 'MediafilePureUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  mediafile?: Maybe<MediafilePureType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MediafilePureUpdateMutationInput = {
  mediafileId: Scalars['ID'];
  performerTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  valueIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type MediafileReportMutation = {
  __typename?: 'MediafileReportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MediafileReportMutationInput = {
  dateRange: DateTimeRange;
  rightholder: Scalars['LenientInt'];
};

export type MediafileUploadMutationInput = {
  file: Scalars['Upload'];
};

export type MediafileUploadPureMutation = {
  __typename?: 'MediafileUploadPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  mediafile?: Maybe<MediafilePureType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MediafileValueType = {
  __typename?: 'MediafileValueType';
  autoTag: Scalars['Boolean'];
  user?: Maybe<UserExtendPureType>;
  value: ValueObjectPureType;
};

export type MediafilesQueryFilter = {
  companyId?: InputMaybe<Scalars['Int']>;
  contentblockId?: InputMaybe<Scalars['ID']>;
  mediafileIds?: InputMaybe<Array<Scalars['ID']>>;
  mediafileTypes?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  rightholders?: InputMaybe<Array<Scalars['ID']>>;
  streamId?: InputMaybe<Scalars['ID']>;
  valueIds?: InputMaybe<Array<Scalars['ID']>>;
  withEmptyCompany?: InputMaybe<Scalars['Boolean']>;
};

export type MediafilesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type MediafilesQueryPaginationType = {
  __typename?: 'MediafilesQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<MediafilePureType>>;
};

export enum MediafilesQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type MultiroomPureType = {
  __typename?: 'MultiroomPureType';
  devices: Array<PlayerDevicePureType>;
};

export type MusicBoxMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['Int']>;
  wifiPassword?: InputMaybe<Scalars['String']>;
  wifiPoint?: InputMaybe<Scalars['String']>;
};

export type MusicBoxReplaceMutation = {
  __typename?: 'MusicBoxReplaceMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type MusicBoxStatusType = {
  __typename?: 'MusicBoxStatusType';
  allInCurrentCount: Scalars['Int'];
  /** eth, wifi, both, down */
  connectionType?: Maybe<Scalars['String']>;
  currentVersion: Scalars['String'];
  device: Scalars['String'];
  endSleep?: Maybe<Scalars['Time']>;
  id?: Maybe<Scalars['Int']>;
  imageOnly: Scalars['Boolean'];
  /** Sleep status current stream on musicbox */
  isSleep?: Maybe<Scalars['Boolean']>;
  lastSendData?: Maybe<Scalars['DateTime']>;
  /** Availability of the device via the Internet */
  netState?: Maybe<Scalars['Boolean']>;
  serial?: Maybe<Scalars['String']>;
  sleepMode?: Maybe<Scalars['Boolean']>;
  startSleep?: Maybe<Scalars['Time']>;
  title: Scalars['String'];
  uploadCount: Scalars['Int'];
  volume: Scalars['Int'];
  wifi?: Maybe<Scalars['Boolean']>;
  wifiActiveSsid: Scalars['String'];
  wifiIdentity: Scalars['String'];
  /** Current setup wifi password */
  wifiPassword?: Maybe<Scalars['String']>;
  /** Current setup wifi ssid */
  wifiPoint?: Maybe<Scalars['String']>;
};

export type MusicBoxType = {
  __typename?: 'MusicBoxType';
  allInCurrentCount: Scalars['Int'];
  /** List wifi cells available at the moment */
  cells?: Maybe<Array<Maybe<CellType>>>;
  comment?: Maybe<Scalars['String']>;
  /** eth, wifi, both, down */
  connectionType?: Maybe<Scalars['String']>;
  /** Depricated (now connection_type) */
  currentConnect?: Maybe<Scalars['String']>;
  currentRotation?: Maybe<Scalars['Int']>;
  currentVersion: Scalars['String'];
  description: Scalars['String'];
  device: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  imageOnly: Scalars['Boolean'];
  /** Sleep status current stream on musicbox */
  isSleep?: Maybe<Scalars['Boolean']>;
  /** Info about last attempt wifi connection */
  lastConnectionAttempt?: Maybe<ConnectionType>;
  lastSendData?: Maybe<Scalars['DateTime']>;
  /** Availability of the device via the Internet */
  netState?: Maybe<Scalars['Boolean']>;
  online?: Maybe<Scalars['Boolean']>;
  /** @deprecated deprecated */
  onlineRotation?: Maybe<Scalars['Int']>;
  point?: Maybe<PointType>;
  serial?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uploadCount: Scalars['Int'];
  volume: Scalars['Int'];
  wifi?: Maybe<Scalars['Boolean']>;
  wifiActiveSsid: Scalars['String'];
  wifiCells?: Maybe<Scalars['JSONString']>;
  /** eth, wifi, both, down */
  wifiConnectionProcessStatus?: Maybe<Scalars['String']>;
  wifiIdentity?: Maybe<Scalars['String']>;
  /** Current setup wifi password */
  wifiPassword?: Maybe<Scalars['String']>;
  /** Current setup wifi ssid */
  wifiPoint?: Maybe<Scalars['String']>;
};

export type MusicBoxUpdateMutation = {
  __typename?: 'MusicBoxUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  id?: Maybe<Scalars['Int']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptanceAdvancedStartSigning?: Maybe<AcceptanceAdvancedStartSigningMutation>;
  adCampaignExcludeFromBrand?: Maybe<AdCampaignExcludeFromBrandMutation>;
  adCampaignIncludeToBrand?: Maybe<AdCampaignIncludeToBrandMutation>;
  adcampaignPureChangePromos?: Maybe<AdCampaignPureChangePromosMutation>;
  adcampaignPureCreate?: Maybe<AdCampaignPureCreateMutation>;
  adcampaignPureEnable?: Maybe<AdCampaignPureEnableMutation>;
  adcampaignPureRemove?: Maybe<AdCampaignPureRemoveMutation>;
  adcampaignPureUpdate?: Maybe<AdCampaignPureUpdateMutation>;
  adcampaignRename?: Maybe<AdCampaignRenameMutation>;
  adcampaignReportPureCreate?: Maybe<AdCampaignReportPureCreateMutation>;
  adcampaignSetCompanyTags?: Maybe<AdCampaignPureSetCompanyTagsMutation>;
  adcampaignSetPointsMutation?: Maybe<AdCampaignPureSetPointsMutation>;
  addDiscountToOrganization?: Maybe<AddDiscountToOrganizationMutation>;
  adminStartVideoDemoPeriod?: Maybe<AdminStartVideoDemoPeriodMutation>;
  amoLeadToCompanyUrl?: Maybe<AmoLeadToCompanyUrlMutation>;
  amoSyncData?: Maybe<AmoSyncDataMutation>;
  applyPrimeDiscountToCompany?: Maybe<ApplyPrimeDiscountToCompanyMutation>;
  archiveUploadMutation?: Maybe<ArchiveUploadMutation>;
  authorizationCodeCreate?: Maybe<AuthorizationCodeCreateMutation>;
  billingDisable?: Maybe<BillingDisableMutation>;
  billingEnable?: Maybe<BillingEnableMutation>;
  brandAdCampaignCreate?: Maybe<BrandAdCampaignCreateMutation>;
  brandAdCampaignMultiEnable?: Maybe<BrandAdCampaignMultiEnableMutation>;
  brandAdCampaignRemove?: Maybe<BrandAdCampaignRemoveMutation>;
  brandAdCampaignUpdate?: Maybe<BrandAdCampaignUpdateMutation>;
  brandAdCampaignsBindToPoints?: Maybe<BrandAdCampaignsBindToPointsMutation>;
  brandAddCompanies?: Maybe<BrandAddCompaniesMutation>;
  brandCreate?: Maybe<BrandCreateMutation>;
  brandPointsChangeSleepSettings?: Maybe<BrandPointsChangeSleepSettingsMutation>;
  brandPointsChangeStream?: Maybe<BrandPointsChangeStreamMutation>;
  brandPointsEnable?: Maybe<BrandPointsEnableMutation>;
  brandRemoveCompanies?: Maybe<BrandRemoveCompaniesMutation>;
  brandStreamCopyWithPoints?: Maybe<BrandStreamCopyWithPointsMutation>;
  brandUpdate?: Maybe<BrandUpdateMutation>;
  cancelDiscountForOrganization?: Maybe<CancelDiscountForOrganizationMutation>;
  certLetterForPointMutation?: Maybe<CertLetterForPointMutation>;
  companyAdCampaignsByDaysEarlyReport?: Maybe<CompanyAdCampaignsByDaysEarlyReportMutation>;
  companyAdCampaignsEarlyReport?: Maybe<CompanyAdCampaignsEarlyReportMutation>;
  companyAddOrChangeUser?: Maybe<CompanyChangeUserMutation>;
  companyCreateAmoTaskToBill?: Maybe<CompanyCreateAmoTaskToBillPureMutation>;
  companyCreateAudioDeviceRequest?: Maybe<CompanyCreateAudioDeviceRequestMutation>;
  companyCreateDeviceRequest?: Maybe<CompanyCreateDeviceRequestPureMutation>;
  companyCreateVideoDeviceRequest?: Maybe<CompanyCreateVideoDeviceRequestMutation>;
  companyDeactivate?: Maybe<CompanyDeactivateMutation>;
  companyFeaturesBulkUpdate?: Maybe<CompanyFeaturesBulkUpdateMutation>;
  companyPlaybackEarlyReport?: Maybe<CompanyPlaybackEarlyReportMutation>;
  companyPlaybackReportSettingsUpdate?: Maybe<CompanyPlaybackReportSettingsUpdateMutation>;
  companyRemoveCard?: Maybe<CompanyRemoveCardMutation>;
  companyRemoveUser?: Maybe<CompanyRemoveUserMutation>;
  companyReportRequestMutation?: Maybe<CompanyReportRequestMutation>;
  companySetPricePlan?: Maybe<CompanySetPricePlanMutation>;
  companySetPricePlanPeriod?: Maybe<CompanySetPricePlanPeriodMutation>;
  companySetShowSberIdButton?: Maybe<CompanySetShowSberIdButtonMutation>;
  companyThematicBlockPureUpdate?: Maybe<CompanyThematicBlockPureUpdateMutation>;
  companyTransferStreams?: Maybe<CompanyTransferStreamsMutation>;
  companyValidate?: Maybe<CompanyValidateMutation>;
  contentBlockMediaUpload?: Maybe<ContentBlockMediaUploadMutation>;
  contentBlockPureCopyAsTemplate?: Maybe<ContentBlockPureCopyAsTemplateMutation>;
  contractAcceptMigration?: Maybe<ContractAcceptMigrationMutation>;
  contractInitMigration?: Maybe<ContractInitMigrationMutation>;
  contractUpdatePaymentTerms?: Maybe<ContractUpdatePaymentTermsMutation>;
  createSlaveStream?: Maybe<CreateSlaveStreamPureMutation>;
  currentUserLogout?: Maybe<CurrentLogoutUser>;
  deviceBindToStream?: Maybe<DeviceBindToStreamMutation>;
  devicePlayingSendState?: Maybe<DevicePlayingSendStates>;
  devicePointDislikeMediafile?: Maybe<DevicePointDislikeMediafileMutation>;
  devicePureChangeWifiSettings?: Maybe<DevicePureChangeWifiSettingsMutation>;
  devicePureDeleteStream?: Maybe<DevicePureDeleteStreamMutation>;
  devicePureDislikeStreamMediafile?: Maybe<DeviceDislikeStreamMediafilePureMutation>;
  devicePureImportHistory?: Maybe<DevicePureImportHistoryMutation>;
  devicePureLikeStreamMediafile?: Maybe<DeviceLikeStreamMediafilePureMutation>;
  /** @deprecated deprecated */
  devicePureRecalcMediafileCrc?: Maybe<DeviceRecalcMediafileCrcHashMutation>;
  devicePureReplaceDesktopbox?: Maybe<DevicePureReplaceDesktopboxMutation>;
  devicePureReportPlaystate?: Maybe<DevicePureReportPlayStateMutation>;
  devicePureRestoreDislikedMediafile?: Maybe<DeviceRestoreDislikedMediafilePureMutation>;
  devicePureRestoreLikedMediafile?: Maybe<DeviceRestoreLikedMediafilePureMutation>;
  devicePureSetDebugMode?: Maybe<DevicePureSetDebugModeMutation>;
  devicePureSetHardware?: Maybe<DevicePureSetHardwareMutation>;
  devicePureSetLogLevel?: Maybe<DevicePureSetLogLevelMutation>;
  devicePureStartSavedStream?: Maybe<DevicePureStartSavedStreamMutation>;
  devicePureStartTemplateStream?: Maybe<DevicePureStartTemplateStreamMutation>;
  devicePureStreamUpdate?: Maybe<DeviceStreamPureUpdateMutation>;
  deviceSetAdditionalFeatures?: Maybe<DeviceSetAdditionalFeatures>;
  deviceToggleDebugMode?: Maybe<DeviceToggleDebugMode>;
  /** Mutation used by web player only to handle updates */
  deviceUpdatePlayerVersion?: Maybe<DeviceUpdatePlayerVersionMutation>;
  /** Mutation used by web player 3 to handle updates. */
  deviceUpdateWebPlayer3Version?: Maybe<DeviceUpdateWebPlayer3VersionMutation>;
  deviceUpdateWifiSettings?: Maybe<WifiSettingsUpdateMutation>;
  devicesGroupCreate?: Maybe<DevicesGroupCreateMutation>;
  devicesGroupDelete?: Maybe<DevicesGroupDeleteMutation>;
  devicesGroupUpdate?: Maybe<DevicesGroupUpdateMutation>;
  e2eCreateDevice?: Maybe<E2ECreateDevice>;
  e2eRemoveUser?: Maybe<E2ERemoveUserByEmailMutation>;
  e2eRemoveUserByPhone?: Maybe<E2ERemoveUserByPhoneMutation>;
  e2eUserSetGroups?: Maybe<E2EUserSetGroupsMutation>;
  emenuCreateMutation?: Maybe<EmenuCreateMutation>;
  emenuDeleteMutation?: Maybe<EmenuDeleteMutation>;
  emenuPointClientIdCreate?: Maybe<EmenuPointClientIdCreateMutation>;
  emenuPointClientIdDelete?: Maybe<EmenuPointClientIdDeleteMutation>;
  emenuPointClientIdUpdate?: Maybe<EmenuPointClientIdUpdateMutation>;
  emenuUpdateMutation?: Maybe<EmenuUpdateMutation>;
  extendSubscription?: Maybe<ExtendSubscriptionMutation>;
  extendSubscriptionRequest?: Maybe<ExtendSubscriptionRequestMutation>;
  extendTrialPeriod?: Maybe<ExtendTrialPeriodMutation>;
  extendVideoDemoPeriod?: Maybe<ExtendVideoDemoPeriodMutation>;
  finishTrialPeriod?: Maybe<FinishTrialPeriodMutation>;
  generateApiTokenCreateMutation?: Maybe<GenerateApiTokenCreateMutation>;
  invitationAccept?: Maybe<UserInvitationAcceptMutation>;
  invitationCreate?: Maybe<UserInvitationCreateMutation>;
  invitationDeactivate?: Maybe<UserInvitationDeactivateMutation>;
  invitationSend?: Maybe<UserInvitationSendMutation>;
  invoicesReportRequest?: Maybe<InvoicesReportRequestMutation>;
  jwtTokenAuthWithCode?: Maybe<JwtTokenAuthWithCodePureMutation>;
  launchSubscription?: Maybe<LaunchSubscriptionMutation>;
  launchSubscriptionWithConfirm?: Maybe<LaunchSubscriptionWithConfirmMutation>;
  licensesResumeAutoRenewal?: Maybe<LicensesResumeAutoRenewalMutation>;
  licensesSuspendAutoRenewal?: Maybe<LicensesSuspendAutoRenewalMutation>;
  markAcceptanceErrorAsViewed?: Maybe<MarkAcceptanceErrorAsViewedMutation>;
  mediafilePureUpdate?: Maybe<MediafilePureUpdateMutation>;
  mediafilePureUpload?: Maybe<MediafileUploadPureMutation>;
  mediafileReport?: Maybe<MediafileReportMutation>;
  mmDisableSyncForBlockPure?: Maybe<MmDisableSyncForBlockMutation>;
  mmForceSyncBlockPure?: Maybe<MmForceSyncBlockMutation>;
  mmSyncOnForBlockPure?: Maybe<MmSyncModeOnForBlockMutation>;
  musicboxClear?: Maybe<ClearMusicBoxMutation>;
  musicboxReplace?: Maybe<MusicBoxReplaceMutation>;
  musicboxUpdate?: Maybe<MusicBoxUpdateMutation>;
  passwordPureSetNew?: Maybe<PasswordPureSetNewMutation>;
  passwordRestore?: Maybe<PasswordResetMutationPayload>;
  passwordRestoreConfirmation?: Maybe<PasswordResetConfirmationMutationPayload>;
  playInstantAdcampaign?: Maybe<PlayInstantAdcampaignMutation>;
  playerImportVersion?: Maybe<PlayerVersionImportMutation>;
  playerPureSetRequiredVersion?: Maybe<DevicePureSetRequiredVersionMutation>;
  /** @TODO: Deprecated in favor of pure mutation version */
  playerSetRequiredVersion?: Maybe<PlayerSetRequiredVersionMutation>;
  pointBindVideoStream?: Maybe<PointBindVideoStreamMutation>;
  pointClearVideoDemo?: Maybe<PointClearVideoDemoMutation>;
  pointDislikeMediafile?: Maybe<PointDislikeMediafileMutation>;
  pointPlaybackReportCreateMutation?: Maybe<PointPlaybackAudioReportCreateMutation>;
  pointPlaybackVideoReportCreateMutation?: Maybe<PointPlaybackVideoReportCreateMutation>;
  pointPureBindDevice?: Maybe<PointPureBindDeviceMutation>;
  pointPureChangeState?: Maybe<PointPureChangeStateMutation>;
  pointPureChangeStream?: Maybe<PointPureChangeStreamMutation>;
  pointPureCreate?: Maybe<PointPureCreateMutation>;
  pointPureMoveSettings?: Maybe<PointPureMoveSettingsMutation>;
  pointPureRegenerateStream?: Maybe<PointPureRegenerateStreamMutation>;
  pointPureRemove?: Maybe<PointPureRemoveMutation>;
  pointPureSetAdcampaigns?: Maybe<PointPureSetAdCampaignsMutation>;
  pointPureSetCacheMode?: Maybe<PointPureSetCacheModeMutation>;
  pointPureSetCompanyTags?: Maybe<PointPureSetCompanyTagsMutation>;
  pointPureSetPeriodicRestart?: Maybe<PointPureSetPeriodicRestartMutation>;
  pointPureSetSpeedLimits?: Maybe<PointPureSpeedLimitsMutation>;
  pointPureSleepSettings?: Maybe<PointPureSleepSettingsMutation>;
  pointPureSwitchDevice?: Maybe<PointSwitchDeviceMutation>;
  pointPureUnbindDevice?: Maybe<PointPureUnbindDeviceMutation>;
  pointPureUnbindStream?: Maybe<PointPureUnbindStreamMutation>;
  pointPureUpdate?: Maybe<PointPureUpdateMutation>;
  /** TODO: change input for Pure-like type. This Mutation input style is deprecated. */
  pointSetDeviceLogLevel?: Maybe<PointDeviceSetLogLevel>;
  pointUnbindVideoStream?: Maybe<PointUnbindVideoStreamMutation>;
  pointWebUpdateStatus?: Maybe<PointWebUpdateStatusMutation>;
  pointsBindCompanyTags?: Maybe<PointsBindCompanyTagsMutation>;
  pointsBulkEnable?: Maybe<PointsBulkEnableMutation>;
  pointsCreate?: Maybe<PointsCreateMutation>;
  pointsUnsetCompanyTags?: Maybe<PointsUnsetCompanyTagsMutation>;
  promoPureUpload?: Maybe<PromoUploadPureMutation>;
  promoRollSynthCreate?: Maybe<PromoRollSynthCreateMutation>;
  promoRollSynthDelete?: Maybe<PromoRollSynthDeleteMutation>;
  promoSelectionDraft?: Maybe<PromoSelectionDraftMutation>;
  resumeTrialPeriod?: Maybe<ResumeTrialPeriodMutation>;
  revokeApiTokenMutation?: Maybe<RevokeApiTokenMutation>;
  rightholderCreate?: Maybe<RightholderCreateMutation>;
  rightholderPlaybackReport?: Maybe<RightholderPlaybackReportMutation>;
  rightholderPlaybackReportByPoints?: Maybe<RightholderPlaybackReportByPointsMutation>;
  rightholderUpdate?: Maybe<RightholderUpdateMutation>;
  saveBrandsSearchResult?: Maybe<SaveBrandsSearchResultMutation>;
  saveCompaniesSearchResult?: Maybe<SaveCompaniesSearchResultMutation>;
  sberMultiroomAddDeviceMutation?: Maybe<SberMultiroomAddDeviceMutation>;
  sberMultiroomRemoveDeviceMutation?: Maybe<SberMultiroomRemoveDeviceMutation>;
  sendEmailPureRepeat?: Maybe<SendEmailPureRepeatMutation>;
  setDeviceState?: Maybe<SetDeviceStateMutation>;
  smartlkCompanyPlaybackReportSettingsUpdate?: Maybe<SmartlkCompanyPlaybackReportSettingsUpdateMutation>;
  smartlkDevicesGroupCreate?: Maybe<SmartlkDevicesGroupCreateMutation>;
  smartlkDevicesGroupDelete?: Maybe<SmartlkDevicesGroupDeleteMutation>;
  smartlkDevicesGroupUpdate?: Maybe<SmartlkDevicesGroupUpdateMutation>;
  smartlkPointCreate?: Maybe<SmartlkPointCreateMutation>;
  smartlkPointUnbindStream?: Maybe<SmartlkPointUnbindStreamMutation>;
  smartlkPointsBindVideoStream?: Maybe<SmartLkPointsBindVideoStreamMutation>;
  smartlkStartVideoDemoPeriod?: Maybe<SmartLkStartVideoDemoPeriodMutation>;
  smartlkVideoOrImageMediafileUpload?: Maybe<SmartlkVideoOrImageMediafileUploadMutation>;
  smartlkVideoStreamCopyFromTemplate?: Maybe<SmartlkVideoStreamCopyFromTemplateMutation>;
  smartlkVideoStreamCreate?: Maybe<SmartlkVideoStreamCreateMutation>;
  smartlkVideoStreamDelete?: Maybe<SmartlkVideoStreamDeleteMutation>;
  smartlkVideoStreamPureSetCompanyTags?: Maybe<SmartLkVideoStreamPureSetCompanyTagsMutation>;
  smartlkVideoStreamUpdate?: Maybe<SmartlkVideoStreamUpdateMutation>;
  speakerCreateAndSetPoint?: Maybe<SmartSpeakerCreateAndSetPoint>;
  speakerDislikeMediafile?: Maybe<SmartSpeakerDislikeMediafileMutation>;
  speakerImportHistory?: Maybe<SmartSpeakerImportHistoryMutation>;
  speakerSetDefaultStream?: Maybe<SmartSpeakerSetDefaultStream>;
  speakerSetStreamByBusinessSphere?: Maybe<SmartSpeakerSetStreamBusinessSphere>;
  speakerSetStreamByGenre?: Maybe<SmartSpeakerSetStreamByGenre>;
  startLinkCard?: Maybe<StartLinkCardMutation>;
  stoppedListeningReportRequest?: Maybe<RequestStoppedListeningReportPureMutation>;
  streamCreateCopyAndSetToPoints?: Maybe<CreateStreamCopyAndSetToPointsMutation>;
  streamDraftBlockCopyAsTemplate?: Maybe<StreamDraftBlockCopyAsTemplateMutation>;
  streamDraftCancel?: Maybe<StreamDraftCancelPureMutation>;
  streamDraftClear?: Maybe<StreamDraftClearPureMutation>;
  streamDraftCreate?: Maybe<StreamDraftCreatePureMutation>;
  streamDraftCreateBlock?: Maybe<StreamDraftCreateBlockPureMutation>;
  streamDraftDeleteBlock?: Maybe<StreamDraftDeleteBlockPureMutation>;
  streamDraftDemoStartGeneration?: Maybe<StreamDraftDemoStartGenerationMutation>;
  streamDraftDuplicateBlock?: Maybe<StreamDraftDuplicateBlockPureMutation>;
  streamDraftSave?: Maybe<StreamDraftSavePureMutation>;
  streamDraftSetConception?: Maybe<StreamDraftSetConceptionMutation>;
  streamDraftUpdate?: Maybe<StreamDraftUpdatePureMutation>;
  streamDraftUpdateBlock?: Maybe<StreamDraftUpdateBlockPureMutation>;
  streamDraftUpdateTracks?: Maybe<StreamDraftUpdateTracksPureMutation>;
  streamExcludeFromReplication?: Maybe<ExculdeStreamFromReplicationPureMutation>;
  streamLibraryDelete?: Maybe<LibraryDeleteMutation>;
  streamLibraryDraftAddStreams?: Maybe<LibraryDraftAddStreamsMutation>;
  streamLibraryDraftCancel?: Maybe<LibraryDraftCancelMutation>;
  streamLibraryDraftChangeCollectionOrder?: Maybe<LibraryDraftChangeCollectionOrderMutation>;
  streamLibraryDraftChangeGroupOrder?: Maybe<LibraryDraftChangeGroupOrderMutation>;
  streamLibraryDraftChangeOrder?: Maybe<LibraryDraftChangeOrderMutation>;
  streamLibraryDraftChangePosterCollection?: Maybe<LibraryDraftChangePosterCollectionMutation>;
  streamLibraryDraftChangeSubcollectionOrder?: Maybe<LibraryDraftChangeSubCollectionOrderMutation>;
  streamLibraryDraftCopySubcollection?: Maybe<LibraryDraftCopySubCollectionMutation>;
  streamLibraryDraftCreateCollection?: Maybe<LibraryDraftCreateCollectionPureMutation>;
  streamLibraryDraftCreateGroup?: Maybe<LibraryDraftCreateGroupPureMutation>;
  streamLibraryDraftCreateSubcollection?: Maybe<LibraryDraftCreateSubCollectionMutation>;
  streamLibraryDraftDiscommendSubcollections?: Maybe<LibraryDraftDiscommendSubCollectionsMutation>;
  streamLibraryDraftPublish?: Maybe<LibraryDraftPublishPureMutation>;
  streamLibraryDraftRecommendSubcollections?: Maybe<LibraryDraftRecommendSubCollectionsMutation>;
  streamLibraryDraftRecommendationsChangeOrder?: Maybe<LibraryDraftRecommendationsChangeOrderMutation>;
  streamLibraryDraftRemoveCollection?: Maybe<LibraryDraftRemoveCollectionMutation>;
  streamLibraryDraftRemoveGroup?: Maybe<LibraryDraftRemoveGroupMutation>;
  streamLibraryDraftRemoveStreams?: Maybe<LibraryDraftRemoveStreamsMutation>;
  streamLibraryDraftRemoveSubcollection?: Maybe<LibraryDraftRemoveSubCollectionMutation>;
  streamLibraryDraftRename?: Maybe<LibraryDraftRenameMutation>;
  streamLibraryDraftRenameCollection?: Maybe<LibraryDraftRenameCollectionMutation>;
  streamLibraryDraftRenameGroup?: Maybe<LibraryDraftRenameGroupMutation>;
  streamLibraryDraftUpdateSubcollection?: Maybe<LibraryDraftUpdateSubCollectionMutation>;
  streamLibraryStartCreate?: Maybe<LibraryStrartCreatePureMutation>;
  streamLibraryStartEdit?: Maybe<LibraryStrartEditPureMutation>;
  streamLibraryUpdate?: Maybe<LibraryUpdateMutation>;
  streamLikeMediafile?: Maybe<StreamLikeMediafileMutation>;
  streamLogPureRestore?: Maybe<StreamLogPureRestoreMutation>;
  streamMasterRollout?: Maybe<RolloutMasterStreamPureMutation>;
  streamPureAutoUpdateTracksNow?: Maybe<StreamAutoUpdateTracksNowPureMutation>;
  streamPureChangeAutoUpdate?: Maybe<StreamChangeAutoUpdateTracksMutation>;
  streamPureCopy?: Maybe<StreamPureCopy>;
  streamPureCopyFromTemplate?: Maybe<StreamPureCopyFromTemplateMutation>;
  streamPureCreate?: Maybe<StreamPureCreate>;
  streamPureDislikeMediafile?: Maybe<StreamPureDislikeMediafileMutation>;
  streamPureDislikeMediafileRestore?: Maybe<StreamPureDislikeMediafileRestoreMutation>;
  streamPureListOfMediafiles?: Maybe<StreamPureListOfMediafilesMutation>;
  streamPureRemove?: Maybe<StreamPureRemoveMutation>;
  streamPureRestore?: Maybe<StreamPureRestoreMutation>;
  streamPureSetToCompanyPoints?: Maybe<StreamPureSetToCompanyPointsMutation>;
  streamPureSetToPoints?: Maybe<StreamPureSetToPointsMutation>;
  streamPureUpdate?: Maybe<StreamPureUpdateMutation>;
  streamPureUploadCover?: Maybe<StreamPureUploadCoverMutation>;
  streamTaskPureCreate?: Maybe<StreamTaskPureCreateMutation>;
  streamTaskPureCreateComment?: Maybe<StreamTaskPureCreateCommentMutation>;
  streamTaskPureRefuse?: Maybe<StreamTaskPureRefuseMutation>;
  streamTaskPureRemove?: Maybe<StreamTaskPureRemoveMutation>;
  streamTaskPureReopen?: Maybe<StreamTaskPureReopenMutation>;
  streamTaskPureSetReady?: Maybe<StreamTaskPureSetReadyMutation>;
  streamTaskPureSetRedactor?: Maybe<StreamTaskPureSetRedactorMutation>;
  streamTaskPureTake?: Maybe<StreamTaskPureTakeMutation>;
  streamTaskPureUpdate?: Maybe<StreamTaskPureUpdateMutation>;
  streamTaskSetCategory?: Maybe<StreamTaskSetCategoryMutation>;
  streamTaskSetComplexity?: Maybe<StreamTaskSetComplexityMutation>;
  streamUnLikeMediafile?: Maybe<StreamUnLikeMediafileMutation>;
  templateAddToLibrary?: Maybe<TemplateAddToLibraryMutation>;
  templateRemoveFromLibrary?: Maybe<TemplateRemoveFromLibraryMutation>;
  templateSetBusinessSphere?: Maybe<TemplateSetBusinessSphereMutation>;
  templateSetSearchTags?: Maybe<TemplateSetSearchTagsMutation>;
  testAcceptanceAdvancedToCanceled?: Maybe<TestAcceptanceAdvanceToCanceledMutation>;
  testChangeSberUserSubId?: Maybe<TestChangeSberUserSubIdMutation>;
  testChangeSelectedPaymentKind?: Maybe<TestChangeSelectedPaymentKindMutation>;
  testClearVideoDemoPeriod?: Maybe<TestClearVideoDemoPeriodMutation>;
  testExpiredTrials?: Maybe<TestExpiredTrialsMutation>;
  testExpiredVideoDemoPeriods?: Maybe<TestExpiredVideoDemoPeriodsMutation>;
  testMoveSubscription?: Maybe<TestMoveSubscriptionMutation>;
  testMoveVideoDemoPeriod?: Maybe<TestMoveVideoDemoPeriodMutation>;
  testPay?: Maybe<TestPayMutation>;
  testSbbolPaymentRequestToSuccess?: Maybe<TestSbbolPaymentRequestToSuccessMutation>;
  testSendNotifications?: Maybe<TestSendNotificationsMutation>;
  testSetInvoiceCalendarMonthlyCutoffDay?: Maybe<TestSetInvoiceCalendarMonthlyCutoffDayMutation>;
  thematicBlockPureRemoveFromCompany?: Maybe<ThematicBlockPureRemoveFromCompanyMutation>;
  thematicBlockPureSetToCompany?: Maybe<ThematicBlockPureSetToCompanyMutation>;
  tokenPureAuth?: Maybe<ObtainPureJsonWebToken>;
  tokenPureRefresh?: Maybe<TokenPureRefresh>;
  tokenPureRetrieveAuth?: Maybe<RetrievePureJsonWebToken>;
  tokenPureRevoke?: Maybe<TokenPureRevoke>;
  tokenPureVerify?: Maybe<TokenPureVerify>;
  tokenRetrieveAuth?: Maybe<RetrieveJsonWebToken>;
  tracksPureRemove?: Maybe<TracksRemovePureMutation>;
  updateRequestPureCancel?: Maybe<UpdateRequestPureCancelMutation>;
  updateRequestPureCreateByDeviceList?: Maybe<UpdateRequestPureCreateByDeviceListMutation>;
  updateRequestPureRunManualCheck?: Maybe<UpdateRequestPureRunManualCheckMutation>;
  userCompanyCreate?: Maybe<UserCompanyCreateMutation>;
  userCompanyUpdate?: Maybe<UserCompanyUpdateMutation>;
  userEmailUpdate?: Maybe<UserEmailUpdateMutation>;
  userFeaturesOnboardingPass?: Maybe<UserFeaturesOnboardingPassMutation>;
  userMarkAsTest?: Maybe<UserPureMarkAsTestMutation>;
  userPhoneUpdate?: Maybe<UserPhoneUpdateMutation>;
  userPureChangeSmartLkAccess?: Maybe<UserPureChangeSmartLkAccessMutation>;
  userPureManualEmailVerified?: Maybe<UserPureManualEmailVerifiedMutation>;
  userPureSignUp?: Maybe<UserPureSignUpMutation>;
  userPureSignUpByPhone?: Maybe<UserPureSignUpByPhoneMutation>;
  userPureSignUpYclients?: Maybe<UserPureSignUpYClientsMutation>;
  userPureUpdate?: Maybe<UserPureUpdateMutation>;
  utmMarksSendToAmoLead?: Maybe<UtmMarksSendToAmoLeadMutation>;
  videoStreamCreate?: Maybe<VideoStreamCreateMutation>;
  videoStreamDelete?: Maybe<VideoStreamDeleteMutation>;
  videoStreamUpdate?: Maybe<VideoStreamUpdateMutation>;
  videoStreamUpdateCompany?: Maybe<VideoStreamUpdateCompanyMutation>;
  videoTypeMediafilesDelete?: Maybe<VideoTypeMediafilesDeleteMutation>;
  videoUpload?: Maybe<VideoUploadMutation>;
  viewNotification?: Maybe<ViewNotificationMutation>;
  zvukPlaylistAdminRestore?: Maybe<ZvukPlaylistAdminRestoreMutation>;
  zvukPlaylistCreateFromStream?: Maybe<ZvukPlaylistCreateFromStreamMutation>;
  zvukPlaylistCreateFromZvuk?: Maybe<ZvukPlaylistCreateFromZvukMutation>;
  zvukPlaylistHide?: Maybe<ZvukPlaylistHideMutation>;
  zvukPlaylistInfo?: Maybe<ZvukPlaylistInfoMutation>;
  zvukPlaylistPublish?: Maybe<ZvukPlaylistPublishMutation>;
  zvukPlaylistRemove?: Maybe<ZvukPlaylistRemoveMutation>;
  zvukPlaylistUpdate?: Maybe<ZvukPlaylistUpdateMutation>;
  zvukProfileAdminPublish?: Maybe<ZvukProfileAdminPublishMutation>;
  zvukProfileAdminRestore?: Maybe<ZvukProfileAdminRestoreMutation>;
  zvukProfileCreate?: Maybe<ZvukProfileCreateMutation>;
  zvukProfileHide?: Maybe<ZvukProfileHideMutation>;
  zvukProfilePublish?: Maybe<ZvukProfilePublishMutation>;
  zvukProfileRemove?: Maybe<ZvukProfileRemoveMutation>;
  zvukProfileUpdate?: Maybe<ZvukProfileUpdateMutation>;
};


export type MutationAcceptanceAdvancedStartSigningArgs = {
  input: AcceptanceAdvancedStartSigningInput;
};


export type MutationAdCampaignExcludeFromBrandArgs = {
  input: AdCampaignExcludeFromBrandMutationInput;
};


export type MutationAdCampaignIncludeToBrandArgs = {
  input: AdCampaignIncludeToBrandMutationInput;
};


export type MutationAdcampaignPureChangePromosArgs = {
  input: AdCampaignPureChangePromosMutationInput;
};


export type MutationAdcampaignPureCreateArgs = {
  input: AdCampaignPureCreateMutationInput;
};


export type MutationAdcampaignPureEnableArgs = {
  input: AdCampaignPureEnableMutationInput;
};


export type MutationAdcampaignPureRemoveArgs = {
  input: AdCampaignPureRemoveMutationInput;
};


export type MutationAdcampaignPureUpdateArgs = {
  input: AdCampaignPureUpdateMutationInput;
};


export type MutationAdcampaignRenameArgs = {
  input: AdCampaignRenameMutationInput;
};


export type MutationAdcampaignReportPureCreateArgs = {
  input: AdCampaignReportPureMutationInput;
};


export type MutationAdcampaignSetCompanyTagsArgs = {
  input: AdCampaignPureSetCompanyTagsMutationInput;
};


export type MutationAdcampaignSetPointsMutationArgs = {
  input: AdCampaignPureSetPointsMutationInput;
};


export type MutationAddDiscountToOrganizationArgs = {
  input: AddDiscountToOrganizationMutationInput;
};


export type MutationAdminStartVideoDemoPeriodArgs = {
  input: AdminStartVideoDemoPeriodMutationInput;
};


export type MutationAmoLeadToCompanyUrlArgs = {
  input: AmoLeadToCompanyUrlInput;
};


export type MutationAmoSyncDataArgs = {
  input: AmoSyncDataMutationInput;
};


export type MutationApplyPrimeDiscountToCompanyArgs = {
  input: ApplyPrimeDiscountToCompanyMutationInput;
};


export type MutationArchiveUploadMutationArgs = {
  input: ArchiveUploadMutationInput;
};


export type MutationAuthorizationCodeCreateArgs = {
  input: AuthorizationCodeCreateMutationInput;
};


export type MutationBillingDisableArgs = {
  input: BillingDisableMutationInput;
};


export type MutationBillingEnableArgs = {
  input: BillingEnableMutationInput;
};


export type MutationBrandAdCampaignCreateArgs = {
  input: BrandAdCampaignCreateMutationInput;
};


export type MutationBrandAdCampaignMultiEnableArgs = {
  input: BrandAdCampaignMultiEnableMutationInput;
};


export type MutationBrandAdCampaignRemoveArgs = {
  input: BrandAdCampaignRemoveMutationInput;
};


export type MutationBrandAdCampaignUpdateArgs = {
  input: BrandAdCampaignUpdateMutationInput;
};


export type MutationBrandAdCampaignsBindToPointsArgs = {
  input: BrandAdCampaignsBindToPointsMutationInput;
};


export type MutationBrandAddCompaniesArgs = {
  input: BrandAddCompaniesMutationInput;
};


export type MutationBrandCreateArgs = {
  input: BrandCreateMutationInput;
};


export type MutationBrandPointsChangeSleepSettingsArgs = {
  input: BrandPointsChangeSleepSettingsMutationInput;
};


export type MutationBrandPointsChangeStreamArgs = {
  input: BrandPointsChangeStreamMutationInput;
};


export type MutationBrandPointsEnableArgs = {
  input: BrandPointsEnableMutationInput;
};


export type MutationBrandRemoveCompaniesArgs = {
  input: BrandRemoveCompaniesMutationInput;
};


export type MutationBrandStreamCopyWithPointsArgs = {
  input: BrandStreamCopyWithPointsInput;
};


export type MutationBrandUpdateArgs = {
  input: BrandUpdateMutationInput;
};


export type MutationCancelDiscountForOrganizationArgs = {
  input: CancelDiscountForOrganizationMutationInput;
};


export type MutationCertLetterForPointMutationArgs = {
  input: CertLetterForPointMutationInput;
};


export type MutationCompanyAdCampaignsByDaysEarlyReportArgs = {
  input: CompanyAdCampaignsByDaysEarlyReportInput;
};


export type MutationCompanyAdCampaignsEarlyReportArgs = {
  input: CompanyAdCampaignsEarlyReportInput;
};


export type MutationCompanyAddOrChangeUserArgs = {
  input: CompanyChangeUserMutationInput;
};


export type MutationCompanyCreateAmoTaskToBillArgs = {
  input: CompanyCreateAmoTaskToBillPureMutationInput;
};


export type MutationCompanyCreateAudioDeviceRequestArgs = {
  input: CompanyCreateDeviceRequestPureMutationInput;
};


export type MutationCompanyCreateDeviceRequestArgs = {
  input: CompanyCreateDeviceRequestPureMutationInput;
};


export type MutationCompanyCreateVideoDeviceRequestArgs = {
  input: CompanyCreateDeviceRequestPureMutationInput;
};


export type MutationCompanyDeactivateArgs = {
  input: CompanyDeactivateMutationInput;
};


export type MutationCompanyFeaturesBulkUpdateArgs = {
  input: CompanyFeaturesBulkUpdateMutationInput;
};


export type MutationCompanyPlaybackEarlyReportArgs = {
  input: CompanyPlaybackEarlyReportMutationInput;
};


export type MutationCompanyPlaybackReportSettingsUpdateArgs = {
  input: CompanyPlaybackReportSettingsUpdateMutationInput;
};


export type MutationCompanyRemoveCardArgs = {
  input: CompanyRemoveCardMutationInput;
};


export type MutationCompanyRemoveUserArgs = {
  input: CompanyRemoveUserMutationInput;
};


export type MutationCompanyReportRequestMutationArgs = {
  input: CompanyReportRequestMutationInput;
};


export type MutationCompanySetPricePlanArgs = {
  input: CompanySetPricePlanMutationInput;
};


export type MutationCompanySetPricePlanPeriodArgs = {
  input: CompanySetPricePlanPeriodMutationInput;
};


export type MutationCompanySetShowSberIdButtonArgs = {
  input: CompanySetShowSberIdButtonMutationInput;
};


export type MutationCompanyThematicBlockPureUpdateArgs = {
  input: CompanyThematicBlockPureUpdateMutationInput;
};


export type MutationCompanyTransferStreamsArgs = {
  input: CompanyTransferStreamsMutationInput;
};


export type MutationCompanyValidateArgs = {
  input: CompanyValidateMutationInput;
};


export type MutationContentBlockMediaUploadArgs = {
  input: ContentBlockMediaUploadMutationInput;
};


export type MutationContentBlockPureCopyAsTemplateArgs = {
  input: ContentBlockPureCopyAsTemplateMutationInput;
};


export type MutationContractAcceptMigrationArgs = {
  input: ContractAcceptMigrationMutationInput;
};


export type MutationContractInitMigrationArgs = {
  input: ContractInitMigrationMutationInput;
};


export type MutationContractUpdatePaymentTermsArgs = {
  input: ContractUpdatePaymentTermsMutationInput;
};


export type MutationCreateSlaveStreamArgs = {
  input: CreateSlaveStreamPureMutationInput;
};


export type MutationDeviceBindToStreamArgs = {
  streamId: Scalars['Int'];
};


export type MutationDevicePlayingSendStateArgs = {
  lineOutPlugIn?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationDevicePointDislikeMediafileArgs = {
  mediafileId?: InputMaybe<Scalars['Int']>;
};


export type MutationDevicePureChangeWifiSettingsArgs = {
  input: DevicePureChangeWifiSettingsMutationInput;
};


export type MutationDevicePureDeleteStreamArgs = {
  input: DevicePureDeleteStreamMutationInput;
};


export type MutationDevicePureDislikeStreamMediafileArgs = {
  input: DeviceDislikeStreamMediafilePureMutationInput;
};


export type MutationDevicePureImportHistoryArgs = {
  input: DevicePureHistoryImportInput;
};


export type MutationDevicePureLikeStreamMediafileArgs = {
  input: DeviceLikeStreamMediafilePureMutationInput;
};


export type MutationDevicePureRecalcMediafileCrcArgs = {
  mediafileId: Scalars['ID'];
};


export type MutationDevicePureReplaceDesktopboxArgs = {
  input: DevicePureReplaceDesktopboxMutationInput;
};


export type MutationDevicePureReportPlaystateArgs = {
  input: DevicePureReportPlayStateInput;
};


export type MutationDevicePureRestoreDislikedMediafileArgs = {
  input: DeviceRestoreDislikedMediafilePureMutationInput;
};


export type MutationDevicePureRestoreLikedMediafileArgs = {
  input: DeviceRestoreLikedMediafilePureMutationInput;
};


export type MutationDevicePureSetDebugModeArgs = {
  input: DevicePureSetDebugModeMutationInput;
};


export type MutationDevicePureSetHardwareArgs = {
  input: DevicePureSetHardwareMutationInput;
};


export type MutationDevicePureSetLogLevelArgs = {
  input: DevicePureSetLogLevelInput;
};


export type MutationDevicePureStartSavedStreamArgs = {
  input: DevicePureStartSavedStreamMutationInput;
};


export type MutationDevicePureStartTemplateStreamArgs = {
  input: DevicePureStartTemplateStreamMutationInput;
};


export type MutationDevicePureStreamUpdateArgs = {
  input: DeviceStreamPureUpdateMutationInput;
};


export type MutationDeviceSetAdditionalFeaturesArgs = {
  additionalFeatures: Array<Scalars['String']>;
  deviceId: Scalars['Int'];
};


export type MutationDeviceToggleDebugModeArgs = {
  deviceId: Scalars['ID'];
};


export type MutationDeviceUpdatePlayerVersionArgs = {
  currentVersion?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<Scalars['String']>;
};


export type MutationDeviceUpdateWebPlayer3VersionArgs = {
  bindingCode: Scalars['String'];
  currentVersion?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<Scalars['String']>;
};


export type MutationDeviceUpdateWifiSettingsArgs = {
  input: ChangeWifiSettingsMutationInput;
};


export type MutationDevicesGroupCreateArgs = {
  input: DevicesGroupCreateMutationInput;
};


export type MutationDevicesGroupDeleteArgs = {
  input: DevicesGroupDeleteMutationInput;
};


export type MutationDevicesGroupUpdateArgs = {
  input: DevicesGroupUpdateMutationInput;
};


export type MutationE2eCreateDeviceArgs = {
  deviceType: Scalars['String'];
  email: Scalars['String'];
  token: Scalars['String'];
};


export type MutationE2eRemoveUserArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};


export type MutationE2eRemoveUserByPhoneArgs = {
  phone: Scalars['String'];
  token: Scalars['String'];
};


export type MutationE2eUserSetGroupsArgs = {
  email: Scalars['String'];
  groupIds: Array<Scalars['ID']>;
  token: Scalars['String'];
};


export type MutationEmenuCreateMutationArgs = {
  input: EmenuCreateMutationInput;
};


export type MutationEmenuDeleteMutationArgs = {
  input: EmenuDeleteMutationInput;
};


export type MutationEmenuPointClientIdCreateArgs = {
  input: EmenuPointClientIdCreateMutationInput;
};


export type MutationEmenuPointClientIdDeleteArgs = {
  input: EmenuPointClientIdDeleteMutationInput;
};


export type MutationEmenuPointClientIdUpdateArgs = {
  input: EmenuPointClientIdUpdateMutationInput;
};


export type MutationEmenuUpdateMutationArgs = {
  input: EmenuUpdateMutationInput;
};


export type MutationExtendSubscriptionArgs = {
  input: ExtendSubscriptionMutationInput;
};


export type MutationExtendSubscriptionRequestArgs = {
  input: ExtendSubscriptionRequestMutationInput;
};


export type MutationExtendTrialPeriodArgs = {
  input: ExtendTrialPeriodMutationInput;
};


export type MutationExtendVideoDemoPeriodArgs = {
  input: ExtendVideoDemoPeriodMutationInput;
};


export type MutationFinishTrialPeriodArgs = {
  input: FinishTrialPeriodMutationInput;
};


export type MutationGenerateApiTokenCreateMutationArgs = {
  input: GenerateApiTokenCreateMutationInput;
};


export type MutationInvitationAcceptArgs = {
  input: UserInvitationAcceptMutationInput;
};


export type MutationInvitationCreateArgs = {
  input: UserInvitationCreateMutationInput;
};


export type MutationInvitationDeactivateArgs = {
  input: UserInvitationDeactivateMutationInput;
};


export type MutationInvitationSendArgs = {
  input: UserInvitationSendMutationInput;
};


export type MutationInvoicesReportRequestArgs = {
  input: InvoicesReportRequestInput;
};


export type MutationJwtTokenAuthWithCodeArgs = {
  input: JwtTokenAuthWithCodePureMutationInput;
};


export type MutationLaunchSubscriptionArgs = {
  input: LaunchSubscriptionMutationInput;
};


export type MutationLaunchSubscriptionWithConfirmArgs = {
  input: LaunchSubscriptionWithConfirmMutationInput;
};


export type MutationLicensesResumeAutoRenewalArgs = {
  input: LicensesResumeAutoRenewalMutationInput;
};


export type MutationLicensesSuspendAutoRenewalArgs = {
  input: LicensesSuspendAutoRenewalMutationInput;
};


export type MutationMarkAcceptanceErrorAsViewedArgs = {
  input: MarkAcceptanceErrorAsViewedInput;
};


export type MutationMediafilePureUpdateArgs = {
  input: MediafilePureUpdateMutationInput;
};


export type MutationMediafilePureUploadArgs = {
  input: MediafileUploadMutationInput;
};


export type MutationMediafileReportArgs = {
  input: MediafileReportMutationInput;
};


export type MutationMmDisableSyncForBlockPureArgs = {
  input: MmSyncMutationInput;
};


export type MutationMmForceSyncBlockPureArgs = {
  input: MmSyncMutationInput;
};


export type MutationMmSyncOnForBlockPureArgs = {
  input: MmSyncModeOnForBlockMutationInput;
};


export type MutationMusicboxClearArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationMusicboxReplaceArgs = {
  firstTitle?: InputMaybe<Scalars['String']>;
  secondTitle?: InputMaybe<Scalars['String']>;
};


export type MutationMusicboxUpdateArgs = {
  input?: InputMaybe<MusicBoxMutationInput>;
};


export type MutationPasswordPureSetNewArgs = {
  input: PasswordPureSetNewMutationInput;
};


export type MutationPasswordRestoreArgs = {
  input: PasswordResetMutationInput;
};


export type MutationPasswordRestoreConfirmationArgs = {
  input: PasswordResetConfirmationMutationInput;
};


export type MutationPlayInstantAdcampaignArgs = {
  input: PlayInstantAdcampaignMutationInput;
};


export type MutationPlayerImportVersionArgs = {
  deviceType: DeviceTypes;
  executable?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  updateChannel: UpdateChannels;
  version: Scalars['String'];
};


export type MutationPlayerPureSetRequiredVersionArgs = {
  input: DevicePureSetRequiredVersionMutationInput;
};


export type MutationPlayerSetRequiredVersionArgs = {
  playerId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationPointBindVideoStreamArgs = {
  input: PointBindVideoStreamMutationInput;
};


export type MutationPointClearVideoDemoArgs = {
  input: PointClearVideoDemoMutationInput;
};


export type MutationPointDislikeMediafileArgs = {
  mediafileId?: InputMaybe<Scalars['Int']>;
  pointId?: InputMaybe<Scalars['Int']>;
};


export type MutationPointPlaybackReportCreateMutationArgs = {
  input: PointPlaybackAudioReportCreateMutationInput;
};


export type MutationPointPlaybackVideoReportCreateMutationArgs = {
  input: PointPlaybackVideoReportCreateMutationInput;
};


export type MutationPointPureBindDeviceArgs = {
  input: PointPureBindDeviceMutationInput;
};


export type MutationPointPureChangeStateArgs = {
  input: PointPureChangeStateMutationInput;
};


export type MutationPointPureChangeStreamArgs = {
  input: PointPureChangeStreamMutationInput;
};


export type MutationPointPureCreateArgs = {
  input: PointPureCreateMutationInput;
};


export type MutationPointPureMoveSettingsArgs = {
  input: PointPureMoveSettingsMutationInput;
};


export type MutationPointPureRegenerateStreamArgs = {
  input: PointPureRegenerateStreamMutationInput;
};


export type MutationPointPureRemoveArgs = {
  input: PointPureRemoveMutationInput;
};


export type MutationPointPureSetAdcampaignsArgs = {
  input: PointPureSetAdCampaignsMutationInput;
};


export type MutationPointPureSetCacheModeArgs = {
  input: PointPureSetCacheModeMutationInput;
};


export type MutationPointPureSetCompanyTagsArgs = {
  input: PointPureSetCompanyTagsMutationInput;
};


export type MutationPointPureSetPeriodicRestartArgs = {
  input: PointPureSetPeriodicRestartMutationInput;
};


export type MutationPointPureSetSpeedLimitsArgs = {
  input: PointSpeedLimitsInput;
};


export type MutationPointPureSleepSettingsArgs = {
  input: PointPureSleepSettingsMutationInput;
};


export type MutationPointPureSwitchDeviceArgs = {
  input: PointSwitchDeviceMutationInput;
};


export type MutationPointPureUnbindDeviceArgs = {
  input: PointPureUnbindDeviceMutationInput;
};


export type MutationPointPureUnbindStreamArgs = {
  input: PointPureUnbindStreamMutationInput;
};


export type MutationPointPureUpdateArgs = {
  input: PointPureUpdateMutationInput;
};


export type MutationPointSetDeviceLogLevelArgs = {
  logLevel: Scalars['String'];
  pointId: Scalars['ID'];
};


export type MutationPointUnbindVideoStreamArgs = {
  input: PointUnbindVideoStreamMutationInput;
};


export type MutationPointWebUpdateStatusArgs = {
  deviceName?: InputMaybe<Scalars['String']>;
  pointLinkName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationPointsBindCompanyTagsArgs = {
  input: PointsBindCompanyTagsMutationInput;
};


export type MutationPointsBulkEnableArgs = {
  input: PointsBulkEnableMutationInput;
};


export type MutationPointsCreateArgs = {
  input: PointsCreateMutationInput;
};


export type MutationPointsUnsetCompanyTagsArgs = {
  input: PointsUnsetCompanyTagsMutationInput;
};


export type MutationPromoPureUploadArgs = {
  input: PromoUploadPureMutationInput;
};


export type MutationPromoRollSynthCreateArgs = {
  input: PromoRollSynthCreateMutationInput;
};


export type MutationPromoRollSynthDeleteArgs = {
  input: PromoRollSynthDeleteMutationInput;
};


export type MutationPromoSelectionDraftArgs = {
  input: PromoSelectionDraftInput;
};


export type MutationResumeTrialPeriodArgs = {
  input: ExtendTrialPeriodMutationInput;
};


export type MutationRevokeApiTokenMutationArgs = {
  input: RevokeApiTokenMutationInput;
};


export type MutationRightholderCreateArgs = {
  input: RightholderCreateInput;
};


export type MutationRightholderPlaybackReportArgs = {
  input: RightholderPlaybackReportMutationInput;
};


export type MutationRightholderPlaybackReportByPointsArgs = {
  input: RightholderPlaybackReportByPointsMutationInput;
};


export type MutationRightholderUpdateArgs = {
  input: RightholderUpdateInput;
};


export type MutationSaveBrandsSearchResultArgs = {
  input: SaveBrandsSearchResultMutationInput;
};


export type MutationSaveCompaniesSearchResultArgs = {
  input: SaveCompaniesSearchResultMutationInput;
};


export type MutationSberMultiroomAddDeviceMutationArgs = {
  input: SberMultiroomAddDeviceMutationInput;
};


export type MutationSberMultiroomRemoveDeviceMutationArgs = {
  input: SberMultiroomRemoveDeviceMutationInput;
};


export type MutationSendEmailPureRepeatArgs = {
  input: SendEmailPureRepeatMutationInput;
};


export type MutationSetDeviceStateArgs = {
  input: SetDeviceStateMutationInput;
};


export type MutationSmartlkCompanyPlaybackReportSettingsUpdateArgs = {
  input: SmartlkCompanyPlaybackReportSettingsUpdateMutationInput;
};


export type MutationSmartlkDevicesGroupCreateArgs = {
  input: SmartlkDevicesGroupCreateMutationInput;
};


export type MutationSmartlkDevicesGroupDeleteArgs = {
  input: SmartlkDevicesGroupDeleteMutationInput;
};


export type MutationSmartlkDevicesGroupUpdateArgs = {
  input: SmartlkDevicesGroupUpdateMutationInput;
};


export type MutationSmartlkPointCreateArgs = {
  input: SmartlkPointCreateMutationInput;
};


export type MutationSmartlkPointUnbindStreamArgs = {
  input: SmartlkPointUnbindStreamMutationInput;
};


export type MutationSmartlkPointsBindVideoStreamArgs = {
  input: SmartLkPointsBindVideoStreamMutationInput;
};


export type MutationSmartlkStartVideoDemoPeriodArgs = {
  input: SmartLkStartVideoDemoPeriodMutationInput;
};


export type MutationSmartlkVideoOrImageMediafileUploadArgs = {
  input: SmartlkVideoOrImageUploadMutationInput;
};


export type MutationSmartlkVideoStreamCopyFromTemplateArgs = {
  input: SmartlkVideoStreamCopyFromTemplateMutationInput;
};


export type MutationSmartlkVideoStreamCreateArgs = {
  input: SmartlkVideoStreamCreateMutationInput;
};


export type MutationSmartlkVideoStreamDeleteArgs = {
  input: SmartlkVideoStreamDeleteMutationInput;
};


export type MutationSmartlkVideoStreamPureSetCompanyTagsArgs = {
  input: SmartLkVideoStreamPureSetCompanyTagsInput;
};


export type MutationSmartlkVideoStreamUpdateArgs = {
  input: SmartlkVideoStreamUpdateMutationInput;
};


export type MutationSpeakerCreateAndSetPointArgs = {
  input: SmartSpeakerCreateAndSetPointInput;
};


export type MutationSpeakerDislikeMediafileArgs = {
  input: SmartSpeakerDislikeMediafileMutationInput;
};


export type MutationSpeakerImportHistoryArgs = {
  input: SmartSpeakerImportHistoryMutationInput;
};


export type MutationSpeakerSetStreamByBusinessSphereArgs = {
  input: SmartSpeakerSetStreamBusinessSphereInput;
};


export type MutationSpeakerSetStreamByGenreArgs = {
  input: SmartSpeakerSetStreamByGenreInput;
};


export type MutationStartLinkCardArgs = {
  input: StartLinkCardMutationInput;
};


export type MutationStoppedListeningReportRequestArgs = {
  input: RequestStoppedListeningReportPureMutationInput;
};


export type MutationStreamCreateCopyAndSetToPointsArgs = {
  input: CreateStreamCopyAndSetToPointsMutationInput;
};


export type MutationStreamDraftBlockCopyAsTemplateArgs = {
  input: StreamDraftBlockCopyAsTemplateMutationInput;
};


export type MutationStreamDraftCancelArgs = {
  input: StreamDraftCancelPureMutationInput;
};


export type MutationStreamDraftClearArgs = {
  input: StreamDraftClearPureMutationInput;
};


export type MutationStreamDraftCreateArgs = {
  input: StreamDraftCreatePureMutationInput;
};


export type MutationStreamDraftCreateBlockArgs = {
  input: StreamDraftCreateBlockPureMutationInput;
};


export type MutationStreamDraftDeleteBlockArgs = {
  input: StreamDraftDeleteBlockPureMutationInput;
};


export type MutationStreamDraftDemoStartGenerationArgs = {
  input: StreamDraftDemoStartGenerationMutationInput;
};


export type MutationStreamDraftDuplicateBlockArgs = {
  input: StreamDraftDuplicateBlockPureMutationInput;
};


export type MutationStreamDraftSaveArgs = {
  input: StreamDraftSavePureMutationInput;
};


export type MutationStreamDraftSetConceptionArgs = {
  input: StreamDraftSetConceptionMutationInput;
};


export type MutationStreamDraftUpdateArgs = {
  input: StreamDraftUpdatePureMutationInput;
};


export type MutationStreamDraftUpdateBlockArgs = {
  input: StreamDraftUpdateBlockPureMutationInput;
};


export type MutationStreamDraftUpdateTracksArgs = {
  input: StreamDraftUpdateTracksPureMutationInput;
};


export type MutationStreamExcludeFromReplicationArgs = {
  input: ExculdeStreamFromReplicationPureMutationInput;
};


export type MutationStreamLibraryDeleteArgs = {
  input: LibraryDeleteMutationInput;
};


export type MutationStreamLibraryDraftAddStreamsArgs = {
  input: LibraryDraftAddStreamsMutationInput;
};


export type MutationStreamLibraryDraftCancelArgs = {
  input: LibraryDraftCancelMutationInput;
};


export type MutationStreamLibraryDraftChangeCollectionOrderArgs = {
  input: LibraryDraftChangeCollectionOrderMutationInput;
};


export type MutationStreamLibraryDraftChangeGroupOrderArgs = {
  input: LibraryDraftChangeGroupOrderMutationInput;
};


export type MutationStreamLibraryDraftChangeOrderArgs = {
  input: LibraryDraftChangeOrderMutationInput;
};


export type MutationStreamLibraryDraftChangePosterCollectionArgs = {
  input: LibraryDraftChangePosterCollectionMutationInput;
};


export type MutationStreamLibraryDraftChangeSubcollectionOrderArgs = {
  input: LibraryDraftChangeSubCollectionOrderMutationInput;
};


export type MutationStreamLibraryDraftCopySubcollectionArgs = {
  input: LibraryDraftCopySubCollectionMutationInput;
};


export type MutationStreamLibraryDraftCreateCollectionArgs = {
  input: LibraryDraftCreateCollectionPureMutationInput;
};


export type MutationStreamLibraryDraftCreateGroupArgs = {
  input: LibraryDraftCreateGroupPureMutationInput;
};


export type MutationStreamLibraryDraftCreateSubcollectionArgs = {
  input: LibraryDraftCreateSubCollectionMutationInput;
};


export type MutationStreamLibraryDraftDiscommendSubcollectionsArgs = {
  input: LibraryDraftDiscommendSubCollectionsInput;
};


export type MutationStreamLibraryDraftPublishArgs = {
  input: LibraryDraftPublishPureMutationInput;
};


export type MutationStreamLibraryDraftRecommendSubcollectionsArgs = {
  input: LibraryDraftRecommendSubCollectionsInput;
};


export type MutationStreamLibraryDraftRecommendationsChangeOrderArgs = {
  input: LibraryDraftRecommendationsChangeOrderInput;
};


export type MutationStreamLibraryDraftRemoveCollectionArgs = {
  input: LibraryDraftRemoveCollectionMutationInput;
};


export type MutationStreamLibraryDraftRemoveGroupArgs = {
  input: LibraryDraftRemoveGroupMutationInput;
};


export type MutationStreamLibraryDraftRemoveStreamsArgs = {
  input: LibraryDraftRemoveStreamsMutationInput;
};


export type MutationStreamLibraryDraftRemoveSubcollectionArgs = {
  input: LibraryDraftRemoveSubCollectionMutationInput;
};


export type MutationStreamLibraryDraftRenameArgs = {
  input: LibraryDraftRenameMutationInput;
};


export type MutationStreamLibraryDraftRenameCollectionArgs = {
  input: LibraryDraftRenameCollectionMutationInput;
};


export type MutationStreamLibraryDraftRenameGroupArgs = {
  input: LibraryDraftRenameGroupMutationInput;
};


export type MutationStreamLibraryDraftUpdateSubcollectionArgs = {
  input: LibraryDraftUpdateSubCollectionMutationInput;
};


export type MutationStreamLibraryStartCreateArgs = {
  input: LibraryStrartCreatePureMutationInput;
};


export type MutationStreamLibraryStartEditArgs = {
  input: LibraryStrartEditPureMutationInput;
};


export type MutationStreamLibraryUpdateArgs = {
  input: LibraryUpdateInput;
};


export type MutationStreamLikeMediafileArgs = {
  input: StreamLikeMediafileInput;
};


export type MutationStreamLogPureRestoreArgs = {
  input: StreamLogPureRestoreMutationInput;
};


export type MutationStreamMasterRolloutArgs = {
  input: RolloutMasterStreamPureMutationInput;
};


export type MutationStreamPureAutoUpdateTracksNowArgs = {
  input: StreamAutoUpdateTracksNowMutationInput;
};


export type MutationStreamPureChangeAutoUpdateArgs = {
  input: StreamChangeAutoUpdateTracksMutationInput;
};


export type MutationStreamPureCopyArgs = {
  input: StreamPureCopyInput;
};


export type MutationStreamPureCopyFromTemplateArgs = {
  input: StreamPureCopyFromTemplateMutationInput;
};


export type MutationStreamPureCreateArgs = {
  input: StreamPureCreateInput;
};


export type MutationStreamPureDislikeMediafileArgs = {
  input: StreamPureDislikeMediafileMutationInput;
};


export type MutationStreamPureDislikeMediafileRestoreArgs = {
  input: StreamPureDislikeMediafileRestoreMutationInput;
};


export type MutationStreamPureListOfMediafilesArgs = {
  input: StreamPureListOfMediafilesMutationInput;
};


export type MutationStreamPureRemoveArgs = {
  input: StreamPureRemoveMutationInput;
};


export type MutationStreamPureRestoreArgs = {
  input: StreamPureRestoreMutationInput;
};


export type MutationStreamPureSetToCompanyPointsArgs = {
  input: StreamPureSetToCompanyPointsMutationInput;
};


export type MutationStreamPureSetToPointsArgs = {
  input: StreamPureSetToPointsMutationInput;
};


export type MutationStreamPureUpdateArgs = {
  input: StreamPureUpdateMutationInput;
};


export type MutationStreamPureUploadCoverArgs = {
  input: StreamPureUploadCoverInput;
};


export type MutationStreamTaskPureCreateArgs = {
  input: StreamTaskPureCreateMutationInput;
};


export type MutationStreamTaskPureCreateCommentArgs = {
  input: StreamTaskPureCreateCommentMutationInput;
};


export type MutationStreamTaskPureRefuseArgs = {
  input: StreamTaskPureRefuseMutationInput;
};


export type MutationStreamTaskPureRemoveArgs = {
  input: StreamTaskPureRemoveMutationInput;
};


export type MutationStreamTaskPureReopenArgs = {
  input: StreamTaskPureReopenMutationInput;
};


export type MutationStreamTaskPureSetReadyArgs = {
  input: StreamTaskPureSetReadyMutationInput;
};


export type MutationStreamTaskPureSetRedactorArgs = {
  input: StreamTaskSetRedactorPureMutationInput;
};


export type MutationStreamTaskPureTakeArgs = {
  input: StreamTaskPureTakeMutationInput;
};


export type MutationStreamTaskPureUpdateArgs = {
  input: StreamTaskPureUpdateMutationInput;
};


export type MutationStreamTaskSetCategoryArgs = {
  input: StreamTaskSetCategoryMutationInput;
};


export type MutationStreamTaskSetComplexityArgs = {
  input: StreamTaskSetComplexityMutationInput;
};


export type MutationStreamUnLikeMediafileArgs = {
  input: StreamUnLikeMediafileInput;
};


export type MutationTemplateAddToLibraryArgs = {
  input: TemplateIdInput;
};


export type MutationTemplateRemoveFromLibraryArgs = {
  input: TemplateIdInput;
};


export type MutationTemplateSetBusinessSphereArgs = {
  input: TemplateSetBusinessSphereMutationInput;
};


export type MutationTemplateSetSearchTagsArgs = {
  input: TemplateSetSearchTagsMutationInput;
};


export type MutationTestAcceptanceAdvancedToCanceledArgs = {
  input: TestAcceptanceAdvanceToCanceledMutationInput;
};


export type MutationTestChangeSberUserSubIdArgs = {
  input: TestChangeSberUserSubIdMutationInput;
};


export type MutationTestChangeSelectedPaymentKindArgs = {
  input: TestChangeSelectedPaymentKindInput;
};


export type MutationTestClearVideoDemoPeriodArgs = {
  input: TestClearVideoDemoPeriodMutationInput;
};


export type MutationTestMoveSubscriptionArgs = {
  input: TestMoveSubscriptionMutationInput;
};


export type MutationTestMoveVideoDemoPeriodArgs = {
  input: TestMoveVideoDemoPeriodMutationInput;
};


export type MutationTestSbbolPaymentRequestToSuccessArgs = {
  input: TestSbbolPaymentRequestInput;
};


export type MutationTestSetInvoiceCalendarMonthlyCutoffDayArgs = {
  input: TestSetInvoiceCalendarMonthlyCutoffDayMutationInput;
};


export type MutationThematicBlockPureRemoveFromCompanyArgs = {
  input: ThematicBlockPureRemoveFromCompanyMutationInput;
};


export type MutationThematicBlockPureSetToCompanyArgs = {
  input: ThematicBlockPureSetToCompanyMutationInput;
};


export type MutationTokenPureAuthArgs = {
  input: JwtTokenAuthPureMutationInput;
};


export type MutationTokenPureRefreshArgs = {
  input: TokenPureRefreshMutationInput;
};


export type MutationTokenPureRetrieveAuthArgs = {
  input: JwtTokenAuthPureMutationInput;
};


export type MutationTokenPureVerifyArgs = {
  input: TokenPureVerifyMutationInput;
};


export type MutationTokenRetrieveAuthArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationTracksPureRemoveArgs = {
  input: TracksRemoveMutationInput;
};


export type MutationUpdateRequestPureCancelArgs = {
  input: UpdateRequestPureCancelMutationInput;
};


export type MutationUpdateRequestPureCreateByDeviceListArgs = {
  input: UpdateRequestPureCreateByDeviceListMutationInput;
};


export type MutationUpdateRequestPureRunManualCheckArgs = {
  input: UpdateRequestPureRunManualCheckMutationInput;
};


export type MutationUserCompanyCreateArgs = {
  input: UserCompanyCreateMutationInput;
};


export type MutationUserCompanyUpdateArgs = {
  input: UserCompanyUpdateMutationInput;
};


export type MutationUserEmailUpdateArgs = {
  input: UserEmailUpdateMutationInput;
};


export type MutationUserFeaturesOnboardingPassArgs = {
  input: UserFeaturesOnboardingPassMutationInput;
};


export type MutationUserMarkAsTestArgs = {
  input: UserPureMakeAsTestMutationInput;
};


export type MutationUserPhoneUpdateArgs = {
  input: UserPhoneUpdateMutationInput;
};


export type MutationUserPureChangeSmartLkAccessArgs = {
  input: UserPureChangeSmartLkAccessMutationInput;
};


export type MutationUserPureManualEmailVerifiedArgs = {
  input: UserPureManualEmailVerifiedMutationInput;
};


export type MutationUserPureSignUpArgs = {
  input: UserPureSignUpMutationInput;
};


export type MutationUserPureSignUpByPhoneArgs = {
  input: UserPureSignUpByPhoneMutationInput;
};


export type MutationUserPureSignUpYclientsArgs = {
  input: UserPureSignUpYClientsMutationInput;
};


export type MutationUserPureUpdateArgs = {
  input: UserPureUpdateMutationInput;
};


export type MutationUtmMarksSendToAmoLeadArgs = {
  input: UtmMarksSendToAmoMutationInput;
};


export type MutationVideoStreamCreateArgs = {
  input: VideoStreamCreateMutationInput;
};


export type MutationVideoStreamDeleteArgs = {
  input: VideoStreamDeleteMutationInput;
};


export type MutationVideoStreamUpdateArgs = {
  input: VideoStreamUpdateMutationInput;
};


export type MutationVideoStreamUpdateCompanyArgs = {
  input: VideoStreamUpdateCompanyMutationInput;
};


export type MutationVideoTypeMediafilesDeleteArgs = {
  input: VideoTypeMediafilesDeleteMutationInput;
};


export type MutationVideoUploadArgs = {
  input: VideoUploadMutationInput;
};


export type MutationViewNotificationArgs = {
  input: ViewNotificationMutationInput;
};


export type MutationZvukPlaylistAdminRestoreArgs = {
  input: ZvukPlaylistAdminRestoreMutationInput;
};


export type MutationZvukPlaylistCreateFromStreamArgs = {
  input: ZvukPlaylistCreateFromStreamMutationInput;
};


export type MutationZvukPlaylistCreateFromZvukArgs = {
  input: ZvukPlaylistCreateFromZvukMutationInput;
};


export type MutationZvukPlaylistHideArgs = {
  input: ZvukPlaylistHideMutationInput;
};


export type MutationZvukPlaylistInfoArgs = {
  input: ZvukPlaylistInfoMutationInput;
};


export type MutationZvukPlaylistPublishArgs = {
  input: ZvukPlaylistPublishMutationInput;
};


export type MutationZvukPlaylistRemoveArgs = {
  input: ZvukPlaylistRemoveMutationInput;
};


export type MutationZvukPlaylistUpdateArgs = {
  input: ZvukPlaylistUpdateMutationInput;
};


export type MutationZvukProfileAdminPublishArgs = {
  input: ZvukProfileAdminPublishMutationInput;
};


export type MutationZvukProfileAdminRestoreArgs = {
  input: ZvukProfileAdminRestoreMutationInput;
};


export type MutationZvukProfileCreateArgs = {
  input: ZvukProfileCreateMutationInput;
};


export type MutationZvukProfileHideArgs = {
  input: ZvukProfileHideMutationInput;
};


export type MutationZvukProfilePublishArgs = {
  input: ZvukProfilePublishMutationInput;
};


export type MutationZvukProfileRemoveArgs = {
  input: ZvukProfileRemoveMutationInput;
};


export type MutationZvukProfileUpdateArgs = {
  input: ZvukProfileUpdateMutationInput;
};

export type NetworkSettingsPureType = {
  __typename?: 'NetworkSettingsPureType';
  cells: Array<WifiCellType>;
  connectionType: ConnectionTypes;
  /** Info about last attempt wifi connection */
  lastConnectionAttempt?: Maybe<ConnectionStatusType>;
  netState: Scalars['Boolean'];
  online: Scalars['Boolean'];
  wifi: Scalars['Boolean'];
  wifiConnectionProcessStatus?: Maybe<ConnectionProcessStatusType>;
  wifiIdentity?: Maybe<Scalars['String']>;
  wifiPassword?: Maybe<Scalars['String']>;
  wifiPoint?: Maybe<Scalars['String']>;
};

export type NewUserType = {
  __typename?: 'NewUserType';
  additionalFeatures: Array<Scalars['String']>;
  avatar?: Maybe<FileObjectType>;
  companies: Array<UserCompanyPureType>;
  contractScenario: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  personalAccountAccess: Scalars['Boolean'];
  roles: Array<UserRoleType>;
  username: Scalars['String'];
};

export type NotificationType = {
  __typename?: 'NotificationType';
  confirm: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  message: Scalars['String'];
  modelId: Scalars['ID'];
  notificationType: Scalars['String'];
  title: Scalars['String'];
};

export type ObtainPureJsonWebToken = {
  __typename?: 'ObtainPureJSONWebToken';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: TokenPureType;
};

export type OrganizationDiscountPureType = {
  __typename?: 'OrganizationDiscountPureType';
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invoiceWithDiscountLimit: Scalars['Int'];
  invoices?: Maybe<Array<InvoicePureType>>;
  licenseWithDiscountLimit: Scalars['Int'];
  manager?: Maybe<UserExtendPureType>;
  organizationId: Scalars['Int'];
  payFrequencyMonth: Scalars['Int'];
  slug: Scalars['String'];
  startDate: Scalars['Date'];
  status: OrganizationDiscountStatus;
  title: Scalars['String'];
  value: Scalars['Int'];
  valueType: DiscountValueType;
};

/** An enumeration. */
export enum OrganizationDiscountStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotActivated = 'NOT_ACTIVATED'
}

export type OrganizationPricePlanPureType = {
  __typename?: 'OrganizationPricePlanPureType';
  organizationId: Scalars['Int'];
  pricePlan?: Maybe<PricePlanPureType>;
  pricePlanPeriod?: Maybe<PricePlanPeriodPureType>;
};

/** An enumeration. */
export enum OrganizationType {
  Individual = 'INDIVIDUAL',
  Legal = 'LEGAL',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type PaginationInfoType = {
  __typename?: 'PaginationInfoType';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PasswordPureSetNewMutation = {
  __typename?: 'PasswordPureSetNewMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PasswordPureSetNewMutationInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type PasswordResetConfirmationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  newPassword1: Scalars['String'];
  token: Scalars['String'];
  uid: Scalars['String'];
};

export type PasswordResetConfirmationMutationPayload = {
  __typename?: 'PasswordResetConfirmationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  newPassword1?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export type PasswordResetMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type PasswordResetMutationPayload = {
  __typename?: 'PasswordResetMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum PaymentKind {
  Sbbol = 'SBBOL',
  Yookassa = 'YOOKASSA'
}

export type PaymentMethodObjectPureType = {
  __typename?: 'PaymentMethodObjectPureType';
  cardType: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  last4: Scalars['String'];
};

export type PaymentMethodStatusType = {
  __typename?: 'PaymentMethodStatusType';
  isLinkingInProcess: Scalars['Boolean'];
  paymentMethod?: Maybe<PaymentMethodObjectPureType>;
};

export type PaymentMethodsStatePureType = {
  __typename?: 'PaymentMethodsStatePureType';
  acceptanceStatus?: Maybe<AcceptanceAdvanceStatus>;
  hasActualAcceptance: Scalars['Boolean'];
  hasLinkedCard: Scalars['Boolean'];
  hasOldPaymentDataOnChange: Scalars['Boolean'];
  hasStalePaymentData: Scalars['Boolean'];
  maskedSbbolAccount?: Maybe<Scalars['String']>;
  selectedPaymentKind: PaymentKind;
};

/** An enumeration. */
export enum PaymentRequestBankStatus {
  Accepted = 'ACCEPTED',
  AcceptedByAbs = 'ACCEPTED_BY_ABS',
  Card2 = 'CARD2',
  Checkerror = 'CHECKERROR',
  CheckerrorBank = 'CHECKERROR_BANK',
  Created = 'CREATED',
  DeclinedByPayer = 'DECLINED_BY_PAYER',
  Delayed = 'DELAYED',
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Exported = 'EXPORTED',
  Fraudallow = 'FRAUDALLOW',
  Frauddeny = 'FRAUDDENY',
  Fraudreview = 'FRAUDREVIEW',
  Fraudsent = 'FRAUDSENT',
  Fraudsms = 'FRAUDSMS',
  Implemented = 'IMPLEMENTED',
  Invalideds = 'INVALIDEDS',
  Noneacceptance = 'NONEACCEPTANCE',
  Partsigned = 'PARTSIGNED',
  Processing = 'PROCESSING',
  Recall = 'RECALL',
  Refusedbyabs = 'REFUSEDBYABS',
  Refusedbybank = 'REFUSEDBYBANK',
  RefusedByRzk = 'REFUSED_BY_RZK',
  RequestedRecall = 'REQUESTED_RECALL',
  Requisiteerror = 'REQUISITEERROR',
  SendedToPayer = 'SENDED_TO_PAYER',
  Signed = 'SIGNED',
  Submitted = 'SUBMITTED'
}

/** An enumeration. */
export enum PaymentScheme {
  InvoiceCalendarMonthly = 'INVOICE_CALENDAR_MONTHLY',
  InvoiceRollingMonthly = 'INVOICE_ROLLING_MONTHLY'
}

export type PlayInstantAdcampaignMutation = {
  __typename?: 'PlayInstantAdcampaignMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PlayInstantAdcampaignMutationInput = {
  adcampaignId: Scalars['ID'];
  pointId: Scalars['ID'];
};

/** An enumeration. */
export enum PlaybackReportStatus {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum PlaybackReportType {
  AdCampaign = 'AD_CAMPAIGN',
  Music = 'MUSIC'
}

export type PlayerDeviceBusinessSpheresQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type PlayerDeviceGenerationLastUpdatedQueryPureType = {
  __typename?: 'PlayerDeviceGenerationLastUpdatedQueryPureType';
  lastUpdated: Scalars['DateTime'];
};

export type PlayerDeviceGenerationSettingsQueryPureType = {
  __typename?: 'PlayerDeviceGenerationSettingsQueryPureType';
  lastUpdated: Scalars['DateTime'];
  mediafiles: Array<Maybe<DeviceMediafileObjectType>>;
  settings: Scalars['String'];
  settingsVersion?: Maybe<GenerationSettingsVersion>;
  stream: StreamPureType;
};

export type PlayerDevicePointHistoryQueryFilter = {
  onAirRange: DateTimeRange;
  query?: InputMaybe<Scalars['String']>;
};

export type PlayerDevicePointHistoryQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum PlayerDevicePointHistoryQuerySort {
  OnAirAsc = 'ON_AIR_ASC',
  OnAirDesc = 'ON_AIR_DESC'
}

export type PlayerDevicePureType = {
  __typename?: 'PlayerDevicePureType';
  additionalFeatures: Array<PointFlag>;
  bindedAt?: Maybe<Scalars['DateTime']>;
  bindingCode: Scalars['String'];
  cleanupPeriod: Scalars['Int'];
  currentVersion?: Maybe<PlayerVersionPureType>;
  debugMode: Scalars['Boolean'];
  formFactor?: Maybe<Scalars['String']>;
  group?: Maybe<DevicesGroupType>;
  hardwareId?: Maybe<Scalars['ID']>;
  historyBatchSize: Scalars['Int'];
  historyMaxItems: Scalars['Int'];
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  logLevel: LogLevels;
  logLink?: Maybe<Scalars['String']>;
  networkSettings?: Maybe<NetworkSettingsPureType>;
  playbackMetricLink?: Maybe<Scalars['String']>;
  point?: Maybe<PointPureType>;
  requiredVersion?: Maybe<PlayerVersionPureType>;
  requiredVersionUrl?: Maybe<Scalars['String']>;
  supportedFeatures: Array<Maybe<Scalars['String']>>;
  type: DeviceTypes;
  uuid: Scalars['String'];
  volume: Scalars['Int'];
};

export type PlayerDeviceQueryFilter = {
  bound?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  currentVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  currentVersions?: InputMaybe<Array<Scalars['String']>>;
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  devicesGroupId?: InputMaybe<Scalars['ID']>;
  excludeCurrentVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeRequiredVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  requiredVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  requiredVersions?: InputMaybe<Array<Scalars['String']>>;
  streamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  withPoints?: InputMaybe<Scalars['Boolean']>;
};

export type PlayerDeviceQueryPagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PlayerDeviceQueryPureType = {
  __typename?: 'PlayerDeviceQueryPureType';
  result?: Maybe<PlayerDevicePureType>;
};

export enum PlayerDeviceQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type PlayerDeviceRandomIdsQueryType = {
  __typename?: 'PlayerDeviceRandomIdsQueryType';
  result: Array<Scalars['ID']>;
};

export type PlayerDeviceStreamGroupsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type PlayerDeviceStreamRandomMediafilesPureQueryFilter = {
  excludeMediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  streamId: Scalars['ID'];
};

export type PlayerDeviceStreamRandomMediafilesPureQueryPagination = {
  pageSize: Scalars['Int'];
};

export type PlayerDeviceType = {
  __typename?: 'PlayerDeviceType';
  additionalFeatures: Array<Scalars['String']>;
  bindingCode: Scalars['String'];
  cleanupPeriod: Scalars['Int'];
  currentVersion: Scalars['String'];
  debugMode: Scalars['Boolean'];
  group?: Maybe<DevicesGroupType>;
  historyBatchSize: Scalars['Int'];
  historyMaxItems: Scalars['Int'];
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  logLevel: Scalars['String'];
  logLink?: Maybe<Scalars['String']>;
  point?: Maybe<PointType>;
  requiredVersion?: Maybe<PlayerVersionPureType>;
  requiredVersionUrl?: Maybe<Scalars['String']>;
  speedKbps?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  type: DeviceTypes;
  typeName: Scalars['String'];
  uuid: Scalars['String'];
  version?: Maybe<PlayerVersionPureType>;
  volume: Scalars['Int'];
  wifiSettings?: Maybe<WifiSettingsPureType>;
};

export type PlayerDeviceVideoSettingsLastUpdatedQueryPureType = {
  __typename?: 'PlayerDeviceVideoSettingsLastUpdatedQueryPureType';
  lastUpdated?: Maybe<Scalars['DateTime']>;
};

export type PlayerDeviceVideoSettingsQueryPureType = {
  __typename?: 'PlayerDeviceVideoSettingsQueryPureType';
  adCampaigns?: Maybe<Array<AdCampaignPureType>>;
  lastUpdated: Scalars['DateTime'];
  settings: Scalars['String'];
  settingsVersion?: Maybe<VideoSettingsVersion>;
};

export type PlayerDevicesQueryPaginationType = {
  __typename?: 'PlayerDevicesQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PlayerDevicePureType>>;
};

export type PlayerDevicesRandomIdsByPercentageFilter = {
  bound?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  currentVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  currentVersions?: InputMaybe<Array<Scalars['String']>>;
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  excludeCurrentVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeRequiredVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  maxCompanyPointsCount?: InputMaybe<Scalars['Int']>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  requiredVersionIds?: InputMaybe<Array<Scalars['ID']>>;
  requiredVersions?: InputMaybe<Array<Scalars['String']>>;
  streamId?: InputMaybe<Scalars['ID']>;
  updateChannels?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type PlayerPlannedUpdatePureType = {
  __typename?: 'PlayerPlannedUpdatePureType';
  id: Scalars['ID'];
  player?: Maybe<PlayerDevicePureType>;
  status: UpdateRequestState;
  updateRequest?: Maybe<UpdateRequestPureType>;
};

/** @TODO: Deprecated in favor of pure mutation version */
export type PlayerSetRequiredVersionMutation = {
  __typename?: 'PlayerSetRequiredVersionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PlayerVersionImportMutation = {
  __typename?: 'PlayerVersionImportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PlayerVersionPaginationType = {
  __typename?: 'PlayerVersionPaginationType';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  result?: Maybe<Array<PlayerVersionPureType>>;
  totalCount: Scalars['Int'];
};

export type PlayerVersionPureType = {
  __typename?: 'PlayerVersionPureType';
  applicationDomain?: Maybe<Scalars['String']>;
  currentPlayers: Array<PlayerDevicePureType>;
  deviceType: DeviceTypes;
  executableFullUrl?: Maybe<Scalars['String']>;
  executableHash?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  stable: Scalars['Boolean'];
  supportedFeatures: Array<Maybe<Scalars['String']>>;
  updateChannel: UpdateChannels;
  updatingPlayers: Array<PlayerDevicePureType>;
  version?: Maybe<Scalars['String']>;
  versionLink?: Maybe<Scalars['String']>;
};

export type PlayerVersionQueryPureType = {
  __typename?: 'PlayerVersionQueryPureType';
  result?: Maybe<PlayerVersionPureType>;
};

export type PlayerVersionsQueryPaginationType = {
  __typename?: 'PlayerVersionsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PlayerVersionPureType>>;
};

/** An enumeration. */
export enum PlayingStates {
  Play = 'play',
  Stop = 'stop'
}

export type PointAdCampaignFilter = {
  adcampaignIds?: InputMaybe<Array<Scalars['ID']>>;
  adcompanyMediaTypes?: InputMaybe<Array<AdCampaignMediaTypeEnum>>;
  excludeAdcampaignIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeQuery?: InputMaybe<Scalars['String']>;
  excludeTagIds?: InputMaybe<Array<Scalars['ID']>>;
  initialAdcampaignIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PointBindVideoStreamMutation = {
  __typename?: 'PointBindVideoStreamMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointBindVideoStreamMutationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  pointId: Scalars['ID'];
  videoStreamId: Scalars['ID'];
};

export type PointClearVideoDemoMutation = {
  __typename?: 'PointClearVideoDemoMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointClearVideoDemoMutationInput = {
  address: Scalars['String'];
  pointId: Scalars['ID'];
};

export type PointCreateSuccessItemType = {
  __typename?: 'PointCreateSuccessItemType';
  metadata?: Maybe<Scalars['JSONString']>;
  point: PointPureType;
};

/** TODO: change input for Pure-like type. This Mutation input style is deprecated. */
export type PointDeviceSetLogLevel = {
  __typename?: 'PointDeviceSetLogLevel';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointDislikeMediafileMutation = {
  __typename?: 'PointDislikeMediafileMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum PointFileFormats {
  Loudnorm = 'LOUDNORM',
  Loudnorm_320 = 'LOUDNORM_320',
  Original = 'ORIGINAL'
}

/** An enumeration. */
export enum PointFlag {
  DisableControlElements = 'disable_control_elements',
  DisableDislikes = 'disable_dislikes',
  DisableLikes = 'disable_likes',
  KioskMode = 'kiosk_mode',
  PeriodicRestart = 'periodic_restart',
  RemoteControl = 'remote_control',
  VideoMode = 'video_mode',
  WebStandaloneMode = 'web_standalone_mode'
}

export type PointHistoryPaginationType = {
  __typename?: 'PointHistoryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<PointPureHistoryItem>;
};

export type PointHistoryQueryFilter = {
  mediafileId?: InputMaybe<Scalars['ID']>;
  onAirRange: DateTimeRange;
  pointId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type PointHistoryQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum PointHistoryQuerySort {
  OnAirAsc = 'ON_AIR_ASC',
  OnAirDesc = 'ON_AIR_DESC'
}

export type PointLogType = {
  __typename?: 'PointLogType';
  created: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONString']>;
  diffWithPrevious?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  logModel?: Maybe<PointPublicType>;
  modified: Scalars['DateTime'];
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendType>;
  userName?: Maybe<Scalars['String']>;
};

export type PointPlayStatusPureType = {
  __typename?: 'PointPlayStatusPureType';
  code?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type PointPlaybackAudioReportCreateMutation = {
  __typename?: 'PointPlaybackAudioReportCreateMutation';
  downloadLink?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointPlaybackAudioReportCreateMutationInput = {
  pointId: Scalars['ID'];
  reportDate: Scalars['Date'];
};

export type PointPlaybackVideoReportCreateMutation = {
  __typename?: 'PointPlaybackVideoReportCreateMutation';
  downloadLink?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointPlaybackVideoReportCreateMutationInput = {
  pointId: Scalars['ID'];
  reportDate: Scalars['Date'];
};

/** An enumeration. */
export enum PointPointAdOverlapResolutionChoices {
  /** drop */
  Drop = 'DROP',
  /** shift */
  Shift = 'SHIFT'
}

/** An enumeration. */
export enum PointPointCacheModeChoices {
  /** full_cache */
  FullCache = 'FULL_CACHE',
  /** no_cache */
  NoCache = 'NO_CACHE',
  /** progressive_cache */
  ProgressiveCache = 'PROGRESSIVE_CACHE'
}

/** An enumeration. */
export enum PointPointCountryChoices {
  /** all */
  All = 'ALL',
  /** by */
  By = 'BY',
  /** kz */
  Kz = 'KZ',
  /** ru */
  Ru = 'RU'
}

/** An enumeration. */
export enum PointPointFileFormatChoices {
  /** gif */
  Gif = 'GIF',
  /** h264_converted */
  H264Converted = 'H264_CONVERTED',
  /** loudnorm */
  Loudnorm = 'LOUDNORM',
  /** loudnorm_320 */
  Loudnorm_320 = 'LOUDNORM_320',
  /** normalize_128 */
  Normalize_128 = 'NORMALIZE_128',
  /** original */
  Original = 'ORIGINAL',
  /** stereo */
  Stereo = 'STEREO'
}

export type PointPublicType = {
  __typename?: 'PointPublicType';
  address?: Maybe<Scalars['String']>;
  audioLinkName?: Maybe<Scalars['String']>;
  autoplay?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  contentBlocks?: Maybe<Array<Maybe<ContentBlockType>>>;
  duration?: Maybe<Scalars['Int']>;
  endSleep?: Maybe<Scalars['Time']>;
  genresObj?: Maybe<Array<Maybe<ValueObjectType>>>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  isVideoMode?: Maybe<Scalars['Boolean']>;
  /** @deprecated ->audio_link_name */
  linkName?: Maybe<Scalars['String']>;
  sleepMode?: Maybe<Scalars['Boolean']>;
  sleepSettings?: Maybe<Array<Maybe<SleepSettingObject>>>;
  startSleep?: Maybe<Scalars['Time']>;
  streamId?: Maybe<Scalars['Int']>;
  streamTitle?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  /** @deprecated ->comment */
  title?: Maybe<Scalars['String']>;
  userRegistered?: Maybe<Scalars['Boolean']>;
  weatherStatus?: Maybe<WeatherObjectType>;
};

export type PointPureBindDeviceMutation = {
  __typename?: 'PointPureBindDeviceMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureBindDeviceMutationInput = {
  deviceId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  pointId: Scalars['ID'];
};

export type PointPureChangeStateMutation = {
  __typename?: 'PointPureChangeStateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureChangeStateMutationInput = {
  origin?: InputMaybe<Scalars['String']>;
  pointId: Scalars['ID'];
  state: Scalars['Boolean'];
};

export type PointPureChangeStreamMutation = {
  __typename?: 'PointPureChangeStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureChangeStreamMutationInput = {
  newStreamId: Scalars['ID'];
  pointId: Scalars['ID'];
  withThematic?: InputMaybe<Scalars['Boolean']>;
};

export type PointPureCreateMutation = {
  __typename?: 'PointPureCreateMutation';
  addressData?: Maybe<AddressDataType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureCreateMutationInput = {
  adOverlapResolution?: InputMaybe<AdOverlapResolution>;
  address: Scalars['String'];
  addressData?: InputMaybe<AddressDataInput>;
  amplifyInstant?: InputMaybe<Scalars['Float']>;
  amplifyPromo: Scalars['Float'];
  amplifyTrack: Scalars['Float'];
  brandId?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  ctype: Scalars['String'];
  cutDuration?: InputMaybe<Scalars['Int']>;
  fileFormat?: InputMaybe<PointFileFormats>;
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['JSONString']>;
  sleepMode: Scalars['Boolean'];
  sleepSettings: Array<InputMaybe<SleepSettingDayInput>>;
  specialGeneration: Scalars['Boolean'];
  streamId?: InputMaybe<Scalars['ID']>;
  supportComment?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
  volume: Scalars['Int'];
  webDeviceAutocreate: Scalars['Boolean'];
  withMusicCut?: InputMaybe<Scalars['Boolean']>;
  withRadiocastHistory?: InputMaybe<Scalars['Boolean']>;
};

export type PointPureHistoryItem = {
  __typename?: 'PointPureHistoryItem';
  adcampaignId?: Maybe<Scalars['ID']>;
  deviceId?: Maybe<Scalars['ID']>;
  id: Scalars['String'];
  mediafile?: Maybe<MediafilePureType>;
  mediafileDuration?: Maybe<Scalars['Int']>;
  mediafileFilename?: Maybe<Scalars['String']>;
  mediafileId?: Maybe<Scalars['ID']>;
  mediafileIsDisliked?: Maybe<Scalars['Boolean']>;
  mediafileIsLiked?: Maybe<Scalars['Boolean']>;
  mediafilePerformerTitle?: Maybe<Scalars['String']>;
  mediafileRightholder?: Maybe<Scalars['Int']>;
  mediafileTitle?: Maybe<Scalars['String']>;
  mediafileType?: Maybe<Scalars['Int']>;
  onAir: Scalars['DateTime'];
  onAirWithLocalTimezone: Scalars['DateTime'];
  playtime?: Maybe<Scalars['DateTime']>;
  rotationId?: Maybe<Scalars['ID']>;
  streamId?: Maybe<Scalars['ID']>;
};

export type PointPureMoveSettingsMutation = {
  __typename?: 'PointPureMoveSettingsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureMoveSettingsMutationInput = {
  oldPointId: Scalars['ID'];
};

export type PointPureRegenerateStreamMutation = {
  __typename?: 'PointPureRegenerateStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureRegenerateStreamMutationInput = {
  pointId: Scalars['ID'];
};

export type PointPureRemoveMutation = {
  __typename?: 'PointPureRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointPureRemoveMutationInput = {
  pointId: Scalars['ID'];
};

export type PointPureSetAdCampaignsMutation = {
  __typename?: 'PointPureSetAdCampaignsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureSetAdCampaignsMutationInput = {
  adcampaignIds?: InputMaybe<Array<Scalars['ID']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeAdcampaignIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<PointAdCampaignFilter>;
  pointId: Scalars['ID'];
  setAllAdcampaigns?: InputMaybe<Scalars['Boolean']>;
};

export type PointPureSetCacheModeMutation = {
  __typename?: 'PointPureSetCacheModeMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureSetCacheModeMutationInput = {
  cacheMode?: InputMaybe<CacheMode>;
  pointId: Scalars['ID'];
};

export type PointPureSetCompanyTagsMutation = {
  __typename?: 'PointPureSetCompanyTagsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureSetCompanyTagsMutationInput = {
  pointId: Scalars['ID'];
  tagNames: Array<Scalars['String']>;
};

export type PointPureSetPeriodicRestartMutation = {
  __typename?: 'PointPureSetPeriodicRestartMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureSetPeriodicRestartMutationInput = {
  enabled: Scalars['Boolean'];
  periodicRestartTime: Scalars['String'];
  pointId: Scalars['ID'];
};

export type PointPureSleepSettingsMutation = {
  __typename?: 'PointPureSleepSettingsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureSleepSettingsMutationInput = {
  pointId: Scalars['ID'];
  sleepMode: Scalars['Boolean'];
  sleepSettings?: InputMaybe<Array<InputMaybe<SleepSettingDayInput>>>;
};

export type PointPureSpeedLimitsMutation = {
  __typename?: 'PointPureSpeedLimitsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureType = {
  __typename?: 'PointPureType';
  adOverlapResolution?: Maybe<AdOverlapResolution>;
  adcampaigns: Array<AdCampaignPureType>;
  address: Scalars['String'];
  addressApproved: Scalars['Boolean'];
  amplifyOptions: AmplifyOptionsPureType;
  brand?: Maybe<BrandType>;
  cacheMode?: Maybe<CacheMode>;
  certificateIsAvailable?: Maybe<Scalars['Boolean']>;
  comment: Scalars['String'];
  company?: Maybe<UserCompanyPureType>;
  country?: Maybe<CountryType>;
  cutDuration?: Maybe<Scalars['Int']>;
  device?: Maybe<PlayerDevicePureType>;
  deviceType?: Maybe<Scalars['Int']>;
  fileFormat?: Maybe<PointFileFormats>;
  generationOptions: GenerationOptionsPureType;
  id: Scalars['ID'];
  invoices: Array<InvoicePureType>;
  isEnabled: Scalars['Boolean'];
  isVideoDemo: Scalars['Boolean'];
  isVideoMode: Scalars['Boolean'];
  lastConnectionTime?: Maybe<Scalars['DateTime']>;
  lastListenTime?: Maybe<Scalars['DateTime']>;
  license?: Maybe<LicensePureType>;
  linkName: Scalars['String'];
  periodicRestartTime: Scalars['String'];
  playingStatus?: Maybe<PointPlayStatusPureType>;
  sleepOptions: SleepOptionsPureType;
  speedLimitOptions: SpeedLimitOptionsPureType;
  stream?: Maybe<StreamPureType>;
  supportComment?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<CompanyTagPureType>>;
  timezone: Scalars['String'];
  typeName?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
  videoStream?: Maybe<VideoStreamType>;
  /** @deprecated Now use -> device.required_version_url */
  webPlayerLink?: Maybe<Scalars['String']>;
  withMusicCut?: Maybe<Scalars['Boolean']>;
  withRadiocastHistory?: Maybe<Scalars['Boolean']>;
};

export type PointPureUnbindDeviceMutation = {
  __typename?: 'PointPureUnbindDeviceMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureUnbindDeviceMutationInput = {
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  pointId: Scalars['ID'];
};

export type PointPureUnbindStreamMutation = {
  __typename?: 'PointPureUnbindStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureUnbindStreamMutationInput = {
  pointId: Scalars['ID'];
};

export type PointPureUpdateMutation = {
  __typename?: 'PointPureUpdateMutation';
  addressData?: Maybe<AddressDataType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointPureUpdateMutationInput = {
  adOverlapResolution?: InputMaybe<AdOverlapResolution>;
  address?: InputMaybe<Scalars['String']>;
  addressData?: InputMaybe<AddressDataInput>;
  amplifyInstant?: InputMaybe<Scalars['Float']>;
  amplifyPromo?: InputMaybe<Scalars['Float']>;
  amplifyTrack?: InputMaybe<Scalars['Float']>;
  comment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  cutDuration?: InputMaybe<Scalars['Int']>;
  fileFormat?: InputMaybe<PointFileFormats>;
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  pointId: Scalars['ID'];
  supportComment?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['Int']>;
  withMusicCut?: InputMaybe<Scalars['Boolean']>;
};

export type PointPureVideoHistoryItem = {
  __typename?: 'PointPureVideoHistoryItem';
  end: Scalars['Int'];
  id: Scalars['String'];
  mediafile?: Maybe<MediafilePureType>;
  mediafileFilename?: Maybe<Scalars['String']>;
  mediafileId: Scalars['ID'];
  mediafileType: Scalars['Int'];
  onAir: Scalars['Int'];
  order: Scalars['Int'];
  pointId: Scalars['ID'];
  rotationId: Scalars['ID'];
  start: Scalars['Int'];
  streamId?: Maybe<Scalars['ID']>;
};

export type PointQueryFilter = {
  adcampaignId?: InputMaybe<Scalars['ID']>;
  billingEventId?: InputMaybe<Scalars['ID']>;
  bound?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  comment?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  companyTagIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  devicesGroupId?: InputMaybe<Scalars['ID']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeVideoStreamId?: InputMaybe<Scalars['ID']>;
  hasVideoSupport?: InputMaybe<Scalars['Boolean']>;
  invoiceId?: InputMaybe<Scalars['ID']>;
  isVideoDemo?: InputMaybe<Scalars['Boolean']>;
  masterStreamId?: InputMaybe<Scalars['ID']>;
  notApproved?: InputMaybe<Scalars['Boolean']>;
  playingStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  streamId?: InputMaybe<Scalars['ID']>;
  streamRightholders?: InputMaybe<Array<Scalars['ID']>>;
  supportComment?: InputMaybe<Scalars['String']>;
  supportedFeatures?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userId?: InputMaybe<Scalars['ID']>;
  videoStreamId?: InputMaybe<Scalars['ID']>;
  withDevices?: InputMaybe<Scalars['Boolean']>;
};

export type PointQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum PointQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsVideoDemoDesc = 'IS_VIDEO_DEMO_DESC'
}

export type PointSpeedLimitsInput = {
  pointId: Scalars['ID'];
  settings: Array<SpeedLimitsInput>;
};

export type PointStatusPureType = {
  __typename?: 'PointStatusPureType';
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  isBillingEnabled: Scalars['Boolean'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  isSleep?: Maybe<Scalars['Boolean']>;
  onlineMediafile?: Maybe<MediafilePublicObjectType>;
  paymentState: LicensePaymentState;
  streamUrl?: Maybe<Scalars['String']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  weatherStatus?: Maybe<WeatherObjectType>;
};

export type PointStatusType = {
  __typename?: 'PointStatusType';
  code?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type PointStatusesCountType = {
  __typename?: 'PointStatusesCountType';
  disabledCount?: Maybe<Scalars['Int']>;
  enabledCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PointSwitchDeviceMutation = {
  __typename?: 'PointSwitchDeviceMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointSwitchDeviceMutationInput = {
  createWebPlayer: Scalars['Boolean'];
  deviceBindingCode?: InputMaybe<Scalars['String']>;
  force?: InputMaybe<Scalars['Boolean']>;
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  pointId: Scalars['ID'];
};

export type PointType = {
  __typename?: 'PointType';
  adCampaigns?: Maybe<Array<Maybe<AdCampaignType>>>;
  adOverlapResolution: PointPointAdOverlapResolutionChoices;
  address: Scalars['String'];
  addressApproved: Scalars['Boolean'];
  amplifyInstant?: Maybe<Scalars['Float']>;
  amplifyMediafile: Scalars['Float'];
  amplifyPromo: Scalars['Float'];
  autoSwitchTo128: Scalars['Boolean'];
  autoplay?: Maybe<Scalars['Boolean']>;
  bound?: Maybe<Scalars['Boolean']>;
  cacheMode?: Maybe<PointPointCacheModeChoices>;
  code?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  company?: Maybe<UserCompanyType>;
  contentBlocks?: Maybe<Array<Maybe<ContentBlockType>>>;
  contentStatus?: Maybe<PointStatusType>;
  country?: Maybe<PointPointCountryChoices>;
  created: Scalars['DateTime'];
  ctype?: Maybe<Scalars['String']>;
  cutDuration: Scalars['Int'];
  deviceType?: Maybe<Scalars['Int']>;
  deviceUuid?: Maybe<Scalars['String']>;
  /** @deprecated depricated */
  endSleep?: Maybe<Scalars['Time']>;
  fileFormat: PointPointFileFormatChoices;
  generationId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  isVideoDemo: Scalars['Boolean'];
  isVideoMode?: Maybe<Scalars['Boolean']>;
  lastContentModified?: Maybe<Scalars['DateTime']>;
  lastListenTime?: Maybe<Scalars['DateTime']>;
  lat?: Maybe<Scalars['Float']>;
  license?: Maybe<LicenseType>;
  licenseStateExt?: Maybe<Scalars['String']>;
  linkName?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['Float']>;
  logLevel?: Maybe<Scalars['String']>;
  logLevels: Array<Scalars['String']>;
  logs: Array<PointLogType>;
  minGenerationCount?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  musicboxPoint?: Maybe<MusicBoxType>;
  normalGenerationCount?: Maybe<Scalars['Int']>;
  onlineMediafile?: Maybe<MediafileObjectType>;
  periodicRestartTime: Scalars['String'];
  playingStatus?: Maybe<PointStatusType>;
  pointAdcompany: Array<AdCampaignType>;
  schedule?: Maybe<Scalars['JSONString']>;
  settings: Scalars['JSONString'];
  sleepMode?: Maybe<Scalars['Boolean']>;
  sleepSettings?: Maybe<Array<Maybe<SleepSettingObject>>>;
  specialGeneration?: Maybe<Scalars['Boolean']>;
  speedLimitOptions: SpeedLimitOptionsPureType;
  speedLimitSettings?: Maybe<Scalars['JSONString']>;
  /** @deprecated depricated */
  startSleep?: Maybe<Scalars['Time']>;
  stateChangedOn?: Maybe<Scalars['DateTime']>;
  stream?: Maybe<StreamType>;
  streamMigrate?: Maybe<StreamType>;
  supportComment: Scalars['String'];
  tags?: Maybe<Array<CompanyTagPureType>>;
  /** @deprecated depricated */
  testPeriod?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  /** @deprecated depricated */
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  typeName?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendType>;
  videoStream?: Maybe<VideoStreamType>;
  volume?: Maybe<Scalars['Int']>;
  weatherAddress: Scalars['String'];
  weatherStatus?: Maybe<WeatherObjectType>;
  webPlayerLink?: Maybe<Scalars['String']>;
  withMusicCut: Scalars['Boolean'];
  withRadiocastHistory: Scalars['Boolean'];
};

export type PointUnbindVideoStreamMutation = {
  __typename?: 'PointUnbindVideoStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type PointUnbindVideoStreamMutationInput = {
  pointId: Scalars['ID'];
};

export type PointVideoHistoryPaginationType = {
  __typename?: 'PointVideoHistoryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<PointPureVideoHistoryItem>;
};

export type PointVideoHistoryQueryFilter = {
  mediafileId?: InputMaybe<Scalars['ID']>;
  onAirRange: DateTimeRange;
  pointId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type PointVideoHistoryQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum PointVideoHistoryQuerySort {
  OnAirAsc = 'ON_AIR_ASC',
  OnAirDesc = 'ON_AIR_DESC'
}

export type PointWebUpdateStatusMutation = {
  __typename?: 'PointWebUpdateStatusMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointsBindCompanyTagsMutation = {
  __typename?: 'PointsBindCompanyTagsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointsBindCompanyTagsMutationInput = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<PointsBindTagsMutationFilter>;
  tagNames: Array<Scalars['String']>;
};

export type PointsBindTagsMutationFilter = {
  all?: InputMaybe<Scalars['Boolean']>;
  pointsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PointsBulkEnableMutation = {
  __typename?: 'PointsBulkEnableMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointsBulkEnableMutationInput = {
  logOrigin?: InputMaybe<Scalars['String']>;
  pointIds: Array<InputMaybe<Scalars['ID']>>;
};

export type PointsCreateMutation = {
  __typename?: 'PointsCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  successItems?: Maybe<Array<PointCreateSuccessItemType>>;
};

export type PointsCreateMutationInput = {
  points: Array<PointPureCreateMutationInput>;
};

export type PointsPlayingStatusesPureType = {
  __typename?: 'PointsPlayingStatusesPureType';
  mbNoConnection?: Maybe<Scalars['Int']>;
  mbPlaying?: Maybe<Scalars['Int']>;
  notGeneration?: Maybe<Scalars['Int']>;
  notPlaying?: Maybe<Scalars['Int']>;
  playerDisabled?: Maybe<Scalars['Int']>;
  playing?: Maybe<Scalars['Int']>;
  sleep?: Maybe<Scalars['Int']>;
  stop?: Maybe<Scalars['Int']>;
};

export type PointsQueryPaginationType = {
  __typename?: 'PointsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PointPureType>>;
  statusesInfo?: Maybe<PointsPlayingStatusesPureType>;
};

export type PointsSearchItem = {
  __typename?: 'PointsSearchItem';
  point?: Maybe<PointPureType>;
  query: Scalars['String'];
};

export type PointsSearchMultilineResult = {
  __typename?: 'PointsSearchMultilineResult';
  excludedResult: Array<PointPureType>;
  result: Array<PointsSearchItem>;
};

export type PointsUnsetCompanyTagsMutation = {
  __typename?: 'PointsUnsetCompanyTagsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PointsUnsetCompanyTagsMutationInput = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<PointsUnsetTagsMutationFilter>;
  tagNames: Array<Scalars['String']>;
};

export type PointsUnsetTagsMutationFilter = {
  all?: InputMaybe<Scalars['Boolean']>;
  pointsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PosterFilePureType = {
  __typename?: 'PosterFilePureType';
  fullhdFilename: Scalars['String'];
  fullhdUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  miniatureFilename?: Maybe<Scalars['String']>;
  miniatureUri?: Maybe<Scalars['String']>;
};

export type PosterObjectType = {
  __typename?: 'PosterObjectType';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mini?: Maybe<Scalars['String']>;
};

export enum PreparationStatusGraphqlEnum {
  PreparationFail = 'preparation_fail',
  PreparationInProgress = 'preparation_in_progress',
  PreparationSuccess = 'preparation_success'
}

export type PricePlanPeriodPureType = {
  __typename?: 'PricePlanPeriodPureType';
  id: Scalars['ID'];
  payFrequencyMonth: Scalars['Int'];
  rows: Array<PricePlanRowPureType>;
  title: Scalars['String'];
};

export type PricePlanPureType = {
  __typename?: 'PricePlanPureType';
  alias: Scalars['String'];
  currency: Currencies;
  id: Scalars['ID'];
  offerLink: Scalars['String'];
  periods: Array<PricePlanPeriodPureType>;
  rows: Array<PricePlanRowPureType>;
  title: Scalars['String'];
  titleForManager: Scalars['String'];
  useByDefault: Scalars['Boolean'];
};

export type PricePlanRowPureType = {
  __typename?: 'PricePlanRowPureType';
  amount: Scalars['Float'];
  id: Scalars['ID'];
  stepRangeLower: Scalars['Int'];
  stepRangeUpper?: Maybe<Scalars['Int']>;
};

export type PromoAdInput = {
  playDuration?: InputMaybe<Scalars['Int']>;
  promoAdId?: InputMaybe<Scalars['ID']>;
  promoId: Scalars['ID'];
  time?: InputMaybe<Scalars['Time']>;
  videoPromoId?: InputMaybe<Scalars['ID']>;
  withSound?: InputMaybe<Scalars['Boolean']>;
};

export type PromoClipType = {
  __typename?: 'PromoClipType';
  adcampaignStatus: Scalars['String'];
  adcampaignTitle: Scalars['String'];
  id: Scalars['ID'];
  isSelected: Scalars['Boolean'];
  promo?: Maybe<MediafilePureType>;
};

export type PromoClipsPaginationType = {
  __typename?: 'PromoClipsPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PromoClipType>>;
  statusesInfo?: Maybe<AdCampaignsStatusesPureType>;
};

export type PromoClipsQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AdCampaignStatusesEnum>>>;
};

export type PromoClipsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum PromoClipsQuerySort {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC'
}

export type PromoObjectType = {
  __typename?: 'PromoObjectType';
  bpm: Scalars['Int'];
  created: Scalars['DateTime'];
  duration: Scalars['Int'];
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  marksJson: Scalars['JSONString'];
  performerTitle: Scalars['String'];
  rms: Scalars['Int'];
  title: Scalars['String'];
  userValues?: Maybe<Array<Maybe<ValueObjectType>>>;
};

export type PromoPureType = {
  __typename?: 'PromoPureType';
  duration: Scalars['Int'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  performerTitle: Scalars['String'];
  title: Scalars['String'];
};

export type PromoRollSynthBackgroundType = {
  __typename?: 'PromoRollSynthBackgroundType';
  backgroundId: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type PromoRollSynthCompanySettingsType = {
  __typename?: 'PromoRollSynthCompanySettingsType';
  dailyLimit: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  maxTextLength: Scalars['Int'];
  remainingToday: Scalars['Int'];
};

export type PromoRollSynthCreateMutation = {
  __typename?: 'PromoRollSynthCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<PromoRollSynthJobType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PromoRollSynthCreateMutationInput = {
  backgroundId: Scalars['ID'];
  companyId: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
  voiceId: Scalars['ID'];
};

export type PromoRollSynthDeleteMutation = {
  __typename?: 'PromoRollSynthDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  job?: Maybe<PromoRollSynthJobType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type PromoRollSynthDeleteMutationInput = {
  companyId: Scalars['ID'];
  jobId: Scalars['ID'];
};

/** An enumeration. */
export enum PromoRollSynthJobStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type PromoRollSynthJobType = {
  __typename?: 'PromoRollSynthJobType';
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  promoMediafile?: Maybe<MediafilePureType>;
  status?: Maybe<PromoRollSynthJobStatus>;
  title: Scalars['String'];
};

export type PromoRollSynthJobsQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type PromoRollSynthJobsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type PromoRollSynthJobsQueryPaginationType = {
  __typename?: 'PromoRollSynthJobsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<PromoRollSynthJobType>>;
};

export type PromoRollSynthVoiceType = {
  __typename?: 'PromoRollSynthVoiceType';
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  voiceId: Scalars['String'];
};

export enum PromoSelectionDraftAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Deselect = 'DESELECT',
  DeselectAll = 'DESELECT_ALL',
  Select = 'SELECT',
  SelectAll = 'SELECT_ALL'
}

export type PromoSelectionDraftFilterInput = {
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AdCampaignStatusesEnum>>>;
};

export type PromoSelectionDraftInput = {
  action: PromoSelectionDraftAction;
  companyId: Scalars['ID'];
  filters?: InputMaybe<PromoSelectionDraftFilterInput>;
  promoIds?: InputMaybe<Array<Scalars['Int']>>;
  promoSelectionDraftId?: InputMaybe<Scalars['ID']>;
};

export type PromoSelectionDraftMutation = {
  __typename?: 'PromoSelectionDraftMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  promoSelectionDraftId?: Maybe<Scalars['ID']>;
  selectedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PromoUploadPureMutation = {
  __typename?: 'PromoUploadPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  promo?: Maybe<MediafilePureType>;
};

export type PromoUploadPureMutationInput = {
  file: Scalars['Upload'];
  mediaType?: InputMaybe<AdCampaignMediaTypeEnum>;
};

export type Query = {
  __typename?: 'Query';
  acceptanceAdvancedQuery?: Maybe<AcceptanceAdvanceType>;
  accountManagersQuery: AccountManagersQueryPaginationType;
  activationCodeSmsStatus: Scalars['String'];
  adCampaignPure?: Maybe<AdCampaignPureType>;
  adcampaignPureLogs?: Maybe<Array<AdCampaignPureLogsType>>;
  adcampaignsPaginationQuery: AdCampaignsQueryPaginationType;
  adcampaignsStatusesCountQuery: AdcampaignsStatusesCountType;
  additionalFeatures?: Maybe<Array<Maybe<AdditionalFeatureObjectTpye>>>;
  allowedActionsForPhone: Scalars['String'];
  asyncTaskProgress?: Maybe<AsyncTaskProgressType>;
  attributesPureQuery: AttributesQueryListType;
  brandPointsSearchByAddress: PointsSearchMultilineResult;
  brandPointsSearchByComment: PointsSearchMultilineResult;
  brandsPaginationQuery: BrandPaginationQueryType;
  businessSpheresPaginationQuery: BusinessSpheresQueryPaginationType;
  captchaSettings: CaptchaSettingsType;
  certificatePointsQuery: CertificatePointsQueryPaginationType;
  checkCountriesAvailabilityChange?: Maybe<CheckCountriesAvailabilityChangeResultType>;
  commonSettingsQuery: CommonSettingsType;
  companyApiTokensPaginationQuery: CompanyApiTokensPaginationType;
  companyBillingInfoQuery?: Maybe<UserBillingInfo>;
  /** @deprecated legacy */
  companyPlaybackReportSettings: Array<CompanyPlaybackReportSettingsType>;
  companyPlaybackReportSettingsQuery: CompanyPlaybackReportSettingsPaginationPureType;
  companyPlaybackReports: Array<CompanyPlaybackReportType>;
  companyRecommendedStreamsQuery: Array<StreamPureType>;
  companyTagPaginationQuery: CompanyTagQueryPaginationType;
  companyTemplateStreamsQuery: CompanyTemplateStreamsType;
  companyThematicContentBlocksPureQuery: Array<CompanyThematicContentBlockPureType>;
  contentBlockPaginationQuery: ContentBlockQueryPaginationType;
  contentBlockPureQuery: ContentBlockPureType;
  countriesQuery: Array<CountryType>;
  currentUser?: Maybe<NewUserType>;
  currentUserPureQuery?: Maybe<UserExtendPureType>;
  desktopPlayerDownloadLinkPureQuery: Scalars['String'];
  deviceBusinessSpheresPaginationPureQuery: DeviceBusinessSpheresQueryPaginationType;
  deviceByBindingCodePureQuery: PlayerDeviceQueryPureType;
  deviceCompanyReferralUuidQuery: Scalars['String'];
  deviceDefaultVideoSettingsPureQuery: PlayerDeviceVideoSettingsQueryPureType;
  deviceDislikedTracksPureQuery: Array<DeviceStreamDislike>;
  deviceGenerationSettingsLastUpdatedPureQuery: PlayerDeviceGenerationLastUpdatedQueryPureType;
  deviceGenerationSettingsPureQuery: PlayerDeviceGenerationSettingsQueryPureType;
  deviceIdsByPercentagePureQuery: PlayerDeviceRandomIdsQueryType;
  deviceLibraryRecommendedCollection?: Maybe<LibraryRecommendedCollectionPagination>;
  deviceLibraryRecommendedSubcollections: SubCollectionsPaginationType;
  deviceLibrarySubcollection?: Maybe<LibrarySubCollectionPureType>;
  deviceLikedTracksPureQuery: Array<DeviceStreamDislike>;
  /** @deprecated deprecated */
  deviceMediafilePureQuery: DeviceMediafileObjectType;
  devicePointHistoryPurePaginationQuery: DevicePointHistoryPurePaginationType;
  devicePureQuery: PlayerDeviceQueryPureType;
  deviceRandomStreamMediafilesPaginationPureQuery: DeviceStreamMediafilesRandomQueryPurePaginationType;
  deviceStateQuery?: Maybe<DeviceStateType>;
  deviceStreamGroupsPaginationPureQuery: DeviceStreamGroupsQueryPaginationType;
  deviceStreamLibrary?: Maybe<LibraryPureType>;
  deviceStreamLibraryCollection?: Maybe<LibraryCollectionPureType>;
  deviceStreamLibraryGroup?: Maybe<LibraryGroupPureType>;
  deviceStreamLibraryStreams: Array<LibraryStreamPureType>;
  deviceStreamMediafiles: DeviceStreamMediafilesPaginationType;
  deviceStreamMediafilesEventsPaginationQuery: MediafileApprovalPaginationType;
  deviceStreamPureQuery?: Maybe<StreamPureType>;
  deviceStreamsPaginationPureQuery: DeviceStreamsQueryPaginationType;
  deviceStreamsSearchTagsPureQuery: StreamSearchTagsPureType;
  deviceTemplateStreamsPaginationPureQuery: DeviceStreamsQueryPaginationType;
  deviceTopStreamsByBusinessSpherePureQuery: Array<StreamPureType>;
  deviceVideoSettingsLastUpdatedPureQuery: PlayerDeviceVideoSettingsLastUpdatedQueryPureType;
  deviceVideoSettingsPureQuery: PlayerDeviceVideoSettingsQueryPureType;
  devicesAdditionalFeatures: Array<Scalars['String']>;
  devicesGroupLogsPurePaginationQuery: DevicesGroupLogsPureQueryPaginationType;
  devicesGroupPaginationQuery: DevicesGroupPaginationPureType;
  devicesGroupQuery: DevicesGroupType;
  devicesPaginationQuery: PlayerDevicesQueryPaginationType;
  discountTemplatesPureQuery?: Maybe<Array<Maybe<DiscountTemplatePureType>>>;
  domainEventQuery?: Maybe<DomainEventPureType>;
  domainEventsPaginationQuery: DomainEventPaginationPureType;
  e2eActivationCodeQuery: Scalars['String'];
  emenuGenerationsPaginationQuery: EmenuGenerationPaginationPureType;
  emenuPaginationQuery: EmenuMediafilePaginationPureType;
  emenuPointClientIdQuery: EmenuPointClientIdType;
  emenuPointClientIdsPaginationQuery: EmenuPointClientIdPaginationPureType;
  emenuPointQuery: EmenuPointType;
  emenuPointsPaginationQuery: EmenuPointPaginationPureType;
  emenuQuery: EmenuMediafileType;
  emenuSkusQuery: Array<Scalars['String']>;
  invitationsPaginationQuery: UserInvitationsPaginationType;
  invoicePureQuery: InvoicePureType;
  invoicesPaginationQuery: InvoicesPaginationType;
  lastLaunchedStream?: Maybe<StreamPureType>;
  libraryBusinessSphereRecommendations: Array<LibraryBusinessSphereRecommendationType>;
  libraryBusinessSphereRecommendationsDraft: Array<LibraryBusinessSphereRecommendationDraftType>;
  libraryCollectionsSearch: CollectionsPaginationType;
  libraryStreamsSearch: StreamsQueryPaginationType;
  licensesPaginationQuery: LicensesPaginationType;
  mediafilePureQuery?: Maybe<MediafilePureType>;
  mediafilesPaginationQuery: MediafilesQueryPaginationType;
  mmSyncStatusPureQuery: Array<MmIntegrationRegistryPureStatus>;
  musicbox?: Maybe<MusicBoxType>;
  musicboxes?: Maybe<Array<Maybe<MusicBoxType>>>;
  notificationsQuery: Array<NotificationType>;
  organizationCurrentPricePlanQuery?: Maybe<OrganizationPricePlanPureType>;
  organizationDiscountsPureQuery?: Maybe<Array<Maybe<OrganizationDiscountPureType>>>;
  organizationPricePlanQuery?: Maybe<PricePlanPureType>;
  organizationPricePlansCanMigrateToQuery?: Maybe<Array<Maybe<PricePlanPureType>>>;
  paymentMethodPureQuery?: Maybe<PaymentMethodStatusType>;
  paymentMethodsStatePureQuery: PaymentMethodsStatePureType;
  playerDevice?: Maybe<PlayerDeviceType>;
  playerDeviceStreams?: Maybe<Array<Maybe<StreamType>>>;
  playerVersionPureQuery: PlayerVersionQueryPureType;
  playerVersions?: Maybe<PlayerVersionPaginationType>;
  playerVersionsPaginationQuery: PlayerVersionsQueryPaginationType;
  pointGenerationSettingsPureQuery: PlayerDeviceGenerationSettingsQueryPureType;
  pointHistoryPaginationQuery: PointHistoryPaginationType;
  pointLog?: Maybe<Array<Maybe<PointLogType>>>;
  pointPublic?: Maybe<PointPublicType>;
  pointPure?: Maybe<PointPureType>;
  pointStatusPure?: Maybe<PointStatusPureType>;
  pointVideoHistoryPaginationQuery: PointVideoHistoryPaginationType;
  pointsByTags: Array<PointPureType>;
  pointsPaginationQuery: PointsQueryPaginationType;
  pointsSearchMultilineByCommentsQuery: PointsSearchMultilineResult;
  pointsSearchMultilineQuery: PointsSearchMultilineResult;
  pointsStatusesCountQuery: PointStatusesCountType;
  promoClipsPaginationQuery: PromoClipsPaginationType;
  promoRollSynthBackgrounds: Array<PromoRollSynthBackgroundType>;
  promoRollSynthCompanySettings: PromoRollSynthCompanySettingsType;
  promoRollSynthJobs: PromoRollSynthJobsQueryPaginationType;
  promoRollSynthVoices: Array<PromoRollSynthVoiceType>;
  resumeSubscriptionCostQuery: ResumeSubscriptionCostInfoPureType;
  rightholdersPaginationQuery: RightholderQueryPaginationType;
  rightholdersPureQuery?: Maybe<RightholdersPureType>;
  sberMultiroomGetMultiroomQuery?: Maybe<MultiroomPureType>;
  searchMmClients?: Maybe<MmClientSearchType>;
  smartlkCompanyMediafilesQuery: VideoMediafileWithStatusQueryType;
  smartlkCompanyPlaybackReportSettingsQuery: CompanyPlaybackReportSettingsPaginationPureType;
  smartlkDevicesGroupPaginationQuery: DevicesGroupPaginationPureType;
  smartlkDevicesGroupQuery: DevicesGroupType;
  smartlkLibraryCollection?: Maybe<LibraryCollectionPureType>;
  smartlkLibraryRecommendedCollection: LibraryRecommendedCollectionPagination;
  smartlkLibraryRecommendedSubcollections: SubCollectionsPaginationType;
  smartlkLibraryStream: LibraryStreamPaginationType;
  smartlkLibrarySubcollection?: Maybe<LibrarySubCollectionPureType>;
  smartlkStreamLibrary?: Maybe<LibraryPureType>;
  smartlkVideoStreamQuery: VideoStreamType;
  smartlkVideoStreamsPaginationQuery: VideoStreamPaginationPureType;
  speakerBusinessSpheresPaginationQuery: DeviceBusinessSpheresQueryPaginationType;
  speakerGenresQuery: Array<Scalars['String']>;
  speakerNextMediafileQuery?: Maybe<SmartSpeakerNextMediafileType>;
  standardizedAddressPureQuery: StandardizedAddressQueryResultType;
  standardizedAddressesQuery: StandardizedAddressesQueryResultType;
  streamApprovalQuery?: Maybe<StreamPureType>;
  streamContainedByLibraries: Array<LibraryFilteredByStreamType>;
  streamDraft?: Maybe<StreamDraftPureType>;
  streamDraftFind?: Maybe<StreamDraftPureType>;
  streamDraftMediafilesRecommendations?: Maybe<ScoredMediafilesPaginationType>;
  streamLibraries: LibrariesPaginationPureType;
  streamLibrary?: Maybe<LibraryPureType>;
  streamLibraryCollection?: Maybe<LibraryCollectionPureType>;
  streamLibraryCollectionDraft?: Maybe<LibraryCollectionDraftPureType>;
  streamLibraryDraft?: Maybe<LibraryDraftPureType>;
  streamLibraryDraftByOrigin?: Maybe<Scalars['ID']>;
  streamLibraryDrafts: LibraryDraftsPaginationPureType;
  streamLibraryGroup?: Maybe<LibraryGroupPureType>;
  streamLibraryGroupDraft?: Maybe<LibraryGroupDraftPureType>;
  streamLibraryOriginByDraft?: Maybe<Scalars['ID']>;
  streamLibrarySubcollection?: Maybe<LibrarySubCollectionPureType>;
  streamLibrarySubcollectionDraft?: Maybe<LibrarySubCollectionDraftPureType>;
  streamLibrarySubcollectionsDrafts: SubCollectionsDraftsPaginationType;
  streamLogsPaginationQuery: StreamLogsQueryPaginationType;
  streamMediafiles: MediafilesQueryPaginationType;
  streamMediafilesApproval: MediafileApprovalPaginationType;
  streamMediafilesEvents: MediafileApprovalPaginationType;
  streamMediafilesRandomPaginationQuery: StreamMediafilesRandomQueryPaginationType;
  streamPureQuery?: Maybe<StreamPureType>;
  streamPureTemplateGroups: Array<StreamPureTemplateGroupType>;
  streamSearchTagsQuery: StreamSearchTagsType;
  streamTaskPureQuery: StreamTaskPureType;
  streamTasksManagersPaginationQuery: StreamTasksManagersQueryPaginationType;
  streamTasksPaginationQuery: StreamTasksQueryPaginationType;
  streamTasksRedactorsPaginationQuery: StreamTasksRedactorsQueryPaginationType;
  streamsFullTextSearchQuery: StreamsQueryPaginationType;
  streamsPaginationQuery: StreamsQueryPaginationType;
  subscriptionCostByPricePlanPeriodQuery?: Maybe<Scalars['Float']>;
  subscriptionExtensionCostQuery: SubscriptionExtensionCostInfoPureType;
  thematicBlockRandomMediafilesPaginationQuery: ThematicBlockRandomMediafilesQueryPaginationType;
  thematicContentBlocksPureQuery: Array<ThematicContentBlockPureType>;
  timezones?: Maybe<Array<Maybe<TimezoneObjectType>>>;
  updateRequestPureQuery: UpdateRequestQueryPureType;
  updateRequestsPaginationQuery: UpdateRequestsQueryPaginationType;
  userCompanies?: Maybe<UserCompanySearchType>;
  userCompaniesPaginationQuery: UserCompaniesQueryPaginationType;
  userCompanyChecklistToDeactivateQuery: CompanyCheckListToDeactivatePureType;
  userCompanyExistQuery: Scalars['Boolean'];
  userCompanyQuery: UserCompanyPureType;
  userFeaturesOnboardingQuery: Array<Maybe<UserFeaturesOnboardingType>>;
  userGetSberLinkUri: Scalars['String'];
  userGetSberOauthUri: Scalars['String'];
  userLog?: Maybe<Array<Maybe<UserLogType>>>;
  userPureQuery?: Maybe<UserExtendPureType>;
  userPureSuggestionAddress: SuggestionAddressQueryResultPureType;
  userPureSuggestionCompany: SuggestionCompanyQueryResultPureType;
  usersPaginationQuery: UsersQueryPaginationType;
  usersSearchMultilineQuery: UsersSearchMultilineResult;
  valuesPureQuery: Array<ValueObjectPureType>;
  videoMediafilesPaginationQuery: VideoMediafilePaginationPureType;
  videoStreamLogsPaginationQuery: VideoStreamLogsQueryPaginationType;
  videoStreamQuery: VideoStreamType;
  videoStreamsPaginationQuery: VideoStreamPaginationPureType;
  zvukProfile?: Maybe<ZvukProfileType>;
  zvukProfileEventsPaginationQuery: ZvukProfileEventsPaginationPureType;
  zvukProfileList: Array<Maybe<ZvukProfileType>>;
  zvukProfilePaginationQuery: ZvukProfileQueryPaginationType;
};


export type QueryAcceptanceAdvancedQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryAccountManagersQueryArgs = {
  filters: AccountManagersQueryFilter;
  pagination: AccountManagersQueryPagination;
  sort: AccountManagersQuerySort;
};


export type QueryActivationCodeSmsStatusArgs = {
  phone: Scalars['String'];
};


export type QueryAdCampaignPureArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAdcampaignPureLogsArgs = {
  input: AdCampaignPureQueryLogsInput;
};


export type QueryAdcampaignsPaginationQueryArgs = {
  filters: AdCampaignQueryFilter;
  pagination: AdCampaignQueryPagination;
  sort: AdCampaignQuerySort;
};


export type QueryAdcampaignsStatusesCountQueryArgs = {
  filters: AdCampaignQueryFilter;
};


export type QueryAllowedActionsForPhoneArgs = {
  phone: Scalars['String'];
};


export type QueryAsyncTaskProgressArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryBrandPointsSearchByAddressArgs = {
  brandId: Scalars['ID'];
  companiesIds?: InputMaybe<Array<Scalars['ID']>>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  queryMultiline: Scalars['String'];
};


export type QueryBrandPointsSearchByCommentArgs = {
  brandId: Scalars['ID'];
  companiesIds?: InputMaybe<Array<Scalars['ID']>>;
  queryMultiline: Scalars['String'];
};


export type QueryBrandsPaginationQueryArgs = {
  filters: BrandPaginationQueryFilter;
  pagination: BrandPaginationQueryPagination;
  sort: BrandPaginationQuerySort;
};


export type QueryBusinessSpheresPaginationQueryArgs = {
  pagination: BusinessSpheresQueryPagination;
  sort?: InputMaybe<BusinessSpheresQuerySort>;
};


export type QueryCertificatePointsQueryArgs = {
  filters: CertificatePointsQueryFilter;
  pagination: CertificatePointsQueryPagination;
};


export type QueryCheckCountriesAvailabilityChangeArgs = {
  input: CheckCountriesAvailabilityChangeQueryInput;
};


export type QueryCompanyApiTokensPaginationQueryArgs = {
  filters: CompanyApiTokensQueryFilter;
  pagination: CompanyApiTokensQueryPagination;
  sort: CompanyApiTokensQuerySort;
};


export type QueryCompanyBillingInfoQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryCompanyPlaybackReportSettingsArgs = {
  companyId: Scalars['ID'];
};


export type QueryCompanyPlaybackReportSettingsQueryArgs = {
  filters: CompanyPlaybackReportSettingsFilter;
  pagination: CompanyPlaybackReportSettingsPagination;
};


export type QueryCompanyPlaybackReportsArgs = {
  companyId: Scalars['ID'];
  filters?: InputMaybe<CompanyPlaybackReportsQueryFilter>;
  rightholderId?: InputMaybe<Scalars['ID']>;
};


export type QueryCompanyRecommendedStreamsQueryArgs = {
  companyId: Scalars['ID'];
  libraryId: Scalars['ID'];
};


export type QueryCompanyTagPaginationQueryArgs = {
  filters: CompanyTagQueryFilter;
  pagination: CompanyTagQueryPagination;
};


export type QueryCompanyTemplateStreamsQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryCompanyThematicContentBlocksPureQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryContentBlockPaginationQueryArgs = {
  filters: ContentBlockQueryFilter;
  pagination: ContentBlockQueryPagination;
  sort: ContentBlockQuerySort;
};


export type QueryContentBlockPureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryDeviceBusinessSpheresPaginationPureQueryArgs = {
  pagination: PlayerDeviceBusinessSpheresQueryPagination;
};


export type QueryDeviceByBindingCodePureQueryArgs = {
  bindingCode: Scalars['String'];
  withRemoteFlag?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDeviceDefaultVideoSettingsPureQueryArgs = {
  version?: InputMaybe<VideoSettingsVersion>;
};


export type QueryDeviceGenerationSettingsPureQueryArgs = {
  version?: InputMaybe<GenerationSettingsVersion>;
};


export type QueryDeviceIdsByPercentagePureQueryArgs = {
  filters: PlayerDevicesRandomIdsByPercentageFilter;
  percentage: Scalars['Int'];
};


export type QueryDeviceLibraryRecommendedCollectionArgs = {
  pagination: DeviceLibraryRecommendedCollectionPagination;
};


export type QueryDeviceLibraryRecommendedSubcollectionsArgs = {
  pagination: DeviceLibraryRecommendedSubCollectionsPagination;
};


export type QueryDeviceLibrarySubcollectionArgs = {
  subcollectionId: Scalars['ID'];
};


export type QueryDeviceMediafilePureQueryArgs = {
  mediafileId: Scalars['ID'];
};


export type QueryDevicePointHistoryPurePaginationQueryArgs = {
  filters: PlayerDevicePointHistoryQueryFilter;
  pagination: PlayerDevicePointHistoryQueryPagination;
  sort: PlayerDevicePointHistoryQuerySort;
};


export type QueryDevicePureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryDeviceRandomStreamMediafilesPaginationPureQueryArgs = {
  filters: PlayerDeviceStreamRandomMediafilesPureQueryFilter;
  pagination: PlayerDeviceStreamRandomMediafilesPureQueryPagination;
};


export type QueryDeviceStateQueryArgs = {
  deviceId: Scalars['ID'];
};


export type QueryDeviceStreamGroupsPaginationPureQueryArgs = {
  pagination: PlayerDeviceStreamGroupsQueryPagination;
};


export type QueryDeviceStreamLibraryCollectionArgs = {
  collectionId: Scalars['ID'];
};


export type QueryDeviceStreamLibraryGroupArgs = {
  groupId: Scalars['ID'];
};


export type QueryDeviceStreamLibraryStreamsArgs = {
  collectionId?: InputMaybe<Scalars['ID']>;
  subcollectionId?: InputMaybe<Scalars['ID']>;
};


export type QueryDeviceStreamMediafilesArgs = {
  filters: DeviceStreamMediafilesFilter;
  pagination: DeviceStreamMediafilesPagination;
  sort: DeviceStreamMediafilesSort;
};


export type QueryDeviceStreamMediafilesEventsPaginationQueryArgs = {
  filters: DeviceStreamMediafilesEventsFilter;
  pagination: DeviceStreamMediafilesEventsPagination;
  sort: DeviceStreamMediafilesEventsSort;
};


export type QueryDeviceStreamPureQueryArgs = {
  streamId: Scalars['ID'];
};


export type QueryDeviceStreamsPaginationPureQueryArgs = {
  filters: DeviceStreamsQueryFilter;
  pagination: DeviceStreamsPagination;
  sort: DeviceStreamsQuerySort;
};


export type QueryDeviceTemplateStreamsPaginationPureQueryArgs = {
  filters: DeviceTemplateStreamsQueryFilter;
  pagination: DeviceTemplateStreamsPagination;
  sort: DeviceTemplateStreamsQuerySort;
};


export type QueryDeviceVideoSettingsPureQueryArgs = {
  version?: InputMaybe<VideoSettingsVersion>;
};


export type QueryDevicesGroupLogsPurePaginationQueryArgs = {
  filters: DevicesGroupLogsPureQueryFilter;
  pagination: DevicesGroupLogsPureQueryPagination;
};


export type QueryDevicesGroupPaginationQueryArgs = {
  filters: DevicesGroupQueryFilter;
  pagination: DevicesGroupQueryPagination;
  sort: DevicesGroupQuerySort;
};


export type QueryDevicesGroupQueryArgs = {
  id: Scalars['ID'];
};


export type QueryDevicesPaginationQueryArgs = {
  filters: PlayerDeviceQueryFilter;
  pagination: PlayerDeviceQueryPagination;
  sort: PlayerDeviceQuerySort;
};


export type QueryDomainEventQueryArgs = {
  eventId: Scalars['ID'];
};


export type QueryDomainEventsPaginationQueryArgs = {
  filters: DomainEventsQueryFilter;
  pagination: DomainEventsQueryPagination;
  sort: DomainEventsQuerySort;
};


export type QueryE2eActivationCodeQueryArgs = {
  phone: Scalars['String'];
  token: Scalars['String'];
};


export type QueryEmenuGenerationsPaginationQueryArgs = {
  filters: EmenuGenerationQueryFilter;
  pagination: EmenuGenerationQueryPagination;
};


export type QueryEmenuPaginationQueryArgs = {
  filters: EmenuQueryFilter;
  pagination: EmenuQueryPagination;
  sort: EmenuQuerySort;
};


export type QueryEmenuPointClientIdQueryArgs = {
  pointId: Scalars['ID'];
};


export type QueryEmenuPointClientIdsPaginationQueryArgs = {
  filters: EmenuPointClientIdQueryFilter;
  pagination: EmenuPointClientIdQueryPagination;
  sort: EmenuPointClientIdQuerySort;
};


export type QueryEmenuPointQueryArgs = {
  id: Scalars['ID'];
};


export type QueryEmenuPointsPaginationQueryArgs = {
  filters: EmenuPointQueryFilter;
  pagination: EmenuPointQueryPagination;
  sort: EmenuPointQuerySort;
};


export type QueryEmenuQueryArgs = {
  id: Scalars['ID'];
};


export type QueryEmenuSkusQueryArgs = {
  filters: EmenuSkusQueryFilter;
};


export type QueryInvitationsPaginationQueryArgs = {
  filters: InvitationsQueryFilter;
  pagination: InvitationsPagination;
  sort: InvitationsQuerySort;
};


export type QueryInvoicePureQueryArgs = {
  invoiceId: Scalars['ID'];
};


export type QueryInvoicesPaginationQueryArgs = {
  filters: InvoicesQueryFilter;
  pagination: InvoicesQueryPagination;
  sort: InvoicesQuerySort;
};


export type QueryLastLaunchedStreamArgs = {
  companyId: Scalars['ID'];
};


export type QueryLibraryBusinessSphereRecommendationsArgs = {
  filters: LibraryBusinessSphereRecommendationsFilter;
};


export type QueryLibraryBusinessSphereRecommendationsDraftArgs = {
  filters: LibraryBusinessSphereRecommendationsDraftFilter;
};


export type QueryLibraryCollectionsSearchArgs = {
  filters: LibraryCollectionsSearchQueryFilter;
  pagination: LibraryCollectionsSearchQueryPagination;
};


export type QueryLibraryStreamsSearchArgs = {
  filters: LibraryStreamsSearchQueryFilter;
  pagination: LibraryStreamsSearchQueryPagination;
};


export type QueryLicensesPaginationQueryArgs = {
  filters: LicensesQueryFilter;
  pagination: LicensesQueryPagination;
  sort: LicensesQuerySort;
};


export type QueryMediafilePureQueryArgs = {
  mediafileId: Scalars['ID'];
};


export type QueryMediafilesPaginationQueryArgs = {
  filters: MediafilesQueryFilter;
  pagination: MediafilesQueryPagination;
  sort: MediafilesQuerySort;
};


export type QueryMmSyncStatusPureQueryArgs = {
  contentBlockIds: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryMusicboxArgs = {
  id: Scalars['Int'];
};


export type QueryMusicboxesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  unavailableLongTime?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrganizationCurrentPricePlanQueryArgs = {
  organizationId: Scalars['ID'];
};


export type QueryOrganizationDiscountsPureQueryArgs = {
  organizationId: Scalars['ID'];
};


export type QueryOrganizationPricePlanQueryArgs = {
  organizationId: Scalars['ID'];
};


export type QueryOrganizationPricePlansCanMigrateToQueryArgs = {
  organizationId: Scalars['ID'];
  usersOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPaymentMethodPureQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryPaymentMethodsStatePureQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryPlayerVersionPureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryPlayerVersionsArgs = {
  deviceType?: InputMaybe<DeviceTypes>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<UpdateChannels>;
};


export type QueryPlayerVersionsPaginationQueryArgs = {
  filters: VersionsQueryFilter;
  pagination: VersionsQueryPagination;
  sort: VersionsQuerySort;
};


export type QueryPointGenerationSettingsPureQueryArgs = {
  pointId: Scalars['ID'];
};


export type QueryPointHistoryPaginationQueryArgs = {
  filters: PointHistoryQueryFilter;
  pagination: PointHistoryQueryPagination;
  sort: PointHistoryQuerySort;
};


export type QueryPointLogArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pointId: Scalars['Int'];
};


export type QueryPointPublicArgs = {
  linkName?: InputMaybe<Scalars['String']>;
};


export type QueryPointPureArgs = {
  id: Scalars['ID'];
};


export type QueryPointStatusPureArgs = {
  linkName: Scalars['String'];
};


export type QueryPointVideoHistoryPaginationQueryArgs = {
  filters: PointVideoHistoryQueryFilter;
  pagination: PointVideoHistoryQueryPagination;
  sort: PointVideoHistoryQuerySort;
};


export type QueryPointsByTagsArgs = {
  brandCompaniesIds?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  tagId: Scalars['ID'];
};


export type QueryPointsPaginationQueryArgs = {
  filters: PointQueryFilter;
  pagination: PointQueryPagination;
  sort: PointQuerySort;
};


export type QueryPointsSearchMultilineByCommentsQueryArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  queryMultiline: Scalars['String'];
};


export type QueryPointsSearchMultilineQueryArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  queryMultiline: Scalars['String'];
};


export type QueryPointsStatusesCountQueryArgs = {
  filters: PointQueryFilter;
};


export type QueryPromoClipsPaginationQueryArgs = {
  companyId: Scalars['ID'];
  filters?: InputMaybe<PromoClipsQueryFilter>;
  pagination: PromoClipsQueryPagination;
  promoSelectionDraftId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<PromoClipsQuerySort>;
};


export type QueryPromoRollSynthCompanySettingsArgs = {
  companyId: Scalars['ID'];
};


export type QueryPromoRollSynthJobsArgs = {
  filters: PromoRollSynthJobsQueryFilter;
  pagination: PromoRollSynthJobsQueryPagination;
};


export type QueryResumeSubscriptionCostQueryArgs = {
  licensesNum: Scalars['Int'];
  organizationId: Scalars['ID'];
};


export type QueryRightholdersPaginationQueryArgs = {
  pagination: RightholdersQueryPagination;
};


export type QuerySberMultiroomGetMultiroomQueryArgs = {
  input: SberMultiroomGetMultiroomQueryInput;
};


export type QuerySearchMmClientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  streamId?: InputMaybe<Scalars['ID']>;
};


export type QuerySmartlkCompanyMediafilesQueryArgs = {
  filters: SmartlkCompanyMediafilesQueryFilter;
  pagination: SmartlkCompanyMediafilesPagination;
  sort?: InputMaybe<SmartlkCompanyMediafilesQuerySort>;
};


export type QuerySmartlkCompanyPlaybackReportSettingsQueryArgs = {
  filters: SmartlkCompanyPlaybackReportSettingsFilter;
  pagination: SmartlkCompanyPlaybackReportSettingsPagination;
};


export type QuerySmartlkDevicesGroupPaginationQueryArgs = {
  filters: SmartlkDevicesGroupQueryFilter;
  pagination: SmartlkDevicesGroupQueryPagination;
  sort: SmartlkDevicesGroupQuerySort;
};


export type QuerySmartlkDevicesGroupQueryArgs = {
  id: Scalars['ID'];
};


export type QuerySmartlkLibraryCollectionArgs = {
  collectionId: Scalars['ID'];
  companyId: Scalars['ID'];
};


export type QuerySmartlkLibraryRecommendedCollectionArgs = {
  filters: SmartLkLibraryRecommendedCollectionFilter;
  pagination: SmartLkLibraryRecommendedCollectionPagination;
};


export type QuerySmartlkLibraryRecommendedSubcollectionsArgs = {
  filters: SmartLkLibraryRecommendedSubCollectionsFilter;
  pagination: SmartLkLibraryRecommendedSubCollectionsPagination;
};


export type QuerySmartlkLibraryStreamArgs = {
  filters: SmartLkLibraryStreamQueryFilter;
  pagination: SmartLkLibraryStreamQueryPagination;
  sort?: InputMaybe<SmartLkLibraryStreamQuerySort>;
};


export type QuerySmartlkLibrarySubcollectionArgs = {
  companyId: Scalars['ID'];
  subcollectionId: Scalars['ID'];
};


export type QuerySmartlkStreamLibraryArgs = {
  companyId: Scalars['ID'];
  libraryId: Scalars['ID'];
};


export type QuerySmartlkVideoStreamQueryArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QuerySmartlkVideoStreamsPaginationQueryArgs = {
  filters: SmartLkVideoStreamsQueryFilter;
  pagination: SmartLkVideoStreamsQueryPagination;
  sort: SmartLkVideoStreamsQuerySort;
};


export type QuerySpeakerBusinessSpheresPaginationQueryArgs = {
  pagination: SmartSpeakerBusinessSpheresPagination;
};


export type QuerySpeakerNextMediafileQueryArgs = {
  currentRotationId?: InputMaybe<Scalars['ID']>;
  skipCurrentMediafile?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStandardizedAddressPureQueryArgs = {
  input: StandardizedAddressQueryPureType;
};


export type QueryStandardizedAddressesQueryArgs = {
  input: StandardizedAddressesQueryInput;
};


export type QueryStreamApprovalQueryArgs = {
  id: Scalars['ID'];
};


export type QueryStreamContainedByLibrariesArgs = {
  streamId: Scalars['ID'];
};


export type QueryStreamDraftArgs = {
  input: StreamDraftPureQueryInput;
};


export type QueryStreamDraftFindArgs = {
  input: StreamDraftFindPureQueryInput;
};


export type QueryStreamDraftMediafilesRecommendationsArgs = {
  filters: StreamDraftMediafilesRecommendationsFilter;
  pagination: StreamDraftMediafilesRecommendationsPagination;
};


export type QueryStreamLibrariesArgs = {
  filters: LibrariesPureQueryFilter;
  pagination: LibrariesPureQueryPagination;
  sort: LibrariesPureQuerySort;
};


export type QueryStreamLibraryArgs = {
  filters: LibraryPureQueryFilter;
};


export type QueryStreamLibraryCollectionArgs = {
  filters: LibraryCollectionPureQueryFilter;
};


export type QueryStreamLibraryCollectionDraftArgs = {
  filters: LibraryCollectionDraftPureQueryFilter;
};


export type QueryStreamLibraryDraftArgs = {
  filters: LibraryDraftPureQueryFilter;
};


export type QueryStreamLibraryDraftByOriginArgs = {
  objOriginId: Scalars['ID'];
  objType: LibraryObjectType;
};


export type QueryStreamLibraryDraftsArgs = {
  filters: LibraryDraftsPureQueryFilter;
  pagination: LibraryDraftsPureQueryPagination;
  sort: LibraryDraftsPureQuerySort;
};


export type QueryStreamLibraryGroupArgs = {
  filters: LibraryGroupPureQueryFilter;
};


export type QueryStreamLibraryGroupDraftArgs = {
  filters: LibraryGroupDraftPureQueryFilter;
};


export type QueryStreamLibraryOriginByDraftArgs = {
  objDraftId: Scalars['ID'];
  objType: LibraryObjectType;
};


export type QueryStreamLibrarySubcollectionArgs = {
  filters: LibrarySubCollectionPureQueryFilter;
};


export type QueryStreamLibrarySubcollectionDraftArgs = {
  filters: LibrarySubCollectionDraftPureQueryFilter;
};


export type QueryStreamLibrarySubcollectionsDraftsArgs = {
  filters: LibrarySubCollectionsDraftsFilter;
  pagination: LibrarySubCollectionsDraftsPagination;
  sort: LibrarySubCollectionsDraftsSort;
};


export type QueryStreamLogsPaginationQueryArgs = {
  filters: StreamLogsQueryFilter;
  pagination: StreamLogsQueryPagination;
  sort: StreamLogsQuerySort;
};


export type QueryStreamMediafilesArgs = {
  filters: StreamMediafilesFilter;
  pagination: StreamMediafilesPagination;
  sort: StreamMediafilesSort;
};


export type QueryStreamMediafilesApprovalArgs = {
  filters: StreamMediafilesApprovalFilter;
  pagination: StreamMediafilesApprovalPagination;
};


export type QueryStreamMediafilesEventsArgs = {
  filters: StreamMediafilesEventsFilter;
  pagination: StreamMediafilesEventsPagination;
  sort: StreamMediafilesEventsSort;
};


export type QueryStreamMediafilesRandomPaginationQueryArgs = {
  filters: StreamMediafilesRandomPaginationQueryFilter;
  pagination: StreamMediafilesRandomQueryPagination;
};


export type QueryStreamPureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryStreamPureTemplateGroupsArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryStreamTaskPureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryStreamTasksManagersPaginationQueryArgs = {
  filters: StreamTasksManagersQueryFilter;
  pagination: StreamTasksManagersQueryPagination;
};


export type QueryStreamTasksPaginationQueryArgs = {
  filters: StreamTasksQueryFilter;
  pagination: StreamTasksQueryPagination;
  sort: StreamTasksQuerySort;
};


export type QueryStreamTasksRedactorsPaginationQueryArgs = {
  filters: StreamTasksRedactorsQueryFilter;
  pagination: StreamTasksRedactorsQueryPagination;
};


export type QueryStreamsFullTextSearchQueryArgs = {
  filters: StreamsFullTextSearchQueryFilter;
  pagination: StreamsQueryPagination;
};


export type QueryStreamsPaginationQueryArgs = {
  filters: StreamsQueryFilter;
  pagination: StreamsQueryPagination;
  sort: StreamsQuerySort;
};


export type QuerySubscriptionCostByPricePlanPeriodQueryArgs = {
  organizationId: Scalars['ID'];
  pricePlanPeriodId: Scalars['ID'];
};


export type QuerySubscriptionExtensionCostQueryArgs = {
  companyId: Scalars['ID'];
  licensesNum: Scalars['Int'];
};


export type QueryThematicBlockRandomMediafilesPaginationQueryArgs = {
  filters: ThematicBlockRandomMediafilesPaginationQueryFilter;
  pagination: ThematicBlockRandomMediafilesQueryPagination;
};


export type QueryThematicContentBlocksPureQueryArgs = {
  forDate: Scalars['DateTime'];
};


export type QueryUpdateRequestPureQueryArgs = {
  id: Scalars['ID'];
};


export type QueryUpdateRequestsPaginationQueryArgs = {
  filters: UpdateRequestsQueryFilter;
  pagination: UpdateRequestsQueryPagination;
  sort: UpdateRequestsQuerySort;
};


export type QueryUserCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mmClientsOnly?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUserCompaniesPaginationQueryArgs = {
  filters: UserCompaniesQueryFilter;
  pagination: UserCompaniesQueryPagination;
  sort: UserCompaniesQuerySort;
};


export type QueryUserCompanyChecklistToDeactivateQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryUserCompanyExistQueryArgs = {
  bin?: InputMaybe<Scalars['String']>;
  iin?: InputMaybe<Scalars['String']>;
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['String']>;
  unp?: InputMaybe<Scalars['String']>;
};


export type QueryUserCompanyQueryArgs = {
  companyId: Scalars['ID'];
};


export type QueryUserFeaturesOnboardingQueryArgs = {
  filters: UserFeaturesOnboardingFilter;
};


export type QueryUserGetSberLinkUriArgs = {
  companyId: Scalars['ID'];
  redirectUri: Scalars['String'];
};


export type QueryUserGetSberOauthUriArgs = {
  redirectUri: Scalars['String'];
};


export type QueryUserLogArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
};


export type QueryUserPureQueryArgs = {
  userId: Scalars['ID'];
};


export type QueryUserPureSuggestionAddressArgs = {
  input: SuggestionAddressQueryPureType;
};


export type QueryUserPureSuggestionCompanyArgs = {
  input: SuggestionCompanyQueryPureType;
};


export type QueryUsersPaginationQueryArgs = {
  filters: UsersQueryFilter;
  pagination: UsersQueryPagination;
  sort: UsersQuerySort;
};


export type QueryUsersSearchMultilineQueryArgs = {
  queryMultiline: Scalars['String'];
};


export type QueryValuesPureQueryArgs = {
  filters: ValuesQueryFilter;
};


export type QueryVideoMediafilesPaginationQueryArgs = {
  filters: VideoMediafilesQueryFilter;
  pagination: VideoMediafilesQueryPagination;
  sort: VideoMediafilesQuerySort;
};


export type QueryVideoStreamLogsPaginationQueryArgs = {
  filters: VideoStreamLogsQueryFilter;
  pagination: VideoStreamLogsQueryPagination;
  sort: VideoStreamLogsQuerySort;
};


export type QueryVideoStreamQueryArgs = {
  id: Scalars['ID'];
};


export type QueryVideoStreamsPaginationQueryArgs = {
  filters: VideoStreamsQueryFilter;
  pagination: VideoStreamsQueryPagination;
  sort: VideoStreamsQuerySort;
};


export type QueryZvukProfileArgs = {
  input: ZvukProfileQueryInput;
};


export type QueryZvukProfileEventsPaginationQueryArgs = {
  filters: ZvukProfileEventsQueryFilter;
  pagination: ZvukProfileEventsQueryPagination;
  sort: ZvukProfileEventsQuerySort;
};


export type QueryZvukProfileListArgs = {
  companyId: Scalars['ID'];
};


export type QueryZvukProfilePaginationQueryArgs = {
  filters: ZvukProfilesQueryFilter;
  pagination: ZvukProfilesQueryPagination;
  sort: ZvukProfilesPagintaionQuerySort;
};

/** An enumeration. */
export enum RegistrationSource {
  Admin = 'ADMIN',
  Email = 'EMAIL',
  Phone = 'PHONE',
  SbBusinessId = 'SB_BUSINESS_ID',
  SbOnline = 'SB_ONLINE',
  Yclients = 'YCLIENTS'
}

/** An enumeration. */
export enum ReplicationRole {
  Master = 'MASTER',
  None = 'NONE',
  Slave = 'SLAVE'
}

/** An enumeration. */
export enum RequestDeviceType {
  Audio = 'AUDIO',
  Video = 'VIDEO'
}

export type RequestStoppedListeningReportPureMutation = {
  __typename?: 'RequestStoppedListeningReportPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RequestStoppedListeningReportPureMutationInput = {
  since: Scalars['Date'];
};

export type RequisiteByPureType = {
  __typename?: 'RequisiteBYPureType';
  emailForDocuments: Scalars['String'];
  emailForNotification?: Maybe<Scalars['String']>;
  managementName: Scalars['String'];
  managementPost: Scalars['String'];
  organizationAddress: Scalars['String'];
  organizationFullname: Scalars['String'];
  organizationShortname: Scalars['String'];
  organizationType: OrganizationType;
  unp: Scalars['String'];
};

export type RequisiteKzPureType = {
  __typename?: 'RequisiteKZPureType';
  bin: Scalars['String'];
  emailForDocuments: Scalars['String'];
  emailForNotification?: Maybe<Scalars['String']>;
  iin: Scalars['String'];
  managementName: Scalars['String'];
  managementPost: Scalars['String'];
  organizationAddress: Scalars['String'];
  organizationFullname: Scalars['String'];
  organizationShortname: Scalars['String'];
  organizationType: OrganizationType;
};

export type RequisitePureType = RequisiteByPureType | RequisiteKzPureType | RequisiteRuPureType;

export type RequisiteRuPureType = {
  __typename?: 'RequisiteRUPureType';
  emailForDocuments: Scalars['String'];
  emailForNotification?: Maybe<Scalars['String']>;
  inn: Scalars['String'];
  kpp: Scalars['String'];
  managementName: Scalars['String'];
  managementPost: Scalars['String'];
  ogrn: Scalars['String'];
  organizationAddress: Scalars['String'];
  organizationFullname: Scalars['String'];
  organizationShortname: Scalars['String'];
  organizationType: OrganizationType;
  selfEmployedFullName?: Maybe<Scalars['String']>;
};

export type ResumeSubscriptionCostInfoPureType = {
  __typename?: 'ResumeSubscriptionCostInfoPureType';
  cost?: Maybe<Scalars['Float']>;
  costWithDiscount?: Maybe<Scalars['Float']>;
  fullPeriodCost?: Maybe<Scalars['Float']>;
};

export type ResumeTrialPeriodMutation = {
  __typename?: 'ResumeTrialPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RetrieveJsonWebToken = {
  __typename?: 'RetrieveJSONWebToken';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
  user: NewUserType;
};

export type RetrievePureJsonWebToken = {
  __typename?: 'RetrievePureJSONWebToken';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: TokenPureType;
  user: UserExtendPureType;
};

export type RevokeApiTokenMutation = {
  __typename?: 'RevokeApiTokenMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  token?: Maybe<CompanyApiTokenType>;
};

export type RevokeApiTokenMutationInput = {
  id: Scalars['ID'];
  revokeReason?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum RightholderCost {
  Generative = 'GENERATIVE',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RightholderCreateInput = {
  canMixinWith?: InputMaybe<Array<Scalars['ID']>>;
  cost?: InputMaybe<RightholderCost>;
  countries?: InputMaybe<Array<Country>>;
  name: Scalars['String'];
};

export type RightholderCreateMutation = {
  __typename?: 'RightholderCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  rightholder: RightholderValuePureType;
};

export type RightholderPlaybackReportByPointsMutation = {
  __typename?: 'RightholderPlaybackReportByPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RightholderPlaybackReportByPointsMutationInput = {
  dateRange: DateTimeRange;
  rightholders: Array<Scalars['ID']>;
};

export type RightholderPlaybackReportMutation = {
  __typename?: 'RightholderPlaybackReportMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RightholderPlaybackReportMutationInput = {
  dateRange: DateTimeRange;
  rightholder: Scalars['LenientInt'];
};

export type RightholderQueryPaginationType = {
  __typename?: 'RightholderQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<RightholderValuePureType>;
};

export type RightholderUpdateInput = {
  canMixinWith?: InputMaybe<Array<Scalars['ID']>>;
  cost?: InputMaybe<RightholderCost>;
  countries?: InputMaybe<Array<Country>>;
  name?: InputMaybe<Scalars['String']>;
  rightholderId: Scalars['ID'];
};

export type RightholderUpdateMutation = {
  __typename?: 'RightholderUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  rightholder: RightholderValuePureType;
};

export type RightholderValuePureType = {
  __typename?: 'RightholderValuePureType';
  canMixinWith: Array<RightholderValuePureType>;
  cost: RightholderCost;
  countries: Array<Country>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type RightholdersPureType = {
  __typename?: 'RightholdersPureType';
  rightholders: Array<RightholderValuePureType>;
};

export type RightholdersQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type RolloutMasterStreamPureMutation = {
  __typename?: 'RolloutMasterStreamPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RolloutMasterStreamPureMutationInput = {
  streamId: Scalars['ID'];
};

export type RotatedMediafilePureType = {
  __typename?: 'RotatedMediafilePureType';
  count: Scalars['Int'];
  mediafileId: Scalars['ID'];
};

export type RotatedMediafileStatePureType = {
  __typename?: 'RotatedMediafileStatePureType';
  count: Scalars['Int'];
  mediafileId: Scalars['ID'];
};

export type SaveBrandsSearchResultFilter = {
  accountManagerIds?: InputMaybe<Array<Scalars['ID']>>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessSize?: InputMaybe<Array<BusinessSize>>;
  companyId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Country>>;
  query?: InputMaybe<Scalars['String']>;
};

export type SaveBrandsSearchResultMutation = {
  __typename?: 'SaveBrandsSearchResultMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveBrandsSearchResultMutationInput = {
  fields: Array<Scalars['String']>;
  filters: SaveBrandsSearchResultFilter;
  sort?: InputMaybe<SaveBrandsSearchResultSort>;
};

export enum SaveBrandsSearchResultSort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SaveCompaniesSearchFeaturesFilter = {
  isBillingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCompaniesSearchFilter = {
  accountManagerIds?: InputMaybe<Array<Scalars['ID']>>;
  bin?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  businessSize?: InputMaybe<Array<BusinessSize>>;
  companyFeatures?: InputMaybe<SaveCompaniesSearchFeaturesFilter>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Country>;
  iin?: InputMaybe<Scalars['String']>;
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['String']>;
  mmClientsOnly?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  unp?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCompaniesSearchResultMutation = {
  __typename?: 'SaveCompaniesSearchResultMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveCompaniesSearchResultMutationInput = {
  fields: Array<Scalars['String']>;
  filters: SaveCompaniesSearchFilter;
  sort?: InputMaybe<SaveCompaniesSearchResultSort>;
};

export enum SaveCompaniesSearchResultSort {
  CountOfObjDesc = 'COUNT_OF_OBJ_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SberBusinessClientInfo = {
  __typename?: 'SberBusinessClientInfo';
  hasSberBusinessAccount: Scalars['Boolean'];
  hasSberPrime: Scalars['Boolean'];
};

export type SberIdButtonStatePureType = {
  __typename?: 'SberIdButtonStatePureType';
  isDisabled: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  scenario?: Maybe<SberIdScenario>;
  unavailabilityReason?: Maybe<SberIdButtonUnavailabilityReason>;
};

/** Причины недоступности кнопки авторизации по Sber ID в ЛК. */
export enum SberIdButtonUnavailabilityReason {
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  AlreadyLinked = 'ALREADY_LINKED',
  BillingDisabled = 'BILLING_DISABLED',
  FeatureDisabled = 'FEATURE_DISABLED',
  InvalidSubscriptionState = 'INVALID_SUBSCRIPTION_STATE',
  NoContract = 'NO_CONTRACT',
  SberBusinessClient = 'SBER_BUSINESS_CLIENT',
  StaffUser = 'STAFF_USER',
  TrialWithCard = 'TRIAL_WITH_CARD',
  UserFromSber = 'USER_FROM_SBER'
}

/** Сценарии состояния компании, определяющие поведение кнопки авторизации по Sber ID в ЛК. */
export enum SberIdScenario {
  ActiveWithoutCard = 'ACTIVE_WITHOUT_CARD',
  ActiveWithCard = 'ACTIVE_WITH_CARD',
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  TrialWithoutCard = 'TRIAL_WITHOUT_CARD',
  TrialWithCard = 'TRIAL_WITH_CARD'
}

export type SberMultiroomAddDeviceMutation = {
  __typename?: 'SberMultiroomAddDeviceMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  multiroom: MultiroomPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SberMultiroomAddDeviceMutationInput = {
  bindingCode: Scalars['String'];
  pointId: Scalars['ID'];
};

export type SberMultiroomGetMultiroomQueryInput = {
  pointId: Scalars['ID'];
};

export type SberMultiroomRemoveDeviceMutation = {
  __typename?: 'SberMultiroomRemoveDeviceMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  multiroom: MultiroomPureType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SberMultiroomRemoveDeviceMutationInput = {
  bindingCode: Scalars['String'];
  pointId: Scalars['ID'];
};

export type ScoredMediafileType = {
  __typename?: 'ScoredMediafileType';
  mediafile: MediafilePureType;
  score: Scalars['Float'];
};

export type ScoredMediafilesPaginationType = {
  __typename?: 'ScoredMediafilesPaginationType';
  consideredDislikesNum: Scalars['Int'];
  paginationInfo: PaginationInfoType;
  result: Array<ScoredMediafileType>;
};

export type SearchTagsType = {
  __typename?: 'SearchTagsType';
  color: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SearchTagsWithOrderInput = {
  saveOrder: Scalars['Int'];
  tagId: Scalars['ID'];
};

export type SearchTagsWithOrderType = {
  __typename?: 'SearchTagsWithOrderType';
  saveOrder: Scalars['Int'];
  tag: SearchTagsType;
};

export type SendEmailPureRepeatMutation = {
  __typename?: 'SendEmailPureRepeatMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendEmailPureRepeatMutationInput = {
  email: Scalars['String'];
};

export type SetDeviceStateMutation = {
  __typename?: 'SetDeviceStateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SetDeviceStateMutationInput = {
  additionalData?: InputMaybe<Scalars['JSONString']>;
  downloadQueueSize: Scalars['Int'];
  freeSpace: Scalars['Int'];
  memorySize?: InputMaybe<Scalars['Int']>;
  memoryUsage?: InputMaybe<Scalars['Int']>;
  playbackStatus: Scalars['String'];
  temperature: Scalars['Float'];
  totalSpace: Scalars['Int'];
};

export type SleepOptionsPureType = {
  __typename?: 'SleepOptionsPureType';
  enabled: Scalars['Boolean'];
  settings?: Maybe<Array<SleepSettingPureType>>;
};

export type SleepSettingDayInput = {
  day: Scalars['Int'];
  end: Scalars['Time'];
  start: Scalars['Time'];
};

export type SleepSettingObject = {
  __typename?: 'SleepSettingObject';
  day?: Maybe<Scalars['Int']>;
  end?: Maybe<Scalars['Time']>;
  start?: Maybe<Scalars['Time']>;
};

export type SleepSettingPureType = {
  __typename?: 'SleepSettingPureType';
  day: Scalars['Int'];
  end: Scalars['Time'];
  start: Scalars['Time'];
};

export type SmartLkLibraryRecommendedCollectionFilter = {
  companyId: Scalars['ID'];
  libraryId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type SmartLkLibraryRecommendedCollectionPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type SmartLkLibraryRecommendedSubCollectionsFilter = {
  companyId: Scalars['ID'];
  libraryId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type SmartLkLibraryRecommendedSubCollectionsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type SmartLkLibraryStreamQueryFilter = {
  collectionId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  subcollectionId?: InputMaybe<Scalars['ID']>;
};

export type SmartLkLibraryStreamQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum SmartLkLibraryStreamQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SmartLkPointsBindVideoStreamMutation = {
  __typename?: 'SmartLkPointsBindVideoStreamMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartLkPointsBindVideoStreamMutationInput = {
  companyId: Scalars['ID'];
  pointIds: Array<Scalars['ID']>;
  videoStreamId: Scalars['ID'];
};

export type SmartLkStartVideoDemoPeriodMutation = {
  __typename?: 'SmartLkStartVideoDemoPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type SmartLkStartVideoDemoPeriodMutationInput = {
  companyId: Scalars['ID'];
};

export type SmartLkVideoStreamPureSetCompanyTagsInput = {
  tagNames: Array<Scalars['String']>;
  videoStreamId: Scalars['ID'];
};

export type SmartLkVideoStreamPureSetCompanyTagsMutation = {
  __typename?: 'SmartLkVideoStreamPureSetCompanyTagsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type SmartLkVideoStreamsQueryFilter = {
  companyId: Scalars['ID'];
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SmartLkVideoStreamsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum SmartLkVideoStreamsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SmartSpeakerBusinessSpheresPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type SmartSpeakerCreateAndSetPoint = {
  __typename?: 'SmartSpeakerCreateAndSetPoint';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  smartSpeakerInfo: SmartSpeakerInfoType;
};

export type SmartSpeakerCreateAndSetPointInput = {
  pointId: Scalars['ID'];
};

export type SmartSpeakerDislikeMediafileMutation = {
  __typename?: 'SmartSpeakerDislikeMediafileMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartSpeakerDislikeMediafileMutationInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type SmartSpeakerImportHistoryMutation = {
  __typename?: 'SmartSpeakerImportHistoryMutation';
  dislikes: Array<DeviceStreamDislike>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartSpeakerImportHistoryMutationInput = {
  currentMediafilePlaytime: Scalars['DateTime'];
  currentRotationId: Scalars['ID'];
};

export type SmartSpeakerInfoType = {
  __typename?: 'SmartSpeakerInfoType';
  deviceToken: Scalars['String'];
  deviceType: Scalars['Int'];
  deviceUuid: Scalars['String'];
};

export type SmartSpeakerNextMediafileType = {
  __typename?: 'SmartSpeakerNextMediafileType';
  deviceMediafile?: Maybe<DeviceMediafileObjectType>;
  mediafile?: Maybe<MediafilePureType>;
  onAir?: Maybe<Scalars['DateTime']>;
  rotationId?: Maybe<Scalars['ID']>;
};

export type SmartSpeakerSetDefaultStream = {
  __typename?: 'SmartSpeakerSetDefaultStream';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamId: Scalars['ID'];
};

export type SmartSpeakerSetStreamBusinessSphere = {
  __typename?: 'SmartSpeakerSetStreamBusinessSphere';
  deviceMediafile?: Maybe<DeviceMediafileObjectType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  mediafile: MediafilePureType;
  ok?: Maybe<Scalars['Boolean']>;
  rotationId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type SmartSpeakerSetStreamBusinessSphereInput = {
  businessSphereId: Scalars['ID'];
};

export type SmartSpeakerSetStreamByGenre = {
  __typename?: 'SmartSpeakerSetStreamByGenre';
  deviceMediafile?: Maybe<DeviceMediafileObjectType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  mediafile: MediafilePureType;
  ok?: Maybe<Scalars['Boolean']>;
  rotationId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type SmartSpeakerSetStreamByGenreInput = {
  genre: Scalars['String'];
};

export type SmartlkCompanyMediafilesPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type SmartlkCompanyMediafilesQueryFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export enum SmartlkCompanyMediafilesQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SmartlkCompanyPlaybackReportSettingsFilter = {
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type SmartlkCompanyPlaybackReportSettingsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type SmartlkCompanyPlaybackReportSettingsUpdateMutation = {
  __typename?: 'SmartlkCompanyPlaybackReportSettingsUpdateMutation';
  companyPlaybackReportSettings?: Maybe<CompanyPlaybackReportSettingsPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkCompanyPlaybackReportSettingsUpdateMutationInput = {
  emailsTo: Array<Scalars['String']>;
  reportSettingsId: Scalars['ID'];
};

export type SmartlkDevicesGroupCreateMutation = {
  __typename?: 'SmartlkDevicesGroupCreateMutation';
  anotherDevicesGroupIdsWithActiveScheduler?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  devicesGroup?: Maybe<DevicesGroupType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkDevicesGroupCreateMutationInput = {
  companyId: Scalars['ID'];
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  force?: InputMaybe<Scalars['Boolean']>;
  masterVideoStreamId?: InputMaybe<Scalars['ID']>;
  schedulerMode?: InputMaybe<DevicesGroupSchedulerMode>;
  title: Scalars['String'];
};

export type SmartlkDevicesGroupDeleteMutation = {
  __typename?: 'SmartlkDevicesGroupDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkDevicesGroupDeleteMutationInput = {
  devicesGroupId: Scalars['ID'];
};

export type SmartlkDevicesGroupQueryFilter = {
  companyId: Scalars['ID'];
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<DevicesGroupStatuses>>>;
  videoStreamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type SmartlkDevicesGroupQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum SmartlkDevicesGroupQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type SmartlkDevicesGroupUpdateMutation = {
  __typename?: 'SmartlkDevicesGroupUpdateMutation';
  anotherDevicesGroupIdsWithActiveScheduler?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  devicesGroup?: Maybe<DevicesGroupType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkDevicesGroupUpdateMutationInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']>>;
  devicesGroupId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  masterVideoStreamId?: InputMaybe<Scalars['ID']>;
  schedulerMode?: InputMaybe<DevicesGroupSchedulerMode>;
  title?: InputMaybe<Scalars['String']>;
};

export type SmartlkEmenuMediafileInput = {
  emenuMediafileId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  order: Scalars['Int'];
  playCount?: InputMaybe<Scalars['Int']>;
  playDuration: Scalars['Int'];
  title: Scalars['String'];
};

export type SmartlkPointCreateMutation = {
  __typename?: 'SmartlkPointCreateMutation';
  addressData?: Maybe<AddressDataType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type SmartlkPointCreateMutationInput = {
  address: Scalars['String'];
  addressData?: InputMaybe<AddressDataInput>;
  bindingCode?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  createWebDevice: Scalars['Boolean'];
  isVideoMode?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type SmartlkPointUnbindStreamMutation = {
  __typename?: 'SmartlkPointUnbindStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  point?: Maybe<PointPureType>;
};

export type SmartlkPointUnbindStreamMutationInput = {
  pointId: Scalars['ID'];
};

export type SmartlkVideoMediafileInput = {
  id?: InputMaybe<Scalars['ID']>;
  mediafileId: Scalars['ID'];
  order: Scalars['Int'];
  playDuration?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  withSound?: InputMaybe<Scalars['Boolean']>;
};

export type SmartlkVideoOrImageMediafileUploadMutation = {
  __typename?: 'SmartlkVideoOrImageMediafileUploadMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  file?: Maybe<MediafilePureType>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkVideoOrImageUploadMutationInput = {
  companyId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type SmartlkVideoStreamCopyFromTemplateMutation = {
  __typename?: 'SmartlkVideoStreamCopyFromTemplateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type SmartlkVideoStreamCopyFromTemplateMutationInput = {
  companyId: Scalars['ID'];
  templateVideoStreamId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type SmartlkVideoStreamCreateMutation = {
  __typename?: 'SmartlkVideoStreamCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type SmartlkVideoStreamCreateMutationInput = {
  companyId: Scalars['ID'];
  description: Scalars['String'];
  emenuMediafiles?: InputMaybe<Array<SmartlkEmenuMediafileInput>>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
  videoMediafiles: Array<SmartlkVideoMediafileInput>;
};

export type SmartlkVideoStreamDeleteMutation = {
  __typename?: 'SmartlkVideoStreamDeleteMutation';
  bindedPointIds?: Maybe<Array<Scalars['ID']>>;
  bindedPointsCount?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type SmartlkVideoStreamDeleteMutationInput = {
  companyId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  videoStreamId: Scalars['ID'];
};

export type SmartlkVideoStreamUpdateMutation = {
  __typename?: 'SmartlkVideoStreamUpdateMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type SmartlkVideoStreamUpdateMutationInput = {
  description?: InputMaybe<Scalars['String']>;
  emenuMediafiles?: InputMaybe<Array<SmartlkEmenuMediafileInput>>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  videoMediafiles?: InputMaybe<Array<SmartlkVideoMediafileInput>>;
  videoStreamId: Scalars['ID'];
};

export enum SourcefileFormatType {
  H264Converted = 'H264_CONVERTED',
  Loudnorm = 'LOUDNORM',
  Loudnorm_320 = 'LOUDNORM_320',
  Original = 'ORIGINAL'
}

export type SourcefileType = {
  __typename?: 'SourcefileType';
  extension: Scalars['String'];
  fileName: Scalars['String'];
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mainFormat: SourcefileFormatType;
  size: Scalars['Int'];
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export enum SpeedLimitEnum {
  KBs_32 = 'kBs_32',
  KBs_64 = 'kBs_64',
  KBs_128 = 'kBs_128',
  KBs_256 = 'kBs_256',
  KBs_512 = 'kBs_512'
}

export type SpeedLimitOptionsPureType = {
  __typename?: 'SpeedLimitOptionsPureType';
  settings?: Maybe<Array<SpeedLimitSettingPureType>>;
};

export type SpeedLimitSettingPureType = {
  __typename?: 'SpeedLimitSettingPureType';
  end: Scalars['Time'];
  speed: SpeedLimits;
  speedValue: Scalars['Int'];
  start: Scalars['Time'];
  weekdays: WeekDayMapType;
};

/** An enumeration. */
export enum SpeedLimits {
  KBs_32 = 'kBs_32',
  KBs_64 = 'kBs_64',
  KBs_128 = 'kBs_128',
  KBs_256 = 'kBs_256',
  KBs_512 = 'kBs_512'
}

export type SpeedLimitsInput = {
  end: Scalars['Time'];
  speed: SpeedLimitEnum;
  start: Scalars['Time'];
  weekdays: Array<InputMaybe<Scalars['Int']>>;
};

export type StandardizedAddressInput = {
  address: Scalars['String'];
  metadata?: InputMaybe<Scalars['JSONString']>;
};

export type StandardizedAddressPureType = {
  __typename?: 'StandardizedAddressPureType';
  address: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fiasId?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type StandardizedAddressQueryPureType = {
  query: Scalars['String'];
};

export type StandardizedAddressQueryResultType = {
  __typename?: 'StandardizedAddressQueryResultType';
  result?: Maybe<Array<StandardizedAddressPureType>>;
};

export type StandardizedAddressResultType = {
  __typename?: 'StandardizedAddressResultType';
  address: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONString']>;
  timezone?: Maybe<Scalars['String']>;
};

export type StandardizedAddressesQueryInput = {
  addresses: Array<StandardizedAddressInput>;
};

export type StandardizedAddressesQueryResultType = {
  __typename?: 'StandardizedAddressesQueryResultType';
  result?: Maybe<Array<StandardizedAddressResultType>>;
};

export type StartLinkCardMutation = {
  __typename?: 'StartLinkCardMutation';
  confirmLink: Scalars['String'];
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StartLinkCardMutationInput = {
  companyId: Scalars['ID'];
  uriForReturn: Scalars['String'];
};

export type StreamAutoUpdate = {
  __typename?: 'StreamAutoUpdate';
  lastDateUpdate?: Maybe<Scalars['DateTime']>;
  percent: Scalars['Int'];
};

export type StreamAutoUpdateTracksNowMutationInput = {
  streamId: Scalars['ID'];
};

export type StreamAutoUpdateTracksNowPureMutation = {
  __typename?: 'StreamAutoUpdateTracksNowPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamBusinessSpherePureType = {
  __typename?: 'StreamBusinessSpherePureType';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type StreamChangeAutoUpdateTracksMutation = {
  __typename?: 'StreamChangeAutoUpdateTracksMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type StreamChangeAutoUpdateTracksMutationInput = {
  autoUpdate: Scalars['Boolean'];
  percent?: InputMaybe<Scalars['Int']>;
  streamId: Scalars['ID'];
};

export type StreamCostType = {
  __typename?: 'StreamCostType';
  cost: StreamRightholderCost;
  value: Scalars['Float'];
};

export type StreamDraftBlockCopyAsTemplateMutation = {
  __typename?: 'StreamDraftBlockCopyAsTemplateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  templateBlock?: Maybe<ContentBlockPureType>;
};

export type StreamDraftBlockCopyAsTemplateMutationInput = {
  blockDraftId: Scalars['ID'];
  streamDraftId: Scalars['ID'];
  templateTitle: Scalars['String'];
};

export type StreamDraftCancelPureMutation = {
  __typename?: 'StreamDraftCancelPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamDraftCancelPureMutationInput = {
  streamDraftId: Scalars['ID'];
};

export type StreamDraftClearPureMutation = {
  __typename?: 'StreamDraftClearPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftClearPureMutationInput = {
  streamDraftId: Scalars['ID'];
};

export type StreamDraftCreateBlockPureMutation = {
  __typename?: 'StreamDraftCreateBlockPureMutation';
  blockDraft?: Maybe<ContentBlockDraftPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamDraftCreateBlockPureMutationInput = {
  days: Array<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  isSpecial: Scalars['Boolean'];
  mediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  pattern?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']>>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  streamDraftId: Scalars['ID'];
  title: Scalars['String'];
};

export type StreamDraftCreatePureMutation = {
  __typename?: 'StreamDraftCreatePureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftCreatePureMutationInput = {
  streamId: Scalars['ID'];
};

export type StreamDraftDeleteBlockPureMutation = {
  __typename?: 'StreamDraftDeleteBlockPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftDeleteBlockPureMutationInput = {
  blockDraftId: Scalars['ID'];
  streamDraftId: Scalars['ID'];
};

export type StreamDraftDemoStartGenerationMutation = {
  __typename?: 'StreamDraftDemoStartGenerationMutation';
  demo?: Maybe<StreamDraftDemoType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamDraftDemoStartGenerationMutationInput = {
  streamDraftId: Scalars['ID'];
};

/** An enumeration. */
export enum StreamDraftDemoStatus {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type StreamDraftDemoType = {
  __typename?: 'StreamDraftDemoType';
  demoMediafiles?: Maybe<MediafilePureType>;
  id: Scalars['ID'];
  status: StreamDraftDemoStatus;
};

export type StreamDraftDuplicateBlockPureMutation = {
  __typename?: 'StreamDraftDuplicateBlockPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftDuplicateBlockPureMutationInput = {
  blockDraftId: Scalars['ID'];
  streamDraftId: Scalars['ID'];
};

export type StreamDraftFindPureQueryInput = {
  streamId: Scalars['ID'];
};

export type StreamDraftMediafilesRecommendationsFilter = {
  contentBlockDraftId?: InputMaybe<Scalars['ID']>;
  mediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  rightholdersIds?: InputMaybe<Array<Scalars['ID']>>;
  streamDraftId: Scalars['ID'];
  valueIds?: InputMaybe<Array<Scalars['ID']>>;
  withDislikes?: InputMaybe<Scalars['Boolean']>;
};

export type StreamDraftMediafilesRecommendationsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamDraftPureQueryInput = {
  streamDraftId: Scalars['ID'];
};

export type StreamDraftPureType = {
  __typename?: 'StreamDraftPureType';
  blockPattern: Array<Maybe<Array<Scalars['ID']>>>;
  conception: Scalars['String'];
  contentBlocks: Array<ContentBlockDraftPureType>;
  cost: Array<StreamCostType>;
  demo?: Maybe<StreamDraftDemoType>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  isUploadAvailable: Scalars['Boolean'];
  mediafilesCount: Scalars['Int'];
  originalId: Scalars['ID'];
  rightholderName: Scalars['String'];
  rightholders: Array<RightholderValuePureType>;
  rotatedMediafileIds: Array<RotatedMediafileStatePureType>;
  tagsWithOrder: Array<StreamDraftSearchTagsType>;
  userId: Scalars['Int'];
};

export type StreamDraftSavePureMutation = {
  __typename?: 'StreamDraftSavePureMutation';
  errorLibraryTitles?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamDraftSavePureMutationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  streamDraftId: Scalars['ID'];
};

export type StreamDraftSearchTagsType = {
  __typename?: 'StreamDraftSearchTagsType';
  saveOrder: Scalars['Int'];
  tag: SearchTagsType;
};

export type StreamDraftSetConceptionMutation = {
  __typename?: 'StreamDraftSetConceptionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftSetConceptionMutationInput = {
  conception: Scalars['String'];
  streamDraftId: Scalars['ID'];
};

export type StreamDraftUpdateBlockPureMutation = {
  __typename?: 'StreamDraftUpdateBlockPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftUpdateBlockPureMutationInput = {
  blockDraftId: Scalars['ID'];
  days?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDayTime?: InputMaybe<Scalars['Time']>;
  isSpecial?: InputMaybe<Scalars['Boolean']>;
  pattern?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']>>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDayTime?: InputMaybe<Scalars['Time']>;
  streamDraftId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type StreamDraftUpdatePureMutation = {
  __typename?: 'StreamDraftUpdatePureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftUpdatePureMutationInput = {
  blockPattern?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']>>>>;
  streamDraftId: Scalars['ID'];
  tagsWithOrder?: InputMaybe<Array<InputMaybe<SearchTagsWithOrderInput>>>;
};

export type StreamDraftUpdateTracksPureMutation = {
  __typename?: 'StreamDraftUpdateTracksPureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  skippedTracks?: Maybe<Array<Maybe<Scalars['ID']>>>;
  streamDraft?: Maybe<StreamDraftPureType>;
};

export type StreamDraftUpdateTracksPureMutationInput = {
  blockDraftId: Scalars['ID'];
  streamDraftId: Scalars['ID'];
  tracksIds: Array<Scalars['ID']>;
};

export type StreamLikeMediafileInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type StreamLikeMediafileMutation = {
  __typename?: 'StreamLikeMediafileMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamLogPureRestoreMutation = {
  __typename?: 'StreamLogPureRestoreMutation';
  errorLibraryTitles?: Maybe<Array<Scalars['String']>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamLogPureRestoreMutationInput = {
  streamLogId: Scalars['ID'];
};

export type StreamLogsPureType = {
  __typename?: 'StreamLogsPureType';
  created: Scalars['DateTime'];
  diffWithPrevious?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
};

export type StreamLogsQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
};

export type StreamLogsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamLogsQueryPaginationType = {
  __typename?: 'StreamLogsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<StreamLogsPureType>;
};

export enum StreamLogsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type StreamMediafilesApprovalFilter = {
  contentBlockId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
};

export type StreamMediafilesApprovalPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamMediafilesEventsFilter = {
  eventType?: InputMaybe<MediafileEventTypes>;
  query?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
};

export type StreamMediafilesEventsPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum StreamMediafilesEventsSort {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC'
}

export type StreamMediafilesFilter = {
  streamId: Scalars['ID'];
};

export type StreamMediafilesPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamMediafilesRandomPaginationQueryFilter = {
  excludeDisliked?: InputMaybe<Scalars['Boolean']>;
  excludeMediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  streamId: Scalars['ID'];
};

export type StreamMediafilesRandomQueryPagination = {
  pageSize: Scalars['Int'];
};

export type StreamMediafilesRandomQueryPaginationType = {
  __typename?: 'StreamMediafilesRandomQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<MediafilePureType>;
};

export enum StreamMediafilesSort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type StreamPureCopy = {
  __typename?: 'StreamPureCopy';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type StreamPureCopyFromTemplateMutation = {
  __typename?: 'StreamPureCopyFromTemplateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream: StreamPureType;
};

export type StreamPureCopyFromTemplateMutationInput = {
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
  withThematic?: InputMaybe<Scalars['Boolean']>;
};

export type StreamPureCopyInput = {
  asReplica: Scalars['Boolean'];
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  copyStreamId: Scalars['ID'];
  streamTaskId?: InputMaybe<Scalars['ID']>;
  streamTitle: Scalars['String'];
};

export type StreamPureCreate = {
  __typename?: 'StreamPureCreate';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type StreamPureCreateInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  isTemplate: Scalars['Boolean'];
  streamTaskId?: InputMaybe<Scalars['ID']>;
  streamTitle: Scalars['String'];
};

export type StreamPureDislikeMediafileMutation = {
  __typename?: 'StreamPureDislikeMediafileMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureDislikeMediafileMutationInput = {
  id: Scalars['ID'];
  mediafileId: Scalars['Int'];
};

export type StreamPureDislikeMediafileRestoreMutation = {
  __typename?: 'StreamPureDislikeMediafileRestoreMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureDislikeMediafileRestoreMutationInput = {
  id: Scalars['Int'];
  mediafileId: Scalars['Int'];
};

export type StreamPureListOfMediafilesMutation = {
  __typename?: 'StreamPureListOfMediafilesMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureListOfMediafilesMutationInput = {
  streamId: Scalars['ID'];
};

export type StreamPureRemoveMutation = {
  __typename?: 'StreamPureRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureRemoveMutationInput = {
  id: Scalars['ID'];
};

export type StreamPureRestoreMutation = {
  __typename?: 'StreamPureRestoreMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type StreamPureRestoreMutationInput = {
  streamId: Scalars['ID'];
};

export type StreamPureSetToCompanyPointsMutation = {
  __typename?: 'StreamPureSetToCompanyPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureSetToCompanyPointsMutationInput = {
  companyId: Scalars['ID'];
  pointIds: Array<Scalars['ID']>;
  streamId: Scalars['ID'];
};

export type StreamPureSetToPointsMutation = {
  __typename?: 'StreamPureSetToPointsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamPureSetToPointsMutationInput = {
  pointIds: Array<Scalars['ID']>;
  streamId: Scalars['ID'];
};

export type StreamPureTemplateGroupType = {
  __typename?: 'StreamPureTemplateGroupType';
  id: Scalars['ID'];
  streams: Array<StreamPureType>;
  title: Scalars['String'];
};

export type StreamPureType = {
  __typename?: 'StreamPureType';
  adcompaniesNum: Scalars['Int'];
  autoMediafileIds: Array<Scalars['ID']>;
  autoUpdate: StreamAutoUpdate;
  autoUpdateEnabled: Scalars['Boolean'];
  /** @deprecated Now use -> auto_update */
  autoUpdatePercent: Scalars['Int'];
  blockPattern: Array<Maybe<Array<Scalars['ID']>>>;
  brand?: Maybe<BrandType>;
  businessSphere: Array<StreamBusinessSpherePureType>;
  businessSpheresNames: Array<Scalars['String']>;
  company?: Maybe<UserCompanyPureType>;
  companyCountry?: Maybe<CountryType>;
  conception: Scalars['String'];
  contentBlocks: Array<ContentBlockPureType>;
  cost: Array<StreamCostType>;
  cover?: Maybe<CoverFilePureType>;
  demoMediafile?: Maybe<MediafilePureType>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  genres: Array<SearchTagsWithOrderType>;
  genresNames: Array<Scalars['String']>;
  hasThematicBlock: Scalars['Boolean'];
  id: Scalars['ID'];
  isLibraryDisplay: Scalars['Boolean'];
  isTemplate: Scalars['Boolean'];
  lastUserActionDate?: Maybe<Scalars['DateTime']>;
  libraries: Array<LibraryPureType>;
  master?: Maybe<StreamPureType>;
  mediafiles: Array<MediafilePureType>;
  mediafilesCount: Scalars['Int'];
  mediafilesLiked: Array<Scalars['ID']>;
  points: Array<PointPureType>;
  pointsNum: Scalars['Int'];
  poster?: Maybe<PosterFilePureType>;
  replicationCanRollout: Scalars['Boolean'];
  replicationRole: ReplicationRole;
  rightholderName: Scalars['String'];
  rightholders: Array<RightholderValuePureType>;
  rotatedMediafileIds: Array<RotatedMediafilePureType>;
  searchTags: Array<SearchTagsWithOrderType>;
  searchTagsNames: Array<Scalars['String']>;
  slavesCount: Scalars['Int'];
  tasks: Array<StreamTaskPureType>;
  templateType: Scalars['String'];
  title: Scalars['String'];
  values: Array<StreamValuePureType>;
};

export type StreamPureUpdateMutation = {
  __typename?: 'StreamPureUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type StreamPureUpdateMutationInput = {
  blockPattern?: InputMaybe<Array<InputMaybe<Array<Scalars['ID']>>>>;
  brandId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  streamId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type StreamPureUploadCoverInput = {
  cover: Scalars['Upload'];
  streamId: Scalars['ID'];
};

export type StreamPureUploadCoverMutation = {
  __typename?: 'StreamPureUploadCoverMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

/** An enumeration. */
export enum StreamRightholderCost {
  Generative = 'GENERATIVE',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type StreamSearchTagAttributeType = {
  __typename?: 'StreamSearchTagAttributeType';
  children: Array<Maybe<SearchTagsType>>;
  color: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** Deprecated. Use StreamSearchTagsType */
export type StreamSearchTagsPureType = {
  __typename?: 'StreamSearchTagsPureType';
  tags: Array<DeviceStreamSearchTagAttributePureType>;
};

export type StreamSearchTagsType = {
  __typename?: 'StreamSearchTagsType';
  tags: Array<StreamSearchTagAttributeType>;
};

/** An enumeration. */
export enum StreamStreamCompanyCountryChoices {
  /** all */
  All = 'ALL',
  /** by */
  By = 'BY',
  /** kz */
  Kz = 'KZ',
  /** ru */
  Ru = 'RU'
}

/** An enumeration. */
export enum StreamStreamFilepathTypeChoices {
  /** default */
  A_0 = 'A_0',
  /** http */
  A_1 = 'A_1',
  /** mcache */
  A_2 = 'A_2'
}

/** An enumeration. */
export enum StreamTaskCategory {
  Correction = 'CORRECTION',
  Demo = 'DEMO',
  NewStream = 'NEW_STREAM',
  Other = 'OTHER',
  Update = 'UPDATE'
}

export type StreamTaskCommentPureType = {
  __typename?: 'StreamTaskCommentPureType';
  created: Scalars['DateTime'];
  files?: Maybe<FileObjectType>;
  id: Scalars['ID'];
  streamTask?: Maybe<StreamTaskPureType>;
  streams: Array<StreamPureType>;
  text: Scalars['String'];
  user?: Maybe<NewUserType>;
};

/** An enumeration. */
export enum StreamTaskComplexity {
  Difficult = 'DIFFICULT',
  Medium = 'MEDIUM',
  Simple = 'SIMPLE',
  VeryDifficult = 'VERY_DIFFICULT',
  VerySimple = 'VERY_SIMPLE'
}

export enum StreamTaskPlatformPureType {
  MarketMusic = 'MarketMusic',
  Muzlab = 'Muzlab'
}

/** An enumeration. */
export enum StreamTaskPriority {
  Normal = 'NORMAL',
  Urgently = 'URGENTLY'
}

export type StreamTaskPureCreateCommentMutation = {
  __typename?: 'StreamTaskPureCreateCommentMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  taskComment?: Maybe<StreamTaskCommentPureType>;
};

export type StreamTaskPureCreateCommentMutationInput = {
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type StreamTaskPureCreateMutation = {
  __typename?: 'StreamTaskPureCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureCreateMutationInput = {
  address?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  briefLink: Scalars['String'];
  category: StreamTaskCategory;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
  genres: Scalars['String'];
  inn: Scalars['String'];
  leadUrl?: InputMaybe<Scalars['String']>;
  mmClientId?: InputMaybe<Scalars['ID']>;
  organizationType: Scalars['String'];
  priority: StreamTaskPriority;
  specifics: Scalars['String'];
  streamId?: InputMaybe<Scalars['ID']>;
  streamTitle: Scalars['String'];
  targetAudience: Scalars['String'];
  whatToDo: Scalars['String'];
};

export type StreamTaskPureRefuseMutation = {
  __typename?: 'StreamTaskPureRefuseMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureRefuseMutationInput = {
  id: Scalars['ID'];
};

export type StreamTaskPureRemoveMutation = {
  __typename?: 'StreamTaskPureRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamTaskPureRemoveMutationInput = {
  id: Scalars['ID'];
};

export type StreamTaskPureReopenMutation = {
  __typename?: 'StreamTaskPureReopenMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureReopenMutationInput = {
  id: Scalars['ID'];
};

export type StreamTaskPureSetReadyMutation = {
  __typename?: 'StreamTaskPureSetReadyMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureSetReadyMutationInput = {
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type StreamTaskPureSetRedactorMutation = {
  __typename?: 'StreamTaskPureSetRedactorMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureTakeMutation = {
  __typename?: 'StreamTaskPureTakeMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureTakeMutationInput = {
  id: Scalars['ID'];
};

export type StreamTaskPureType = {
  __typename?: 'StreamTaskPureType';
  brand?: Maybe<BrandType>;
  briefLink: Scalars['String'];
  category?: Maybe<StreamTaskCategory>;
  comments: Array<StreamTaskCommentPureType>;
  company?: Maybe<UserCompanyPureType>;
  complexity?: Maybe<StreamTaskComplexity>;
  contactEmail?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  crmLeadUrl: Scalars['String'];
  description: Scalars['String'];
  endComment?: Maybe<StreamTaskCommentPureType>;
  files: Array<FileObjectType>;
  genres: Scalars['String'];
  id: Scalars['ID'];
  manager?: Maybe<NewUserType>;
  mmClient?: Maybe<MmClientObjectPureType>;
  platform: StreamTaskPlatformPureType;
  priority: StreamTaskPriority;
  redactor?: Maybe<NewUserType>;
  status: StreamTaskStatus;
  streamTitle: Scalars['String'];
  streams: Array<StreamPureType>;
  targetAudience: Scalars['String'];
  typeOrg: Scalars['String'];
  whatToDo: Scalars['String'];
  whenToDo?: Maybe<Scalars['DateTime']>;
};

export type StreamTaskPureUpdateMutation = {
  __typename?: 'StreamTaskPureUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskPureUpdateMutationInput = {
  briefLink: Scalars['String'];
  contactEmail: Scalars['String'];
  genres: Scalars['String'];
  id: Scalars['ID'];
  organizationType?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<StreamTaskPriority>;
  specifics: Scalars['String'];
  targetAudience?: InputMaybe<Scalars['String']>;
  whatToDo: Scalars['String'];
};

export type StreamTaskSetCategoryMutation = {
  __typename?: 'StreamTaskSetCategoryMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskSetCategoryMutationInput = {
  category: StreamTaskCategory;
  id: Scalars['ID'];
};

export type StreamTaskSetComplexityMutation = {
  __typename?: 'StreamTaskSetComplexityMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StreamTaskPureType>;
};

export type StreamTaskSetComplexityMutationInput = {
  complexity: StreamTaskComplexity;
  id: Scalars['ID'];
};

export type StreamTaskSetRedactorPureMutationInput = {
  id: Scalars['ID'];
  redactorId: Scalars['ID'];
};

/** An enumeration. */
export enum StreamTaskStatus {
  Created = 'CREATED',
  InProcess = 'IN_PROCESS',
  Ready = 'READY'
}

export type StreamTasksManagersQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
};

export type StreamTasksManagersQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamTasksManagersQueryPaginationType = {
  __typename?: 'StreamTasksManagersQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UserExtendPureType>>;
};

export type StreamTasksQueryFilter = {
  categories?: InputMaybe<Array<StreamTaskCategory>>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  complexities?: InputMaybe<Array<StreamTaskComplexity>>;
  managersIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  priorities?: InputMaybe<Array<StreamTaskPriority>>;
  query?: InputMaybe<Scalars['String']>;
  redactorsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  statuses?: InputMaybe<Array<StreamTaskStatus>>;
  streamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type StreamTasksQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamTasksQueryPaginationType = {
  __typename?: 'StreamTasksQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<StreamTaskPureType>>;
};

export enum StreamTasksQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type StreamTasksRedactorsQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
};

export type StreamTasksRedactorsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamTasksRedactorsQueryPaginationType = {
  __typename?: 'StreamTasksRedactorsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UserExtendPureType>>;
};

export type StreamType = {
  __typename?: 'StreamType';
  /** @deprecated depricated */
  amplifyMediafile?: Maybe<Scalars['Float']>;
  /** @deprecated depricated */
  amplifyPromo?: Maybe<Scalars['Float']>;
  autoMediafilesIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  autoplay: Scalars['Boolean'];
  availableCountries: Array<Scalars['String']>;
  bitrate: Scalars['Int'];
  blockPattern?: Maybe<Scalars['JSONString']>;
  company?: Maybe<UserCompanyType>;
  companyCountry?: Maybe<StreamStreamCompanyCountryChoices>;
  conception: Scalars['String'];
  contentBlockMediafiles?: Maybe<Array<Maybe<MediafileObjectType>>>;
  cost: Scalars['JSONString'];
  cover?: Maybe<PosterObjectType>;
  created: Scalars['DateTime'];
  crossfade: Scalars['Boolean'];
  /** @deprecated depricated */
  ctype?: Maybe<Scalars['String']>;
  demoMediafile?: Maybe<MediafileObjectType>;
  demoMediafiles?: Maybe<Array<Maybe<MediafileObjectType>>>;
  /** @deprecated depricated */
  demoUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Scalars['String'];
  dislikedMediafiles?: Maybe<Array<Maybe<MediafileObjectType>>>;
  dislikedMediafilesCount?: Maybe<Scalars['Int']>;
  duration: Scalars['Int'];
  events: Array<MediafileObjectType>;
  filepathType: StreamStreamFilepathTypeChoices;
  id: Scalars['Int'];
  isActive?: Maybe<Scalars['Boolean']>;
  isLibraryDisplay: Scalars['Boolean'];
  /** @deprecated depricated */
  isSleep?: Maybe<Scalars['Boolean']>;
  isSubscribe: Scalars['Boolean'];
  isTemplate: Scalars['Boolean'];
  lastManualUpdateAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated depricated */
  leads?: Maybe<Array<Maybe<AmoCrmLeadType>>>;
  /** @deprecated depricated */
  linkName?: Maybe<Scalars['String']>;
  mediafilesCount: Scalars['Int'];
  mediafilesIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  modified: Scalars['DateTime'];
  needToRegenerate?: Maybe<Scalars['Boolean']>;
  normalize: Scalars['Boolean'];
  /** @deprecated depricated */
  notListenDegree?: Maybe<Scalars['Boolean']>;
  percentAutoUpdate?: Maybe<Scalars['Int']>;
  points?: Maybe<Array<Maybe<PointType>>>;
  pointsMigrate: Array<PointPublicType>;
  poster?: Maybe<PosterObjectType>;
  promoRecorderMode: Scalars['Boolean'];
  rightholderName: Scalars['String'];
  rotatedMediafileIds?: Maybe<Array<Maybe<DictionaryMostRotated>>>;
  searchTags: Array<ValueObjectType>;
  streamContenblock?: Maybe<Array<Maybe<ContentBlockType>>>;
  streamContentBlock?: Maybe<Array<Maybe<ContentBlockType>>>;
  streamContentblock: Array<ContentBlockType>;
  streamUrl?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ValueObjectType>>>;
  templateId?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  tracksAutoUpdate?: Maybe<Scalars['Boolean']>;
  voiceover: Array<MediafileObjectType>;
  voiceoverDelay: Scalars['Int'];
  warningsAll?: Maybe<Array<Maybe<Scalars['String']>>>;
  weatherMode?: Maybe<Scalars['Boolean']>;
};

export type StreamUnLikeMediafileInput = {
  mediafileId: Scalars['ID'];
  streamId: Scalars['ID'];
};

export type StreamUnLikeMediafileMutation = {
  __typename?: 'StreamUnLikeMediafileMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type StreamValuePureType = {
  __typename?: 'StreamValuePureType';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type StreamsFullTextSearchQueryFilter = {
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  includeActive?: InputMaybe<Scalars['Boolean']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
};

export type StreamsQueryFilter = {
  adcampaignId?: InputMaybe<Scalars['ID']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  businessSphereIds?: InputMaybe<Array<Scalars['ID']>>;
  companyCountries?: InputMaybe<Array<Scalars['String']>>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupId?: InputMaybe<Scalars['ID']>;
  inactive?: InputMaybe<Scalars['Boolean']>;
  isLibraryDisplay?: InputMaybe<Scalars['Boolean']>;
  libraryId?: InputMaybe<Scalars['ID']>;
  masterStreamId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  replicationRoles?: InputMaybe<Array<ReplicationRole>>;
  rightholders?: InputMaybe<Array<Scalars['ID']>>;
  rightholdersContains?: InputMaybe<Array<Scalars['ID']>>;
  searchTagIds?: InputMaybe<Array<Scalars['ID']>>;
  streamId?: InputMaybe<Scalars['ID']>;
  template?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
  warnings?: InputMaybe<Scalars['Boolean']>;
  withMmIntegration?: InputMaybe<Scalars['Boolean']>;
  withThematic?: InputMaybe<Scalars['Boolean']>;
};

export type StreamsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type StreamsQueryPaginationType = {
  __typename?: 'StreamsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<StreamPureType>>;
};

export enum StreamsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PointsNumAsc = 'POINTS_NUM_ASC',
  PointsNumDesc = 'POINTS_NUM_DESC'
}

export type SubCollectionFilteredByStreamType = {
  __typename?: 'SubCollectionFilteredByStreamType';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type SubCollectionsDraftsPaginationType = {
  __typename?: 'SubCollectionsDraftsPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<LibrarySubCollectionDraftPureType>;
};

export type SubCollectionsPaginationType = {
  __typename?: 'SubCollectionsPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<LibrarySubCollectionPureType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  musicboxStatus?: Maybe<MusicBoxStatusType>;
  /** @deprecated deprecated */
  musicboxStatusX?: Maybe<MusicBoxStatusType>;
};


export type SubscriptionMusicboxStatusArgs = {
  title: Scalars['String'];
};


export type SubscriptionMusicboxStatusXArgs = {
  title: Scalars['String'];
};

export type SubscriptionExtensionCostInfoPureType = {
  __typename?: 'SubscriptionExtensionCostInfoPureType';
  cost?: Maybe<Scalars['Float']>;
  fullPeriodCost?: Maybe<Scalars['Float']>;
};

export enum SubscriptionStatus {
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  GraceSubscription = 'GRACE_SUBSCRIPTION',
  InactiveSubscription = 'INACTIVE_SUBSCRIPTION',
  TrialSubscription = 'TRIAL_SUBSCRIPTION',
  WaitPaymentSubscription = 'WAIT_PAYMENT_SUBSCRIPTION'
}

export type SuggestionAddressPureType = {
  __typename?: 'SuggestionAddressPureType';
  value: Scalars['String'];
};

export type SuggestionAddressQueryPureType = {
  country?: InputMaybe<Country>;
  query: Scalars['String'];
};

export type SuggestionAddressQueryResultPureType = {
  __typename?: 'SuggestionAddressQueryResultPureType';
  result?: Maybe<Array<SuggestionAddressPureType>>;
};

export type SuggestionCompanyPureType = {
  __typename?: 'SuggestionCompanyPureType';
  address?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  inn?: Maybe<Scalars['String']>;
  kpp?: Maybe<Scalars['String']>;
  management?: Maybe<SuggestionManagementType>;
  name: Scalars['String'];
  ogrn?: Maybe<Scalars['String']>;
  organizationType: SuggestionOrganizationTypeEnum;
  region?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  unp?: Maybe<Scalars['String']>;
};

export type SuggestionCompanyQueryPureType = {
  country?: InputMaybe<Country>;
  query: Scalars['String'];
};

export type SuggestionCompanyQueryResultPureType = {
  __typename?: 'SuggestionCompanyQueryResultPureType';
  result?: Maybe<Array<SuggestionCompanyPureType>>;
};

export type SuggestionManagementType = {
  __typename?: 'SuggestionManagementType';
  name: Scalars['String'];
  post?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SuggestionOrganizationTypeEnum {
  Branch = 'BRANCH',
  ForeignBranch = 'FOREIGN_BRANCH',
  Individual = 'INDIVIDUAL',
  IndividualJointVenture = 'INDIVIDUAL_JOINT_VENTURE',
  Legal = 'LEGAL'
}

export type TemplateAddToLibraryMutation = {
  __typename?: 'TemplateAddToLibraryMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type TemplateIdInput = {
  templateId: Scalars['ID'];
};

export type TemplateRemoveFromLibraryMutation = {
  __typename?: 'TemplateRemoveFromLibraryMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type TemplateSetBusinessSphereMutation = {
  __typename?: 'TemplateSetBusinessSphereMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type TemplateSetBusinessSphereMutationInput = {
  businessSphereIds: Array<InputMaybe<Scalars['ID']>>;
  streamId: Scalars['ID'];
};

export type TemplateSetSearchTagsMutation = {
  __typename?: 'TemplateSetSearchTagsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  stream?: Maybe<StreamPureType>;
};

export type TemplateSetSearchTagsMutationInput = {
  streamId: Scalars['ID'];
  tagsWithOrder: Array<InputMaybe<SearchTagsWithOrderInput>>;
};

export type TestAcceptanceAdvanceToCanceledMutation = {
  __typename?: 'TestAcceptanceAdvanceToCanceledMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestAcceptanceAdvanceToCanceledMutationInput = {
  bankStatus: AcceptanceAdvanceBankStatus;
  companyId: Scalars['ID'];
};

export type TestChangeSberUserSubIdMutation = {
  __typename?: 'TestChangeSberUserSubIdMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestChangeSberUserSubIdMutationInput = {
  subId: Scalars['String'];
  userId: Scalars['ID'];
};

export type TestChangeSelectedPaymentKindInput = {
  companyId: Scalars['ID'];
  selectedPaymentKind: PaymentKind;
};

export type TestChangeSelectedPaymentKindMutation = {
  __typename?: 'TestChangeSelectedPaymentKindMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestClearVideoDemoPeriodMutation = {
  __typename?: 'TestClearVideoDemoPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestClearVideoDemoPeriodMutationInput = {
  address?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

export type TestExpiredTrialsMutation = {
  __typename?: 'TestExpiredTrialsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestExpiredVideoDemoPeriodsMutation = {
  __typename?: 'TestExpiredVideoDemoPeriodsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestMoveSubscriptionMutation = {
  __typename?: 'TestMoveSubscriptionMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestMoveSubscriptionMutationInput = {
  endsInMinutes: Scalars['LenientInt'];
  userId: Scalars['ID'];
};

export type TestMoveVideoDemoPeriodMutation = {
  __typename?: 'TestMoveVideoDemoPeriodMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestMoveVideoDemoPeriodMutationInput = {
  companyId: Scalars['ID'];
  endsInMinutes: Scalars['LenientInt'];
};

export type TestPayMutation = {
  __typename?: 'TestPayMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestSbbolPaymentRequestInput = {
  bankStatus: PaymentRequestBankStatus;
  companyId: Scalars['ID'];
};

export type TestSbbolPaymentRequestToSuccessMutation = {
  __typename?: 'TestSbbolPaymentRequestToSuccessMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestSendNotificationsMutation = {
  __typename?: 'TestSendNotificationsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestSetInvoiceCalendarMonthlyCutoffDayMutation = {
  __typename?: 'TestSetInvoiceCalendarMonthlyCutoffDayMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type TestSetInvoiceCalendarMonthlyCutoffDayMutationInput = {
  companyId: Scalars['ID'];
  dayOfMonth: Scalars['Int'];
};

export type ThematicBlockPureRemoveFromCompanyMutation = {
  __typename?: 'ThematicBlockPureRemoveFromCompanyMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ThematicBlockPureRemoveFromCompanyMutationInput = {
  companyThematicBlockId: Scalars['ID'];
};

export type ThematicBlockPureSetToCompanyMutation = {
  __typename?: 'ThematicBlockPureSetToCompanyMutation';
  companyThematicBlock?: Maybe<CompanyThematicContentBlockPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ThematicBlockPureSetToCompanyMutationInput = {
  companyId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  streamsIds?: InputMaybe<Array<Scalars['ID']>>;
  thematicBlockId: Scalars['ID'];
};

export type ThematicBlockRandomMediafilesPaginationQueryFilter = {
  excludeMediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  thematicContentBlockId: Scalars['ID'];
};

export type ThematicBlockRandomMediafilesQueryPagination = {
  pageSize: Scalars['Int'];
};

export type ThematicBlockRandomMediafilesQueryPaginationType = {
  __typename?: 'ThematicBlockRandomMediafilesQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<MediafilePureType>;
};

export type ThematicContentBlockPureType = {
  __typename?: 'ThematicContentBlockPureType';
  endDate?: Maybe<Scalars['Date']>;
  eventTitle: Scalars['String'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  poster?: Maybe<PosterFilePureType>;
  startDate?: Maybe<Scalars['Date']>;
  title: Scalars['String'];
};

export type TimezoneObjectType = {
  __typename?: 'TimezoneObjectType';
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TokenPureRefresh = {
  __typename?: 'TokenPureRefresh';
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
  token: Scalars['String'];
};

export type TokenPureRefreshMutationInput = {
  refreshToken: Scalars['String'];
};

export type TokenPureRevoke = {
  __typename?: 'TokenPureRevoke';
  revoked: Scalars['Int'];
};

export type TokenPureType = {
  __typename?: 'TokenPureType';
  value: Scalars['String'];
};

export type TokenPureVerify = {
  __typename?: 'TokenPureVerify';
  payload: Scalars['GenericScalar'];
};

export type TokenPureVerifyMutationInput = {
  token: Scalars['String'];
};

export type TracksRemoveMutationInput = {
  tracksIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type TracksRemovePureMutation = {
  __typename?: 'TracksRemovePureMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UpdateChannels {
  Dev = 'DEV',
  Prod = 'PROD'
}

export type UpdateRequestPureCancelMutation = {
  __typename?: 'UpdateRequestPureCancelMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  updateRequest?: Maybe<UpdateRequestPureType>;
};

export type UpdateRequestPureCancelMutationInput = {
  updateRequestId: Scalars['ID'];
};

export type UpdateRequestPureCreateByDeviceListMutation = {
  __typename?: 'UpdateRequestPureCreateByDeviceListMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  updateRequest?: Maybe<UpdateRequestPureType>;
};

export type UpdateRequestPureCreateByDeviceListMutationInput = {
  fromVersionId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  playerIds: Array<InputMaybe<Scalars['ID']>>;
  scheduledDate: Scalars['Date'];
  scheduledTime: Scalars['Time'];
  toVersionId: Scalars['ID'];
};

export type UpdateRequestPureRunManualCheckMutation = {
  __typename?: 'UpdateRequestPureRunManualCheckMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  updateRequest?: Maybe<UpdateRequestPureType>;
};

export type UpdateRequestPureRunManualCheckMutationInput = {
  updateRequestId: Scalars['ID'];
};

export type UpdateRequestPureType = {
  __typename?: 'UpdateRequestPureType';
  created: Scalars['DateTime'];
  fromVersion?: Maybe<PlayerVersionPureType>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  startDatetime?: Maybe<Scalars['DateTime']>;
  startTime: Scalars['Time'];
  statistics: UpdateRequestStatPureType;
  status: UpdateRequestState;
  toVersion?: Maybe<PlayerVersionPureType>;
  updatePlans: Array<PlayerPlannedUpdatePureType>;
  user?: Maybe<UserExtendPureType>;
};

export type UpdateRequestQueryPureType = {
  __typename?: 'UpdateRequestQueryPureType';
  result?: Maybe<UpdateRequestPureType>;
};

export type UpdateRequestStatPureType = {
  __typename?: 'UpdateRequestStatPureType';
  totalCancelled: Scalars['Int'];
  totalDevices: Scalars['Int'];
  totalDone: Scalars['Int'];
  totalInProgress: Scalars['Int'];
  totalPending: Scalars['Int'];
};

/** An enumeration. */
export enum UpdateRequestState {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type UpdateRequestsQueryFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  states?: InputMaybe<Array<UpdateRequestState>>;
  updateChannel?: InputMaybe<UpdateChannels>;
  userId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateRequestsQueryPagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type UpdateRequestsQueryPaginationType = {
  __typename?: 'UpdateRequestsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UpdateRequestPureType>>;
};

export enum UpdateRequestsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

/** An enumeration. */
export enum UserAdditionalFeatureTypeChoices {
  /** adcompany_group_promo_type */
  AdcompanyGroupPromoType = 'ADCOMPANY_GROUP_PROMO_TYPE',
  /** profile_organization_page */
  ProfileOrganizationPage = 'PROFILE_ORGANIZATION_PAGE',
  /** profile_payment_page */
  ProfilePaymentPage = 'PROFILE_PAYMENT_PAGE',
  /** upload_mediafile_to_content_block */
  UploadMediafileToContentBlock = 'UPLOAD_MEDIAFILE_TO_CONTENT_BLOCK'
}

export enum UserAdditionalFeaturesPureType {
  AdcompanyGroupPromoType = 'ADCOMPANY_GROUP_PROMO_TYPE',
  ProfileOrganizationPage = 'PROFILE_ORGANIZATION_PAGE',
  ProfilePaymentPage = 'PROFILE_PAYMENT_PAGE',
  UploadMediafileToContentBlock = 'UPLOAD_MEDIAFILE_TO_CONTENT_BLOCK'
}

export type UserBillingInfo = {
  __typename?: 'UserBillingInfo';
  canRealizeBillingOperation?: Maybe<Scalars['Boolean']>;
  canRealizeBillingOperationWithPayment?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<OrganizationDiscountPureType>;
  expiresLicenseDate?: Maybe<Scalars['String']>;
  firstPaidAt?: Maybe<Scalars['DateTime']>;
  fullPeriodAmount?: Maybe<Scalars['Float']>;
  fullPeriodAmountWithDiscount?: Maybe<Scalars['Float']>;
  hasActiveLicenses: Scalars['Boolean'];
  hasGraceLicenses: Scalars['Boolean'];
  hasInactiveLicenses: Scalars['Boolean'];
  hasNonRenewableLicenses?: Maybe<Scalars['Boolean']>;
  hasRenewableLicenses?: Maybe<Scalars['Boolean']>;
  hasTrialLicenses: Scalars['Boolean'];
  hasWaitPaymentLicenses: Scalars['Boolean'];
  isBillingEnabled?: Maybe<Scalars['Boolean']>;
  isGraceLicense?: Maybe<Scalars['Boolean']>;
  isLastInvoiceHasZeroAmount?: Maybe<Scalars['Boolean']>;
  isWaitPaymentLicense?: Maybe<Scalars['Boolean']>;
  nextBillingAmount?: Maybe<Scalars['Float']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  nextBillingLicenses: Array<LicensePureType>;
  nextBillingPriceAmount?: Maybe<Scalars['Float']>;
  nonRenewableLicenses: Array<LicensePureType>;
  paymentMethod?: Maybe<PaymentMethodObjectPureType>;
  paymentScheme?: Maybe<PaymentScheme>;
  renewableLicenses: Array<LicensePureType>;
  selectedPaymentKind: PaymentKind;
  status: SubscriptionStatus;
  totalLicenses: Array<LicensePureType>;
  unpaidLicenses: Array<LicensePureType>;
};

export type UserCompaniesFeaturesFilter = {
  isBillingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserCompaniesQueryFilter = {
  accountManagerIds?: InputMaybe<Array<Scalars['ID']>>;
  bin?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  businessSize?: InputMaybe<Array<BusinessSize>>;
  companyFeatures?: InputMaybe<UserCompaniesFeaturesFilter>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  country?: InputMaybe<Country>;
  devicesGroupId?: InputMaybe<Scalars['ID']>;
  iin?: InputMaybe<Scalars['String']>;
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['String']>;
  mmClientsOnly?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  unp?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type UserCompaniesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type UserCompaniesQueryPaginationType = {
  __typename?: 'UserCompaniesQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UserCompanyPureType>>;
};

export enum UserCompaniesQuerySort {
  CountOfObjDesc = 'COUNT_OF_OBJ_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

/** An enumeration. */
export enum UserCompanyContractOfferReasonChoices {
  /** lk_registration */
  LkRegistration = 'LK_REGISTRATION',
  /** organization_type_change */
  OrganizationTypeChange = 'ORGANIZATION_TYPE_CHANGE',
  /** price_plan_change */
  PricePlanChange = 'PRICE_PLAN_CHANGE',
  /** transfer_to_offerta */
  TransferToOfferta = 'TRANSFER_TO_OFFERTA'
}

/** An enumeration. */
export enum UserCompanyContractOfferTypeChoices {
  /** legal_individual */
  LegalIndividual = 'LEGAL_INDIVIDUAL',
  /** popular */
  Popular = 'POPULAR',
  /** self_employed */
  SelfEmployed = 'SELF_EMPLOYED'
}

/** An enumeration. */
export enum UserCompanyContractStatusChoices {
  /** actual */
  Actual = 'ACTUAL',
  /** suspended */
  Suspended = 'SUSPENDED'
}

/** An enumeration. */
export enum UserCompanyContractTypeContractChoices {
  /** base */
  Base = 'BASE',
  /** offerta */
  Offerta = 'OFFERTA'
}

export type UserCompanyCreateMutation = {
  __typename?: 'UserCompanyCreateMutation';
  company?: Maybe<UserCompanyPureType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserCompanyCreateMutationInput = {
  accountManagerId?: InputMaybe<Scalars['ID']>;
  actualName?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessSize?: InputMaybe<BusinessSize>;
  businessSphereId?: InputMaybe<Scalars['ID']>;
  country?: InputMaybe<Country>;
  crmLink?: InputMaybe<Scalars['String']>;
  crmSyncIsActive?: InputMaybe<Scalars['Boolean']>;
  emailForDocuments?: InputMaybe<Scalars['String']>;
  requisite?: InputMaybe<UserCompanyRequisiteInputType>;
  skipRequisitesStep?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type UserCompanyPureType = {
  __typename?: 'UserCompanyPureType';
  accountManager?: Maybe<UserExtendPureType>;
  actualName: Scalars['String'];
  adcampaigns: Array<AdCampaignPureType>;
  addTelegramSubscribeLink?: Maybe<Scalars['String']>;
  autoApplySberPrimeBenefits: Scalars['Boolean'];
  brand?: Maybe<BrandType>;
  businessSize?: Maybe<BusinessSize>;
  businessSphereFromClient?: Maybe<Scalars['String']>;
  businessSphereId?: Maybe<Scalars['ID']>;
  /**
   * DO NOT USE IN PAGINATION
   * @deprecated Use sberIdButtonState instead
   */
  canSberIdLink: Scalars['Boolean'];
  completeData: Scalars['Boolean'];
  contractMigrations: Array<CompanyContractMigrationType>;
  contracts: Array<CompanyContractPureType>;
  country: Country;
  created: Scalars['DateTime'];
  crmLink?: Maybe<Scalars['String']>;
  crmSyncIsActive: Scalars['Boolean'];
  deviceRequests?: Maybe<Array<CompanyDeviceRequestPureType>>;
  emailRecipients: Array<Scalars['String']>;
  filespace?: Maybe<CompanyFilespacePureType>;
  hasDesktopPlayers: Scalars['Boolean'];
  hasInstantAdCampaigns: Scalars['Boolean'];
  hasMinimumData: Scalars['Boolean'];
  id: Scalars['ID'];
  imported: Scalars['Boolean'];
  invoices: Array<InvoicePureType>;
  isBillingEnabled: Scalars['Boolean'];
  isPaymentByInvoiceRequested: Scalars['Boolean'];
  isSberPrimeSubscription: Scalars['Boolean'];
  marketingMaterialsAgreementReceived: Scalars['Boolean'];
  paymentCardInfo?: Maybe<PaymentMethodObjectPureType>;
  points: Array<PointPureType>;
  pricePlan?: Maybe<PricePlanPureType>;
  referral?: Maybe<CompanyReferralPureType>;
  registrationSource?: Maybe<RegistrationSource>;
  requisite?: Maybe<RequisitePureType>;
  /** DO NOT USE IN PAGINATION */
  sberIdButtonState: SberIdButtonStatePureType;
  sberIdWasLinked: Scalars['Boolean'];
  selectedPaymentKind: PaymentKind;
  streamLibrariesIds?: Maybe<Array<Scalars['Int']>>;
  streams: Array<StreamPureType>;
  trialPeriod?: Maybe<UserTrialPeriodType>;
  uiFeatures: UserCompanyUiFeaturesType;
  /** @deprecated user -> users */
  user?: Maybe<UserExtendPureType>;
  users: Array<UserCompanyWithRole>;
  validated: Scalars['Boolean'];
  videoDemoPeriod?: Maybe<UserVideoDemoPeriodType>;
  videoStreams?: Maybe<Array<VideoStreamType>>;
  zvukProfileCount: Scalars['Int'];
};

export type UserCompanyRequisiteInputType = {
  bin?: InputMaybe<Scalars['String']>;
  emailForDocuments?: InputMaybe<Scalars['String']>;
  emailForNotification?: InputMaybe<Scalars['String']>;
  iin?: InputMaybe<Scalars['String']>;
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['LenientString']>;
  managementName?: InputMaybe<Scalars['String']>;
  managementPost?: InputMaybe<Scalars['String']>;
  ogrn?: InputMaybe<Scalars['String']>;
  organizationAddress?: InputMaybe<Scalars['String']>;
  organizationFullname?: InputMaybe<Scalars['String']>;
  organizationShortname?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<OrganizationType>;
  selfEmployedFullName?: InputMaybe<Scalars['String']>;
  unp?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum UserCompanyRole {
  Admin = 'ADMIN',
  Readonly = 'READONLY'
}

export type UserCompanySearchType = {
  __typename?: 'UserCompanySearchType';
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  result?: Maybe<Array<UserCompanyPureType>>;
  totalCount: Scalars['Int'];
};

export type UserCompanyType = {
  __typename?: 'UserCompanyType';
  accountManager?: Maybe<UserExtendType>;
  actualName: Scalars['String'];
  adcompanies: Array<AdCampaignType>;
  apiTokens: Array<CompanyApiTokenType>;
  businessProfileAutoOpenedAt?: Maybe<Scalars['DateTime']>;
  businessSize?: Maybe<UserUserCompanyBusinessSizeChoices>;
  contracts?: Maybe<Array<Maybe<CompanyContractType>>>;
  country: UserUserCompanyCountryChoices;
  created: Scalars['DateTime'];
  crmCompanyId?: Maybe<Scalars['Int']>;
  crmSyncIsActive: Scalars['Boolean'];
  firstPaymentDate?: Maybe<Scalars['DateTime']>;
  firstPaymentMessageHasSent: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  imported: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isBusinessProfileAutoOpened: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  leads?: Maybe<Array<Maybe<AmoCrmLeadType>>>;
  marketingMaterialsAgreementReceived: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  points: Array<PointPublicType>;
  registrationSource?: Maybe<UserUserCompanyRegistrationSourceChoices>;
  sberIdWasLinked: Scalars['Boolean'];
  selectedPaymentKind: UserUserCompanySelectedPaymentKindChoices;
  skipRequisitesStep: Scalars['Boolean'];
  streams: Array<StreamType>;
  user?: Maybe<UserExtendType>;
  userCompanyLeads: Array<AmoCrmLeadType>;
  users: Array<UserExtendType>;
  validated: Scalars['Boolean'];
};

export type UserCompanyUiFeaturesType = {
  __typename?: 'UserCompanyUIFeaturesType';
  isAddressesGroupsAvailable: Scalars['Boolean'];
  isBillingEnabled: Scalars['Boolean'];
  isBusinessProfileAvailable: Scalars['Boolean'];
  isCertLetterAvailable: Scalars['Boolean'];
  isChangePricePlanAvailable: Scalars['Boolean'];
  isInstantAdcampaignAvailable: Scalars['Boolean'];
  isOffertaChanged: Scalars['Boolean'];
  isShowReports: Scalars['Boolean'];
  isVideoAdsAvailable: Scalars['Boolean'];
  isVideoAvailable: Scalars['Boolean'];
  showSberIdButtonInLk: Scalars['Boolean'];
};

export type UserCompanyUpdateMutation = {
  __typename?: 'UserCompanyUpdateMutation';
  company: UserCompanyPureType;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserCompanyUpdateMutationInput = {
  accountManagerId?: InputMaybe<Scalars['ID']>;
  actualName?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  businessSize?: InputMaybe<BusinessSize>;
  businessSphereId?: InputMaybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  country?: InputMaybe<Country>;
  crmLink?: InputMaybe<Scalars['String']>;
  crmSyncIsActive?: InputMaybe<Scalars['Boolean']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']>>;
  marketingMaterialsAgreementReceived?: InputMaybe<Scalars['Boolean']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  requisite?: InputMaybe<UserCompanyRequisiteInputType>;
};

export type UserCompanyWithRole = {
  __typename?: 'UserCompanyWithRole';
  canSberIdLink: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['ID'];
  phone: Scalars['String'];
  registrationSource: RegistrationSource;
  role: UserCompanyRole;
};

export type UserEmailUpdateMutation = {
  __typename?: 'UserEmailUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserEmailUpdateMutationInput = {
  email: Scalars['String'];
  userId: Scalars['ID'];
};

export type UserExtendPureType = {
  __typename?: 'UserExtendPureType';
  adcampaigns: Array<AdCampaignType>;
  additionalFeatures: Array<UserAdditionalFeaturesPureType>;
  autoApplySberPrimeBenefits: Scalars['Boolean'];
  companies: Array<UserCompanyPureType>;
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  firstName: Scalars['String'];
  hasCompaniesWithInn: Scalars['Boolean'];
  id: Scalars['ID'];
  isTest: Scalars['Boolean'];
  lastName: Scalars['String'];
  mainCompany?: Maybe<UserCompanyPureType>;
  personalAccountAccess: Scalars['Boolean'];
  phone: Scalars['String'];
  points: Array<PointPureType>;
  pointsCount: Scalars['Int'];
  pointsExists: Scalars['Boolean'];
  registrationSource: RegistrationSource;
  roleNames?: Maybe<Array<Scalars['String']>>;
  sberBusinessClientInfo: SberBusinessClientInfo;
  smartLkAccess: Scalars['Boolean'];
  streams: Array<StreamPureType>;
  streamsCount: Scalars['Int'];
};

export type UserExtendType = {
  __typename?: 'UserExtendType';
  additionalFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  autoApplySberPrimeBenefits?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Array<Maybe<UserCompanyType>>>;
  contractScenario?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  personalAccountAccess?: Maybe<Scalars['Boolean']>;
  roleNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  roles?: Maybe<Array<Maybe<Scalars['Int']>>>;
  salesman?: Maybe<Scalars['Boolean']>;
  sberBusinessClientInfo: SberBusinessClientInfo;
  streamIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  streams?: Maybe<Array<Maybe<StreamType>>>;
  username?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum UserFeatures {
  PlaybackReports = 'PLAYBACK_REPORTS',
  WarningStreamFirstStart = 'WARNING_STREAM_FIRST_START'
}

export type UserFeaturesOnboardingFilter = {
  features?: InputMaybe<Array<UserFeatures>>;
  query?: InputMaybe<Scalars['String']>;
};

export type UserFeaturesOnboardingPassMutation = {
  __typename?: 'UserFeaturesOnboardingPassMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserFeaturesOnboardingPassMutationInput = {
  feature: UserFeatures;
};

export type UserFeaturesOnboardingType = {
  __typename?: 'UserFeaturesOnboardingType';
  feature: UserFeatures;
  isOnboarded: Scalars['Boolean'];
};

export type UserInvitationAcceptMutation = {
  __typename?: 'UserInvitationAcceptMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserInvitationAcceptMutationInput = {
  password: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type UserInvitationCreateMutation = {
  __typename?: 'UserInvitationCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  invitation: UserInvitationType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserInvitationCreateMutationInput = {
  companyId: Scalars['ID'];
  email: Scalars['String'];
};

export type UserInvitationDeactivateMutation = {
  __typename?: 'UserInvitationDeactivateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  invitation: UserInvitationType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserInvitationDeactivateMutationInput = {
  invitationId: Scalars['ID'];
};

export type UserInvitationSendMutation = {
  __typename?: 'UserInvitationSendMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  invitation: UserInvitationType;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserInvitationSendMutationInput = {
  invitationId: Scalars['ID'];
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type UserInvitationType = {
  __typename?: 'UserInvitationType';
  company: UserCompanyPureType;
  createdBy?: Maybe<UserExtendPureType>;
  email: Scalars['String'];
  id: Scalars['ID'];
  isAccepted: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isSent: Scalars['Boolean'];
};

export type UserInvitationsPaginationType = {
  __typename?: 'UserInvitationsPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UserInvitationType>>;
};

export type UserLogType = {
  __typename?: 'UserLogType';
  created?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSONString']>;
  diffWithPrevious?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
  userName?: Maybe<Scalars['String']>;
};

export type UserPhoneUpdateMutation = {
  __typename?: 'UserPhoneUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserPhoneUpdateMutationInput = {
  phone: Scalars['String'];
  userId: Scalars['ID'];
};

export type UserPureChangeSmartLkAccessMutation = {
  __typename?: 'UserPureChangeSmartLkAccessMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserExtendPureType>;
};

export type UserPureChangeSmartLkAccessMutationInput = {
  isOpen: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type UserPureMakeAsTestMutationInput = {
  isTest?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};

export type UserPureManualEmailVerifiedMutation = {
  __typename?: 'UserPureManualEmailVerifiedMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserExtendPureType>;
};

export type UserPureManualEmailVerifiedMutationInput = {
  userId: Scalars['ID'];
};

export type UserPureMarkAsTestMutation = {
  __typename?: 'UserPureMarkAsTestMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserExtendPureType>;
};

export type UserPureSignUpByPhoneMutation = {
  __typename?: 'UserPureSignUpByPhoneMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  payload: Scalars['GenericScalar'];
  refreshExpiresIn: Scalars['Int'];
  token: TokenPureType;
  user: UserExtendPureType;
};

export type UserPureSignUpByPhoneMutationInput = {
  code: Scalars['String'];
  country?: InputMaybe<Country>;
  crmLeadId?: InputMaybe<Scalars['ID']>;
  organizationType?: InputMaybe<OrganizationType>;
  phone: Scalars['String'];
  referralUuid?: InputMaybe<Scalars['String']>;
  skipRequisitesStep?: InputMaybe<Scalars['Boolean']>;
  utmMarks?: InputMaybe<Array<UtmMarksInput>>;
};

export type UserPureSignUpMutation = {
  __typename?: 'UserPureSignUpMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserPureSignUpMutationInput = {
  country?: InputMaybe<Country>;
  crmLeadId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  organizationType?: InputMaybe<OrganizationType>;
  password: Scalars['String'];
  phone: Scalars['String'];
  referralUuid?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  skipRequisitesStep?: InputMaybe<Scalars['Boolean']>;
  utmMarks?: InputMaybe<Array<UtmMarksInput>>;
};

export type UserPureSignUpYClientsMutation = {
  __typename?: 'UserPureSignUpYClientsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UserPureSignUpYClientsMutationInput = {
  country?: InputMaybe<Country>;
  crmLeadId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  organizationType?: InputMaybe<OrganizationType>;
  password: Scalars['String'];
  phone: Scalars['String'];
  referralUuid?: InputMaybe<Scalars['String']>;
  registrationUrl?: InputMaybe<Scalars['String']>;
  salonId: Scalars['ID'];
  skipRequisitesStep?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
  utmMarks?: InputMaybe<Array<UtmMarksInput>>;
};

export type UserPureUpdateMutation = {
  __typename?: 'UserPureUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserExtendPureType>;
};

export type UserPureUpdateMutationInput = {
  email?: InputMaybe<Scalars['String']>;
};

export enum UserRoleType {
  AccountManagerEnterprise = 'ACCOUNT_MANAGER_ENTERPRISE',
  AccountManagerSmb = 'ACCOUNT_MANAGER_SMB',
  Admin = 'ADMIN',
  Client = 'CLIENT',
  Crmaccess = 'CRMACCESS',
  MainRedactor = 'MAIN_REDACTOR',
  Manager = 'MANAGER',
  Redactor = 'REDACTOR',
  Salesman = 'SALESMAN',
  Support = 'SUPPORT',
  Testing = 'TESTING',
  Useraccess = 'USERACCESS'
}

export type UserTrialPeriodType = {
  __typename?: 'UserTrialPeriodType';
  expiredAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  isExpired: Scalars['Boolean'];
  isFinished: Scalars['Boolean'];
  lengthDays: Scalars['Int'];
  lengthMinutes: Scalars['Int'];
  startedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum UserUserCompanyBusinessSizeChoices {
  /** ent */
  Ent = 'ENT',
  /** smb */
  Smb = 'SMB'
}

/** An enumeration. */
export enum UserUserCompanyCountryChoices {
  /** all */
  All = 'ALL',
  /** by */
  By = 'BY',
  /** kz */
  Kz = 'KZ',
  /** ru */
  Ru = 'RU'
}

/** An enumeration. */
export enum UserUserCompanyRegistrationSourceChoices {
  /** admin */
  Admin = 'ADMIN',
  /** email */
  Email = 'EMAIL',
  /** phone */
  Phone = 'PHONE',
  /** sb_business_id */
  SbBusinessId = 'SB_BUSINESS_ID',
  /** sb_online */
  SbOnline = 'SB_ONLINE',
  /** yclients */
  Yclients = 'YCLIENTS'
}

/** An enumeration. */
export enum UserUserCompanySelectedPaymentKindChoices {
  /** sbbol */
  Sbbol = 'SBBOL',
  /** yookassa */
  Yookassa = 'YOOKASSA'
}

export type UserVideoDemoPeriodType = {
  __typename?: 'UserVideoDemoPeriodType';
  expiredAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  isExpired: Scalars['Boolean'];
  isFinished: Scalars['Boolean'];
  lengthDays: Scalars['Int'];
  lengthMinutes: Scalars['Int'];
  startedAt: Scalars['DateTime'];
};

export type UsersQueryFilter = {
  adcampaignId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  query?: InputMaybe<Scalars['String']>;
  streamId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UsersQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type UsersQueryPaginationType = {
  __typename?: 'UsersQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<UserExtendPureType>>;
};

export enum UsersQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type UsersSearchItem = {
  __typename?: 'UsersSearchItem';
  query: Scalars['String'];
  user?: Maybe<UserExtendPureType>;
};

export type UsersSearchMultilineResult = {
  __typename?: 'UsersSearchMultilineResult';
  result: Array<UsersSearchItem>;
};

/** An enumeration. */
export enum UtmMarkKeyTypeEnum {
  Alice = 'ALICE',
  Mobile = 'MOBILE',
  Mybeast = 'MYBEAST',
  Platform = 'PLATFORM',
  Promocode = 'PROMOCODE',
  PromoCreateBot = 'PROMO_CREATE_BOT',
  Roistat = 'ROISTAT',
  SberAgentId = 'SBER_AGENT_ID',
  Tariff = 'TARIFF',
  UtmSource = 'UTM_SOURCE',
  Yclients = 'YCLIENTS',
  YmId = 'YM_ID'
}

export type UtmMarksInput = {
  key: UtmMarkKeyTypeEnum;
  value: Scalars['String'];
};

export type UtmMarksSendToAmoLeadMutation = {
  __typename?: 'UtmMarksSendToAmoLeadMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UtmMarksSendToAmoMutationInput = {
  utmMarks?: InputMaybe<Array<UtmMarksInput>>;
};

export type ValueObjectPureType = {
  __typename?: 'ValueObjectPureType';
  attribute?: Maybe<AttributeObjectPureType>;
  children?: Maybe<Array<Maybe<ValueObjectPureType>>>;
  color: Scalars['String'];
  id: Scalars['ID'];
  isMain?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type ValueObjectType = {
  __typename?: 'ValueObjectType';
  attribute?: Maybe<AttributeObjectType>;
  attributeId?: Maybe<Scalars['Int']>;
  childs?: Maybe<Array<Maybe<ValueObjectType>>>;
  color: Scalars['String'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isMain?: Maybe<Scalars['Boolean']>;
  mediafile: Array<MediafileObjectType>;
  modified: Scalars['DateTime'];
  parent?: Maybe<ValueObjectType>;
  parentId?: Maybe<Scalars['Int']>;
  searchTaggedStreams: Array<StreamType>;
  soundreef: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendType>;
  valueAdcompany: Array<AdCampaignType>;
};

export type ValuesByGroups = {
  __typename?: 'ValuesByGroups';
  group?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<ValueObjectType>>>;
};

export type ValuesByGroupsPure = {
  __typename?: 'ValuesByGroupsPure';
  group?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<ValueObjectPureType>>>;
};

export type ValuesQueryFilter = {
  attributeId?: InputMaybe<Scalars['ID']>;
  attributeIds?: InputMaybe<Array<Scalars['ID']>>;
  mediafilesIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  valuesIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type VersionsQueryFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  deviceTypes?: InputMaybe<Array<DeviceTypes>>;
  query?: InputMaybe<Scalars['String']>;
  updateChannel?: InputMaybe<UpdateChannels>;
};

export type VersionsQueryPagination = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export enum VersionsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type VideoMediafileBindInfoAdminItemType = {
  __typename?: 'VideoMediafileBindInfoAdminItemType';
  bindedToPointsCount: Scalars['Int'];
  bindedToVideoStreamsCount: Scalars['Int'];
  mediafileId: Scalars['ID'];
};

export type VideoMediafileInput = {
  id?: InputMaybe<Scalars['ID']>;
  mediafileId: Scalars['ID'];
  order: Scalars['Int'];
  playDuration: Scalars['Int'];
  title: Scalars['String'];
  withSound?: InputMaybe<Scalars['Boolean']>;
};

export type VideoMediafilePaginationPureType = {
  __typename?: 'VideoMediafilePaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<VideoMediafileType>;
};

export type VideoMediafileType = {
  __typename?: 'VideoMediafileType';
  id: Scalars['ID'];
  mediafile: MediafilePureType;
  order: Scalars['Int'];
  playDuration: Scalars['Int'];
  previewUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  videoStream: VideoStreamType;
  videoUrl?: Maybe<Scalars['String']>;
  withSound?: Maybe<Scalars['Boolean']>;
};

export type VideoMediafileWithPreparationStatusType = {
  __typename?: 'VideoMediafileWithPreparationStatusType';
  bpm: Scalars['String'];
  company?: Maybe<UserCompanyPureType>;
  duration: Scalars['Int'];
  explicit: Scalars['Boolean'];
  filename: Scalars['String'];
  genres: Scalars['String'];
  hasVector: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDeleting: Scalars['Boolean'];
  maxQuality?: Maybe<Scalars['Int']>;
  performerTitle: Scalars['String'];
  preparationStatus?: Maybe<PreparationStatusGraphqlEnum>;
  previewUrl?: Maybe<Scalars['String']>;
  rightholder: RightholderValuePureType;
  rightholderName: Scalars['String'];
  rms: Scalars['String'];
  sourcefiles: Array<SourcefileType>;
  tagged: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['Int'];
  uri: Scalars['String'];
  valueIds: Array<Scalars['ID']>;
  values: Array<ValueObjectPureType>;
  valuesExtend: Array<MediafileValueType>;
  valuesNames: Array<Scalars['String']>;
};

export type VideoMediafileWithStatusQueryType = {
  __typename?: 'VideoMediafileWithStatusQueryType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<VideoMediafileWithPreparationStatusType>>;
};

export type VideoMediafilesQueryFilter = {
  companyId?: InputMaybe<Scalars['ID']>;
  mediafileId?: InputMaybe<Scalars['ID']>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  videoStreamId?: InputMaybe<Scalars['ID']>;
};

export type VideoMediafilesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum VideoMediafilesQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

/** An enumeration. */
export enum VideoSettingsVersion {
  Version_1 = 'VERSION_1'
}

export type VideoStreamCreateMutation = {
  __typename?: 'VideoStreamCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type VideoStreamCreateMutationInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  description: Scalars['String'];
  emenuMediafiles?: InputMaybe<Array<EmenuMediafileInput>>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
  videoMediafiles: Array<VideoMediafileInput>;
};

export type VideoStreamDeleteMutation = {
  __typename?: 'VideoStreamDeleteMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type VideoStreamDeleteMutationInput = {
  videoStreamId: Scalars['ID'];
};

export type VideoStreamEmenuMediafileType = {
  __typename?: 'VideoStreamEmenuMediafileType';
  emenuMediafile: EmenuMediafileType;
  id: Scalars['ID'];
  order: Scalars['Int'];
  playCount: Scalars['Int'];
  playDuration: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  videoStream: VideoStreamType;
};

export type VideoStreamLogsPureType = {
  __typename?: 'VideoStreamLogsPureType';
  created: Scalars['DateTime'];
  diffWithPrevious?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logModel?: Maybe<VideoStreamType>;
  origin?: Maybe<Scalars['String']>;
  user?: Maybe<UserExtendPureType>;
};

export type VideoStreamLogsQueryFilter = {
  query?: InputMaybe<Scalars['String']>;
  videoStreamId: Scalars['ID'];
};

export type VideoStreamLogsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export type VideoStreamLogsQueryPaginationType = {
  __typename?: 'VideoStreamLogsQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result: Array<VideoStreamLogsPureType>;
};

export enum VideoStreamLogsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type VideoStreamPaginationPureType = {
  __typename?: 'VideoStreamPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<VideoStreamType>;
};

export type VideoStreamType = {
  __typename?: 'VideoStreamType';
  company?: Maybe<UserCompanyPureType>;
  description?: Maybe<Scalars['String']>;
  devicesGroup?: Maybe<DevicesGroupType>;
  duration: Scalars['Int'];
  emenuMediafiles: Array<VideoStreamEmenuMediafileType>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  isLibraryDisplay: Scalars['Boolean'];
  isShared: Scalars['Boolean'];
  points: Array<PointPureType>;
  previewUrl?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  tags?: Maybe<Array<CompanyTagPureType>>;
  title?: Maybe<Scalars['String']>;
  videoMediafiles: Array<VideoMediafileType>;
};

export type VideoStreamUpdateCompanyMutation = {
  __typename?: 'VideoStreamUpdateCompanyMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type VideoStreamUpdateCompanyMutationInput = {
  companyId: Scalars['ID'];
  videoStreamId: Scalars['ID'];
};

export type VideoStreamUpdateMutation = {
  __typename?: 'VideoStreamUpdateMutation';
  bindedToAnotherGroupsDeviceIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  videoStream?: Maybe<VideoStreamType>;
};

export type VideoStreamUpdateMutationInput = {
  description?: InputMaybe<Scalars['String']>;
  emenuMediafiles?: InputMaybe<Array<EmenuMediafileInput>>;
  isLibraryDisplay?: InputMaybe<Scalars['Boolean']>;
  pointIds?: InputMaybe<Array<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
  videoMediafiles?: InputMaybe<Array<VideoMediafileInput>>;
  videoStreamId: Scalars['ID'];
};

export type VideoStreamsQueryFilter = {
  adcampaignId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  devicesGroupId?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  pointId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};

export type VideoStreamsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum VideoStreamsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type VideoTypeMediafilesDeleteMutation = {
  __typename?: 'VideoTypeMediafilesDeleteMutation';
  bindInfo: Array<Maybe<VideoMediafileBindInfoAdminItemType>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type VideoTypeMediafilesDeleteMutationInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  mediafileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type VideoUploadMutation = {
  __typename?: 'VideoUploadMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  video?: Maybe<MediafilePureType>;
};

export type VideoUploadMutationInput = {
  companyId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  isPromo?: InputMaybe<Scalars['Boolean']>;
};

export type ViewNotificationMutation = {
  __typename?: 'ViewNotificationMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ViewNotificationMutationInput = {
  notificationId: Scalars['ID'];
};

export type WeatherObjectType = {
  __typename?: 'WeatherObjectType';
  city?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  humidity?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  temp?: Maybe<Scalars['String']>;
};

export type WeekDayMapType = {
  __typename?: 'WeekDayMapType';
  friday: Scalars['Boolean'];
  monday: Scalars['Boolean'];
  saturday: Scalars['Boolean'];
  sunday: Scalars['Boolean'];
  thursday: Scalars['Boolean'];
  tuesday: Scalars['Boolean'];
  wednesday: Scalars['Boolean'];
};

export type WifiCellType = {
  __typename?: 'WifiCellType';
  encrypted?: Maybe<Scalars['Boolean']>;
  encryptionType?: Maybe<Scalars['String']>;
  identity?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  signal?: Maybe<Scalars['Int']>;
  ssid?: Maybe<Scalars['String']>;
};

export type WifiSettingsPureType = {
  __typename?: 'WifiSettingsPureType';
  cells: Array<CellType>;
  connectionType: Scalars['String'];
  /** Info about last attempt wifi connection */
  lastConnectionAttempt?: Maybe<ConnectionType>;
  netState: Scalars['Boolean'];
  online: Scalars['Boolean'];
  wifi: Scalars['Boolean'];
  wifiConnectionProcessStatus?: Maybe<Scalars['String']>;
  wifiIdentity?: Maybe<Scalars['String']>;
  wifiPassword?: Maybe<Scalars['String']>;
  wifiPoint?: Maybe<Scalars['String']>;
};

export type WifiSettingsUpdateMutation = {
  __typename?: 'WifiSettingsUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ZvukApiPlaylistType = {
  __typename?: 'ZvukAPIPlaylistType';
  createdOn?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isPublic: Scalars['Boolean'];
  name: Scalars['String'];
  trackCount: Scalars['Int'];
  tracks?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updatedOn?: Maybe<Scalars['String']>;
};

export type ZvukPlaylistAdminRestoreMutation = {
  __typename?: 'ZvukPlaylistAdminRestoreMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistAdminRestoreMutationInput = {
  playlistId: Scalars['ID'];
};

export type ZvukPlaylistCreateFromStreamMutation = {
  __typename?: 'ZvukPlaylistCreateFromStreamMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistCreateFromStreamMutationInput = {
  companyId: Scalars['ID'];
  description: Scalars['String'];
  poster?: InputMaybe<Scalars['Upload']>;
  profileId: Scalars['ID'];
  streamId: Scalars['ID'];
  title: Scalars['String'];
};

export type ZvukPlaylistCreateFromZvukMutation = {
  __typename?: 'ZvukPlaylistCreateFromZvukMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistCreateFromZvukMutationInput = {
  companyId: Scalars['ID'];
  description: Scalars['String'];
  playlistLink: Scalars['String'];
  poster?: InputMaybe<Scalars['Upload']>;
  profileId: Scalars['ID'];
  title: Scalars['String'];
};

export type ZvukPlaylistHideMutation = {
  __typename?: 'ZvukPlaylistHideMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistHideMutationInput = {
  companyId: Scalars['ID'];
  playlistId: Scalars['ID'];
};

export type ZvukPlaylistInfoMutation = {
  __typename?: 'ZvukPlaylistInfoMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukApiPlaylistType>;
};

export type ZvukPlaylistInfoMutationInput = {
  companyId: Scalars['ID'];
  playlistLink: Scalars['String'];
};

export type ZvukPlaylistPublishMutation = {
  __typename?: 'ZvukPlaylistPublishMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistPublishMutationInput = {
  companyId: Scalars['ID'];
  playlistId: Scalars['ID'];
};

export type ZvukPlaylistRemoveMutation = {
  __typename?: 'ZvukPlaylistRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistRemoveMutationInput = {
  companyId: Scalars['ID'];
  playlistId: Scalars['ID'];
};

/** An enumeration. */
export enum ZvukPlaylistSource {
  ZvukB2BStream = 'ZVUK_B2B_STREAM',
  ZvukPlaylist = 'ZVUK_PLAYLIST'
}

export type ZvukPlaylistType = {
  __typename?: 'ZvukPlaylistType';
  companyId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isAutoCreated?: Maybe<Scalars['Boolean']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  modified?: Maybe<Scalars['DateTime']>;
  poster?: Maybe<Scalars['String']>;
  profileId: Scalars['ID'];
  remotePlaylistLink?: Maybe<Scalars['String']>;
  source?: Maybe<ZvukPlaylistSource>;
  streamId?: Maybe<Scalars['ID']>;
  syncStatus?: Maybe<ZvukSyncStatus>;
  title?: Maybe<Scalars['String']>;
  tracksCount?: Maybe<Scalars['Int']>;
};

export type ZvukPlaylistUpdateMutation = {
  __typename?: 'ZvukPlaylistUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  playlist?: Maybe<ZvukPlaylistType>;
};

export type ZvukPlaylistUpdateMutationInput = {
  companyId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  playlistId: Scalars['ID'];
  poster?: InputMaybe<Scalars['Upload']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ZvukProfileAdminPublishMutation = {
  __typename?: 'ZvukProfileAdminPublishMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileAdminPublishMutationInput = {
  profileId: Scalars['ID'];
};

export type ZvukProfileAdminRestoreMutation = {
  __typename?: 'ZvukProfileAdminRestoreMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileAdminRestoreMutationInput = {
  profileId: Scalars['ID'];
};

export type ZvukProfileCreateMutation = {
  __typename?: 'ZvukProfileCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileCreateMutationInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  bannerMobile?: InputMaybe<Scalars['Upload']>;
  bannerWeb?: InputMaybe<Scalars['Upload']>;
  companyId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['Upload']>;
  site?: InputMaybe<Scalars['String']>;
};

export type ZvukProfileEventPureType = {
  __typename?: 'ZvukProfileEventPureType';
  created: Scalars['DateTime'];
  eventType: ZvukProfilesAuditEventTypesEnum;
  id: Scalars['ID'];
  payload?: Maybe<Scalars['String']>;
  playlistId?: Maybe<Scalars['ID']>;
  user?: Maybe<UserExtendPureType>;
};

export type ZvukProfileEventsPaginationPureType = {
  __typename?: 'ZvukProfileEventsPaginationPureType';
  paginationInfo: PaginationInfoType;
  result: Array<ZvukProfileEventPureType>;
};

export type ZvukProfileEventsQueryFilter = {
  profileId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type ZvukProfileEventsQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

export enum ZvukProfileEventsQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type ZvukProfileHideMutation = {
  __typename?: 'ZvukProfileHideMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileHideMutationInput = {
  companyId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type ZvukProfilePublishMutation = {
  __typename?: 'ZvukProfilePublishMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfilePublishMutationInput = {
  companyId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type ZvukProfileQueryInput = {
  companyId: Scalars['ID'];
  zvukProfileId: Scalars['ID'];
};

export type ZvukProfileQueryPaginationType = {
  __typename?: 'ZvukProfileQueryPaginationType';
  paginationInfo: PaginationInfoType;
  result?: Maybe<Array<ZvukProfileType>>;
};

export type ZvukProfileRemoveMutation = {
  __typename?: 'ZvukProfileRemoveMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileRemoveMutationInput = {
  companyId: Scalars['ID'];
  profileId: Scalars['ID'];
};

export type ZvukProfileType = {
  __typename?: 'ZvukProfileType';
  avatar?: Maybe<Scalars['String']>;
  bannerLink?: Maybe<Scalars['String']>;
  bannerMobile?: Maybe<Scalars['String']>;
  bannerWeb?: Maybe<Scalars['String']>;
  company?: Maybe<UserCompanyPureType>;
  companyName?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublished?: Maybe<Scalars['Boolean']>;
  playlists?: Maybe<Array<Maybe<ZvukPlaylistType>>>;
  poster?: Maybe<Scalars['String']>;
  remoteProfileLink?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<ZvukSyncStatus>;
};

export type ZvukProfileUpdateMutation = {
  __typename?: 'ZvukProfileUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<ZvukProfileType>;
};

export type ZvukProfileUpdateMutationInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  bannerLink?: InputMaybe<Scalars['String']>;
  bannerMobile?: InputMaybe<Scalars['Upload']>;
  bannerWeb?: InputMaybe<Scalars['Upload']>;
  companyId: Scalars['ID'];
  companyName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['Upload']>;
  profileId: Scalars['ID'];
  site?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum ZvukProfilesAuditEventTypesEnum {
  ZvukB2BPlaylistCreated = 'ZVUK_B2B_PLAYLIST_CREATED',
  ZvukB2BPlaylistHidden = 'ZVUK_B2B_PLAYLIST_HIDDEN',
  ZvukB2BPlaylistPublished = 'ZVUK_B2B_PLAYLIST_PUBLISHED',
  ZvukB2BPlaylistUpdated = 'ZVUK_B2B_PLAYLIST_UPDATED',
  ZvukB2BProfileCreated = 'ZVUK_B2B_PROFILE_CREATED',
  ZvukB2BProfileHidden = 'ZVUK_B2B_PROFILE_HIDDEN',
  ZvukB2BProfilePublished = 'ZVUK_B2B_PROFILE_PUBLISHED',
  ZvukB2BProfileUpdated = 'ZVUK_B2B_PROFILE_UPDATED',
  ZvukPlaylistB2BDeleted = 'ZVUK_PLAYLIST_B2B_DELETED',
  ZvukPlaylistB2BRestored = 'ZVUK_PLAYLIST_B2B_RESTORED',
  ZvukPlaylistCreated = 'ZVUK_PLAYLIST_CREATED',
  ZvukPlaylistDeleted = 'ZVUK_PLAYLIST_DELETED',
  ZvukPlaylistHidden = 'ZVUK_PLAYLIST_HIDDEN',
  ZvukPlaylistPublished = 'ZVUK_PLAYLIST_PUBLISHED',
  ZvukPlaylistUpdated = 'ZVUK_PLAYLIST_UPDATED',
  ZvukProfileB2BDeleted = 'ZVUK_PROFILE_B2B_DELETED',
  ZvukProfileB2BRestored = 'ZVUK_PROFILE_B2B_RESTORED',
  ZvukProfileCreated = 'ZVUK_PROFILE_CREATED',
  ZvukProfileHidden = 'ZVUK_PROFILE_HIDDEN',
  ZvukProfilePublished = 'ZVUK_PROFILE_PUBLISHED',
  ZvukProfileUpdated = 'ZVUK_PROFILE_UPDATED'
}

export enum ZvukProfilesPagintaionQuerySort {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC'
}

export type ZvukProfilesQueryFilter = {
  companyName?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type ZvukProfilesQueryPagination = {
  page: Scalars['Int'];
  /** max 100 */
  pageSize: Scalars['Int'];
};

/** An enumeration. */
export enum ZvukSyncStatus {
  AwaitingSync = 'AWAITING_SYNC',
  NeverSynced = 'NEVER_SYNCED',
  Synced = 'SYNCED'
}

export type BillingLicensesModalViewModelQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type BillingLicensesModalViewModelQuery = { __typename?: 'Query', organizationCurrentPricePlanQuery?: { __typename?: 'OrganizationPricePlanPureType', organizationId: number, pricePlan?: { __typename?: 'PricePlanPureType', id: string } | null } | null, companyBillingInfoQuery?: { __typename?: 'UserBillingInfo', status: SubscriptionStatus, selectedPaymentKind: PaymentKind, nextBillingDate?: any | null, nextBillingAmount?: number | null, fullPeriodAmount?: number | null, paymentScheme?: PaymentScheme | null, hasTrialLicenses: boolean, hasActiveLicenses: boolean, hasInactiveLicenses: boolean, hasWaitPaymentLicenses: boolean, hasGraceLicenses: boolean, nonRenewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, renewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, unpaidLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, totalLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }> } | null, paymentMethodPureQuery?: { __typename?: 'PaymentMethodStatusType', isLinkingInProcess: boolean, paymentMethod?: { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string } | null } | null, acceptanceAdvancedQuery?: { __typename?: 'AcceptanceAdvanceType', status: AcceptanceAdvanceStatus, payerAccount: string } | null };

export type BillingCurrentPricePlanViewModelQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type BillingCurrentPricePlanViewModelQuery = { __typename?: 'Query', organizationCurrentPricePlanQuery?: { __typename?: 'OrganizationPricePlanPureType', organizationId: number, pricePlan?: { __typename?: 'PricePlanPureType', id: string, title: string, titleForManager: string, alias: string, currency: Currencies, useByDefault: boolean, offerLink: string, periods: Array<{ __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> }>, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null, pricePlanPeriod?: { __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null } | null, companyBillingInfoQuery?: { __typename?: 'UserBillingInfo', status: SubscriptionStatus, selectedPaymentKind: PaymentKind, nextBillingDate?: any | null, hasActiveLicenses: boolean, hasInactiveLicenses: boolean, hasWaitPaymentLicenses: boolean, hasGraceLicenses: boolean, hasTrialLicenses: boolean, expiresLicenseDate?: string | null, hasRenewableLicenses?: boolean | null, isWaitPaymentLicense?: boolean | null, isGraceLicense?: boolean | null, discount?: { __typename?: 'OrganizationDiscountPureType', id: string, title: string, startDate: any, endDate?: any | null, invoiceWithDiscountLimit: number, payFrequencyMonth: number, value: number, valueType: DiscountValueType, organizationId: number, status: OrganizationDiscountStatus, slug: string } | null, nonRenewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, renewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, unpaidLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, totalLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }> } | null, acceptanceAdvancedQuery?: { __typename?: 'AcceptanceAdvanceType', status: AcceptanceAdvanceStatus, payerAccount: string } | null };

export type AuthTokenMutationVariables = Exact<{
  input: JwtTokenAuthPureMutationInput;
}>;


export type AuthTokenMutation = { __typename?: 'Mutation', auth?: { __typename?: 'ObtainPureJSONWebToken', token: { __typename?: 'TokenPureType', value: string } } | null };

export type AuthAllowedActionsForPhoneQueryVariables = Exact<{
  phone: Scalars['String'];
}>;


export type AuthAllowedActionsForPhoneQuery = { __typename?: 'Query', allowedActionsForPhone: string };

export type AuthTokenRetrieveMutationVariables = Exact<{
  input: JwtTokenAuthPureMutationInput;
}>;


export type AuthTokenRetrieveMutation = { __typename?: 'Mutation', auth?: { __typename?: 'RetrievePureJSONWebToken', token: { __typename?: 'TokenPureType', value: string }, user: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } } | null };

export type AuthPasswordRestoreMutationVariables = Exact<{
  input: PasswordResetMutationInput;
}>;


export type AuthPasswordRestoreMutation = { __typename?: 'Mutation', passwordRestore?: { __typename?: 'PasswordResetMutationPayload', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type AuthPasswordRestoreConfirmationMutationVariables = Exact<{
  input: PasswordResetConfirmationMutationInput;
}>;


export type AuthPasswordRestoreConfirmationMutation = { __typename?: 'Mutation', passwordRestoreConfirmation?: { __typename?: 'PasswordResetConfirmationMutationPayload', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type AuthSendEmailRepeatMutationVariables = Exact<{
  input: SendEmailPureRepeatMutationInput;
}>;


export type AuthSendEmailRepeatMutation = { __typename?: 'Mutation', sendEmailPureRepeat?: { __typename?: 'SendEmailPureRepeatMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type AuthPasswordSetNewMutationVariables = Exact<{
  input: PasswordPureSetNewMutationInput;
}>;


export type AuthPasswordSetNewMutation = { __typename?: 'Mutation', passwordPureSetNew?: { __typename?: 'PasswordPureSetNewMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type AuthTokenRevokeMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthTokenRevokeMutation = { __typename?: 'Mutation', tokenPureRevoke?: { __typename?: 'TokenPureRevoke', revoked: number } | null };

export type CurrentUserLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserLogoutMutation = { __typename?: 'Mutation', currentUserLogout?: { __typename?: 'CurrentLogoutUser', deleted: boolean } | null };

export type AuthCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthCurrentUserQuery = { __typename?: 'Query', currentUserPureQuery?: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } | null };

export type AuthUserSignUpMutationVariables = Exact<{
  input: UserPureSignUpMutationInput;
}>;


export type AuthUserSignUpMutation = { __typename?: 'Mutation', auth?: { __typename?: 'UserPureSignUpMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AuthUserSignUpYclientsMutationVariables = Exact<{
  input: UserPureSignUpYClientsMutationInput;
}>;


export type AuthUserSignUpYclientsMutation = { __typename?: 'Mutation', auth?: { __typename?: 'UserPureSignUpYClientsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AuthUserGetSberOauthUriQueryVariables = Exact<{
  redirect: Scalars['String'];
}>;


export type AuthUserGetSberOauthUriQuery = { __typename?: 'Query', userGetSberOauthUri: string };

export type AuthUserGetSberReauthUriQueryVariables = Exact<{
  redirectUri: Scalars['String'];
  companyId: Scalars['ID'];
}>;


export type AuthUserGetSberReauthUriQuery = { __typename?: 'Query', userGetSberLinkUri: string };

export type AuthLeadUtmMarksMutationVariables = Exact<{
  input: UtmMarksSendToAmoMutationInput;
}>;


export type AuthLeadUtmMarksMutation = { __typename?: 'Mutation', utmMarksSendToAmoLead?: { __typename?: 'UtmMarksSendToAmoLeadMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AuthInvitationCreateMutationVariables = Exact<{
  input: UserInvitationCreateMutationInput;
}>;


export type AuthInvitationCreateMutation = { __typename?: 'Mutation', invitationCreate?: { __typename?: 'UserInvitationCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, invitation: { __typename?: 'UserInvitationType', id: string, email: string, isSent: boolean, isAccepted: boolean, isActive: boolean } } | null };

export type AuthInvitationSendMutationVariables = Exact<{
  input: UserInvitationSendMutationInput;
}>;


export type AuthInvitationSendMutation = { __typename?: 'Mutation', invitationSend?: { __typename?: 'UserInvitationSendMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, invitation: { __typename?: 'UserInvitationType', id: string, email: string, isSent: boolean, isAccepted: boolean, isActive: boolean } } | null };

export type AuthInvitationDeactivateMutationVariables = Exact<{
  input: UserInvitationDeactivateMutationInput;
}>;


export type AuthInvitationDeactivateMutation = { __typename?: 'Mutation', invitationDeactivate?: { __typename?: 'UserInvitationDeactivateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, invitation: { __typename?: 'UserInvitationType', id: string, email: string, isSent: boolean, isAccepted: boolean, isActive: boolean } } | null };

export type AuthInvitationAcceptMutationVariables = Exact<{
  input: UserInvitationAcceptMutationInput;
}>;


export type AuthInvitationAcceptMutation = { __typename?: 'Mutation', invitationAccept?: { __typename?: 'UserInvitationAcceptMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AuthInvitationsQueryVariables = Exact<{
  filters: InvitationsQueryFilter;
  pagination: InvitationsPagination;
  sort: InvitationsQuerySort;
}>;


export type AuthInvitationsQuery = { __typename?: 'Query', invitationsPaginationQuery: { __typename?: 'UserInvitationsPaginationType', result?: Array<{ __typename?: 'UserInvitationType', id: string, email: string, isSent: boolean, isAccepted: boolean, isActive: boolean }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AuthCompanyRemoveUserMutationVariables = Exact<{
  input: CompanyRemoveUserMutationInput;
}>;


export type AuthCompanyRemoveUserMutation = { __typename?: 'Mutation', companyRemoveUser?: { __typename?: 'CompanyRemoveUserMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AuthBusinessSpheresQueryVariables = Exact<{
  pagination: BusinessSpheresQueryPagination;
  sort?: InputMaybe<BusinessSpheresQuerySort>;
}>;


export type AuthBusinessSpheresQuery = { __typename?: 'Query', result: { __typename?: 'BusinessSpheresQueryPaginationType', result?: Array<{ __typename?: 'BusinessSpherePureType', id: string, title: string }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number } } };

export type CaptchaSettingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CaptchaSettingsQueryQuery = { __typename?: 'Query', captchaSettings: { __typename?: 'CaptchaSettingsType', enabled: boolean, countries: Array<Country | null> } };

export type AuthActivationCodeSmsStatusQueryVariables = Exact<{
  phone: Scalars['String'];
}>;


export type AuthActivationCodeSmsStatusQuery = { __typename?: 'Query', result: string };

export type AuthContractAcceptMigrationMutationVariables = Exact<{
  input: ContractAcceptMigrationMutationInput;
}>;


export type AuthContractAcceptMigrationMutation = { __typename?: 'Mutation', contractAcceptMigration?: { __typename?: 'ContractAcceptMigrationMutation', ok?: boolean | null } | null };

export type AuthAmoSyncDataMutationVariables = Exact<{
  input: AmoSyncDataMutationInput;
}>;


export type AuthAmoSyncDataMutation = { __typename?: 'Mutation', amoSyncData?: { __typename?: 'AmoSyncDataMutation', ok?: boolean | null } | null };

export type AuthCodeCreateMutationVariables = Exact<{
  input: AuthorizationCodeCreateMutationInput;
}>;


export type AuthCodeCreateMutation = { __typename?: 'Mutation', authorizationCodeCreate?: { __typename?: 'AuthorizationCodeCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, codeData?: { __typename?: 'AuthorizationCodePureType', isActive: boolean, phone: string, created?: any | null } | null } | null };

export type AuthUserPureUpdateMutationVariables = Exact<{
  input: UserPureUpdateMutationInput;
}>;


export type AuthUserPureUpdateMutation = { __typename?: 'Mutation', userPureUpdate?: { __typename?: 'UserPureUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, user?: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } | null } | null };

export type AuthUserPureSignUpByPhoneMutationVariables = Exact<{
  input: UserPureSignUpByPhoneMutationInput;
}>;


export type AuthUserPureSignUpByPhoneMutation = { __typename?: 'Mutation', userPureSignUpByPhone?: { __typename?: 'UserPureSignUpByPhoneMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, token: { __typename?: 'TokenPureType', value: string }, user: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } } | null };

export type AuthCodeTokenMutationVariables = Exact<{
  input: JwtTokenAuthWithCodePureMutationInput;
}>;


export type AuthCodeTokenMutation = { __typename?: 'Mutation', jwtTokenAuthWithCode?: { __typename?: 'JwtTokenAuthWithCodePureMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, token: { __typename?: 'TokenPureType', value: string }, user: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } } | null };

export type CompanyUpdateMutationVariables = Exact<{
  input: UserCompanyUpdateMutationInput;
}>;


export type CompanyUpdateMutation = { __typename?: 'Mutation', userCompanyUpdate?: { __typename?: 'UserCompanyUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null, company: { __typename?: 'UserCompanyPureType', marketingMaterialsAgreementReceived: boolean, id: string, requisite?: { __typename?: 'RequisiteBYPureType', emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', emailForDocuments: string } | null } } | null };

export type CompanyExistQueryVariables = Exact<{
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['String']>;
  bin?: InputMaybe<Scalars['String']>;
  iin?: InputMaybe<Scalars['String']>;
  unp?: InputMaybe<Scalars['String']>;
}>;


export type CompanyExistQuery = { __typename?: 'Query', result: boolean };

export type AutocompleteSuggestionCompanyQueryVariables = Exact<{
  input: SuggestionCompanyQueryPureType;
}>;


export type AutocompleteSuggestionCompanyQuery = { __typename?: 'Query', userPureSuggestionCompany: { __typename?: 'SuggestionCompanyQueryResultPureType', result?: Array<{ __typename?: 'SuggestionCompanyPureType', inn?: string | null, address?: string | null, city?: string | null, fullName: string, kpp?: string | null, name: string, ogrn?: string | null, bin?: string | null, unp?: string | null, region?: string | null, shortName?: string | null, organizationType: SuggestionOrganizationTypeEnum, management?: { __typename?: 'SuggestionManagementType', name: string, post?: string | null } | null }> | null } };

export type AutocompleteSuggestionAddressQueryVariables = Exact<{
  input: SuggestionAddressQueryPureType;
}>;


export type AutocompleteSuggestionAddressQuery = { __typename?: 'Query', userPureSuggestionAddress: { __typename?: 'SuggestionAddressQueryResultPureType', result?: Array<{ __typename?: 'SuggestionAddressPureType', value: string }> | null } };

export type OrganizationPricePlanQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationPricePlanQuery = { __typename?: 'Query', organizationPricePlanQuery?: { __typename?: 'PricePlanPureType', id: string, title: string, titleForManager: string, alias: string, currency: Currencies, useByDefault: boolean, offerLink: string, periods: Array<{ __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> }>, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null };

export type BillingLaunchSubscriptionMutationVariables = Exact<{
  input: LaunchSubscriptionMutationInput;
}>;


export type BillingLaunchSubscriptionMutation = { __typename?: 'Mutation', launchSubscription?: { __typename?: 'LaunchSubscriptionMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingExtendSubscriptionMutationVariables = Exact<{
  input: ExtendSubscriptionMutationInput;
}>;


export type BillingExtendSubscriptionMutation = { __typename?: 'Mutation', extendSubscription?: { __typename?: 'ExtendSubscriptionMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingLicensesQueryVariables = Exact<{
  filters: LicensesQueryFilter;
  pagination: LicensesQueryPagination;
  sort: LicensesQuerySort;
}>;


export type BillingLicensesQuery = { __typename?: 'Query', result: { __typename?: 'LicensesPaginationType', result?: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type BillingCompanyBillingInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type BillingCompanyBillingInfoQuery = { __typename?: 'Query', result?: { __typename?: 'UserBillingInfo', status: SubscriptionStatus, firstPaidAt?: any | null, nextBillingDate?: any | null, nextBillingAmount?: number | null, nextBillingPriceAmount?: number | null, fullPeriodAmount?: number | null, fullPeriodAmountWithDiscount?: number | null, selectedPaymentKind: PaymentKind, paymentScheme?: PaymentScheme | null, isBillingEnabled?: boolean | null, hasTrialLicenses: boolean, hasActiveLicenses: boolean, hasInactiveLicenses: boolean, hasWaitPaymentLicenses: boolean, hasGraceLicenses: boolean, expiresLicenseDate?: string | null, isLastInvoiceHasZeroAmount?: boolean | null, isWaitPaymentLicense?: boolean | null, isGraceLicense?: boolean | null, canRealizeBillingOperation?: boolean | null, canRealizeBillingOperationWithPayment?: boolean | null, hasRenewableLicenses?: boolean | null, hasNonRenewableLicenses?: boolean | null, renewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, nonRenewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, unpaidLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, discount?: { __typename?: 'OrganizationDiscountPureType', id: string, title: string, startDate: any, endDate?: any | null, invoiceWithDiscountLimit: number, payFrequencyMonth: number, value: number, valueType: DiscountValueType, organizationId: number, status: OrganizationDiscountStatus, slug: string } | null, nextBillingLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, totalLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, paymentMethod?: { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string } | null } | null };

export type BillingLicensesSendSuspendAutoRenewalMutationVariables = Exact<{
  input: LicensesSuspendAutoRenewalMutationInput;
}>;


export type BillingLicensesSendSuspendAutoRenewalMutation = { __typename?: 'Mutation', result?: { __typename?: 'LicensesSuspendAutoRenewalMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingLicensesSendResumeAutoRenewalMutationVariables = Exact<{
  input: LicensesResumeAutoRenewalMutationInput;
}>;


export type BillingLicensesSendResumeAutoRenewalMutation = { __typename?: 'Mutation', result?: { __typename?: 'LicensesResumeAutoRenewalMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type CompanyCreateAmoTaskToBillMutationVariables = Exact<{
  input: CompanyCreateAmoTaskToBillPureMutationInput;
}>;


export type CompanyCreateAmoTaskToBillMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanyCreateAmoTaskToBillPureMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type ResumeSubscriptionCostQueryVariables = Exact<{
  licensesNum: Scalars['Int'];
  organizationId: Scalars['ID'];
}>;


export type ResumeSubscriptionCostQuery = { __typename?: 'Query', result: { __typename?: 'ResumeSubscriptionCostInfoPureType', cost?: number | null, costWithDiscount?: number | null, fullPeriodCost?: number | null } };

export type SubscriptionExtensionCostQueryVariables = Exact<{
  licensesNum: Scalars['Int'];
  companyId: Scalars['ID'];
}>;


export type SubscriptionExtensionCostQuery = { __typename?: 'Query', result: { __typename?: 'SubscriptionExtensionCostInfoPureType', cost?: number | null, fullPeriodCost?: number | null } };

export type BillingSubscriptionCostByPricePlanPeriodQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  pricePlanPeriodId: Scalars['ID'];
}>;


export type BillingSubscriptionCostByPricePlanPeriodQuery = { __typename?: 'Query', result?: number | null };

export type BillingExtendSubscriptionRequestMutationVariables = Exact<{
  input: ExtendSubscriptionRequestMutationInput;
}>;


export type BillingExtendSubscriptionRequestMutation = { __typename?: 'Mutation', result?: { __typename?: 'ExtendSubscriptionRequestMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingAcceptanceAdvancedQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type BillingAcceptanceAdvancedQuery = { __typename?: 'Query', acceptanceAdvancedQuery?: { __typename?: 'AcceptanceAdvanceType', id: string, status: AcceptanceAdvanceStatus, payerAccount: string, cancellationReason?: AcceptanceCancellationReason | null, payerInn?: string | null, payerName?: string | null, userId?: string | null, errorViewedAt?: any | null } | null };

export type BillingMarkAcceptanceErrorAsViewedMutationVariables = Exact<{
  input: MarkAcceptanceErrorAsViewedInput;
}>;


export type BillingMarkAcceptanceErrorAsViewedMutation = { __typename?: 'Mutation', result?: { __typename?: 'MarkAcceptanceErrorAsViewedMutation', ok?: boolean | null, acceptance?: { __typename?: 'AcceptanceAdvanceType', errorViewedAt?: any | null } | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingAcceptanceAdvancedStartSigningMutationVariables = Exact<{
  input: AcceptanceAdvancedStartSigningInput;
}>;


export type BillingAcceptanceAdvancedStartSigningMutation = { __typename?: 'Mutation', result?: { __typename?: 'AcceptanceAdvancedStartSigningMutation', ok?: boolean | null, confirmLink: string, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type ZvukProfileListQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type ZvukProfileListQuery = { __typename?: 'Query', zvukProfileList: Array<{ __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null> };

export type BusinessProfileCreateMutationVariables = Exact<{
  input: ZvukProfileCreateMutationInput;
}>;


export type BusinessProfileCreateMutation = { __typename?: 'Mutation', zvukProfileCreate?: { __typename?: 'ZvukProfileCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, profile?: { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null } | null };

export type BusinessProfileUpdateMutationVariables = Exact<{
  input: ZvukProfileUpdateMutationInput;
}>;


export type BusinessProfileUpdateMutation = { __typename?: 'Mutation', zvukProfileUpdate?: { __typename?: 'ZvukProfileUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, profile?: { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null } | null };

export type BusinessProfileRemoveMutationVariables = Exact<{
  input: ZvukProfileRemoveMutationInput;
}>;


export type BusinessProfileRemoveMutation = { __typename?: 'Mutation', zvukProfileRemove?: { __typename?: 'ZvukProfileRemoveMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, profile?: { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null } | null };

export type BusinessProfileHideMutationVariables = Exact<{
  input: ZvukProfileHideMutationInput;
}>;


export type BusinessProfileHideMutation = { __typename?: 'Mutation', zvukProfileHide?: { __typename?: 'ZvukProfileHideMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, profile?: { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null } | null };

export type BusinessProfilePublishMutationVariables = Exact<{
  input: ZvukProfilePublishMutationInput;
}>;


export type BusinessProfilePublishMutation = { __typename?: 'Mutation', zvukProfilePublish?: { __typename?: 'ZvukProfilePublishMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, profile?: { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null } | null } | null };

export type BusinessProfileCompanySavedStreamsQueryVariables = Exact<{
  filters: StreamsQueryFilter;
  pagination: StreamsQueryPagination;
  sort: StreamsQuerySort;
}>;


export type BusinessProfileCompanySavedStreamsQuery = { __typename?: 'Query', streamsPaginationQuery: { __typename?: 'StreamsQueryPaginationType', result?: Array<{ __typename?: 'StreamPureType', id: string, title: string, description: string, mediafilesCount: number, poster?: { __typename?: 'PosterFilePureType', id: string, miniatureFilename?: string | null, miniatureUri?: string | null } | null, points: Array<{ __typename?: 'PointPureType', id: string, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, title?: string | null } | null }> }> | null } };

export type BusinessProfilePlaylistCreateFromStreamMutationVariables = Exact<{
  input: ZvukPlaylistCreateFromStreamMutationInput;
}>;


export type BusinessProfilePlaylistCreateFromStreamMutation = { __typename?: 'Mutation', zvukPlaylistCreateFromStream?: { __typename?: 'ZvukPlaylistCreateFromStreamMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null } | null };

export type BusinessProfilePlaylistUpdateMutationVariables = Exact<{
  input: ZvukPlaylistUpdateMutationInput;
}>;


export type BusinessProfilePlaylistUpdateMutation = { __typename?: 'Mutation', zvukPlaylistUpdate?: { __typename?: 'ZvukPlaylistUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null } | null };

export type BusinessProfilePlaylistHideMutationVariables = Exact<{
  input: ZvukPlaylistHideMutationInput;
}>;


export type BusinessProfilePlaylistHideMutation = { __typename?: 'Mutation', zvukPlaylistHide?: { __typename?: 'ZvukPlaylistHideMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null } | null };

export type BusinessProfilePlaylistRemoveMutationVariables = Exact<{
  input: ZvukPlaylistRemoveMutationInput;
}>;


export type BusinessProfilePlaylistRemoveMutation = { __typename?: 'Mutation', zvukPlaylistRemove?: { __typename?: 'ZvukPlaylistRemoveMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null } | null };

export type BusinessProfilePlaylistPublishMutationVariables = Exact<{
  input: ZvukPlaylistPublishMutationInput;
}>;


export type BusinessProfilePlaylistPublishMutation = { __typename?: 'Mutation', zvukPlaylistPublish?: { __typename?: 'ZvukPlaylistPublishMutation', ok?: boolean | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type BusinessProfileZvukPlaylistInfoMutationVariables = Exact<{
  input: ZvukPlaylistInfoMutationInput;
}>;


export type BusinessProfileZvukPlaylistInfoMutation = { __typename?: 'Mutation', zvukPlaylistInfo?: { __typename?: 'ZvukPlaylistInfoMutation', ok?: boolean | null, playlist?: { __typename?: 'ZvukAPIPlaylistType', id: string, name: string, description?: string | null, isPublic: boolean, trackCount: number, imageUrl?: string | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type BusinessProfilePlaylistCreateFromZvukMutationVariables = Exact<{
  input: ZvukPlaylistCreateFromZvukMutationInput;
}>;


export type BusinessProfilePlaylistCreateFromZvukMutation = { __typename?: 'Mutation', zvukPlaylistCreateFromZvuk?: { __typename?: 'ZvukPlaylistCreateFromZvukMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, playlist?: { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null } | null };

export type CreateCertificateMutationVariables = Exact<{
  input: CertLetterForPointMutationInput;
}>;


export type CreateCertificateMutation = { __typename?: 'Mutation', certLetterForPointMutation?: { __typename?: 'CertLetterForPointMutation', ok?: boolean | null, downloadLink?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaCompanyStreamsQueryVariables = Exact<{
  filters: StreamsQueryFilter;
  pagination: StreamsQueryPagination;
  sort: StreamsQuerySort;
}>;


export type MediaCompanyStreamsQuery = { __typename?: 'Query', result: { __typename?: 'StreamsQueryPaginationType', result?: Array<{ __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, master?: { __typename?: 'StreamPureType', id: string } | null, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MediaStreamTemplateGroupsQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type MediaStreamTemplateGroupsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'StreamPureTemplateGroupType', id: string, title: string, streams: Array<{ __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null }> }> };

export type MediaStreamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaStreamQuery = { __typename?: 'Query', result?: { __typename?: 'StreamPureType', mediafilesCount: number, duration: number, hasThematicBlock: boolean, mediafilesLiked: Array<string>, id: string, title: string, description: string, isTemplate: boolean, templateType: string, points: Array<{ __typename?: 'PointPureType', id: string, address: string }>, contentBlocks: Array<{ __typename?: 'ContentBlockPureType', id: string, copyFromId?: string | null, title: string, startDayTime?: any | null, endDayTime?: any | null, startDate?: any | null, endDate?: any | null }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null } | null };

export type StreamApprovalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StreamApprovalQuery = { __typename?: 'Query', result?: { __typename?: 'StreamPureType', id: string, title: string, contentBlocks: Array<{ __typename?: 'ContentBlockPureType', id: string, title: string, startDayTime?: any | null, endDayTime?: any | null }> } | null };

export type MediaStreamCopyFromTemplateMutationVariables = Exact<{
  input: StreamPureCopyFromTemplateMutationInput;
}>;


export type MediaStreamCopyFromTemplateMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamPureCopyFromTemplateMutation', ok?: boolean | null, stream: { __typename?: 'StreamPureType', id: string }, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type MediaStreamSetToPointsMutationVariables = Exact<{
  input: StreamPureSetToCompanyPointsMutationInput;
}>;


export type MediaStreamSetToPointsMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamPureSetToCompanyPointsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type MediaStreamRemoveMutationVariables = Exact<{
  input: StreamPureRemoveMutationInput;
}>;


export type MediaStreamRemoveMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamPureRemoveMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type MediaMediafilesRandomQueryVariables = Exact<{
  filters: StreamMediafilesRandomPaginationQueryFilter;
  pagination: StreamMediafilesRandomQueryPagination;
}>;


export type MediaMediafilesRandomQuery = { __typename?: 'Query', streamMediafilesRandomPaginationQuery: { __typename?: 'StreamMediafilesRandomQueryPaginationType', result: Array<{ __typename?: 'MediafilePureType', id: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, type: number, explicit: boolean, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MediaMediafilesQueryVariables = Exact<{
  filters: MediafilesQueryFilter;
  pagination: MediafilesQueryPagination;
  sort: MediafilesQuerySort;
}>;


export type MediaMediafilesQuery = { __typename?: 'Query', mediafilesPaginationQuery: { __typename?: 'MediafilesQueryPaginationType', result?: Array<{ __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MediaAdCampaignRenameMutationVariables = Exact<{
  adCompanyId: Scalars['ID'];
  title: Scalars['String'];
}>;


export type MediaAdCampaignRenameMutation = { __typename?: 'Mutation', adcampaignRename?: { __typename?: 'AdCampaignRenameMutation', adCompany?: { __typename?: 'AdCampaignPureType', id: string, title: string } | null } | null };

export type MediaThematicBlockRemoveFromCompanyMutationVariables = Exact<{
  input: ThematicBlockPureRemoveFromCompanyMutationInput;
}>;


export type MediaThematicBlockRemoveFromCompanyMutation = { __typename?: 'Mutation', result?: { __typename?: 'ThematicBlockPureRemoveFromCompanyMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type MediaThematicBlockSetToCompanyMutationVariables = Exact<{
  input: ThematicBlockPureSetToCompanyMutationInput;
}>;


export type MediaThematicBlockSetToCompanyMutation = { __typename?: 'Mutation', result?: { __typename?: 'ThematicBlockPureSetToCompanyMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null, companyThematicBlock?: { __typename?: 'CompanyThematicContentBlockPureType', id: string, playFromDate: any, playToDate: any, isActive: boolean, isEnabled: boolean, title: string, eventTitle: string } | null } | null };

export type MediaCompanyThematicBlockUpdateMutationVariables = Exact<{
  input: CompanyThematicBlockPureUpdateMutationInput;
}>;


export type MediaCompanyThematicBlockUpdateMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanyThematicBlockPureUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null, companyThematicBlock?: { __typename?: 'CompanyThematicContentBlockPureType', id: string, playFromDate: any, playToDate: any, isActive: boolean, isEnabled: boolean, title: string, eventTitle: string } | null } | null };

export type MediaCompanyThematicContentBlocksQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type MediaCompanyThematicContentBlocksQuery = { __typename?: 'Query', result: Array<{ __typename?: 'CompanyThematicContentBlockPureType', streamsIdsWithThematic: Array<string>, id: string, playFromDate: any, playToDate: any, isActive: boolean, isEnabled: boolean, title: string, eventTitle: string }> };

export type MediaThematicContentBlocksQueryVariables = Exact<{
  forDate: Scalars['DateTime'];
}>;


export type MediaThematicContentBlocksQuery = { __typename?: 'Query', result: Array<{ __typename?: 'ThematicContentBlockPureType', id: string, title: string, eventTitle: string, isEnabled: boolean, startDate?: any | null, endDate?: any | null }> };

export type MediaThematicBlockRandomMediafilesPaginationQueryVariables = Exact<{
  filters: ThematicBlockRandomMediafilesPaginationQueryFilter;
  pagination: ThematicBlockRandomMediafilesQueryPagination;
}>;


export type MediaThematicBlockRandomMediafilesPaginationQuery = { __typename?: 'Query', result: { __typename?: 'ThematicBlockRandomMediafilesQueryPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, result: Array<{ __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> }> } };

export type ExcludeMediafileMutationVariables = Exact<{
  input: StreamPureDislikeMediafileMutationInput;
}>;


export type ExcludeMediafileMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamPureDislikeMediafileMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RestoreMediafileMutationVariables = Exact<{
  input: StreamPureDislikeMediafileRestoreMutationInput;
}>;


export type RestoreMediafileMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamPureDislikeMediafileRestoreMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaDislikedMediafilesPaginationQueryVariables = Exact<{
  filters: StreamMediafilesEventsFilter;
  pagination: StreamMediafilesEventsPagination;
  sort: StreamMediafilesEventsSort;
}>;


export type MediaDislikedMediafilesPaginationQuery = { __typename?: 'Query', streamDislikedMediafiles: { __typename?: 'MediafileApprovalPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, result: Array<{ __typename?: 'MediafileApprovalType', eventType?: MediafileEventTypes | null, mediafile: { __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }> } };

export type StreamLibraryQueryVariables = Exact<{
  companyId: Scalars['ID'];
  libraryId: Scalars['ID'];
}>;


export type StreamLibraryQuery = { __typename?: 'Query', result?: { __typename?: 'LibraryPureType', id: string, title: string, groups: Array<{ __typename?: 'LibraryGroupPureType', id: string, title: string, collections: Array<{ __typename?: 'LibraryCollectionPureType', id: string, title: string, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } }> }> } | null };

export type LibraryCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
  companyId: Scalars['ID'];
}>;


export type LibraryCollectionQuery = { __typename?: 'Query', result?: { __typename?: 'LibraryCollectionPureType', id: string, title: string } | null };

export type LibrarySubCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
  companyId: Scalars['ID'];
}>;


export type LibrarySubCollectionQuery = { __typename?: 'Query', result?: { __typename?: 'LibraryCollectionPureType', id: string, title: string, subcollections: Array<{ __typename?: 'LibrarySubCollectionPureType', id: string, title: string, description: string }> } | null };

export type StreamLibrarySubcollectionTitleQueryVariables = Exact<{
  companyId: Scalars['ID'];
  subcollectionId: Scalars['ID'];
}>;


export type StreamLibrarySubcollectionTitleQuery = { __typename?: 'Query', result?: { __typename?: 'LibrarySubCollectionPureType', title: string } | null };

export type LibrarySubCollectionStreamsWithPaginationQueryVariables = Exact<{
  filters: SmartLkLibraryStreamQueryFilter;
  pagination: SmartLkLibraryStreamQueryPagination;
  sort: SmartLkLibraryStreamQuerySort;
}>;


export type LibrarySubCollectionStreamsWithPaginationQuery = { __typename?: 'Query', result: { __typename?: 'LibraryStreamPaginationType', result: Array<{ __typename?: 'LibraryStreamPureType', id: string, stream: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } }> } };

export type LibraryCollectionWithPaginationQueryVariables = Exact<{
  filters: SmartLkLibraryStreamQueryFilter;
  pagination: SmartLkLibraryStreamQueryPagination;
  sort: SmartLkLibraryStreamQuerySort;
}>;


export type LibraryCollectionWithPaginationQuery = { __typename?: 'Query', result: { __typename?: 'LibraryStreamPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, result: Array<{ __typename?: 'LibraryStreamPureType', id: string, stream: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } }> } };

export type LibraryRecommendedSubCollectionsQueryVariables = Exact<{
  filters: SmartLkLibraryRecommendedSubCollectionsFilter;
  pagination: SmartLkLibraryRecommendedSubCollectionsPagination;
}>;


export type LibraryRecommendedSubCollectionsQuery = { __typename?: 'Query', result: { __typename?: 'SubCollectionsPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, result: Array<{ __typename?: 'LibrarySubCollectionPureType', id: string, title: string, description: string }> } };

export type CompanyPlaybackReportSettingQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyPlaybackReportSettingQuery = { __typename?: 'Query', result: Array<{ __typename?: 'CompanyPlaybackReportSettingsType', rightholderId?: string | null, isGenerateReport: boolean, title: string, reportType: PlaybackReportType, emptyReportTitle: string, helpLink: string }> };

export type CompanyPlaybackReportsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filters: CompanyPlaybackReportsQueryFilter;
}>;


export type CompanyPlaybackReportsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'CompanyPlaybackReportType', title: string, rightholderId?: string | null, dateFrom: any, dateTo: any, status: PlaybackReportStatus, reportFileUri?: string | null, id: string, reportType: PlaybackReportType }> };

export type RequestCompanyPlaybackEarlyReportMutationVariables = Exact<{
  input: CompanyPlaybackEarlyReportMutationInput;
}>;


export type RequestCompanyPlaybackEarlyReportMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanyPlaybackEarlyReportMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaCompanyAdCampaignsEarlyReportMutationVariables = Exact<{
  input: CompanyAdCampaignsEarlyReportInput;
}>;


export type MediaCompanyAdCampaignsEarlyReportMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanyAdCampaignsEarlyReportMutation', ok?: boolean | null, isCreated: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UserFeaturesOnboardingQueryQueryVariables = Exact<{
  filters: UserFeaturesOnboardingFilter;
}>;


export type UserFeaturesOnboardingQueryQuery = { __typename?: 'Query', result: Array<{ __typename?: 'UserFeaturesOnboardingType', feature: UserFeatures, isOnboarded: boolean } | null> };

export type FeaturesOnboardingPassMutationVariables = Exact<{
  input: UserFeaturesOnboardingPassMutationInput;
}>;


export type FeaturesOnboardingPassMutation = { __typename?: 'Mutation', result?: { __typename?: 'UserFeaturesOnboardingPassMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', result: Array<{ __typename?: 'NotificationType', modelId: string, notificationType: string, message: string, title: string, confirm: string, isBlocked: boolean }> };

export type SetNotificationSetViewedMutationVariables = Exact<{
  input: ViewNotificationMutationInput;
}>;


export type SetNotificationSetViewedMutation = { __typename?: 'Mutation', result?: { __typename?: 'ViewNotificationMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type LibraryStreamsSearchQueryVariables = Exact<{
  filters: LibraryStreamsSearchQueryFilter;
  pagination: LibraryStreamsSearchQueryPagination;
}>;


export type LibraryStreamsSearchQuery = { __typename?: 'Query', result: { __typename?: 'StreamsQueryPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, result?: Array<{ __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null }> | null } };

export type LibraryCollectionsSearchQueryVariables = Exact<{
  filters: LibraryCollectionsSearchQueryFilter;
  pagination: LibraryCollectionsSearchQueryPagination;
}>;


export type LibraryCollectionsSearchQuery = { __typename?: 'Query', result: { __typename?: 'CollectionsPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, result?: Array<{ __typename?: 'LibraryCollectionPureType', id: string, title: string, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } }> | null } };

export type StreamSearchTagsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type StreamSearchTagsQueryQuery = { __typename?: 'Query', result: { __typename?: 'StreamSearchTagsType', tags: Array<{ __typename?: 'StreamSearchTagAttributeType', id: string, title: string, children: Array<{ __typename?: 'SearchTagsType', id: string, title: string } | null> }> } };

export type MediaLikeMediafileMutationVariables = Exact<{
  input: StreamLikeMediafileInput;
}>;


export type MediaLikeMediafileMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamLikeMediafileMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaUnLikeMediafileMutationVariables = Exact<{
  input: StreamUnLikeMediafileInput;
}>;


export type MediaUnLikeMediafileMutation = { __typename?: 'Mutation', result?: { __typename?: 'StreamUnLikeMediafileMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediafilesApprovalQueryVariables = Exact<{
  filters: StreamMediafilesApprovalFilter;
  pagination: StreamMediafilesApprovalPagination;
}>;


export type MediafilesApprovalQuery = { __typename?: 'Query', streamMediafilesApproval: { __typename?: 'MediafileApprovalPaginationType', result: Array<{ __typename?: 'MediafileApprovalType', timestamp?: any | null, eventType?: MediafileEventTypes | null, mediafile: { __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, explicit: boolean, type: number, isDeleting: boolean, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MediafilesStreamQueryVariables = Exact<{
  filters: StreamMediafilesFilter;
  pagination: StreamMediafilesPagination;
  sort: StreamMediafilesSort;
}>;


export type MediafilesStreamQuery = { __typename?: 'Query', streamMediafiles: { __typename?: 'MediafilesQueryPaginationType', result?: Array<{ __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetCompanyStreamsQueryVariables = Exact<{
  filters: StreamsQueryFilter;
  pagination: StreamsQueryPagination;
  sort: StreamsQuerySort;
}>;


export type GetCompanyStreamsQuery = { __typename?: 'Query', streamsPaginationQuery: { __typename?: 'StreamsQueryPaginationType', result?: Array<{ __typename?: 'StreamPureType', id: string, title: string, pointsNum: number, hasThematicBlock: boolean, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetCompanyVideoStreamsQueryVariables = Exact<{
  filters: SmartLkVideoStreamsQueryFilter;
  pagination: SmartLkVideoStreamsQueryPagination;
  sort: SmartLkVideoStreamsQuerySort;
}>;


export type GetCompanyVideoStreamsQuery = { __typename?: 'Query', smartlkVideoStreamsPaginationQuery: { __typename?: 'VideoStreamPaginationPureType', result: Array<{ __typename?: 'VideoStreamType', id: string, title?: string | null, previewUrl?: string | null }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type VideoStreamQueryVariables = Exact<{
  companyId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type VideoStreamQuery = { __typename?: 'Query', result: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, isDefault: boolean, size: number, duration: number, devicesGroup?: { __typename?: 'DevicesGroupType', id: string, title: string, schedulerMode: DevicesGroupSchedulerMode, isValid: boolean, validationError?: string | null, masterVideoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null } | null } | null, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string, order: number, title?: string | null, previewUrl?: string | null, playDuration: number, mediafile: { __typename?: 'MediafilePureType', id: string, type: number, duration: number, uri: string, sourcefiles: Array<{ __typename?: 'SourcefileType', extension: string }> } }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string, order: number, playDuration: number, playCount: number, title?: string | null, emenuMediafile: { __typename?: 'EmenuMediafileType', id: string, generationDuration: number } }>, points: Array<{ __typename?: 'PointPureType', id: string }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } };

export type PointsBindVideoStreamMutationVariables = Exact<{
  input: SmartLkPointsBindVideoStreamMutationInput;
}>;


export type PointsBindVideoStreamMutation = { __typename?: 'Mutation', result?: { __typename?: 'SmartLkPointsBindVideoStreamMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type GetCompanyMediafilesQueryVariables = Exact<{
  filters: SmartlkCompanyMediafilesQueryFilter;
  pagination: SmartlkCompanyMediafilesPagination;
}>;


export type GetCompanyMediafilesQuery = { __typename?: 'Query', smartlkCompanyMediafilesQuery: { __typename?: 'VideoMediafileWithStatusQueryType', result?: Array<{ __typename?: 'VideoMediafileWithPreparationStatusType', id: string, title: string, previewUrl?: string | null, duration: number, sourcefiles: Array<{ __typename?: 'SourcefileType', extension: string }> }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UploadMediaFilesMutationVariables = Exact<{
  input: SmartlkVideoOrImageUploadMutationInput;
}>;


export type UploadMediaFilesMutation = { __typename?: 'Mutation', result?: { __typename?: 'SmartlkVideoOrImageMediafileUploadMutation', ok?: boolean | null, file?: { __typename?: 'MediafilePureType', id: string, title: string, duration: number, previewUrl?: string | null } | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type CreateVideoStreamMutationVariables = Exact<{
  input: SmartlkVideoStreamCreateMutationInput;
}>;


export type CreateVideoStreamMutation = { __typename?: 'Mutation', result?: { __typename?: 'SmartlkVideoStreamCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, videoStream?: { __typename?: 'VideoStreamType', id: string } | null } | null };

export type UpdateVideoStreamMutationVariables = Exact<{
  input: SmartlkVideoStreamUpdateMutationInput;
}>;


export type UpdateVideoStreamMutation = { __typename?: 'Mutation', result?: { __typename?: 'SmartlkVideoStreamUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, videoStream?: { __typename?: 'VideoStreamType', id: string } | null } | null };

export type CopyVideoStreamFromTemplateMutationVariables = Exact<{
  input: SmartlkVideoStreamCopyFromTemplateMutationInput;
}>;


export type CopyVideoStreamFromTemplateMutation = { __typename?: 'Mutation', result?: { __typename?: 'SmartlkVideoStreamCopyFromTemplateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, videoStream?: { __typename?: 'VideoStreamType', id: string } | null } | null };

export type VideoStreamSetCompanyTagsMutationVariables = Exact<{
  input: SmartLkVideoStreamPureSetCompanyTagsInput;
}>;


export type VideoStreamSetCompanyTagsMutation = { __typename?: 'Mutation', smartlkVideoStreamPureSetCompanyTags?: { __typename?: 'SmartLkVideoStreamPureSetCompanyTagsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, videoStream?: { __typename?: 'VideoStreamType', id: string, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null } | null };

export type PointQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PointQuery = { __typename?: 'Query', pointPure?: { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null } | null };

export type PointListQueryVariables = Exact<{
  filters: PointQueryFilter;
  pagination: PointQueryPagination;
  sort: PointQuerySort;
}>;


export type PointListQuery = { __typename?: 'Query', pointsPaginationQuery: { __typename?: 'PointsQueryPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, result?: Array<{ __typename?: 'PointPureType', id: string, address: string, comment: string, isEnabled: boolean, certificateIsAvailable?: boolean | null, cutDuration?: number | null, withMusicCut?: boolean | null, adOverlapResolution?: AdOverlapResolution | null, fileFormat?: PointFileFormats | null, isVideoMode: boolean, isVideoDemo: boolean, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, size: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null }> | null, statusesInfo?: { __typename?: 'PointsPlayingStatusesPureType', playing?: number | null, sleep?: number | null, notPlaying?: number | null, mbNoConnection?: number | null, playerDisabled?: number | null, notGeneration?: number | null, stop?: number | null, mbPlaying?: number | null } | null } };

export type PointListMetadataQueryVariables = Exact<{
  filters: PointQueryFilter;
  pagination: PointQueryPagination;
  sort: PointQuerySort;
}>;


export type PointListMetadataQuery = { __typename?: 'Query', pointsPaginationQuery: { __typename?: 'PointsQueryPaginationType', result?: Array<{ __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, stream?: { __typename?: 'StreamPureType', id: string, title: string } | null, license?: { __typename?: 'LicensePureType', id: string } | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, statusesInfo?: { __typename?: 'PointsPlayingStatusesPureType', playing?: number | null, sleep?: number | null, notPlaying?: number | null, mbNoConnection?: number | null, playerDisabled?: number | null, notGeneration?: number | null, stop?: number | null, mbPlaying?: number | null } | null } };

export type PointCerttificateListQueryVariables = Exact<{
  filters: CertificatePointsQueryFilter;
  pagination: CertificatePointsQueryPagination;
}>;


export type PointCerttificateListQuery = { __typename?: 'Query', certificatePointsQuery: { __typename?: 'CertificatePointsQueryPaginationType', certificatePointsCount: number, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, result?: Array<{ __typename?: 'PointPureType', id: string, address: string, comment: string, isEnabled: boolean, certificateIsAvailable?: boolean | null, cutDuration?: number | null, withMusicCut?: boolean | null, adOverlapResolution?: AdOverlapResolution | null, fileFormat?: PointFileFormats | null, isVideoMode: boolean, isVideoDemo: boolean, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, size: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null }> | null } };

export type PointList_SpecialQueryVariables = Exact<{
  filters: PointQueryFilter;
  pagination: PointQueryPagination;
  sort: PointQuerySort;
}>;


export type PointList_SpecialQuery = { __typename?: 'Query', pointsPaginationQuery: { __typename?: 'PointsQueryPaginationType', paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, result?: Array<{ __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', id: string, title: string } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null } | null, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null }> | null } };

export type PointCreateMutationVariables = Exact<{
  input: PointPureCreateMutationInput;
}>;


export type PointCreateMutation = { __typename?: 'Mutation', pointPureCreate?: { __typename?: 'PointPureCreateMutation', ok?: boolean | null, point?: { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PointSmartLkCreateMutationVariables = Exact<{
  input: SmartlkPointCreateMutationInput;
}>;


export type PointSmartLkCreateMutation = { __typename?: 'Mutation', smartlkPointCreate?: { __typename?: 'SmartlkPointCreateMutation', ok?: boolean | null, point?: { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PointUpdateMutationVariables = Exact<{
  input: PointPureUpdateMutationInput;
}>;


export type PointUpdateMutation = { __typename?: 'Mutation', pointPureUpdate?: { __typename?: 'PointPureUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string, comment: string, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null } | null } | null };

export type PointRemoveMutationVariables = Exact<{
  input: PointPureRemoveMutationInput;
}>;


export type PointRemoveMutation = { __typename?: 'Mutation', pointPureRemove?: { __typename?: 'PointPureRemoveMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type PointChangeStreamMutationVariables = Exact<{
  input: PointPureChangeStreamMutationInput;
}>;


export type PointChangeStreamMutation = { __typename?: 'Mutation', pointPureChangeStream?: { __typename?: 'PointPureChangeStreamMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type PointUnbindStreamMutationVariables = Exact<{
  input: SmartlkPointUnbindStreamMutationInput;
}>;


export type PointUnbindStreamMutation = { __typename?: 'Mutation', smartlkPointUnbindStream?: { __typename?: 'SmartlkPointUnbindStreamMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type PointChangeSleepSettingsMutationVariables = Exact<{
  input: PointPureSleepSettingsMutationInput;
}>;


export type PointChangeSleepSettingsMutation = { __typename?: 'Mutation', pointPureSleepSettings?: { __typename?: 'PointPureSleepSettingsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null } | null } | null };

export type PointChangeDeviceMutationVariables = Exact<{
  input: PointSwitchDeviceMutationInput;
}>;


export type PointChangeDeviceMutation = { __typename?: 'Mutation', pointPureSwitchDevice?: { __typename?: 'PointSwitchDeviceMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null } | null } | null };

export type DesktopDownloadLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type DesktopDownloadLinkQuery = { __typename?: 'Query', link: string };

export type PointHistoryQueryVariables = Exact<{
  filters: PointHistoryQueryFilter;
  pagination: PointHistoryQueryPagination;
  sort: PointHistoryQuerySort;
}>;


export type PointHistoryQuery = { __typename?: 'Query', pointHistoryPaginationQuery: { __typename?: 'PointHistoryPaginationType', result: Array<{ __typename?: 'PointPureHistoryItem', id: string, playtime?: any | null, streamId?: string | null, mediafileId?: string | null, mediafilePerformerTitle?: string | null, mediafileTitle?: string | null, mediafileType?: number | null, mediafileFilename?: string | null, mediafileIsDisliked?: boolean | null, mediafileIsLiked?: boolean | null, onAir: any, onAirWithLocalTimezone: any, mediafile?: { __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PointVideoHistoryQueryVariables = Exact<{
  filters: PointVideoHistoryQueryFilter;
  pagination: PointVideoHistoryQueryPagination;
  sort: PointVideoHistoryQuerySort;
}>;


export type PointVideoHistoryQuery = { __typename?: 'Query', pointVideoHistoryPaginationQuery: { __typename?: 'PointVideoHistoryPaginationType', result: Array<{ __typename?: 'PointPureVideoHistoryItem', id: string, start: number, onAir: number, end: number, mediafileId: string, mediafileType: number, mediafileFilename?: string | null, rotationId: string, mediafile?: { __typename?: 'MediafilePureType', previewUrl?: string | null, id: string, title: string, type: number, uri: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, extension: string }> } | null }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PointHistoryReportCreateMutationVariables = Exact<{
  input: PointPlaybackAudioReportCreateMutationInput;
}>;


export type PointHistoryReportCreateMutation = { __typename?: 'Mutation', pointPlaybackReportCreateMutation?: { __typename?: 'PointPlaybackAudioReportCreateMutation', ok?: boolean | null, downloadLink?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PointVideoHistoryReportCreateMutationVariables = Exact<{
  input: PointPlaybackVideoReportCreateMutationInput;
}>;


export type PointVideoHistoryReportCreateMutation = { __typename?: 'Mutation', pointPlaybackVideoReportCreateMutation?: { __typename?: 'PointPlaybackVideoReportCreateMutation', ok?: boolean | null, downloadLink?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SpeakerCreateAndSetPointMutationVariables = Exact<{
  input: SmartSpeakerCreateAndSetPointInput;
}>;


export type SpeakerCreateAndSetPointMutation = { __typename?: 'Mutation', speakerCreateAndSetPoint?: { __typename?: 'SmartSpeakerCreateAndSetPoint', ok?: boolean | null, smartSpeakerInfo: { __typename?: 'SmartSpeakerInfoType', deviceType: number, deviceToken: string, deviceUuid: string }, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type PointSetAdCampaignsMutationVariables = Exact<{
  input: PointPureSetAdCampaignsMutationInput;
}>;


export type PointSetAdCampaignsMutation = { __typename?: 'Mutation', pointPureSetAdcampaigns?: { __typename?: 'PointPureSetAdCampaignsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string } | null } | null };

export type StandardizedAddressQueryVariables = Exact<{
  input: StandardizedAddressQueryPureType;
}>;


export type StandardizedAddressQuery = { __typename?: 'Query', standardizedAddressPureQuery: { __typename?: 'StandardizedAddressQueryResultType', result?: Array<{ __typename?: 'StandardizedAddressPureType', address: string, timezone: string, street?: string | null, city?: string | null, region?: string | null, country?: string | null, postalCode?: string | null, latitude?: string | null, longitude?: string | null, fiasId?: string | null }> | null } };

export type TimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezonesQuery = { __typename?: 'Query', timezones?: Array<{ __typename?: 'TimezoneObjectType', timezone?: string | null, title?: string | null } | null> | null };

export type PointSetCompanyTagsMutationVariables = Exact<{
  input: PointPureSetCompanyTagsMutationInput;
}>;


export type PointSetCompanyTagsMutation = { __typename?: 'Mutation', pointPureSetCompanyTags?: { __typename?: 'PointPureSetCompanyTagsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string } | null } | null };

export type PointGenerationSettingsQueryVariables = Exact<{
  pointId: Scalars['ID'];
}>;


export type PointGenerationSettingsQuery = { __typename?: 'Query', pointGenerationSettingsPureQuery: { __typename?: 'PlayerDeviceGenerationSettingsQueryPureType', settings: string, lastUpdated: any, mediafiles: Array<{ __typename?: 'DeviceMediafileObjectType', id?: number | null, filename?: string | null, title?: string | null, performerTitle?: string | null, type?: number | null } | null> } };

export type MultiroomGetMultiroomQueryVariables = Exact<{
  input: SberMultiroomGetMultiroomQueryInput;
}>;


export type MultiroomGetMultiroomQuery = { __typename?: 'Query', result?: { __typename?: 'MultiroomPureType', devices: Array<{ __typename?: 'PlayerDevicePureType', bindingCode: string }> } | null };

export type PointsGroupsQueryVariables = Exact<{
  filters: SmartlkDevicesGroupQueryFilter;
  pagination: SmartlkDevicesGroupQueryPagination;
  sort: SmartlkDevicesGroupQuerySort;
}>;


export type PointsGroupsQuery = { __typename?: 'Query', smartlkDevicesGroupPaginationQuery: { __typename?: 'DevicesGroupPaginationPureType', result: Array<{ __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null, devices?: Array<{ __typename?: 'PlayerDeviceType', id: string }> | null, masterVideoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null } | null }>, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean }, statusesInfo?: { __typename?: 'DevicesGroupStatusesPureType', valid?: number | null, invalid?: number | null } | null } };

export type PointsGroupsStatusesQueryVariables = Exact<{
  filters: SmartlkDevicesGroupQueryFilter;
  pagination: SmartlkDevicesGroupQueryPagination;
  sort: SmartlkDevicesGroupQuerySort;
}>;


export type PointsGroupsStatusesQuery = { __typename?: 'Query', smartlkDevicesGroupPaginationQuery: { __typename?: 'DevicesGroupPaginationPureType', statusesInfo?: { __typename?: 'DevicesGroupStatusesPureType', valid?: number | null, invalid?: number | null } | null } };

export type PointsGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PointsGroupQuery = { __typename?: 'Query', smartlkDevicesGroupQuery: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null, devices?: Array<{ __typename?: 'PlayerDeviceType', id: string, point?: { __typename?: 'PointType', id: number, address: string, isActive: boolean, isEnabled: boolean, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string, mediafile: { __typename?: 'MediafilePureType', id: string, type: number } }> } | null } | null }> | null, masterVideoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }> } | null } };

export type PointsGroupUpdateMutationVariables = Exact<{
  input: SmartlkDevicesGroupUpdateMutationInput;
}>;


export type PointsGroupUpdateMutation = { __typename?: 'Mutation', smartlkDevicesGroupUpdate?: { __typename?: 'SmartlkDevicesGroupUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, devicesGroup?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, devices?: Array<{ __typename?: 'PlayerDeviceType', id: string, point?: { __typename?: 'PointType', id: number, address: string, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }> } | null } | null }> | null, masterVideoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }> } | null } | null } | null };

export type PointsGroupDeleteMutationVariables = Exact<{
  input: SmartlkDevicesGroupDeleteMutationInput;
}>;


export type PointsGroupDeleteMutation = { __typename?: 'Mutation', smartlkDevicesGroupDelete?: { __typename?: 'SmartlkDevicesGroupDeleteMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type PointsGroupCreateMutationVariables = Exact<{
  input: SmartlkDevicesGroupCreateMutationInput;
}>;


export type PointsGroupCreateMutation = { __typename?: 'Mutation', smartlkDevicesGroupCreate?: { __typename?: 'SmartlkDevicesGroupCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null, devicesGroup?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null, devices?: Array<{ __typename?: 'PlayerDeviceType', id: string, point?: { __typename?: 'PointType', id: number, address: string, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }> } | null } | null }> | null, masterVideoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }> } | null } | null } | null };

export type MediaAdCampaignsPaginationQueryQueryVariables = Exact<{
  filters: AdCampaignQueryFilter;
  sort: AdCampaignQuerySort;
  pagination: AdCampaignQueryPagination;
}>;


export type MediaAdCampaignsPaginationQueryQuery = { __typename?: 'Query', adcampaignsPaginationQuery: { __typename?: 'AdCampaignsQueryPaginationType', result?: Array<{ __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, type: AdCampaignTypeEnum, mediaType: AdCampaignMediaTypeEnum, durationPromos?: number | null, replicationRole: ReplicationRole, promos: Array<{ __typename?: 'PromoPureType', id: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, promo: { __typename?: 'MediafilePureType', sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, points: Array<{ __typename?: 'PointPureType', id: string }>, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, statusesInfo?: { __typename?: 'AdCampaignsStatusesPureType', active?: number | null, planned?: number | null, passed?: number | null, stopped?: number | null } | null } };

export type MediaAdCampaignsMetadataPaginationQueryQueryVariables = Exact<{
  filters: AdCampaignQueryFilter;
  sort: AdCampaignQuerySort;
  pagination: AdCampaignQueryPagination;
}>;


export type MediaAdCampaignsMetadataPaginationQueryQuery = { __typename?: 'Query', adcampaignsPaginationQuery: { __typename?: 'AdCampaignsQueryPaginationType', result?: Array<{ __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, type: AdCampaignTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, totalPages: number }, statusesInfo?: { __typename?: 'AdCampaignsStatusesPureType', active?: number | null, planned?: number | null, passed?: number | null, stopped?: number | null } | null } };

export type MediaAdCampaignQueryVariables = Exact<{
  adCampaignId: Scalars['ID'];
}>;


export type MediaAdCampaignQuery = { __typename?: 'Query', adCampaignPure?: { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null };

export type MediaPromoUploadMutationVariables = Exact<{
  input: PromoUploadPureMutationInput;
}>;


export type MediaPromoUploadMutation = { __typename?: 'Mutation', result?: { __typename?: 'PromoUploadPureMutation', ok?: boolean | null, promo?: { __typename?: 'MediafilePureType', id: string, filename: string, duration: number, previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null };

export type MediaAdCampaignCreateMutationVariables = Exact<{
  input: AdCampaignPureCreateMutationInput;
}>;


export type MediaAdCampaignCreateMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignPureCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCompany?: { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null } | null };

export type MediaAdCampaignUpdateMutationVariables = Exact<{
  input: AdCampaignPureUpdateMutationInput;
}>;


export type MediaAdCampaignUpdateMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignPureUpdateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCompany?: { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null } | null };

export type MediaAdCampaignPromosUpdateMutationVariables = Exact<{
  input: AdCampaignPureChangePromosMutationInput;
}>;


export type MediaAdCampaignPromosUpdateMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignPureChangePromosMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCompany?: { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null } | null };

export type MediaPromoClipsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  draftId?: InputMaybe<Scalars['ID']>;
  filters?: InputMaybe<PromoClipsQueryFilter>;
  pagination: PromoClipsQueryPagination;
  sort: PromoClipsQuerySort;
}>;


export type MediaPromoClipsQuery = { __typename?: 'Query', result: { __typename?: 'PromoClipsPaginationType', result?: Array<{ __typename?: 'PromoClipType', id: string, adcampaignTitle: string, adcampaignStatus: string, isSelected: boolean, promo?: { __typename?: 'MediafilePureType', id: string, title: string, uri: string } | null }> | null, statusesInfo?: { __typename?: 'AdCampaignsStatusesPureType', active?: number | null, planned?: number | null, passed?: number | null, stopped?: number | null } | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MediaPromoSelectionDraftMutationVariables = Exact<{
  input: PromoSelectionDraftInput;
}>;


export type MediaPromoSelectionDraftMutation = { __typename?: 'Mutation', result?: { __typename?: 'PromoSelectionDraftMutation', ok?: boolean | null, promoSelectionDraftId?: string | null, selectedCount: number, totalCount: number, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaAdCampaignEnableMutationVariables = Exact<{
  input: AdCampaignPureEnableMutationInput;
}>;


export type MediaAdCampaignEnableMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignPureEnableMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCompany?: { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null } | null } | null };

export type MediaAdCampaignRemoveMutationVariables = Exact<{
  input: AdCampaignPureRemoveMutationInput;
}>;


export type MediaAdCampaignRemoveMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignPureRemoveMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type MediaAdCampaignReportCreateMutationVariables = Exact<{
  input: AdCampaignReportPureMutationInput;
}>;


export type MediaAdCampaignReportCreateMutation = { __typename?: 'Mutation', result?: { __typename?: 'AdCampaignReportPureCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type MediaAdCampaignSetCompanyTagsMutationVariables = Exact<{
  input: AdCampaignPureSetCompanyTagsMutationInput;
}>;


export type MediaAdCampaignSetCompanyTagsMutation = { __typename?: 'Mutation', adcampaignSetCompanyTags?: { __typename?: 'AdCampaignPureSetCompanyTagsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCampaign?: { __typename?: 'AdCampaignPureType', id: string } | null } | null };

export type MediaAdCampaignInstantLaunchMutationVariables = Exact<{
  input: PlayInstantAdcampaignMutationInput;
}>;


export type MediaAdCampaignInstantLaunchMutation = { __typename?: 'Mutation', playInstantAdcampaign?: { __typename?: 'PlayInstantAdcampaignMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MediaAdCampaignSetPointsMutationVariables = Exact<{
  input: AdCampaignPureSetPointsMutationInput;
}>;


export type MediaAdCampaignSetPointsMutation = { __typename?: 'Mutation', adcampaignSetPointsMutation?: { __typename?: 'AdCampaignPureSetPointsMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, adCampaign?: { __typename?: 'AdCampaignPureType', id: string, points: Array<{ __typename?: 'PointPureType', id: string }> } | null } | null };

export type CompanyUserCompanyTagsQueryVariables = Exact<{
  filters: CompanyTagQueryFilter;
  pagination: CompanyTagQueryPagination;
}>;


export type CompanyUserCompanyTagsQuery = { __typename?: 'Query', companyTagPaginationQuery: { __typename?: 'CompanyTagQueryPaginationType', result?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CompanyDeviceRequestMutationVariables = Exact<{
  input: CompanyCreateDeviceRequestPureMutationInput;
}>;


export type CompanyDeviceRequestMutation = { __typename?: 'Mutation', companyCreateDeviceRequest?: { __typename?: 'CompanyCreateDeviceRequestPureMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CompanyAudioDeviceRequestMutationVariables = Exact<{
  input: CompanyCreateDeviceRequestPureMutationInput;
}>;


export type CompanyAudioDeviceRequestMutation = { __typename?: 'Mutation', companyCreateAudioDeviceRequest?: { __typename?: 'CompanyCreateAudioDeviceRequestMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CompanyVideoDeviceRequestMutationVariables = Exact<{
  input: CompanyCreateDeviceRequestPureMutationInput;
}>;


export type CompanyVideoDeviceRequestMutation = { __typename?: 'Mutation', companyCreateVideoDeviceRequest?: { __typename?: 'CompanyCreateVideoDeviceRequestMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CompanySmartlkStartVideoDemoPeriodMutationVariables = Exact<{
  input: SmartLkStartVideoDemoPeriodMutationInput;
}>;


export type CompanySmartlkStartVideoDemoPeriodMutation = { __typename?: 'Mutation', smartlkStartVideoDemoPeriod?: { __typename?: 'SmartLkStartVideoDemoPeriodMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null } | null, device?: { __typename?: 'PlayerDevicePureType', id: string, type: DeviceTypes } | null } | null } | null };

export type BillingPaymentMethodQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type BillingPaymentMethodQuery = { __typename?: 'Query', paymentMethodPureQuery?: { __typename?: 'PaymentMethodStatusType', isLinkingInProcess: boolean, paymentMethod?: { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string } | null } | null };

export type BillingStartLinkCardMutationVariables = Exact<{
  input: StartLinkCardMutationInput;
}>;


export type BillingStartLinkCardMutation = { __typename?: 'Mutation', startLinkCard?: { __typename?: 'StartLinkCardMutation', confirmLink: string, ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingRemoveCardMutationVariables = Exact<{
  input: CompanyRemoveCardMutationInput;
}>;


export type BillingRemoveCardMutation = { __typename?: 'Mutation', companyRemoveCard?: { __typename?: 'CompanyRemoveCardMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingLaunchSubscriptionWithConfirmMutationVariables = Exact<{
  input: LaunchSubscriptionWithConfirmMutationInput;
}>;


export type BillingLaunchSubscriptionWithConfirmMutation = { __typename?: 'Mutation', launchSubscriptionWithConfirm?: { __typename?: 'LaunchSubscriptionWithConfirmMutation', confirmLink: string, ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingPricePlansQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  usersOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type BillingPricePlansQuery = { __typename?: 'Query', organizationPricePlansCanMigrateToQuery?: Array<{ __typename?: 'PricePlanPureType', id: string, title: string, titleForManager: string, alias: string, currency: Currencies, useByDefault: boolean, offerLink: string, periods: Array<{ __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> }>, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null> | null };

export type BillingOrganizationCurrentPricePlanQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type BillingOrganizationCurrentPricePlanQuery = { __typename?: 'Query', result?: { __typename?: 'OrganizationPricePlanPureType', organizationId: number, pricePlan?: { __typename?: 'PricePlanPureType', id: string, title: string, titleForManager: string, alias: string, currency: Currencies, useByDefault: boolean, offerLink: string, periods: Array<{ __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> }>, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null, pricePlanPeriod?: { __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> } | null } | null };

export type BillingCompanySetPricePlanPeriodMutationVariables = Exact<{
  input: CompanySetPricePlanPeriodMutationInput;
}>;


export type BillingCompanySetPricePlanPeriodMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanySetPricePlanPeriodMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type BillingCompanySetPricePlanMutationVariables = Exact<{
  input: CompanySetPricePlanMutationInput;
}>;


export type BillingCompanySetPricePlanMutation = { __typename?: 'Mutation', result?: { __typename?: 'CompanySetPricePlanMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string> } | null> | null } | null };

export type PromoRollSynthJobFieldsFragment = { __typename?: 'PromoRollSynthJobType', id: string, title: string, status?: PromoRollSynthJobStatus | null, promoMediafile?: { __typename?: 'MediafilePureType', id: string, title: string, filename: string, duration: number, previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null };

export type PromoRollSynthBackgroundsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromoRollSynthBackgroundsQuery = { __typename?: 'Query', promoRollSynthBackgrounds: Array<{ __typename?: 'PromoRollSynthBackgroundType', id: string, backgroundId: string, title: string, fileUrl: string }> };

export type PromoRollSynthCompanySettingsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type PromoRollSynthCompanySettingsQuery = { __typename?: 'Query', promoRollSynthCompanySettings: { __typename?: 'PromoRollSynthCompanySettingsType', isEnabled: boolean, maxTextLength: number, dailyLimit: number, remainingToday: number } };

export type PromoRollSynthJobsQueryVariables = Exact<{
  filters: PromoRollSynthJobsQueryFilter;
  pagination: PromoRollSynthJobsQueryPagination;
}>;


export type PromoRollSynthJobsQuery = { __typename?: 'Query', promoRollSynthJobs: { __typename?: 'PromoRollSynthJobsQueryPaginationType', result?: Array<{ __typename?: 'PromoRollSynthJobType', id: string, title: string, status?: PromoRollSynthJobStatus | null, promoMediafile?: { __typename?: 'MediafilePureType', id: string, title: string, filename: string, duration: number, previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null }> | null, paginationInfo: { __typename?: 'PaginationInfoType', page: number, pageSize: number, totalPages: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PromoRollSynthVoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type PromoRollSynthVoicesQuery = { __typename?: 'Query', promoRollSynthVoices: Array<{ __typename?: 'PromoRollSynthVoiceType', id: string, voiceId: string, title: string, fileUrl: string }> };

export type PromoRollSynthCreateJobMutationVariables = Exact<{
  input: PromoRollSynthCreateMutationInput;
}>;


export type PromoRollSynthCreateJobMutation = { __typename?: 'Mutation', promoRollSynthCreate?: { __typename?: 'PromoRollSynthCreateMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, job?: { __typename?: 'PromoRollSynthJobType', id: string, title: string, status?: PromoRollSynthJobStatus | null, promoMediafile?: { __typename?: 'MediafilePureType', id: string, title: string, filename: string, duration: number, previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null } | null };

export type PromoRollSynthDeleteJobMutationVariables = Exact<{
  input: PromoRollSynthDeleteMutationInput;
}>;


export type PromoRollSynthDeleteJobMutation = { __typename?: 'Mutation', promoRollSynthDelete?: { __typename?: 'PromoRollSynthDeleteMutation', ok?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AppInitializationQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AppInitializationQuery = { __typename?: 'Query', currentUserPureQuery?: { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> } | null, organizationCurrentPricePlanQuery?: { __typename?: 'OrganizationPricePlanPureType', organizationId: number, pricePlan?: { __typename?: 'PricePlanPureType', id: string } | null } | null, companyBillingInfoQuery?: { __typename?: 'UserBillingInfo', status: SubscriptionStatus, firstPaidAt?: any | null, nextBillingDate?: any | null, nextBillingAmount?: number | null, nextBillingPriceAmount?: number | null, selectedPaymentKind: PaymentKind, isBillingEnabled?: boolean | null, hasTrialLicenses: boolean, hasActiveLicenses: boolean, hasInactiveLicenses: boolean, hasWaitPaymentLicenses: boolean, hasGraceLicenses: boolean, expiresLicenseDate?: string | null, isLastInvoiceHasZeroAmount?: boolean | null, isWaitPaymentLicense?: boolean | null, isGraceLicense?: boolean | null, canRealizeBillingOperation?: boolean | null, canRealizeBillingOperationWithPayment?: boolean | null, hasRenewableLicenses?: boolean | null, hasNonRenewableLicenses?: boolean | null, renewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, nonRenewableLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, unpaidLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, discount?: { __typename?: 'OrganizationDiscountPureType', id: string, title: string, startDate: any, endDate?: any | null, invoiceWithDiscountLimit: number, payFrequencyMonth: number, value: number, valueType: DiscountValueType, organizationId: number, status: OrganizationDiscountStatus, slug: string } | null, nextBillingLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, totalLicenses: Array<{ __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null }>, paymentMethod?: { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string } | null } | null, paymentMethodPureQuery?: { __typename?: 'PaymentMethodStatusType', isLinkingInProcess: boolean, paymentMethod?: { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string } | null } | null, acceptanceAdvancedQuery?: { __typename?: 'AcceptanceAdvanceType', status: AcceptanceAdvanceStatus, payerAccount: string } | null };

export type MediafileInfoTypeFragment = { __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, genres: string, valueIds: Array<string>, type: number, explicit: boolean, isDeleting: boolean, values: Array<{ __typename?: 'ValueObjectPureType', id: string, title?: string | null, color: string }>, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> };

export type MediaFilesRandomTypeFragment = { __typename?: 'MediafilePureType', id: string, title: string, performerTitle: string, filename: string, uri: string, duration: number, type: number, explicit: boolean, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> };

export type StreamShortTypeFragment = { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null };

export type StreamInfoTypeFragment = { __typename?: 'StreamPureType', mediafilesCount: number, duration: number, hasThematicBlock: boolean, mediafilesLiked: Array<string>, id: string, title: string, description: string, isTemplate: boolean, templateType: string, points: Array<{ __typename?: 'PointPureType', id: string, address: string }>, contentBlocks: Array<{ __typename?: 'ContentBlockPureType', id: string, copyFromId?: string | null, title: string, startDayTime?: any | null, endDayTime?: any | null, startDate?: any | null, endDate?: any | null }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null };

export type StreamApprovalInfoTypeFragment = { __typename?: 'StreamPureType', id: string, title: string, contentBlocks: Array<{ __typename?: 'ContentBlockPureType', id: string, title: string, startDayTime?: any | null, endDayTime?: any | null }> };

export type PlayerDeviceInfoTypeFragment = { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null };

export type PointInfoTypeFragment = { __typename?: 'PointPureType', id: string, comment: string, timezone: string, fileFormat?: PointFileFormats | null, address: string, isEnabled: boolean, withMusicCut?: boolean | null, cutDuration?: number | null, adOverlapResolution?: AdOverlapResolution | null, isVideoMode: boolean, isVideoDemo: boolean, license?: { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null } | null, sleepOptions: { __typename?: 'SleepOptionsPureType', enabled: boolean, settings?: Array<{ __typename?: 'SleepSettingPureType', day: number, start: any, end: any }> | null }, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, bindingCode: string, type: DeviceTypes, volume: number, supportedFeatures: Array<string | null>, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', hasThematicBlock: boolean, id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, amplifyOptions: { __typename?: 'AmplifyOptionsPureType', amplifyMediafile: number, amplifyPromo: number, amplifyInstant?: number | null }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, size: number, duration: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null };

export type PointShortTypeFragment = { __typename?: 'PointPureType', id: string, address: string, comment: string, isEnabled: boolean, certificateIsAvailable?: boolean | null, cutDuration?: number | null, withMusicCut?: boolean | null, adOverlapResolution?: AdOverlapResolution | null, fileFormat?: PointFileFormats | null, isVideoMode: boolean, isVideoDemo: boolean, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null, videoStream?: { __typename?: 'VideoStreamType', id: string, title?: string | null, description?: string | null, previewUrl?: string | null, duration: number, size: number, videoMediafiles: Array<{ __typename?: 'VideoMediafileType', id: string }>, emenuMediafiles: Array<{ __typename?: 'VideoStreamEmenuMediafileType', id: string }> } | null };

export type PointSpecialTypeFragment = { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, device?: { __typename?: 'PlayerDevicePureType', id: string, requiredVersionUrl?: string | null, supportedFeatures: Array<string | null>, bindingCode: string, type: DeviceTypes, bindedAt?: any | null, group?: { __typename?: 'DevicesGroupType', id: string, title: string, isValid: boolean, validationError?: string | null } | null } | null, stream?: { __typename?: 'StreamPureType', id: string, title: string } | null, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null } | null, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null };

export type PointMetadataTypeFragment = { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, adcampaigns: Array<{ __typename?: 'AdCampaignPureType', id: string, type: AdCampaignTypeEnum }>, stream?: { __typename?: 'StreamPureType', id: string, title: string } | null, license?: { __typename?: 'LicensePureType', id: string } | null };

export type LicenseShortTypeFragment = { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null };

export type LicenseInfoTypeFragment = { __typename?: 'LicensePureType', id: string, autoRenewal: boolean, paymentState: LicensePaymentState, expiresAt?: any | null, modified?: any | null, point?: { __typename?: 'PointPureType', id: string, address: string, isEnabled: boolean, playingStatus?: { __typename?: 'PointPlayStatusPureType', code?: number | null, color?: string | null, title?: string | null, progress?: number | null } | null } | null };

export type CompanyContractPaymentTermsTypeInfoTypeFragment = { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null };

export type CompanyContractInfoTypeFragment = { __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null };

export type InvoiceInfoTypeFragment = { __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean };

export type CompanyDeviceRequestInfoTypeFragment = { __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any };

export type UserCompanyShortTypeFragment = { __typename?: 'UserCompanyPureType', id: string, requisite?: { __typename?: 'RequisiteBYPureType', emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', emailForDocuments: string } | null };

export type UserCompanyInfoTypeFragment = { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null };

export type UserInfoTypeFragment = { __typename?: 'UserExtendPureType', id: string, email: string, phone: string, firstName: string, isTest: boolean, registrationSource: RegistrationSource, smartLkAccess: boolean, personalAccountAccess: boolean, pointsExists: boolean, sberBusinessClientInfo: { __typename?: 'SberBusinessClientInfo', hasSberBusinessAccount: boolean }, mainCompany?: { __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null } | null, companies: Array<{ __typename?: 'UserCompanyPureType', id: string, hasMinimumData: boolean, country: Country, created: any, actualName: string, validated: boolean, businessSphereId?: string | null, isBillingEnabled: boolean, streamLibrariesIds?: Array<number> | null, hasDesktopPlayers: boolean, hasInstantAdCampaigns: boolean, zvukProfileCount: number, addTelegramSubscribeLink?: string | null, canSberIdLink: boolean, sberIdWasLinked: boolean, isPaymentByInvoiceRequested: boolean, sberIdButtonState: { __typename?: 'SberIdButtonStatePureType', isVisible: boolean, isDisabled: boolean, scenario?: SberIdScenario | null, unavailabilityReason?: SberIdButtonUnavailabilityReason | null }, deviceRequests?: Array<{ __typename?: 'CompanyDeviceRequestPureType', companyId: string, deviceType?: DeviceTypes | null, requestType?: RequestDeviceType | null, status: CompanyAmoTaskRequestStatus, pointId?: string | null, lastRequestDate: any }> | null, users: Array<{ __typename?: 'UserCompanyWithRole', id: string, email: string, role: UserCompanyRole }>, invoices: Array<{ __typename?: 'InvoicePureType', id: string, status: InvoiceState, amount: number, created: any, type: InvoiceType, isActual: boolean }>, contractMigrations: Array<{ __typename?: 'CompanyContractMigrationType', id: string, offerUrl: string, contractType: CompanyContractKind, status: ContractMigrationStatusEnum }>, contracts: Array<{ __typename?: 'CompanyContractPureType', id: string, name?: string | null, number?: string | null, date?: any | null, typeContract: CompanyContractKind, isConfirmed: boolean, billingEnabled: boolean, status: CompanyContractStatusEnum, paymentTerms?: { __typename?: 'CompanyContractPaymentTermsType', amount?: number | null, payFrequencyMonth?: number | null } | null }>, referral?: { __typename?: 'CompanyReferralPureType', uuid: string, registeredUsers?: Array<{ __typename?: 'UserExtendPureType', id: string, email: string, phone: string, registrationSource: RegistrationSource } | null> | null } | null, requisite?: { __typename?: 'RequisiteBYPureType', unp: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteKZPureType', iin: string, bin: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string } | { __typename?: 'RequisiteRUPureType', inn: string, kpp: string, ogrn: string, organizationShortname: string, organizationFullname: string, organizationAddress: string, organizationType: OrganizationType, managementPost: string, managementName: string, emailForDocuments: string, selfEmployedFullName?: string | null } | null, trialPeriod?: { __typename?: 'UserTrialPeriodType', startedAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null, uiFeatures: { __typename?: 'UserCompanyUIFeaturesType', isBillingEnabled: boolean, isShowReports: boolean, isChangePricePlanAvailable: boolean, isOffertaChanged: boolean, isCertLetterAvailable: boolean, isInstantAdcampaignAvailable: boolean, isBusinessProfileAvailable: boolean, isVideoAvailable: boolean, isAddressesGroupsAvailable: boolean, isVideoAdsAvailable: boolean }, pricePlan?: { __typename?: 'PricePlanPureType', alias: string, currency: Currencies } | null, videoDemoPeriod?: { __typename?: 'UserVideoDemoPeriodType', startedAt: any, expiredAt: any, finishedAt?: any | null, lengthDays: number, lengthMinutes: number, isFinished: boolean, isExpired: boolean } | null }> };

export type UserInvitationInfoTypeFragment = { __typename?: 'UserInvitationType', id: string, email: string, isSent: boolean, isAccepted: boolean, isActive: boolean };

export type AdCampaignTimingSettingsInfoTypeFragment = { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } };

export type AdCampaignShortTypeFragment = { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, type: AdCampaignTypeEnum, mediaType: AdCampaignMediaTypeEnum, durationPromos?: number | null, replicationRole: ReplicationRole, promos: Array<{ __typename?: 'PromoPureType', id: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, promo: { __typename?: 'MediafilePureType', sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, points: Array<{ __typename?: 'PointPureType', id: string }>, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null };

export type AdCampaignMetadataTypeFragment = { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, type: AdCampaignTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null };

export type AdCampaignInfoTypeFragment = { __typename?: 'AdCampaignPureType', id: string, title: string, enable: boolean, period: number, interval: number, type: AdCampaignTypeEnum, prevMediafileRequired: boolean, mediaType: AdCampaignMediaTypeEnum, replicationRole: ReplicationRole, timingSettings: { __typename?: 'AdCampaignTimingSettingsType', dayEndTime?: any | null, dayStartTime?: any | null, endDate?: any | null, startDate?: any | null, weekdays: { __typename?: 'WeekDayMapType', monday: boolean, friday: boolean, saturday: boolean, sunday: boolean, thursday: boolean, tuesday: boolean, wednesday: boolean } }, points: Array<{ __typename?: 'PointPureType', id: string, deviceType?: number | null, address: string }>, adPromos: Array<{ __typename?: 'AdPromoPureType', id: string, promoId: string, order?: number | null, title: string, filename: string, duration: number, time?: any | null, performerTitle: string, promo: { __typename?: 'MediafilePureType', previewUrl?: string | null, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } }>, tags?: Array<{ __typename?: 'CompanyTagPureType', id: string, title: string }> | null };

export type ThematicContentBlockInfoTypeFragment = { __typename?: 'ThematicContentBlockPureType', id: string, title: string, eventTitle: string, isEnabled: boolean, startDate?: any | null, endDate?: any | null };

export type CompanyThematicContentBlockInfoTypeFragment = { __typename?: 'CompanyThematicContentBlockPureType', id: string, playFromDate: any, playToDate: any, isActive: boolean, isEnabled: boolean, title: string, eventTitle: string };

export type CollectionShortTypeFragment = { __typename?: 'LibraryCollectionPureType', id: string, title: string, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } };

export type CollectionTypeFragment = { __typename?: 'LibraryCollectionPureType', id: string, title: string, streams: Array<{ __typename?: 'LibraryStreamPureType', id: string, stream: { __typename?: 'StreamPureType', id: string, title: string, description: string, isTemplate: boolean, templateType: string, cover?: { __typename?: 'CoverFilePureType', miniatureUri?: string | null } | null, genres: Array<{ __typename?: 'SearchTagsWithOrderType', tag: { __typename?: 'SearchTagsType', id: string, title: string } }>, demoMediafile?: { __typename?: 'MediafilePureType', id: string, filename: string, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } | null } }>, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } };

export type GroupTypeFragment = { __typename?: 'LibraryGroupPureType', id: string, title: string, collections: Array<{ __typename?: 'LibraryCollectionPureType', id: string, title: string, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } }> };

export type StreamLibraryTypeFragment = { __typename?: 'LibraryPureType', id: string, title: string, groups: Array<{ __typename?: 'LibraryGroupPureType', id: string, title: string, collections: Array<{ __typename?: 'LibraryCollectionPureType', id: string, title: string, poster: { __typename?: 'LibraryPosterPureType', id: string, uri: string } }> }> };

export type CompanyPlaybackReportSettingTypeFragment = { __typename?: 'CompanyPlaybackReportSettingsType', rightholderId?: string | null, isGenerateReport: boolean, title: string, reportType: PlaybackReportType, emptyReportTitle: string, helpLink: string };

export type CompanyReportTypeFragment = { __typename?: 'CompanyPlaybackReportType', title: string, rightholderId?: string | null, dateFrom: any, dateTo: any, status: PlaybackReportStatus, reportFileUri?: string | null, id: string, reportType: PlaybackReportType };

export type PaymentMethodInfoTypeFragment = { __typename?: 'PaymentMethodObjectPureType', last4: string, cardType: string, expiryYear: string, expiryMonth: string };

export type PricePlanInfoTypeFragment = { __typename?: 'PricePlanPureType', id: string, title: string, titleForManager: string, alias: string, currency: Currencies, useByDefault: boolean, offerLink: string, periods: Array<{ __typename?: 'PricePlanPeriodPureType', id: string, title: string, payFrequencyMonth: number, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> }>, rows: Array<{ __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null }> };

export type PricePlanRowInfoTypeFragment = { __typename?: 'PricePlanRowPureType', id: string, amount: number, stepRangeLower: number, stepRangeUpper?: number | null };

export type CompanyDiscountInfoTypeFragment = { __typename?: 'OrganizationDiscountPureType', id: string, title: string, startDate: any, endDate?: any | null, invoiceWithDiscountLimit: number, payFrequencyMonth: number, value: number, valueType: DiscountValueType, organizationId: number, status: OrganizationDiscountStatus, slug: string };

export type UserFeatureOnboardingFragment = { __typename?: 'UserFeaturesOnboardingType', feature: UserFeatures, isOnboarded: boolean };

export type NotificationFragmentFragment = { __typename?: 'NotificationType', modelId: string, notificationType: string, message: string, title: string, confirm: string, isBlocked: boolean };

export type MediafileApprovalFragmentFragment = { __typename?: 'MediafileApprovalType', timestamp?: any | null, eventType?: MediafileEventTypes | null, mediafile: { __typename?: 'MediafilePureType', id: string, rightholderName: string, title: string, performerTitle: string, filename: string, uri: string, explicit: boolean, type: number, isDeleting: boolean, sourcefiles: Array<{ __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string }> } };

export type BusinessPlaylistTypeFragment = { __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null };

export type BusinessProfileTypeFragment = { __typename?: 'ZvukProfileType', id: string, isPublished?: boolean | null, description?: string | null, companyName?: string | null, site?: string | null, avatar?: string | null, poster?: string | null, bannerLink?: string | null, bannerWeb?: string | null, bannerMobile?: string | null, remoteProfileLink?: string | null, syncStatus?: ZvukSyncStatus | null, created: any, company?: { __typename?: 'UserCompanyPureType', id: string } | null, playlists?: Array<{ __typename?: 'ZvukPlaylistType', id: string, companyId: string, profileId: string, streamId?: string | null, isPublished?: boolean | null, description?: string | null, modified?: any | null, tracksCount?: number | null, remotePlaylistLink?: string | null, poster?: string | null, title?: string | null, source?: ZvukPlaylistSource | null, syncStatus?: ZvukSyncStatus | null, isAutoCreated?: boolean | null } | null> | null };

export type SourcefileTypeFragmentFragment = { __typename?: 'SourcefileType', url: string, mainFormat: SourcefileFormatType, extension: string };

export const SourcefileTypeFragmentFragmentDoc = gql`
    fragment SourcefileTypeFragment on SourcefileType {
  url
  mainFormat
  extension
}
    `;
export const PromoRollSynthJobFieldsFragmentDoc = gql`
    fragment PromoRollSynthJobFields on PromoRollSynthJobType {
  id
  title
  status
  promoMediafile {
    id
    title
    filename
    duration
    previewUrl
    sourcefiles {
      ...SourcefileTypeFragment
    }
  }
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export const MediafileInfoTypeFragmentDoc = gql`
    fragment MediafileInfoType on MediafilePureType {
  id
  rightholderName
  title
  performerTitle
  filename
  uri
  duration
  genres
  values {
    id
    title
    color
  }
  valueIds
  type
  explicit
  sourcefiles {
    ...SourcefileTypeFragment
  }
  isDeleting
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export const MediaFilesRandomTypeFragmentDoc = gql`
    fragment MediaFilesRandomType on MediafilePureType {
  id
  title
  performerTitle
  filename
  uri
  duration
  type
  explicit
  sourcefiles {
    ...SourcefileTypeFragment
  }
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export const StreamShortTypeFragmentDoc = gql`
    fragment StreamShortType on StreamPureType {
  id
  title
  description
  isTemplate
  templateType
  cover {
    miniatureUri
  }
  genres {
    tag {
      id
      title
    }
  }
  demoMediafile {
    id
    filename
    sourcefiles {
      ...SourcefileTypeFragment
    }
  }
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export const StreamInfoTypeFragmentDoc = gql`
    fragment StreamInfoType on StreamPureType {
  ...StreamShortType
  points {
    id
    address
  }
  contentBlocks {
    id
    copyFromId
    title
    startDayTime
    endDayTime
    startDate
    endDate
  }
  demoMediafile {
    id
    filename
    sourcefiles {
      ...SourcefileTypeFragment
    }
  }
  mediafilesCount
  duration
  genres {
    tag {
      id
      title
    }
  }
  hasThematicBlock
  mediafilesLiked
}
    ${StreamShortTypeFragmentDoc}
${SourcefileTypeFragmentFragmentDoc}`;
export const StreamApprovalInfoTypeFragmentDoc = gql`
    fragment StreamApprovalInfoType on StreamPureType {
  id
  title
  contentBlocks {
    id
    title
    startDayTime
    endDayTime
  }
}
    `;
export const LicenseShortTypeFragmentDoc = gql`
    fragment LicenseShortType on LicensePureType {
  id
  autoRenewal
  paymentState
  expiresAt
  modified
}
    `;
export const PlayerDeviceInfoTypeFragmentDoc = gql`
    fragment PlayerDeviceInfoType on PlayerDevicePureType {
  id
  requiredVersionUrl
  supportedFeatures
  bindingCode
  type
  bindedAt
  group {
    id
    title
    isValid
    validationError
  }
}
    `;
export const PointInfoTypeFragmentDoc = gql`
    fragment PointInfoType on PointPureType {
  id
  comment
  timezone
  fileFormat
  address
  license {
    ...LicenseShortType
  }
  isEnabled
  sleepOptions {
    enabled
    settings {
      day
      start
      end
    }
  }
  device {
    id
    requiredVersionUrl
    bindingCode
    type
    volume
    ...PlayerDeviceInfoType
  }
  stream {
    ...StreamShortType
    hasThematicBlock
  }
  playingStatus {
    code
    color
    title
    progress
  }
  amplifyOptions {
    amplifyMediafile
    amplifyPromo
    amplifyInstant
  }
  tags {
    id
    title
  }
  adcampaigns {
    id
    type
  }
  videoStream {
    id
    title
    description
    previewUrl
    size
    duration
    videoMediafiles {
      id
    }
    emenuMediafiles {
      id
    }
  }
  withMusicCut
  cutDuration
  adOverlapResolution
  isVideoMode
  isVideoDemo
}
    ${LicenseShortTypeFragmentDoc}
${PlayerDeviceInfoTypeFragmentDoc}
${StreamShortTypeFragmentDoc}`;
export const PointShortTypeFragmentDoc = gql`
    fragment PointShortType on PointPureType {
  id
  address
  comment
  isEnabled
  device {
    ...PlayerDeviceInfoType
  }
  stream {
    ...StreamShortType
  }
  playingStatus {
    code
    color
    title
    progress
  }
  tags {
    id
    title
  }
  certificateIsAvailable
  cutDuration
  withMusicCut
  adOverlapResolution
  fileFormat
  isVideoMode
  isVideoDemo
  videoStream {
    id
    title
    description
    previewUrl
    duration
    size
    videoMediafiles {
      id
    }
    emenuMediafiles {
      id
    }
  }
}
    ${PlayerDeviceInfoTypeFragmentDoc}
${StreamShortTypeFragmentDoc}`;
export const PointSpecialTypeFragmentDoc = gql`
    fragment PointSpecialType on PointPureType {
  id
  address
  isEnabled
  device {
    ...PlayerDeviceInfoType
  }
  stream {
    id
    title
  }
  playingStatus {
    code
  }
  tags {
    id
    title
  }
}
    ${PlayerDeviceInfoTypeFragmentDoc}`;
export const PointMetadataTypeFragmentDoc = gql`
    fragment PointMetadataType on PointPureType {
  id
  address
  isEnabled
  adcampaigns {
    id
    type
  }
  stream {
    id
    title
  }
  license {
    id
  }
}
    `;
export const LicenseInfoTypeFragmentDoc = gql`
    fragment LicenseInfoType on LicensePureType {
  id
  point {
    id
    address
    isEnabled
    playingStatus {
      code
      color
      title
      progress
    }
  }
  autoRenewal
  paymentState
  expiresAt
  modified
}
    `;
export const UserCompanyShortTypeFragmentDoc = gql`
    fragment UserCompanyShortType on UserCompanyPureType {
  id
  requisite {
    ... on RequisiteRUPureType {
      emailForDocuments
    }
    ... on RequisiteKZPureType {
      emailForDocuments
    }
    ... on RequisiteBYPureType {
      emailForDocuments
    }
  }
}
    `;
export const CompanyDeviceRequestInfoTypeFragmentDoc = gql`
    fragment CompanyDeviceRequestInfoType on CompanyDeviceRequestPureType {
  companyId
  deviceType
  requestType
  status
  pointId
  lastRequestDate
}
    `;
export const InvoiceInfoTypeFragmentDoc = gql`
    fragment InvoiceInfoType on InvoicePureType {
  id
  status
  amount
  created
  type
  isActual
}
    `;
export const CompanyContractPaymentTermsTypeInfoTypeFragmentDoc = gql`
    fragment CompanyContractPaymentTermsTypeInfoType on CompanyContractPaymentTermsType {
  amount
  payFrequencyMonth
}
    `;
export const CompanyContractInfoTypeFragmentDoc = gql`
    fragment CompanyContractInfoType on CompanyContractPureType {
  id
  name
  number
  date
  typeContract
  isConfirmed
  billingEnabled
  paymentTerms {
    ...CompanyContractPaymentTermsTypeInfoType
  }
  status
}
    ${CompanyContractPaymentTermsTypeInfoTypeFragmentDoc}`;
export const UserCompanyInfoTypeFragmentDoc = gql`
    fragment UserCompanyInfoType on UserCompanyPureType {
  id
  hasMinimumData
  country
  created
  actualName
  validated
  businessSphereId
  isBillingEnabled
  streamLibrariesIds
  hasDesktopPlayers
  hasInstantAdCampaigns
  zvukProfileCount
  addTelegramSubscribeLink
  canSberIdLink
  sberIdWasLinked
  sberIdButtonState {
    isVisible
    isDisabled
    scenario
    unavailabilityReason
  }
  deviceRequests {
    ...CompanyDeviceRequestInfoType
  }
  isPaymentByInvoiceRequested
  users {
    id
    email
    role
  }
  invoices {
    ...InvoiceInfoType
  }
  contractMigrations {
    id
    offerUrl
    contractType
    status
  }
  contracts {
    ...CompanyContractInfoType
  }
  referral {
    uuid
    registeredUsers {
      id
      email
      phone
      registrationSource
    }
  }
  requisite {
    ... on RequisiteRUPureType {
      inn
      kpp
      ogrn
      organizationShortname
      organizationFullname
      organizationAddress
      organizationType
      managementPost
      managementName
      emailForDocuments
      selfEmployedFullName
    }
    ... on RequisiteKZPureType {
      iin
      bin
      organizationShortname
      organizationFullname
      organizationAddress
      organizationType
      managementPost
      managementName
      emailForDocuments
    }
    ... on RequisiteBYPureType {
      unp
      organizationShortname
      organizationFullname
      organizationAddress
      organizationType
      managementPost
      managementName
      emailForDocuments
    }
  }
  trialPeriod {
    startedAt
    finishedAt
    lengthDays
    lengthMinutes
    isFinished
    isExpired
  }
  uiFeatures {
    isBillingEnabled
    isShowReports
    isChangePricePlanAvailable
    isOffertaChanged
    isCertLetterAvailable
    isInstantAdcampaignAvailable
    isBusinessProfileAvailable
    isVideoAvailable
    isAddressesGroupsAvailable
    isVideoAdsAvailable
  }
  pricePlan {
    alias
    currency
  }
  videoDemoPeriod {
    startedAt
    expiredAt
    finishedAt
    lengthDays
    lengthMinutes
    isFinished
    isExpired
  }
}
    ${CompanyDeviceRequestInfoTypeFragmentDoc}
${InvoiceInfoTypeFragmentDoc}
${CompanyContractInfoTypeFragmentDoc}`;
export const UserInfoTypeFragmentDoc = gql`
    fragment UserInfoType on UserExtendPureType {
  id
  email
  phone
  firstName
  isTest
  registrationSource
  smartLkAccess
  personalAccountAccess
  pointsExists
  sberBusinessClientInfo {
    hasSberBusinessAccount
  }
  mainCompany {
    ...UserCompanyInfoType
  }
  companies {
    ...UserCompanyInfoType
  }
}
    ${UserCompanyInfoTypeFragmentDoc}`;
export const UserInvitationInfoTypeFragmentDoc = gql`
    fragment UserInvitationInfoType on UserInvitationType {
  id
  email
  isSent
  isAccepted
  isActive
}
    `;
export const AdCampaignTimingSettingsInfoTypeFragmentDoc = gql`
    fragment AdCampaignTimingSettingsInfoType on AdCampaignTimingSettingsType {
  dayEndTime
  dayStartTime
  endDate
  startDate
  weekdays {
    monday
    friday
    saturday
    sunday
    thursday
    tuesday
    wednesday
  }
}
    `;
export const AdCampaignShortTypeFragmentDoc = gql`
    fragment AdCampaignShortType on AdCampaignPureType {
  id
  title
  enable
  type
  mediaType
  promos {
    id
  }
  adPromos {
    id
    promoId
    order
    title
    filename
    duration
    promo {
      sourcefiles {
        ...SourcefileTypeFragment
      }
    }
  }
  points {
    id
  }
  timingSettings {
    ...AdCampaignTimingSettingsInfoType
  }
  tags {
    id
    title
  }
  durationPromos
  replicationRole
}
    ${SourcefileTypeFragmentFragmentDoc}
${AdCampaignTimingSettingsInfoTypeFragmentDoc}`;
export const AdCampaignMetadataTypeFragmentDoc = gql`
    fragment AdCampaignMetadataType on AdCampaignPureType {
  id
  title
  enable
  type
  replicationRole
  timingSettings {
    ...AdCampaignTimingSettingsInfoType
  }
  tags {
    id
    title
  }
}
    ${AdCampaignTimingSettingsInfoTypeFragmentDoc}`;
export const AdCampaignInfoTypeFragmentDoc = gql`
    fragment AdCampaignInfoType on AdCampaignPureType {
  id
  title
  enable
  period
  interval
  type
  prevMediafileRequired
  mediaType
  timingSettings {
    ...AdCampaignTimingSettingsInfoType
  }
  points {
    id
    deviceType
    address
  }
  adPromos {
    id
    promoId
    order
    title
    filename
    duration
    time
    performerTitle
    promo {
      previewUrl
      sourcefiles {
        ...SourcefileTypeFragment
      }
    }
  }
  tags {
    id
    title
  }
  replicationRole
}
    ${AdCampaignTimingSettingsInfoTypeFragmentDoc}
${SourcefileTypeFragmentFragmentDoc}`;
export const ThematicContentBlockInfoTypeFragmentDoc = gql`
    fragment ThematicContentBlockInfoType on ThematicContentBlockPureType {
  id
  title
  eventTitle
  isEnabled
  startDate
  endDate
}
    `;
export const CompanyThematicContentBlockInfoTypeFragmentDoc = gql`
    fragment CompanyThematicContentBlockInfoType on CompanyThematicContentBlockPureType {
  id
  playFromDate
  playToDate
  isActive
  isEnabled
  title
  eventTitle
}
    `;
export const CollectionShortTypeFragmentDoc = gql`
    fragment CollectionShortType on LibraryCollectionPureType {
  id
  title
  poster {
    id
    uri
  }
}
    `;
export const CollectionTypeFragmentDoc = gql`
    fragment CollectionType on LibraryCollectionPureType {
  ...CollectionShortType
  streams {
    id
    stream {
      ...StreamShortType
    }
  }
}
    ${CollectionShortTypeFragmentDoc}
${StreamShortTypeFragmentDoc}`;
export const GroupTypeFragmentDoc = gql`
    fragment GroupType on LibraryGroupPureType {
  id
  title
  collections {
    ...CollectionShortType
  }
}
    ${CollectionShortTypeFragmentDoc}`;
export const StreamLibraryTypeFragmentDoc = gql`
    fragment StreamLibraryType on LibraryPureType {
  id
  title
  groups {
    ...GroupType
  }
}
    ${GroupTypeFragmentDoc}`;
export const CompanyPlaybackReportSettingTypeFragmentDoc = gql`
    fragment CompanyPlaybackReportSettingType on CompanyPlaybackReportSettingsType {
  rightholderId
  isGenerateReport
  title
  reportType
  emptyReportTitle
  helpLink
}
    `;
export const CompanyReportTypeFragmentDoc = gql`
    fragment CompanyReportType on CompanyPlaybackReportType {
  title
  rightholderId
  dateFrom
  dateTo
  status
  reportFileUri
  id
  reportType
}
    `;
export const PaymentMethodInfoTypeFragmentDoc = gql`
    fragment PaymentMethodInfoType on PaymentMethodObjectPureType {
  last4
  cardType
  expiryYear
  expiryMonth
}
    `;
export const PricePlanRowInfoTypeFragmentDoc = gql`
    fragment PricePlanRowInfoType on PricePlanRowPureType {
  id
  amount
  stepRangeLower
  stepRangeUpper
}
    `;
export const PricePlanInfoTypeFragmentDoc = gql`
    fragment PricePlanInfoType on PricePlanPureType {
  id
  title
  titleForManager
  alias
  currency
  useByDefault
  periods {
    id
    title
    payFrequencyMonth
    rows {
      ...PricePlanRowInfoType
    }
  }
  rows {
    ...PricePlanRowInfoType
  }
  offerLink
}
    ${PricePlanRowInfoTypeFragmentDoc}`;
export const CompanyDiscountInfoTypeFragmentDoc = gql`
    fragment CompanyDiscountInfoType on OrganizationDiscountPureType {
  id
  title
  startDate
  endDate
  invoiceWithDiscountLimit
  payFrequencyMonth
  value
  valueType
  organizationId
  status
  slug
}
    `;
export const UserFeatureOnboardingFragmentDoc = gql`
    fragment UserFeatureOnboarding on UserFeaturesOnboardingType {
  feature
  isOnboarded
}
    `;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on NotificationType {
  modelId
  notificationType
  message
  title
  confirm
  isBlocked
}
    `;
export const MediafileApprovalFragmentFragmentDoc = gql`
    fragment MediafileApprovalFragment on MediafileApprovalType {
  mediafile {
    id
    rightholderName
    title
    performerTitle
    filename
    uri
    explicit
    type
    sourcefiles {
      ...SourcefileTypeFragment
    }
    isDeleting
  }
  timestamp
  eventType
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export const BusinessPlaylistTypeFragmentDoc = gql`
    fragment BusinessPlaylistType on ZvukPlaylistType {
  id
  companyId
  profileId
  streamId
  isPublished
  description
  modified
  tracksCount
  remotePlaylistLink
  poster
  title
  source
  syncStatus
  isAutoCreated
}
    `;
export const BusinessProfileTypeFragmentDoc = gql`
    fragment BusinessProfileType on ZvukProfileType {
  id
  company {
    id
  }
  isPublished
  description
  companyName
  site
  avatar
  poster
  bannerLink
  bannerWeb
  bannerMobile
  remoteProfileLink
  syncStatus
  created
  playlists {
    ...BusinessPlaylistType
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export const BillingLicensesModalViewModelDocument = gql`
    query billingLicensesModalViewModel($companyId: ID!) {
  organizationCurrentPricePlanQuery(organizationId: $companyId) {
    organizationId
    pricePlan {
      id
    }
  }
  companyBillingInfoQuery(companyId: $companyId) {
    status
    selectedPaymentKind
    nextBillingDate
    nextBillingAmount
    fullPeriodAmount
    paymentScheme
    nonRenewableLicenses {
      ...LicenseInfoType
    }
    renewableLicenses {
      ...LicenseInfoType
    }
    unpaidLicenses {
      ...LicenseInfoType
    }
    hasTrialLicenses @client
    hasActiveLicenses @client
    hasInactiveLicenses @client
    hasWaitPaymentLicenses @client
    hasGraceLicenses @client
    totalLicenses @client {
      ...LicenseInfoType
    }
  }
  paymentMethodPureQuery(companyId: $companyId) {
    paymentMethod {
      ...PaymentMethodInfoType
    }
    isLinkingInProcess
  }
  acceptanceAdvancedQuery(companyId: $companyId) {
    status
    payerAccount
  }
}
    ${LicenseInfoTypeFragmentDoc}
${PaymentMethodInfoTypeFragmentDoc}`;

/**
 * __useBillingLicensesModalViewModelQuery__
 *
 * To run a query within a React component, call `useBillingLicensesModalViewModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingLicensesModalViewModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingLicensesModalViewModelQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillingLicensesModalViewModelQuery(baseOptions: Apollo.QueryHookOptions<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables> & ({ variables: BillingLicensesModalViewModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>(BillingLicensesModalViewModelDocument, options);
      }
export function useBillingLicensesModalViewModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>(BillingLicensesModalViewModelDocument, options);
        }
// @ts-ignore
export function useBillingLicensesModalViewModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>): Apollo.UseSuspenseQueryResult<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>;
export function useBillingLicensesModalViewModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>): Apollo.UseSuspenseQueryResult<BillingLicensesModalViewModelQuery | undefined, BillingLicensesModalViewModelQueryVariables>;
export function useBillingLicensesModalViewModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>(BillingLicensesModalViewModelDocument, options);
        }
export type BillingLicensesModalViewModelQueryHookResult = ReturnType<typeof useBillingLicensesModalViewModelQuery>;
export type BillingLicensesModalViewModelLazyQueryHookResult = ReturnType<typeof useBillingLicensesModalViewModelLazyQuery>;
export type BillingLicensesModalViewModelSuspenseQueryHookResult = ReturnType<typeof useBillingLicensesModalViewModelSuspenseQuery>;
export type BillingLicensesModalViewModelQueryResult = Apollo.QueryResult<BillingLicensesModalViewModelQuery, BillingLicensesModalViewModelQueryVariables>;
export const BillingCurrentPricePlanViewModelDocument = gql`
    query billingCurrentPricePlanViewModel($companyId: ID!) {
  organizationCurrentPricePlanQuery(organizationId: $companyId) {
    organizationId
    pricePlan {
      ...PricePlanInfoType
    }
    pricePlanPeriod {
      id
      title
      payFrequencyMonth
      rows {
        ...PricePlanRowInfoType
      }
    }
  }
  companyBillingInfoQuery(companyId: $companyId) {
    status
    selectedPaymentKind
    nextBillingDate
    discount {
      ...CompanyDiscountInfoType
    }
    nonRenewableLicenses {
      ...LicenseInfoType
    }
    renewableLicenses {
      ...LicenseInfoType
    }
    unpaidLicenses {
      ...LicenseInfoType
    }
    hasActiveLicenses @client
    hasInactiveLicenses @client
    hasWaitPaymentLicenses @client
    hasGraceLicenses @client
    hasTrialLicenses @client
    totalLicenses @client {
      ...LicenseInfoType
    }
    expiresLicenseDate @client
    hasRenewableLicenses @client
    isWaitPaymentLicense @client
    isGraceLicense @client
  }
  acceptanceAdvancedQuery(companyId: $companyId) {
    status
    payerAccount
  }
}
    ${PricePlanInfoTypeFragmentDoc}
${PricePlanRowInfoTypeFragmentDoc}
${CompanyDiscountInfoTypeFragmentDoc}
${LicenseInfoTypeFragmentDoc}`;

/**
 * __useBillingCurrentPricePlanViewModelQuery__
 *
 * To run a query within a React component, call `useBillingCurrentPricePlanViewModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingCurrentPricePlanViewModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingCurrentPricePlanViewModelQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillingCurrentPricePlanViewModelQuery(baseOptions: Apollo.QueryHookOptions<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables> & ({ variables: BillingCurrentPricePlanViewModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>(BillingCurrentPricePlanViewModelDocument, options);
      }
export function useBillingCurrentPricePlanViewModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>(BillingCurrentPricePlanViewModelDocument, options);
        }
// @ts-ignore
export function useBillingCurrentPricePlanViewModelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>): Apollo.UseSuspenseQueryResult<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>;
export function useBillingCurrentPricePlanViewModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>): Apollo.UseSuspenseQueryResult<BillingCurrentPricePlanViewModelQuery | undefined, BillingCurrentPricePlanViewModelQueryVariables>;
export function useBillingCurrentPricePlanViewModelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>(BillingCurrentPricePlanViewModelDocument, options);
        }
export type BillingCurrentPricePlanViewModelQueryHookResult = ReturnType<typeof useBillingCurrentPricePlanViewModelQuery>;
export type BillingCurrentPricePlanViewModelLazyQueryHookResult = ReturnType<typeof useBillingCurrentPricePlanViewModelLazyQuery>;
export type BillingCurrentPricePlanViewModelSuspenseQueryHookResult = ReturnType<typeof useBillingCurrentPricePlanViewModelSuspenseQuery>;
export type BillingCurrentPricePlanViewModelQueryResult = Apollo.QueryResult<BillingCurrentPricePlanViewModelQuery, BillingCurrentPricePlanViewModelQueryVariables>;
export const AuthTokenDocument = gql`
    mutation authToken($input: JwtTokenAuthPureMutationInput!) {
  auth: tokenPureAuth(input: $input) {
    token {
      value
    }
  }
}
    `;
export type AuthTokenMutationFn = Apollo.MutationFunction<AuthTokenMutation, AuthTokenMutationVariables>;

/**
 * __useAuthTokenMutation__
 *
 * To run a mutation, you first call `useAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authTokenMutation, { data, loading, error }] = useAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthTokenMutation, AuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthTokenMutation, AuthTokenMutationVariables>(AuthTokenDocument, options);
      }
export type AuthTokenMutationHookResult = ReturnType<typeof useAuthTokenMutation>;
export type AuthTokenMutationResult = Apollo.MutationResult<AuthTokenMutation>;
export type AuthTokenMutationOptions = Apollo.BaseMutationOptions<AuthTokenMutation, AuthTokenMutationVariables>;
export const AuthAllowedActionsForPhoneDocument = gql`
    query authAllowedActionsForPhone($phone: String!) {
  allowedActionsForPhone(phone: $phone)
}
    `;

/**
 * __useAuthAllowedActionsForPhoneQuery__
 *
 * To run a query within a React component, call `useAuthAllowedActionsForPhoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthAllowedActionsForPhoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthAllowedActionsForPhoneQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAuthAllowedActionsForPhoneQuery(baseOptions: Apollo.QueryHookOptions<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables> & ({ variables: AuthAllowedActionsForPhoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>(AuthAllowedActionsForPhoneDocument, options);
      }
export function useAuthAllowedActionsForPhoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>(AuthAllowedActionsForPhoneDocument, options);
        }
// @ts-ignore
export function useAuthAllowedActionsForPhoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>): Apollo.UseSuspenseQueryResult<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>;
export function useAuthAllowedActionsForPhoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>): Apollo.UseSuspenseQueryResult<AuthAllowedActionsForPhoneQuery | undefined, AuthAllowedActionsForPhoneQueryVariables>;
export function useAuthAllowedActionsForPhoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>(AuthAllowedActionsForPhoneDocument, options);
        }
export type AuthAllowedActionsForPhoneQueryHookResult = ReturnType<typeof useAuthAllowedActionsForPhoneQuery>;
export type AuthAllowedActionsForPhoneLazyQueryHookResult = ReturnType<typeof useAuthAllowedActionsForPhoneLazyQuery>;
export type AuthAllowedActionsForPhoneSuspenseQueryHookResult = ReturnType<typeof useAuthAllowedActionsForPhoneSuspenseQuery>;
export type AuthAllowedActionsForPhoneQueryResult = Apollo.QueryResult<AuthAllowedActionsForPhoneQuery, AuthAllowedActionsForPhoneQueryVariables>;
export const AuthTokenRetrieveDocument = gql`
    mutation authTokenRetrieve($input: JwtTokenAuthPureMutationInput!) {
  auth: tokenPureRetrieveAuth(input: $input) {
    token {
      value
    }
    user {
      ...UserInfoType
    }
  }
}
    ${UserInfoTypeFragmentDoc}`;
export type AuthTokenRetrieveMutationFn = Apollo.MutationFunction<AuthTokenRetrieveMutation, AuthTokenRetrieveMutationVariables>;

/**
 * __useAuthTokenRetrieveMutation__
 *
 * To run a mutation, you first call `useAuthTokenRetrieveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthTokenRetrieveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authTokenRetrieveMutation, { data, loading, error }] = useAuthTokenRetrieveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthTokenRetrieveMutation(baseOptions?: Apollo.MutationHookOptions<AuthTokenRetrieveMutation, AuthTokenRetrieveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthTokenRetrieveMutation, AuthTokenRetrieveMutationVariables>(AuthTokenRetrieveDocument, options);
      }
export type AuthTokenRetrieveMutationHookResult = ReturnType<typeof useAuthTokenRetrieveMutation>;
export type AuthTokenRetrieveMutationResult = Apollo.MutationResult<AuthTokenRetrieveMutation>;
export type AuthTokenRetrieveMutationOptions = Apollo.BaseMutationOptions<AuthTokenRetrieveMutation, AuthTokenRetrieveMutationVariables>;
export const AuthPasswordRestoreDocument = gql`
    mutation authPasswordRestore($input: PasswordResetMutationInput!) {
  passwordRestore(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type AuthPasswordRestoreMutationFn = Apollo.MutationFunction<AuthPasswordRestoreMutation, AuthPasswordRestoreMutationVariables>;

/**
 * __useAuthPasswordRestoreMutation__
 *
 * To run a mutation, you first call `useAuthPasswordRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthPasswordRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authPasswordRestoreMutation, { data, loading, error }] = useAuthPasswordRestoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthPasswordRestoreMutation(baseOptions?: Apollo.MutationHookOptions<AuthPasswordRestoreMutation, AuthPasswordRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthPasswordRestoreMutation, AuthPasswordRestoreMutationVariables>(AuthPasswordRestoreDocument, options);
      }
export type AuthPasswordRestoreMutationHookResult = ReturnType<typeof useAuthPasswordRestoreMutation>;
export type AuthPasswordRestoreMutationResult = Apollo.MutationResult<AuthPasswordRestoreMutation>;
export type AuthPasswordRestoreMutationOptions = Apollo.BaseMutationOptions<AuthPasswordRestoreMutation, AuthPasswordRestoreMutationVariables>;
export const AuthPasswordRestoreConfirmationDocument = gql`
    mutation authPasswordRestoreConfirmation($input: PasswordResetConfirmationMutationInput!) {
  passwordRestoreConfirmation(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type AuthPasswordRestoreConfirmationMutationFn = Apollo.MutationFunction<AuthPasswordRestoreConfirmationMutation, AuthPasswordRestoreConfirmationMutationVariables>;

/**
 * __useAuthPasswordRestoreConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthPasswordRestoreConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthPasswordRestoreConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authPasswordRestoreConfirmationMutation, { data, loading, error }] = useAuthPasswordRestoreConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthPasswordRestoreConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthPasswordRestoreConfirmationMutation, AuthPasswordRestoreConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthPasswordRestoreConfirmationMutation, AuthPasswordRestoreConfirmationMutationVariables>(AuthPasswordRestoreConfirmationDocument, options);
      }
export type AuthPasswordRestoreConfirmationMutationHookResult = ReturnType<typeof useAuthPasswordRestoreConfirmationMutation>;
export type AuthPasswordRestoreConfirmationMutationResult = Apollo.MutationResult<AuthPasswordRestoreConfirmationMutation>;
export type AuthPasswordRestoreConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthPasswordRestoreConfirmationMutation, AuthPasswordRestoreConfirmationMutationVariables>;
export const AuthSendEmailRepeatDocument = gql`
    mutation authSendEmailRepeat($input: SendEmailPureRepeatMutationInput!) {
  sendEmailPureRepeat(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type AuthSendEmailRepeatMutationFn = Apollo.MutationFunction<AuthSendEmailRepeatMutation, AuthSendEmailRepeatMutationVariables>;

/**
 * __useAuthSendEmailRepeatMutation__
 *
 * To run a mutation, you first call `useAuthSendEmailRepeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthSendEmailRepeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authSendEmailRepeatMutation, { data, loading, error }] = useAuthSendEmailRepeatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthSendEmailRepeatMutation(baseOptions?: Apollo.MutationHookOptions<AuthSendEmailRepeatMutation, AuthSendEmailRepeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthSendEmailRepeatMutation, AuthSendEmailRepeatMutationVariables>(AuthSendEmailRepeatDocument, options);
      }
export type AuthSendEmailRepeatMutationHookResult = ReturnType<typeof useAuthSendEmailRepeatMutation>;
export type AuthSendEmailRepeatMutationResult = Apollo.MutationResult<AuthSendEmailRepeatMutation>;
export type AuthSendEmailRepeatMutationOptions = Apollo.BaseMutationOptions<AuthSendEmailRepeatMutation, AuthSendEmailRepeatMutationVariables>;
export const AuthPasswordSetNewDocument = gql`
    mutation authPasswordSetNew($input: PasswordPureSetNewMutationInput!) {
  passwordPureSetNew(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type AuthPasswordSetNewMutationFn = Apollo.MutationFunction<AuthPasswordSetNewMutation, AuthPasswordSetNewMutationVariables>;

/**
 * __useAuthPasswordSetNewMutation__
 *
 * To run a mutation, you first call `useAuthPasswordSetNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthPasswordSetNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authPasswordSetNewMutation, { data, loading, error }] = useAuthPasswordSetNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthPasswordSetNewMutation(baseOptions?: Apollo.MutationHookOptions<AuthPasswordSetNewMutation, AuthPasswordSetNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthPasswordSetNewMutation, AuthPasswordSetNewMutationVariables>(AuthPasswordSetNewDocument, options);
      }
export type AuthPasswordSetNewMutationHookResult = ReturnType<typeof useAuthPasswordSetNewMutation>;
export type AuthPasswordSetNewMutationResult = Apollo.MutationResult<AuthPasswordSetNewMutation>;
export type AuthPasswordSetNewMutationOptions = Apollo.BaseMutationOptions<AuthPasswordSetNewMutation, AuthPasswordSetNewMutationVariables>;
export const AuthTokenRevokeDocument = gql`
    mutation authTokenRevoke {
  tokenPureRevoke {
    revoked
  }
}
    `;
export type AuthTokenRevokeMutationFn = Apollo.MutationFunction<AuthTokenRevokeMutation, AuthTokenRevokeMutationVariables>;

/**
 * __useAuthTokenRevokeMutation__
 *
 * To run a mutation, you first call `useAuthTokenRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthTokenRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authTokenRevokeMutation, { data, loading, error }] = useAuthTokenRevokeMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthTokenRevokeMutation(baseOptions?: Apollo.MutationHookOptions<AuthTokenRevokeMutation, AuthTokenRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthTokenRevokeMutation, AuthTokenRevokeMutationVariables>(AuthTokenRevokeDocument, options);
      }
export type AuthTokenRevokeMutationHookResult = ReturnType<typeof useAuthTokenRevokeMutation>;
export type AuthTokenRevokeMutationResult = Apollo.MutationResult<AuthTokenRevokeMutation>;
export type AuthTokenRevokeMutationOptions = Apollo.BaseMutationOptions<AuthTokenRevokeMutation, AuthTokenRevokeMutationVariables>;
export const CurrentUserLogoutDocument = gql`
    mutation currentUserLogout {
  currentUserLogout {
    deleted
  }
}
    `;
export type CurrentUserLogoutMutationFn = Apollo.MutationFunction<CurrentUserLogoutMutation, CurrentUserLogoutMutationVariables>;

/**
 * __useCurrentUserLogoutMutation__
 *
 * To run a mutation, you first call `useCurrentUserLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [currentUserLogoutMutation, { data, loading, error }] = useCurrentUserLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserLogoutMutation(baseOptions?: Apollo.MutationHookOptions<CurrentUserLogoutMutation, CurrentUserLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CurrentUserLogoutMutation, CurrentUserLogoutMutationVariables>(CurrentUserLogoutDocument, options);
      }
export type CurrentUserLogoutMutationHookResult = ReturnType<typeof useCurrentUserLogoutMutation>;
export type CurrentUserLogoutMutationResult = Apollo.MutationResult<CurrentUserLogoutMutation>;
export type CurrentUserLogoutMutationOptions = Apollo.BaseMutationOptions<CurrentUserLogoutMutation, CurrentUserLogoutMutationVariables>;
export const AuthCurrentUserDocument = gql`
    query authCurrentUser {
  currentUserPureQuery {
    ...UserInfoType
  }
}
    ${UserInfoTypeFragmentDoc}`;

/**
 * __useAuthCurrentUserQuery__
 *
 * To run a query within a React component, call `useAuthCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>(AuthCurrentUserDocument, options);
      }
export function useAuthCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>(AuthCurrentUserDocument, options);
        }
// @ts-ignore
export function useAuthCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>;
export function useAuthCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<AuthCurrentUserQuery | undefined, AuthCurrentUserQueryVariables>;
export function useAuthCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>(AuthCurrentUserDocument, options);
        }
export type AuthCurrentUserQueryHookResult = ReturnType<typeof useAuthCurrentUserQuery>;
export type AuthCurrentUserLazyQueryHookResult = ReturnType<typeof useAuthCurrentUserLazyQuery>;
export type AuthCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAuthCurrentUserSuspenseQuery>;
export type AuthCurrentUserQueryResult = Apollo.QueryResult<AuthCurrentUserQuery, AuthCurrentUserQueryVariables>;
export const AuthUserSignUpDocument = gql`
    mutation authUserSignUp($input: UserPureSignUpMutationInput!) {
  auth: userPureSignUp(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type AuthUserSignUpMutationFn = Apollo.MutationFunction<AuthUserSignUpMutation, AuthUserSignUpMutationVariables>;

/**
 * __useAuthUserSignUpMutation__
 *
 * To run a mutation, you first call `useAuthUserSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUserSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUserSignUpMutation, { data, loading, error }] = useAuthUserSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthUserSignUpMutation(baseOptions?: Apollo.MutationHookOptions<AuthUserSignUpMutation, AuthUserSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUserSignUpMutation, AuthUserSignUpMutationVariables>(AuthUserSignUpDocument, options);
      }
export type AuthUserSignUpMutationHookResult = ReturnType<typeof useAuthUserSignUpMutation>;
export type AuthUserSignUpMutationResult = Apollo.MutationResult<AuthUserSignUpMutation>;
export type AuthUserSignUpMutationOptions = Apollo.BaseMutationOptions<AuthUserSignUpMutation, AuthUserSignUpMutationVariables>;
export const AuthUserSignUpYclientsDocument = gql`
    mutation authUserSignUpYclients($input: UserPureSignUpYClientsMutationInput!) {
  auth: userPureSignUpYclients(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type AuthUserSignUpYclientsMutationFn = Apollo.MutationFunction<AuthUserSignUpYclientsMutation, AuthUserSignUpYclientsMutationVariables>;

/**
 * __useAuthUserSignUpYclientsMutation__
 *
 * To run a mutation, you first call `useAuthUserSignUpYclientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUserSignUpYclientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUserSignUpYclientsMutation, { data, loading, error }] = useAuthUserSignUpYclientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthUserSignUpYclientsMutation(baseOptions?: Apollo.MutationHookOptions<AuthUserSignUpYclientsMutation, AuthUserSignUpYclientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUserSignUpYclientsMutation, AuthUserSignUpYclientsMutationVariables>(AuthUserSignUpYclientsDocument, options);
      }
export type AuthUserSignUpYclientsMutationHookResult = ReturnType<typeof useAuthUserSignUpYclientsMutation>;
export type AuthUserSignUpYclientsMutationResult = Apollo.MutationResult<AuthUserSignUpYclientsMutation>;
export type AuthUserSignUpYclientsMutationOptions = Apollo.BaseMutationOptions<AuthUserSignUpYclientsMutation, AuthUserSignUpYclientsMutationVariables>;
export const AuthUserGetSberOauthUriDocument = gql`
    query authUserGetSberOauthUri($redirect: String!) {
  userGetSberOauthUri(redirectUri: $redirect)
}
    `;

/**
 * __useAuthUserGetSberOauthUriQuery__
 *
 * To run a query within a React component, call `useAuthUserGetSberOauthUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserGetSberOauthUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserGetSberOauthUriQuery({
 *   variables: {
 *      redirect: // value for 'redirect'
 *   },
 * });
 */
export function useAuthUserGetSberOauthUriQuery(baseOptions: Apollo.QueryHookOptions<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables> & ({ variables: AuthUserGetSberOauthUriQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>(AuthUserGetSberOauthUriDocument, options);
      }
export function useAuthUserGetSberOauthUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>(AuthUserGetSberOauthUriDocument, options);
        }
// @ts-ignore
export function useAuthUserGetSberOauthUriSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>;
export function useAuthUserGetSberOauthUriSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserGetSberOauthUriQuery | undefined, AuthUserGetSberOauthUriQueryVariables>;
export function useAuthUserGetSberOauthUriSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>(AuthUserGetSberOauthUriDocument, options);
        }
export type AuthUserGetSberOauthUriQueryHookResult = ReturnType<typeof useAuthUserGetSberOauthUriQuery>;
export type AuthUserGetSberOauthUriLazyQueryHookResult = ReturnType<typeof useAuthUserGetSberOauthUriLazyQuery>;
export type AuthUserGetSberOauthUriSuspenseQueryHookResult = ReturnType<typeof useAuthUserGetSberOauthUriSuspenseQuery>;
export type AuthUserGetSberOauthUriQueryResult = Apollo.QueryResult<AuthUserGetSberOauthUriQuery, AuthUserGetSberOauthUriQueryVariables>;
export const AuthUserGetSberReauthUriDocument = gql`
    query authUserGetSberReauthUri($redirectUri: String!, $companyId: ID!) {
  userGetSberLinkUri(redirectUri: $redirectUri, companyId: $companyId)
}
    `;

/**
 * __useAuthUserGetSberReauthUriQuery__
 *
 * To run a query within a React component, call `useAuthUserGetSberReauthUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserGetSberReauthUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserGetSberReauthUriQuery({
 *   variables: {
 *      redirectUri: // value for 'redirectUri'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAuthUserGetSberReauthUriQuery(baseOptions: Apollo.QueryHookOptions<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables> & ({ variables: AuthUserGetSberReauthUriQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>(AuthUserGetSberReauthUriDocument, options);
      }
export function useAuthUserGetSberReauthUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>(AuthUserGetSberReauthUriDocument, options);
        }
// @ts-ignore
export function useAuthUserGetSberReauthUriSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>;
export function useAuthUserGetSberReauthUriSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>): Apollo.UseSuspenseQueryResult<AuthUserGetSberReauthUriQuery | undefined, AuthUserGetSberReauthUriQueryVariables>;
export function useAuthUserGetSberReauthUriSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>(AuthUserGetSberReauthUriDocument, options);
        }
export type AuthUserGetSberReauthUriQueryHookResult = ReturnType<typeof useAuthUserGetSberReauthUriQuery>;
export type AuthUserGetSberReauthUriLazyQueryHookResult = ReturnType<typeof useAuthUserGetSberReauthUriLazyQuery>;
export type AuthUserGetSberReauthUriSuspenseQueryHookResult = ReturnType<typeof useAuthUserGetSberReauthUriSuspenseQuery>;
export type AuthUserGetSberReauthUriQueryResult = Apollo.QueryResult<AuthUserGetSberReauthUriQuery, AuthUserGetSberReauthUriQueryVariables>;
export const AuthLeadUtmMarksDocument = gql`
    mutation authLeadUtmMarks($input: UtmMarksSendToAmoMutationInput!) {
  utmMarksSendToAmoLead(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type AuthLeadUtmMarksMutationFn = Apollo.MutationFunction<AuthLeadUtmMarksMutation, AuthLeadUtmMarksMutationVariables>;

/**
 * __useAuthLeadUtmMarksMutation__
 *
 * To run a mutation, you first call `useAuthLeadUtmMarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthLeadUtmMarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authLeadUtmMarksMutation, { data, loading, error }] = useAuthLeadUtmMarksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthLeadUtmMarksMutation(baseOptions?: Apollo.MutationHookOptions<AuthLeadUtmMarksMutation, AuthLeadUtmMarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthLeadUtmMarksMutation, AuthLeadUtmMarksMutationVariables>(AuthLeadUtmMarksDocument, options);
      }
export type AuthLeadUtmMarksMutationHookResult = ReturnType<typeof useAuthLeadUtmMarksMutation>;
export type AuthLeadUtmMarksMutationResult = Apollo.MutationResult<AuthLeadUtmMarksMutation>;
export type AuthLeadUtmMarksMutationOptions = Apollo.BaseMutationOptions<AuthLeadUtmMarksMutation, AuthLeadUtmMarksMutationVariables>;
export const AuthInvitationCreateDocument = gql`
    mutation authInvitationCreate($input: UserInvitationCreateMutationInput!) {
  invitationCreate(input: $input) {
    ok
    errors {
      field
      messages
    }
    invitation {
      ...UserInvitationInfoType
    }
  }
}
    ${UserInvitationInfoTypeFragmentDoc}`;
export type AuthInvitationCreateMutationFn = Apollo.MutationFunction<AuthInvitationCreateMutation, AuthInvitationCreateMutationVariables>;

/**
 * __useAuthInvitationCreateMutation__
 *
 * To run a mutation, you first call `useAuthInvitationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInvitationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInvitationCreateMutation, { data, loading, error }] = useAuthInvitationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthInvitationCreateMutation(baseOptions?: Apollo.MutationHookOptions<AuthInvitationCreateMutation, AuthInvitationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInvitationCreateMutation, AuthInvitationCreateMutationVariables>(AuthInvitationCreateDocument, options);
      }
export type AuthInvitationCreateMutationHookResult = ReturnType<typeof useAuthInvitationCreateMutation>;
export type AuthInvitationCreateMutationResult = Apollo.MutationResult<AuthInvitationCreateMutation>;
export type AuthInvitationCreateMutationOptions = Apollo.BaseMutationOptions<AuthInvitationCreateMutation, AuthInvitationCreateMutationVariables>;
export const AuthInvitationSendDocument = gql`
    mutation authInvitationSend($input: UserInvitationSendMutationInput!) {
  invitationSend(input: $input) {
    ok
    errors {
      field
      messages
    }
    invitation {
      ...UserInvitationInfoType
    }
  }
}
    ${UserInvitationInfoTypeFragmentDoc}`;
export type AuthInvitationSendMutationFn = Apollo.MutationFunction<AuthInvitationSendMutation, AuthInvitationSendMutationVariables>;

/**
 * __useAuthInvitationSendMutation__
 *
 * To run a mutation, you first call `useAuthInvitationSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInvitationSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInvitationSendMutation, { data, loading, error }] = useAuthInvitationSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthInvitationSendMutation(baseOptions?: Apollo.MutationHookOptions<AuthInvitationSendMutation, AuthInvitationSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInvitationSendMutation, AuthInvitationSendMutationVariables>(AuthInvitationSendDocument, options);
      }
export type AuthInvitationSendMutationHookResult = ReturnType<typeof useAuthInvitationSendMutation>;
export type AuthInvitationSendMutationResult = Apollo.MutationResult<AuthInvitationSendMutation>;
export type AuthInvitationSendMutationOptions = Apollo.BaseMutationOptions<AuthInvitationSendMutation, AuthInvitationSendMutationVariables>;
export const AuthInvitationDeactivateDocument = gql`
    mutation authInvitationDeactivate($input: UserInvitationDeactivateMutationInput!) {
  invitationDeactivate(input: $input) {
    ok
    errors {
      field
      messages
    }
    invitation {
      ...UserInvitationInfoType
    }
  }
}
    ${UserInvitationInfoTypeFragmentDoc}`;
export type AuthInvitationDeactivateMutationFn = Apollo.MutationFunction<AuthInvitationDeactivateMutation, AuthInvitationDeactivateMutationVariables>;

/**
 * __useAuthInvitationDeactivateMutation__
 *
 * To run a mutation, you first call `useAuthInvitationDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInvitationDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInvitationDeactivateMutation, { data, loading, error }] = useAuthInvitationDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthInvitationDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<AuthInvitationDeactivateMutation, AuthInvitationDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInvitationDeactivateMutation, AuthInvitationDeactivateMutationVariables>(AuthInvitationDeactivateDocument, options);
      }
export type AuthInvitationDeactivateMutationHookResult = ReturnType<typeof useAuthInvitationDeactivateMutation>;
export type AuthInvitationDeactivateMutationResult = Apollo.MutationResult<AuthInvitationDeactivateMutation>;
export type AuthInvitationDeactivateMutationOptions = Apollo.BaseMutationOptions<AuthInvitationDeactivateMutation, AuthInvitationDeactivateMutationVariables>;
export const AuthInvitationAcceptDocument = gql`
    mutation authInvitationAccept($input: UserInvitationAcceptMutationInput!) {
  invitationAccept(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type AuthInvitationAcceptMutationFn = Apollo.MutationFunction<AuthInvitationAcceptMutation, AuthInvitationAcceptMutationVariables>;

/**
 * __useAuthInvitationAcceptMutation__
 *
 * To run a mutation, you first call `useAuthInvitationAcceptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthInvitationAcceptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authInvitationAcceptMutation, { data, loading, error }] = useAuthInvitationAcceptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthInvitationAcceptMutation(baseOptions?: Apollo.MutationHookOptions<AuthInvitationAcceptMutation, AuthInvitationAcceptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthInvitationAcceptMutation, AuthInvitationAcceptMutationVariables>(AuthInvitationAcceptDocument, options);
      }
export type AuthInvitationAcceptMutationHookResult = ReturnType<typeof useAuthInvitationAcceptMutation>;
export type AuthInvitationAcceptMutationResult = Apollo.MutationResult<AuthInvitationAcceptMutation>;
export type AuthInvitationAcceptMutationOptions = Apollo.BaseMutationOptions<AuthInvitationAcceptMutation, AuthInvitationAcceptMutationVariables>;
export const AuthInvitationsDocument = gql`
    query authInvitations($filters: InvitationsQueryFilter!, $pagination: InvitationsPagination!, $sort: InvitationsQuerySort!) {
  invitationsPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      ...UserInvitationInfoType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${UserInvitationInfoTypeFragmentDoc}`;

/**
 * __useAuthInvitationsQuery__
 *
 * To run a query within a React component, call `useAuthInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthInvitationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAuthInvitationsQuery(baseOptions: Apollo.QueryHookOptions<AuthInvitationsQuery, AuthInvitationsQueryVariables> & ({ variables: AuthInvitationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthInvitationsQuery, AuthInvitationsQueryVariables>(AuthInvitationsDocument, options);
      }
export function useAuthInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthInvitationsQuery, AuthInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthInvitationsQuery, AuthInvitationsQueryVariables>(AuthInvitationsDocument, options);
        }
// @ts-ignore
export function useAuthInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthInvitationsQuery, AuthInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthInvitationsQuery, AuthInvitationsQueryVariables>;
export function useAuthInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthInvitationsQuery, AuthInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<AuthInvitationsQuery | undefined, AuthInvitationsQueryVariables>;
export function useAuthInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthInvitationsQuery, AuthInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthInvitationsQuery, AuthInvitationsQueryVariables>(AuthInvitationsDocument, options);
        }
export type AuthInvitationsQueryHookResult = ReturnType<typeof useAuthInvitationsQuery>;
export type AuthInvitationsLazyQueryHookResult = ReturnType<typeof useAuthInvitationsLazyQuery>;
export type AuthInvitationsSuspenseQueryHookResult = ReturnType<typeof useAuthInvitationsSuspenseQuery>;
export type AuthInvitationsQueryResult = Apollo.QueryResult<AuthInvitationsQuery, AuthInvitationsQueryVariables>;
export const AuthCompanyRemoveUserDocument = gql`
    mutation authCompanyRemoveUser($input: CompanyRemoveUserMutationInput!) {
  companyRemoveUser(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type AuthCompanyRemoveUserMutationFn = Apollo.MutationFunction<AuthCompanyRemoveUserMutation, AuthCompanyRemoveUserMutationVariables>;

/**
 * __useAuthCompanyRemoveUserMutation__
 *
 * To run a mutation, you first call `useAuthCompanyRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthCompanyRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authCompanyRemoveUserMutation, { data, loading, error }] = useAuthCompanyRemoveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthCompanyRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<AuthCompanyRemoveUserMutation, AuthCompanyRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthCompanyRemoveUserMutation, AuthCompanyRemoveUserMutationVariables>(AuthCompanyRemoveUserDocument, options);
      }
export type AuthCompanyRemoveUserMutationHookResult = ReturnType<typeof useAuthCompanyRemoveUserMutation>;
export type AuthCompanyRemoveUserMutationResult = Apollo.MutationResult<AuthCompanyRemoveUserMutation>;
export type AuthCompanyRemoveUserMutationOptions = Apollo.BaseMutationOptions<AuthCompanyRemoveUserMutation, AuthCompanyRemoveUserMutationVariables>;
export const AuthBusinessSpheresDocument = gql`
    query authBusinessSpheres($pagination: BusinessSpheresQueryPagination!, $sort: BusinessSpheresQuerySort) {
  result: businessSpheresPaginationQuery(pagination: $pagination, sort: $sort) {
    result {
      id
      title
    }
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
  }
}
    `;

/**
 * __useAuthBusinessSpheresQuery__
 *
 * To run a query within a React component, call `useAuthBusinessSpheresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthBusinessSpheresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthBusinessSpheresQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAuthBusinessSpheresQuery(baseOptions: Apollo.QueryHookOptions<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables> & ({ variables: AuthBusinessSpheresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>(AuthBusinessSpheresDocument, options);
      }
export function useAuthBusinessSpheresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>(AuthBusinessSpheresDocument, options);
        }
// @ts-ignore
export function useAuthBusinessSpheresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>): Apollo.UseSuspenseQueryResult<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>;
export function useAuthBusinessSpheresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>): Apollo.UseSuspenseQueryResult<AuthBusinessSpheresQuery | undefined, AuthBusinessSpheresQueryVariables>;
export function useAuthBusinessSpheresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>(AuthBusinessSpheresDocument, options);
        }
export type AuthBusinessSpheresQueryHookResult = ReturnType<typeof useAuthBusinessSpheresQuery>;
export type AuthBusinessSpheresLazyQueryHookResult = ReturnType<typeof useAuthBusinessSpheresLazyQuery>;
export type AuthBusinessSpheresSuspenseQueryHookResult = ReturnType<typeof useAuthBusinessSpheresSuspenseQuery>;
export type AuthBusinessSpheresQueryResult = Apollo.QueryResult<AuthBusinessSpheresQuery, AuthBusinessSpheresQueryVariables>;
export const CaptchaSettingsQueryDocument = gql`
    query captchaSettingsQuery {
  captchaSettings {
    enabled
    countries
  }
}
    `;

/**
 * __useCaptchaSettingsQueryQuery__
 *
 * To run a query within a React component, call `useCaptchaSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaptchaSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaptchaSettingsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCaptchaSettingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>(CaptchaSettingsQueryDocument, options);
      }
export function useCaptchaSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>(CaptchaSettingsQueryDocument, options);
        }
// @ts-ignore
export function useCaptchaSettingsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>;
export function useCaptchaSettingsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<CaptchaSettingsQueryQuery | undefined, CaptchaSettingsQueryQueryVariables>;
export function useCaptchaSettingsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>(CaptchaSettingsQueryDocument, options);
        }
export type CaptchaSettingsQueryQueryHookResult = ReturnType<typeof useCaptchaSettingsQueryQuery>;
export type CaptchaSettingsQueryLazyQueryHookResult = ReturnType<typeof useCaptchaSettingsQueryLazyQuery>;
export type CaptchaSettingsQuerySuspenseQueryHookResult = ReturnType<typeof useCaptchaSettingsQuerySuspenseQuery>;
export type CaptchaSettingsQueryQueryResult = Apollo.QueryResult<CaptchaSettingsQueryQuery, CaptchaSettingsQueryQueryVariables>;
export const AuthActivationCodeSmsStatusDocument = gql`
    query authActivationCodeSmsStatus($phone: String!) {
  result: activationCodeSmsStatus(phone: $phone)
}
    `;

/**
 * __useAuthActivationCodeSmsStatusQuery__
 *
 * To run a query within a React component, call `useAuthActivationCodeSmsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthActivationCodeSmsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthActivationCodeSmsStatusQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useAuthActivationCodeSmsStatusQuery(baseOptions: Apollo.QueryHookOptions<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables> & ({ variables: AuthActivationCodeSmsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>(AuthActivationCodeSmsStatusDocument, options);
      }
export function useAuthActivationCodeSmsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>(AuthActivationCodeSmsStatusDocument, options);
        }
// @ts-ignore
export function useAuthActivationCodeSmsStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>): Apollo.UseSuspenseQueryResult<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>;
export function useAuthActivationCodeSmsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>): Apollo.UseSuspenseQueryResult<AuthActivationCodeSmsStatusQuery | undefined, AuthActivationCodeSmsStatusQueryVariables>;
export function useAuthActivationCodeSmsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>(AuthActivationCodeSmsStatusDocument, options);
        }
export type AuthActivationCodeSmsStatusQueryHookResult = ReturnType<typeof useAuthActivationCodeSmsStatusQuery>;
export type AuthActivationCodeSmsStatusLazyQueryHookResult = ReturnType<typeof useAuthActivationCodeSmsStatusLazyQuery>;
export type AuthActivationCodeSmsStatusSuspenseQueryHookResult = ReturnType<typeof useAuthActivationCodeSmsStatusSuspenseQuery>;
export type AuthActivationCodeSmsStatusQueryResult = Apollo.QueryResult<AuthActivationCodeSmsStatusQuery, AuthActivationCodeSmsStatusQueryVariables>;
export const AuthContractAcceptMigrationDocument = gql`
    mutation authContractAcceptMigration($input: ContractAcceptMigrationMutationInput!) {
  contractAcceptMigration(input: $input) {
    ok
  }
}
    `;
export type AuthContractAcceptMigrationMutationFn = Apollo.MutationFunction<AuthContractAcceptMigrationMutation, AuthContractAcceptMigrationMutationVariables>;

/**
 * __useAuthContractAcceptMigrationMutation__
 *
 * To run a mutation, you first call `useAuthContractAcceptMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthContractAcceptMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authContractAcceptMigrationMutation, { data, loading, error }] = useAuthContractAcceptMigrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthContractAcceptMigrationMutation(baseOptions?: Apollo.MutationHookOptions<AuthContractAcceptMigrationMutation, AuthContractAcceptMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthContractAcceptMigrationMutation, AuthContractAcceptMigrationMutationVariables>(AuthContractAcceptMigrationDocument, options);
      }
export type AuthContractAcceptMigrationMutationHookResult = ReturnType<typeof useAuthContractAcceptMigrationMutation>;
export type AuthContractAcceptMigrationMutationResult = Apollo.MutationResult<AuthContractAcceptMigrationMutation>;
export type AuthContractAcceptMigrationMutationOptions = Apollo.BaseMutationOptions<AuthContractAcceptMigrationMutation, AuthContractAcceptMigrationMutationVariables>;
export const AuthAmoSyncDataDocument = gql`
    mutation authAmoSyncData($input: AmoSyncDataMutationInput!) {
  amoSyncData(input: $input) {
    ok
  }
}
    `;
export type AuthAmoSyncDataMutationFn = Apollo.MutationFunction<AuthAmoSyncDataMutation, AuthAmoSyncDataMutationVariables>;

/**
 * __useAuthAmoSyncDataMutation__
 *
 * To run a mutation, you first call `useAuthAmoSyncDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthAmoSyncDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authAmoSyncDataMutation, { data, loading, error }] = useAuthAmoSyncDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthAmoSyncDataMutation(baseOptions?: Apollo.MutationHookOptions<AuthAmoSyncDataMutation, AuthAmoSyncDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthAmoSyncDataMutation, AuthAmoSyncDataMutationVariables>(AuthAmoSyncDataDocument, options);
      }
export type AuthAmoSyncDataMutationHookResult = ReturnType<typeof useAuthAmoSyncDataMutation>;
export type AuthAmoSyncDataMutationResult = Apollo.MutationResult<AuthAmoSyncDataMutation>;
export type AuthAmoSyncDataMutationOptions = Apollo.BaseMutationOptions<AuthAmoSyncDataMutation, AuthAmoSyncDataMutationVariables>;
export const AuthCodeCreateDocument = gql`
    mutation authCodeCreate($input: AuthorizationCodeCreateMutationInput!) {
  authorizationCodeCreate(input: $input) {
    ok
    errors {
      messages
    }
    codeData {
      isActive
      phone
      created
    }
  }
}
    `;
export type AuthCodeCreateMutationFn = Apollo.MutationFunction<AuthCodeCreateMutation, AuthCodeCreateMutationVariables>;

/**
 * __useAuthCodeCreateMutation__
 *
 * To run a mutation, you first call `useAuthCodeCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthCodeCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authCodeCreateMutation, { data, loading, error }] = useAuthCodeCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthCodeCreateMutation(baseOptions?: Apollo.MutationHookOptions<AuthCodeCreateMutation, AuthCodeCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthCodeCreateMutation, AuthCodeCreateMutationVariables>(AuthCodeCreateDocument, options);
      }
export type AuthCodeCreateMutationHookResult = ReturnType<typeof useAuthCodeCreateMutation>;
export type AuthCodeCreateMutationResult = Apollo.MutationResult<AuthCodeCreateMutation>;
export type AuthCodeCreateMutationOptions = Apollo.BaseMutationOptions<AuthCodeCreateMutation, AuthCodeCreateMutationVariables>;
export const AuthUserPureUpdateDocument = gql`
    mutation authUserPureUpdate($input: UserPureUpdateMutationInput!) {
  userPureUpdate(input: $input) {
    ok
    errors {
      messages
    }
    user {
      ...UserInfoType
    }
  }
}
    ${UserInfoTypeFragmentDoc}`;
export type AuthUserPureUpdateMutationFn = Apollo.MutationFunction<AuthUserPureUpdateMutation, AuthUserPureUpdateMutationVariables>;

/**
 * __useAuthUserPureUpdateMutation__
 *
 * To run a mutation, you first call `useAuthUserPureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUserPureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUserPureUpdateMutation, { data, loading, error }] = useAuthUserPureUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthUserPureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AuthUserPureUpdateMutation, AuthUserPureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUserPureUpdateMutation, AuthUserPureUpdateMutationVariables>(AuthUserPureUpdateDocument, options);
      }
export type AuthUserPureUpdateMutationHookResult = ReturnType<typeof useAuthUserPureUpdateMutation>;
export type AuthUserPureUpdateMutationResult = Apollo.MutationResult<AuthUserPureUpdateMutation>;
export type AuthUserPureUpdateMutationOptions = Apollo.BaseMutationOptions<AuthUserPureUpdateMutation, AuthUserPureUpdateMutationVariables>;
export const AuthUserPureSignUpByPhoneDocument = gql`
    mutation authUserPureSignUpByPhone($input: UserPureSignUpByPhoneMutationInput!) {
  userPureSignUpByPhone(input: $input) {
    ok
    errors {
      messages
    }
    token {
      value
    }
    user {
      ...UserInfoType
    }
  }
}
    ${UserInfoTypeFragmentDoc}`;
export type AuthUserPureSignUpByPhoneMutationFn = Apollo.MutationFunction<AuthUserPureSignUpByPhoneMutation, AuthUserPureSignUpByPhoneMutationVariables>;

/**
 * __useAuthUserPureSignUpByPhoneMutation__
 *
 * To run a mutation, you first call `useAuthUserPureSignUpByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthUserPureSignUpByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authUserPureSignUpByPhoneMutation, { data, loading, error }] = useAuthUserPureSignUpByPhoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthUserPureSignUpByPhoneMutation(baseOptions?: Apollo.MutationHookOptions<AuthUserPureSignUpByPhoneMutation, AuthUserPureSignUpByPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthUserPureSignUpByPhoneMutation, AuthUserPureSignUpByPhoneMutationVariables>(AuthUserPureSignUpByPhoneDocument, options);
      }
export type AuthUserPureSignUpByPhoneMutationHookResult = ReturnType<typeof useAuthUserPureSignUpByPhoneMutation>;
export type AuthUserPureSignUpByPhoneMutationResult = Apollo.MutationResult<AuthUserPureSignUpByPhoneMutation>;
export type AuthUserPureSignUpByPhoneMutationOptions = Apollo.BaseMutationOptions<AuthUserPureSignUpByPhoneMutation, AuthUserPureSignUpByPhoneMutationVariables>;
export const AuthCodeTokenDocument = gql`
    mutation authCodeToken($input: JwtTokenAuthWithCodePureMutationInput!) {
  jwtTokenAuthWithCode(input: $input) {
    ok
    errors {
      messages
    }
    token {
      value
    }
    user {
      ...UserInfoType
    }
  }
}
    ${UserInfoTypeFragmentDoc}`;
export type AuthCodeTokenMutationFn = Apollo.MutationFunction<AuthCodeTokenMutation, AuthCodeTokenMutationVariables>;

/**
 * __useAuthCodeTokenMutation__
 *
 * To run a mutation, you first call `useAuthCodeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthCodeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authCodeTokenMutation, { data, loading, error }] = useAuthCodeTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthCodeTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthCodeTokenMutation, AuthCodeTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthCodeTokenMutation, AuthCodeTokenMutationVariables>(AuthCodeTokenDocument, options);
      }
export type AuthCodeTokenMutationHookResult = ReturnType<typeof useAuthCodeTokenMutation>;
export type AuthCodeTokenMutationResult = Apollo.MutationResult<AuthCodeTokenMutation>;
export type AuthCodeTokenMutationOptions = Apollo.BaseMutationOptions<AuthCodeTokenMutation, AuthCodeTokenMutationVariables>;
export const CompanyUpdateDocument = gql`
    mutation companyUpdate($input: UserCompanyUpdateMutationInput!) {
  userCompanyUpdate(input: $input) {
    ok
    errors {
      messages
      field
    }
    company {
      ...UserCompanyShortType
      marketingMaterialsAgreementReceived
    }
  }
}
    ${UserCompanyShortTypeFragmentDoc}`;
export type CompanyUpdateMutationFn = Apollo.MutationFunction<CompanyUpdateMutation, CompanyUpdateMutationVariables>;

/**
 * __useCompanyUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateMutation, { data, loading, error }] = useCompanyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyUpdateMutation, CompanyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyUpdateMutation, CompanyUpdateMutationVariables>(CompanyUpdateDocument, options);
      }
export type CompanyUpdateMutationHookResult = ReturnType<typeof useCompanyUpdateMutation>;
export type CompanyUpdateMutationResult = Apollo.MutationResult<CompanyUpdateMutation>;
export type CompanyUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyUpdateMutation, CompanyUpdateMutationVariables>;
export const CompanyExistDocument = gql`
    query companyExist($inn: String, $kpp: String, $bin: String, $iin: String, $unp: String) {
  result: userCompanyExistQuery(
    inn: $inn
    kpp: $kpp
    bin: $bin
    iin: $iin
    unp: $unp
  )
}
    `;

/**
 * __useCompanyExistQuery__
 *
 * To run a query within a React component, call `useCompanyExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyExistQuery({
 *   variables: {
 *      inn: // value for 'inn'
 *      kpp: // value for 'kpp'
 *      bin: // value for 'bin'
 *      iin: // value for 'iin'
 *      unp: // value for 'unp'
 *   },
 * });
 */
export function useCompanyExistQuery(baseOptions?: Apollo.QueryHookOptions<CompanyExistQuery, CompanyExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyExistQuery, CompanyExistQueryVariables>(CompanyExistDocument, options);
      }
export function useCompanyExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyExistQuery, CompanyExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyExistQuery, CompanyExistQueryVariables>(CompanyExistDocument, options);
        }
// @ts-ignore
export function useCompanyExistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyExistQuery, CompanyExistQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyExistQuery, CompanyExistQueryVariables>;
export function useCompanyExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyExistQuery, CompanyExistQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyExistQuery | undefined, CompanyExistQueryVariables>;
export function useCompanyExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyExistQuery, CompanyExistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyExistQuery, CompanyExistQueryVariables>(CompanyExistDocument, options);
        }
export type CompanyExistQueryHookResult = ReturnType<typeof useCompanyExistQuery>;
export type CompanyExistLazyQueryHookResult = ReturnType<typeof useCompanyExistLazyQuery>;
export type CompanyExistSuspenseQueryHookResult = ReturnType<typeof useCompanyExistSuspenseQuery>;
export type CompanyExistQueryResult = Apollo.QueryResult<CompanyExistQuery, CompanyExistQueryVariables>;
export const AutocompleteSuggestionCompanyDocument = gql`
    query autocompleteSuggestionCompany($input: SuggestionCompanyQueryPureType!) {
  userPureSuggestionCompany(input: $input) {
    result {
      inn
      address
      city
      fullName
      kpp
      name
      ogrn
      bin
      unp
      region
      shortName
      organizationType
      management {
        name
        post
      }
    }
  }
}
    `;

/**
 * __useAutocompleteSuggestionCompanyQuery__
 *
 * To run a query within a React component, call `useAutocompleteSuggestionCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteSuggestionCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteSuggestionCompanyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutocompleteSuggestionCompanyQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables> & ({ variables: AutocompleteSuggestionCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>(AutocompleteSuggestionCompanyDocument, options);
      }
export function useAutocompleteSuggestionCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>(AutocompleteSuggestionCompanyDocument, options);
        }
// @ts-ignore
export function useAutocompleteSuggestionCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>;
export function useAutocompleteSuggestionCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<AutocompleteSuggestionCompanyQuery | undefined, AutocompleteSuggestionCompanyQueryVariables>;
export function useAutocompleteSuggestionCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>(AutocompleteSuggestionCompanyDocument, options);
        }
export type AutocompleteSuggestionCompanyQueryHookResult = ReturnType<typeof useAutocompleteSuggestionCompanyQuery>;
export type AutocompleteSuggestionCompanyLazyQueryHookResult = ReturnType<typeof useAutocompleteSuggestionCompanyLazyQuery>;
export type AutocompleteSuggestionCompanySuspenseQueryHookResult = ReturnType<typeof useAutocompleteSuggestionCompanySuspenseQuery>;
export type AutocompleteSuggestionCompanyQueryResult = Apollo.QueryResult<AutocompleteSuggestionCompanyQuery, AutocompleteSuggestionCompanyQueryVariables>;
export const AutocompleteSuggestionAddressDocument = gql`
    query autocompleteSuggestionAddress($input: SuggestionAddressQueryPureType!) {
  userPureSuggestionAddress(input: $input) {
    result {
      value
    }
  }
}
    `;

/**
 * __useAutocompleteSuggestionAddressQuery__
 *
 * To run a query within a React component, call `useAutocompleteSuggestionAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteSuggestionAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteSuggestionAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutocompleteSuggestionAddressQuery(baseOptions: Apollo.QueryHookOptions<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables> & ({ variables: AutocompleteSuggestionAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>(AutocompleteSuggestionAddressDocument, options);
      }
export function useAutocompleteSuggestionAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>(AutocompleteSuggestionAddressDocument, options);
        }
// @ts-ignore
export function useAutocompleteSuggestionAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>): Apollo.UseSuspenseQueryResult<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>;
export function useAutocompleteSuggestionAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>): Apollo.UseSuspenseQueryResult<AutocompleteSuggestionAddressQuery | undefined, AutocompleteSuggestionAddressQueryVariables>;
export function useAutocompleteSuggestionAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>(AutocompleteSuggestionAddressDocument, options);
        }
export type AutocompleteSuggestionAddressQueryHookResult = ReturnType<typeof useAutocompleteSuggestionAddressQuery>;
export type AutocompleteSuggestionAddressLazyQueryHookResult = ReturnType<typeof useAutocompleteSuggestionAddressLazyQuery>;
export type AutocompleteSuggestionAddressSuspenseQueryHookResult = ReturnType<typeof useAutocompleteSuggestionAddressSuspenseQuery>;
export type AutocompleteSuggestionAddressQueryResult = Apollo.QueryResult<AutocompleteSuggestionAddressQuery, AutocompleteSuggestionAddressQueryVariables>;
export const OrganizationPricePlanDocument = gql`
    query organizationPricePlan($organizationId: ID!) {
  organizationPricePlanQuery(organizationId: $organizationId) {
    ...PricePlanInfoType
  }
}
    ${PricePlanInfoTypeFragmentDoc}`;

/**
 * __useOrganizationPricePlanQuery__
 *
 * To run a query within a React component, call `useOrganizationPricePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPricePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPricePlanQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationPricePlanQuery(baseOptions: Apollo.QueryHookOptions<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables> & ({ variables: OrganizationPricePlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>(OrganizationPricePlanDocument, options);
      }
export function useOrganizationPricePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>(OrganizationPricePlanDocument, options);
        }
// @ts-ignore
export function useOrganizationPricePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>;
export function useOrganizationPricePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationPricePlanQuery | undefined, OrganizationPricePlanQueryVariables>;
export function useOrganizationPricePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>(OrganizationPricePlanDocument, options);
        }
export type OrganizationPricePlanQueryHookResult = ReturnType<typeof useOrganizationPricePlanQuery>;
export type OrganizationPricePlanLazyQueryHookResult = ReturnType<typeof useOrganizationPricePlanLazyQuery>;
export type OrganizationPricePlanSuspenseQueryHookResult = ReturnType<typeof useOrganizationPricePlanSuspenseQuery>;
export type OrganizationPricePlanQueryResult = Apollo.QueryResult<OrganizationPricePlanQuery, OrganizationPricePlanQueryVariables>;
export const BillingLaunchSubscriptionDocument = gql`
    mutation billingLaunchSubscription($input: LaunchSubscriptionMutationInput!) {
  launchSubscription(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingLaunchSubscriptionMutationFn = Apollo.MutationFunction<BillingLaunchSubscriptionMutation, BillingLaunchSubscriptionMutationVariables>;

/**
 * __useBillingLaunchSubscriptionMutation__
 *
 * To run a mutation, you first call `useBillingLaunchSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingLaunchSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingLaunchSubscriptionMutation, { data, loading, error }] = useBillingLaunchSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingLaunchSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<BillingLaunchSubscriptionMutation, BillingLaunchSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingLaunchSubscriptionMutation, BillingLaunchSubscriptionMutationVariables>(BillingLaunchSubscriptionDocument, options);
      }
export type BillingLaunchSubscriptionMutationHookResult = ReturnType<typeof useBillingLaunchSubscriptionMutation>;
export type BillingLaunchSubscriptionMutationResult = Apollo.MutationResult<BillingLaunchSubscriptionMutation>;
export type BillingLaunchSubscriptionMutationOptions = Apollo.BaseMutationOptions<BillingLaunchSubscriptionMutation, BillingLaunchSubscriptionMutationVariables>;
export const BillingExtendSubscriptionDocument = gql`
    mutation billingExtendSubscription($input: ExtendSubscriptionMutationInput!) {
  extendSubscription(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingExtendSubscriptionMutationFn = Apollo.MutationFunction<BillingExtendSubscriptionMutation, BillingExtendSubscriptionMutationVariables>;

/**
 * __useBillingExtendSubscriptionMutation__
 *
 * To run a mutation, you first call `useBillingExtendSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingExtendSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingExtendSubscriptionMutation, { data, loading, error }] = useBillingExtendSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingExtendSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<BillingExtendSubscriptionMutation, BillingExtendSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingExtendSubscriptionMutation, BillingExtendSubscriptionMutationVariables>(BillingExtendSubscriptionDocument, options);
      }
export type BillingExtendSubscriptionMutationHookResult = ReturnType<typeof useBillingExtendSubscriptionMutation>;
export type BillingExtendSubscriptionMutationResult = Apollo.MutationResult<BillingExtendSubscriptionMutation>;
export type BillingExtendSubscriptionMutationOptions = Apollo.BaseMutationOptions<BillingExtendSubscriptionMutation, BillingExtendSubscriptionMutationVariables>;
export const BillingLicensesDocument = gql`
    query billingLicenses($filters: LicensesQueryFilter!, $pagination: LicensesQueryPagination!, $sort: LicensesQuerySort!) {
  result: licensesPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      ...LicenseInfoType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${LicenseInfoTypeFragmentDoc}`;

/**
 * __useBillingLicensesQuery__
 *
 * To run a query within a React component, call `useBillingLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingLicensesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBillingLicensesQuery(baseOptions: Apollo.QueryHookOptions<BillingLicensesQuery, BillingLicensesQueryVariables> & ({ variables: BillingLicensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingLicensesQuery, BillingLicensesQueryVariables>(BillingLicensesDocument, options);
      }
export function useBillingLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingLicensesQuery, BillingLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingLicensesQuery, BillingLicensesQueryVariables>(BillingLicensesDocument, options);
        }
// @ts-ignore
export function useBillingLicensesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingLicensesQuery, BillingLicensesQueryVariables>): Apollo.UseSuspenseQueryResult<BillingLicensesQuery, BillingLicensesQueryVariables>;
export function useBillingLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingLicensesQuery, BillingLicensesQueryVariables>): Apollo.UseSuspenseQueryResult<BillingLicensesQuery | undefined, BillingLicensesQueryVariables>;
export function useBillingLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingLicensesQuery, BillingLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingLicensesQuery, BillingLicensesQueryVariables>(BillingLicensesDocument, options);
        }
export type BillingLicensesQueryHookResult = ReturnType<typeof useBillingLicensesQuery>;
export type BillingLicensesLazyQueryHookResult = ReturnType<typeof useBillingLicensesLazyQuery>;
export type BillingLicensesSuspenseQueryHookResult = ReturnType<typeof useBillingLicensesSuspenseQuery>;
export type BillingLicensesQueryResult = Apollo.QueryResult<BillingLicensesQuery, BillingLicensesQueryVariables>;
export const BillingCompanyBillingInfoDocument = gql`
    query billingCompanyBillingInfo($companyId: ID!) {
  result: companyBillingInfoQuery(companyId: $companyId) {
    status
    firstPaidAt
    nextBillingDate
    nextBillingAmount
    nextBillingPriceAmount
    fullPeriodAmount
    fullPeriodAmountWithDiscount
    renewableLicenses {
      ...LicenseInfoType
    }
    nonRenewableLicenses {
      ...LicenseInfoType
    }
    unpaidLicenses {
      ...LicenseInfoType
    }
    discount {
      ...CompanyDiscountInfoType
    }
    selectedPaymentKind
    paymentScheme
    isBillingEnabled @client
    hasTrialLicenses @client
    hasActiveLicenses @client
    hasInactiveLicenses @client
    hasWaitPaymentLicenses @client
    hasGraceLicenses @client
    expiresLicenseDate @client
    nextBillingLicenses @client {
      ...LicenseInfoType
    }
    totalLicenses @client {
      ...LicenseInfoType
    }
    isLastInvoiceHasZeroAmount @client
    isWaitPaymentLicense @client
    isGraceLicense @client
    paymentMethod @client {
      ...PaymentMethodInfoType
    }
    canRealizeBillingOperation @client
    canRealizeBillingOperationWithPayment @client
    hasRenewableLicenses @client
    hasNonRenewableLicenses @client
  }
}
    ${LicenseInfoTypeFragmentDoc}
${CompanyDiscountInfoTypeFragmentDoc}
${PaymentMethodInfoTypeFragmentDoc}`;

/**
 * __useBillingCompanyBillingInfoQuery__
 *
 * To run a query within a React component, call `useBillingCompanyBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingCompanyBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingCompanyBillingInfoQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillingCompanyBillingInfoQuery(baseOptions: Apollo.QueryHookOptions<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables> & ({ variables: BillingCompanyBillingInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>(BillingCompanyBillingInfoDocument, options);
      }
export function useBillingCompanyBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>(BillingCompanyBillingInfoDocument, options);
        }
// @ts-ignore
export function useBillingCompanyBillingInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>): Apollo.UseSuspenseQueryResult<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>;
export function useBillingCompanyBillingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>): Apollo.UseSuspenseQueryResult<BillingCompanyBillingInfoQuery | undefined, BillingCompanyBillingInfoQueryVariables>;
export function useBillingCompanyBillingInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>(BillingCompanyBillingInfoDocument, options);
        }
export type BillingCompanyBillingInfoQueryHookResult = ReturnType<typeof useBillingCompanyBillingInfoQuery>;
export type BillingCompanyBillingInfoLazyQueryHookResult = ReturnType<typeof useBillingCompanyBillingInfoLazyQuery>;
export type BillingCompanyBillingInfoSuspenseQueryHookResult = ReturnType<typeof useBillingCompanyBillingInfoSuspenseQuery>;
export type BillingCompanyBillingInfoQueryResult = Apollo.QueryResult<BillingCompanyBillingInfoQuery, BillingCompanyBillingInfoQueryVariables>;
export const BillingLicensesSendSuspendAutoRenewalDocument = gql`
    mutation billingLicensesSendSuspendAutoRenewal($input: LicensesSuspendAutoRenewalMutationInput!) {
  result: licensesSuspendAutoRenewal(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingLicensesSendSuspendAutoRenewalMutationFn = Apollo.MutationFunction<BillingLicensesSendSuspendAutoRenewalMutation, BillingLicensesSendSuspendAutoRenewalMutationVariables>;

/**
 * __useBillingLicensesSendSuspendAutoRenewalMutation__
 *
 * To run a mutation, you first call `useBillingLicensesSendSuspendAutoRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingLicensesSendSuspendAutoRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingLicensesSendSuspendAutoRenewalMutation, { data, loading, error }] = useBillingLicensesSendSuspendAutoRenewalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingLicensesSendSuspendAutoRenewalMutation(baseOptions?: Apollo.MutationHookOptions<BillingLicensesSendSuspendAutoRenewalMutation, BillingLicensesSendSuspendAutoRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingLicensesSendSuspendAutoRenewalMutation, BillingLicensesSendSuspendAutoRenewalMutationVariables>(BillingLicensesSendSuspendAutoRenewalDocument, options);
      }
export type BillingLicensesSendSuspendAutoRenewalMutationHookResult = ReturnType<typeof useBillingLicensesSendSuspendAutoRenewalMutation>;
export type BillingLicensesSendSuspendAutoRenewalMutationResult = Apollo.MutationResult<BillingLicensesSendSuspendAutoRenewalMutation>;
export type BillingLicensesSendSuspendAutoRenewalMutationOptions = Apollo.BaseMutationOptions<BillingLicensesSendSuspendAutoRenewalMutation, BillingLicensesSendSuspendAutoRenewalMutationVariables>;
export const BillingLicensesSendResumeAutoRenewalDocument = gql`
    mutation billingLicensesSendResumeAutoRenewal($input: LicensesResumeAutoRenewalMutationInput!) {
  result: licensesResumeAutoRenewal(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingLicensesSendResumeAutoRenewalMutationFn = Apollo.MutationFunction<BillingLicensesSendResumeAutoRenewalMutation, BillingLicensesSendResumeAutoRenewalMutationVariables>;

/**
 * __useBillingLicensesSendResumeAutoRenewalMutation__
 *
 * To run a mutation, you first call `useBillingLicensesSendResumeAutoRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingLicensesSendResumeAutoRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingLicensesSendResumeAutoRenewalMutation, { data, loading, error }] = useBillingLicensesSendResumeAutoRenewalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingLicensesSendResumeAutoRenewalMutation(baseOptions?: Apollo.MutationHookOptions<BillingLicensesSendResumeAutoRenewalMutation, BillingLicensesSendResumeAutoRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingLicensesSendResumeAutoRenewalMutation, BillingLicensesSendResumeAutoRenewalMutationVariables>(BillingLicensesSendResumeAutoRenewalDocument, options);
      }
export type BillingLicensesSendResumeAutoRenewalMutationHookResult = ReturnType<typeof useBillingLicensesSendResumeAutoRenewalMutation>;
export type BillingLicensesSendResumeAutoRenewalMutationResult = Apollo.MutationResult<BillingLicensesSendResumeAutoRenewalMutation>;
export type BillingLicensesSendResumeAutoRenewalMutationOptions = Apollo.BaseMutationOptions<BillingLicensesSendResumeAutoRenewalMutation, BillingLicensesSendResumeAutoRenewalMutationVariables>;
export const CompanyCreateAmoTaskToBillDocument = gql`
    mutation companyCreateAmoTaskToBill($input: CompanyCreateAmoTaskToBillPureMutationInput!) {
  result: companyCreateAmoTaskToBill(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type CompanyCreateAmoTaskToBillMutationFn = Apollo.MutationFunction<CompanyCreateAmoTaskToBillMutation, CompanyCreateAmoTaskToBillMutationVariables>;

/**
 * __useCompanyCreateAmoTaskToBillMutation__
 *
 * To run a mutation, you first call `useCompanyCreateAmoTaskToBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyCreateAmoTaskToBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyCreateAmoTaskToBillMutation, { data, loading, error }] = useCompanyCreateAmoTaskToBillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyCreateAmoTaskToBillMutation(baseOptions?: Apollo.MutationHookOptions<CompanyCreateAmoTaskToBillMutation, CompanyCreateAmoTaskToBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyCreateAmoTaskToBillMutation, CompanyCreateAmoTaskToBillMutationVariables>(CompanyCreateAmoTaskToBillDocument, options);
      }
export type CompanyCreateAmoTaskToBillMutationHookResult = ReturnType<typeof useCompanyCreateAmoTaskToBillMutation>;
export type CompanyCreateAmoTaskToBillMutationResult = Apollo.MutationResult<CompanyCreateAmoTaskToBillMutation>;
export type CompanyCreateAmoTaskToBillMutationOptions = Apollo.BaseMutationOptions<CompanyCreateAmoTaskToBillMutation, CompanyCreateAmoTaskToBillMutationVariables>;
export const ResumeSubscriptionCostDocument = gql`
    query resumeSubscriptionCost($licensesNum: Int!, $organizationId: ID!) {
  result: resumeSubscriptionCostQuery(
    licensesNum: $licensesNum
    organizationId: $organizationId
  ) {
    cost
    costWithDiscount
    fullPeriodCost
  }
}
    `;

/**
 * __useResumeSubscriptionCostQuery__
 *
 * To run a query within a React component, call `useResumeSubscriptionCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResumeSubscriptionCostQuery({
 *   variables: {
 *      licensesNum: // value for 'licensesNum'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useResumeSubscriptionCostQuery(baseOptions: Apollo.QueryHookOptions<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables> & ({ variables: ResumeSubscriptionCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>(ResumeSubscriptionCostDocument, options);
      }
export function useResumeSubscriptionCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>(ResumeSubscriptionCostDocument, options);
        }
// @ts-ignore
export function useResumeSubscriptionCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>): Apollo.UseSuspenseQueryResult<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>;
export function useResumeSubscriptionCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>): Apollo.UseSuspenseQueryResult<ResumeSubscriptionCostQuery | undefined, ResumeSubscriptionCostQueryVariables>;
export function useResumeSubscriptionCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>(ResumeSubscriptionCostDocument, options);
        }
export type ResumeSubscriptionCostQueryHookResult = ReturnType<typeof useResumeSubscriptionCostQuery>;
export type ResumeSubscriptionCostLazyQueryHookResult = ReturnType<typeof useResumeSubscriptionCostLazyQuery>;
export type ResumeSubscriptionCostSuspenseQueryHookResult = ReturnType<typeof useResumeSubscriptionCostSuspenseQuery>;
export type ResumeSubscriptionCostQueryResult = Apollo.QueryResult<ResumeSubscriptionCostQuery, ResumeSubscriptionCostQueryVariables>;
export const SubscriptionExtensionCostDocument = gql`
    query subscriptionExtensionCost($licensesNum: Int!, $companyId: ID!) {
  result: subscriptionExtensionCostQuery(
    licensesNum: $licensesNum
    companyId: $companyId
  ) {
    cost
    fullPeriodCost
  }
}
    `;

/**
 * __useSubscriptionExtensionCostQuery__
 *
 * To run a query within a React component, call `useSubscriptionExtensionCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionExtensionCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionExtensionCostQuery({
 *   variables: {
 *      licensesNum: // value for 'licensesNum'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSubscriptionExtensionCostQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables> & ({ variables: SubscriptionExtensionCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>(SubscriptionExtensionCostDocument, options);
      }
export function useSubscriptionExtensionCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>(SubscriptionExtensionCostDocument, options);
        }
// @ts-ignore
export function useSubscriptionExtensionCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>;
export function useSubscriptionExtensionCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionExtensionCostQuery | undefined, SubscriptionExtensionCostQueryVariables>;
export function useSubscriptionExtensionCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>(SubscriptionExtensionCostDocument, options);
        }
export type SubscriptionExtensionCostQueryHookResult = ReturnType<typeof useSubscriptionExtensionCostQuery>;
export type SubscriptionExtensionCostLazyQueryHookResult = ReturnType<typeof useSubscriptionExtensionCostLazyQuery>;
export type SubscriptionExtensionCostSuspenseQueryHookResult = ReturnType<typeof useSubscriptionExtensionCostSuspenseQuery>;
export type SubscriptionExtensionCostQueryResult = Apollo.QueryResult<SubscriptionExtensionCostQuery, SubscriptionExtensionCostQueryVariables>;
export const BillingSubscriptionCostByPricePlanPeriodDocument = gql`
    query billingSubscriptionCostByPricePlanPeriod($organizationId: ID!, $pricePlanPeriodId: ID!) {
  result: subscriptionCostByPricePlanPeriodQuery(
    organizationId: $organizationId
    pricePlanPeriodId: $pricePlanPeriodId
  )
}
    `;

/**
 * __useBillingSubscriptionCostByPricePlanPeriodQuery__
 *
 * To run a query within a React component, call `useBillingSubscriptionCostByPricePlanPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingSubscriptionCostByPricePlanPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingSubscriptionCostByPricePlanPeriodQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      pricePlanPeriodId: // value for 'pricePlanPeriodId'
 *   },
 * });
 */
export function useBillingSubscriptionCostByPricePlanPeriodQuery(baseOptions: Apollo.QueryHookOptions<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables> & ({ variables: BillingSubscriptionCostByPricePlanPeriodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>(BillingSubscriptionCostByPricePlanPeriodDocument, options);
      }
export function useBillingSubscriptionCostByPricePlanPeriodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>(BillingSubscriptionCostByPricePlanPeriodDocument, options);
        }
// @ts-ignore
export function useBillingSubscriptionCostByPricePlanPeriodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>): Apollo.UseSuspenseQueryResult<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>;
export function useBillingSubscriptionCostByPricePlanPeriodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>): Apollo.UseSuspenseQueryResult<BillingSubscriptionCostByPricePlanPeriodQuery | undefined, BillingSubscriptionCostByPricePlanPeriodQueryVariables>;
export function useBillingSubscriptionCostByPricePlanPeriodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>(BillingSubscriptionCostByPricePlanPeriodDocument, options);
        }
export type BillingSubscriptionCostByPricePlanPeriodQueryHookResult = ReturnType<typeof useBillingSubscriptionCostByPricePlanPeriodQuery>;
export type BillingSubscriptionCostByPricePlanPeriodLazyQueryHookResult = ReturnType<typeof useBillingSubscriptionCostByPricePlanPeriodLazyQuery>;
export type BillingSubscriptionCostByPricePlanPeriodSuspenseQueryHookResult = ReturnType<typeof useBillingSubscriptionCostByPricePlanPeriodSuspenseQuery>;
export type BillingSubscriptionCostByPricePlanPeriodQueryResult = Apollo.QueryResult<BillingSubscriptionCostByPricePlanPeriodQuery, BillingSubscriptionCostByPricePlanPeriodQueryVariables>;
export const BillingExtendSubscriptionRequestDocument = gql`
    mutation billingExtendSubscriptionRequest($input: ExtendSubscriptionRequestMutationInput!) {
  result: extendSubscriptionRequest(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingExtendSubscriptionRequestMutationFn = Apollo.MutationFunction<BillingExtendSubscriptionRequestMutation, BillingExtendSubscriptionRequestMutationVariables>;

/**
 * __useBillingExtendSubscriptionRequestMutation__
 *
 * To run a mutation, you first call `useBillingExtendSubscriptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingExtendSubscriptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingExtendSubscriptionRequestMutation, { data, loading, error }] = useBillingExtendSubscriptionRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingExtendSubscriptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<BillingExtendSubscriptionRequestMutation, BillingExtendSubscriptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingExtendSubscriptionRequestMutation, BillingExtendSubscriptionRequestMutationVariables>(BillingExtendSubscriptionRequestDocument, options);
      }
export type BillingExtendSubscriptionRequestMutationHookResult = ReturnType<typeof useBillingExtendSubscriptionRequestMutation>;
export type BillingExtendSubscriptionRequestMutationResult = Apollo.MutationResult<BillingExtendSubscriptionRequestMutation>;
export type BillingExtendSubscriptionRequestMutationOptions = Apollo.BaseMutationOptions<BillingExtendSubscriptionRequestMutation, BillingExtendSubscriptionRequestMutationVariables>;
export const BillingAcceptanceAdvancedDocument = gql`
    query billingAcceptanceAdvanced($companyId: ID!) {
  acceptanceAdvancedQuery(companyId: $companyId) {
    id
    status
    payerAccount
    cancellationReason
    payerInn
    payerName
    userId
    errorViewedAt
  }
}
    `;

/**
 * __useBillingAcceptanceAdvancedQuery__
 *
 * To run a query within a React component, call `useBillingAcceptanceAdvancedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAcceptanceAdvancedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAcceptanceAdvancedQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillingAcceptanceAdvancedQuery(baseOptions: Apollo.QueryHookOptions<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables> & ({ variables: BillingAcceptanceAdvancedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>(BillingAcceptanceAdvancedDocument, options);
      }
export function useBillingAcceptanceAdvancedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>(BillingAcceptanceAdvancedDocument, options);
        }
// @ts-ignore
export function useBillingAcceptanceAdvancedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>): Apollo.UseSuspenseQueryResult<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>;
export function useBillingAcceptanceAdvancedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>): Apollo.UseSuspenseQueryResult<BillingAcceptanceAdvancedQuery | undefined, BillingAcceptanceAdvancedQueryVariables>;
export function useBillingAcceptanceAdvancedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>(BillingAcceptanceAdvancedDocument, options);
        }
export type BillingAcceptanceAdvancedQueryHookResult = ReturnType<typeof useBillingAcceptanceAdvancedQuery>;
export type BillingAcceptanceAdvancedLazyQueryHookResult = ReturnType<typeof useBillingAcceptanceAdvancedLazyQuery>;
export type BillingAcceptanceAdvancedSuspenseQueryHookResult = ReturnType<typeof useBillingAcceptanceAdvancedSuspenseQuery>;
export type BillingAcceptanceAdvancedQueryResult = Apollo.QueryResult<BillingAcceptanceAdvancedQuery, BillingAcceptanceAdvancedQueryVariables>;
export const BillingMarkAcceptanceErrorAsViewedDocument = gql`
    mutation billingMarkAcceptanceErrorAsViewed($input: MarkAcceptanceErrorAsViewedInput!) {
  result: markAcceptanceErrorAsViewed(input: $input) {
    acceptance {
      errorViewedAt
    }
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingMarkAcceptanceErrorAsViewedMutationFn = Apollo.MutationFunction<BillingMarkAcceptanceErrorAsViewedMutation, BillingMarkAcceptanceErrorAsViewedMutationVariables>;

/**
 * __useBillingMarkAcceptanceErrorAsViewedMutation__
 *
 * To run a mutation, you first call `useBillingMarkAcceptanceErrorAsViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingMarkAcceptanceErrorAsViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingMarkAcceptanceErrorAsViewedMutation, { data, loading, error }] = useBillingMarkAcceptanceErrorAsViewedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingMarkAcceptanceErrorAsViewedMutation(baseOptions?: Apollo.MutationHookOptions<BillingMarkAcceptanceErrorAsViewedMutation, BillingMarkAcceptanceErrorAsViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingMarkAcceptanceErrorAsViewedMutation, BillingMarkAcceptanceErrorAsViewedMutationVariables>(BillingMarkAcceptanceErrorAsViewedDocument, options);
      }
export type BillingMarkAcceptanceErrorAsViewedMutationHookResult = ReturnType<typeof useBillingMarkAcceptanceErrorAsViewedMutation>;
export type BillingMarkAcceptanceErrorAsViewedMutationResult = Apollo.MutationResult<BillingMarkAcceptanceErrorAsViewedMutation>;
export type BillingMarkAcceptanceErrorAsViewedMutationOptions = Apollo.BaseMutationOptions<BillingMarkAcceptanceErrorAsViewedMutation, BillingMarkAcceptanceErrorAsViewedMutationVariables>;
export const BillingAcceptanceAdvancedStartSigningDocument = gql`
    mutation billingAcceptanceAdvancedStartSigning($input: AcceptanceAdvancedStartSigningInput!) {
  result: acceptanceAdvancedStartSigning(input: $input) {
    ok
    errors {
      messages
    }
    confirmLink
  }
}
    `;
export type BillingAcceptanceAdvancedStartSigningMutationFn = Apollo.MutationFunction<BillingAcceptanceAdvancedStartSigningMutation, BillingAcceptanceAdvancedStartSigningMutationVariables>;

/**
 * __useBillingAcceptanceAdvancedStartSigningMutation__
 *
 * To run a mutation, you first call `useBillingAcceptanceAdvancedStartSigningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingAcceptanceAdvancedStartSigningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingAcceptanceAdvancedStartSigningMutation, { data, loading, error }] = useBillingAcceptanceAdvancedStartSigningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingAcceptanceAdvancedStartSigningMutation(baseOptions?: Apollo.MutationHookOptions<BillingAcceptanceAdvancedStartSigningMutation, BillingAcceptanceAdvancedStartSigningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingAcceptanceAdvancedStartSigningMutation, BillingAcceptanceAdvancedStartSigningMutationVariables>(BillingAcceptanceAdvancedStartSigningDocument, options);
      }
export type BillingAcceptanceAdvancedStartSigningMutationHookResult = ReturnType<typeof useBillingAcceptanceAdvancedStartSigningMutation>;
export type BillingAcceptanceAdvancedStartSigningMutationResult = Apollo.MutationResult<BillingAcceptanceAdvancedStartSigningMutation>;
export type BillingAcceptanceAdvancedStartSigningMutationOptions = Apollo.BaseMutationOptions<BillingAcceptanceAdvancedStartSigningMutation, BillingAcceptanceAdvancedStartSigningMutationVariables>;
export const ZvukProfileListDocument = gql`
    query zvukProfileList($companyId: ID!) {
  zvukProfileList(companyId: $companyId) {
    ...BusinessProfileType
  }
}
    ${BusinessProfileTypeFragmentDoc}`;

/**
 * __useZvukProfileListQuery__
 *
 * To run a query within a React component, call `useZvukProfileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZvukProfileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZvukProfileListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useZvukProfileListQuery(baseOptions: Apollo.QueryHookOptions<ZvukProfileListQuery, ZvukProfileListQueryVariables> & ({ variables: ZvukProfileListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZvukProfileListQuery, ZvukProfileListQueryVariables>(ZvukProfileListDocument, options);
      }
export function useZvukProfileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZvukProfileListQuery, ZvukProfileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZvukProfileListQuery, ZvukProfileListQueryVariables>(ZvukProfileListDocument, options);
        }
// @ts-ignore
export function useZvukProfileListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZvukProfileListQuery, ZvukProfileListQueryVariables>): Apollo.UseSuspenseQueryResult<ZvukProfileListQuery, ZvukProfileListQueryVariables>;
export function useZvukProfileListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZvukProfileListQuery, ZvukProfileListQueryVariables>): Apollo.UseSuspenseQueryResult<ZvukProfileListQuery | undefined, ZvukProfileListQueryVariables>;
export function useZvukProfileListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZvukProfileListQuery, ZvukProfileListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZvukProfileListQuery, ZvukProfileListQueryVariables>(ZvukProfileListDocument, options);
        }
export type ZvukProfileListQueryHookResult = ReturnType<typeof useZvukProfileListQuery>;
export type ZvukProfileListLazyQueryHookResult = ReturnType<typeof useZvukProfileListLazyQuery>;
export type ZvukProfileListSuspenseQueryHookResult = ReturnType<typeof useZvukProfileListSuspenseQuery>;
export type ZvukProfileListQueryResult = Apollo.QueryResult<ZvukProfileListQuery, ZvukProfileListQueryVariables>;
export const BusinessProfileCreateDocument = gql`
    mutation businessProfileCreate($input: ZvukProfileCreateMutationInput!) {
  zvukProfileCreate(input: $input) {
    ok
    errors {
      field
      messages
    }
    profile {
      ...BusinessProfileType
    }
  }
}
    ${BusinessProfileTypeFragmentDoc}`;
export type BusinessProfileCreateMutationFn = Apollo.MutationFunction<BusinessProfileCreateMutation, BusinessProfileCreateMutationVariables>;

/**
 * __useBusinessProfileCreateMutation__
 *
 * To run a mutation, you first call `useBusinessProfileCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileCreateMutation, { data, loading, error }] = useBusinessProfileCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileCreateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileCreateMutation, BusinessProfileCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileCreateMutation, BusinessProfileCreateMutationVariables>(BusinessProfileCreateDocument, options);
      }
export type BusinessProfileCreateMutationHookResult = ReturnType<typeof useBusinessProfileCreateMutation>;
export type BusinessProfileCreateMutationResult = Apollo.MutationResult<BusinessProfileCreateMutation>;
export type BusinessProfileCreateMutationOptions = Apollo.BaseMutationOptions<BusinessProfileCreateMutation, BusinessProfileCreateMutationVariables>;
export const BusinessProfileUpdateDocument = gql`
    mutation businessProfileUpdate($input: ZvukProfileUpdateMutationInput!) {
  zvukProfileUpdate(input: $input) {
    ok
    errors {
      field
      messages
    }
    profile {
      ...BusinessProfileType
    }
  }
}
    ${BusinessProfileTypeFragmentDoc}`;
export type BusinessProfileUpdateMutationFn = Apollo.MutationFunction<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>;

/**
 * __useBusinessProfileUpdateMutation__
 *
 * To run a mutation, you first call `useBusinessProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileUpdateMutation, { data, loading, error }] = useBusinessProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>(BusinessProfileUpdateDocument, options);
      }
export type BusinessProfileUpdateMutationHookResult = ReturnType<typeof useBusinessProfileUpdateMutation>;
export type BusinessProfileUpdateMutationResult = Apollo.MutationResult<BusinessProfileUpdateMutation>;
export type BusinessProfileUpdateMutationOptions = Apollo.BaseMutationOptions<BusinessProfileUpdateMutation, BusinessProfileUpdateMutationVariables>;
export const BusinessProfileRemoveDocument = gql`
    mutation businessProfileRemove($input: ZvukProfileRemoveMutationInput!) {
  zvukProfileRemove(input: $input) {
    ok
    errors {
      field
      messages
    }
    profile {
      ...BusinessProfileType
    }
  }
}
    ${BusinessProfileTypeFragmentDoc}`;
export type BusinessProfileRemoveMutationFn = Apollo.MutationFunction<BusinessProfileRemoveMutation, BusinessProfileRemoveMutationVariables>;

/**
 * __useBusinessProfileRemoveMutation__
 *
 * To run a mutation, you first call `useBusinessProfileRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileRemoveMutation, { data, loading, error }] = useBusinessProfileRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileRemoveMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileRemoveMutation, BusinessProfileRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileRemoveMutation, BusinessProfileRemoveMutationVariables>(BusinessProfileRemoveDocument, options);
      }
export type BusinessProfileRemoveMutationHookResult = ReturnType<typeof useBusinessProfileRemoveMutation>;
export type BusinessProfileRemoveMutationResult = Apollo.MutationResult<BusinessProfileRemoveMutation>;
export type BusinessProfileRemoveMutationOptions = Apollo.BaseMutationOptions<BusinessProfileRemoveMutation, BusinessProfileRemoveMutationVariables>;
export const BusinessProfileHideDocument = gql`
    mutation businessProfileHide($input: ZvukProfileHideMutationInput!) {
  zvukProfileHide(input: $input) {
    ok
    errors {
      field
      messages
    }
    profile {
      ...BusinessProfileType
    }
  }
}
    ${BusinessProfileTypeFragmentDoc}`;
export type BusinessProfileHideMutationFn = Apollo.MutationFunction<BusinessProfileHideMutation, BusinessProfileHideMutationVariables>;

/**
 * __useBusinessProfileHideMutation__
 *
 * To run a mutation, you first call `useBusinessProfileHideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileHideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileHideMutation, { data, loading, error }] = useBusinessProfileHideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileHideMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileHideMutation, BusinessProfileHideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileHideMutation, BusinessProfileHideMutationVariables>(BusinessProfileHideDocument, options);
      }
export type BusinessProfileHideMutationHookResult = ReturnType<typeof useBusinessProfileHideMutation>;
export type BusinessProfileHideMutationResult = Apollo.MutationResult<BusinessProfileHideMutation>;
export type BusinessProfileHideMutationOptions = Apollo.BaseMutationOptions<BusinessProfileHideMutation, BusinessProfileHideMutationVariables>;
export const BusinessProfilePublishDocument = gql`
    mutation businessProfilePublish($input: ZvukProfilePublishMutationInput!) {
  zvukProfilePublish(input: $input) {
    ok
    errors {
      field
      messages
    }
    profile {
      ...BusinessProfileType
    }
  }
}
    ${BusinessProfileTypeFragmentDoc}`;
export type BusinessProfilePublishMutationFn = Apollo.MutationFunction<BusinessProfilePublishMutation, BusinessProfilePublishMutationVariables>;

/**
 * __useBusinessProfilePublishMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePublishMutation, { data, loading, error }] = useBusinessProfilePublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePublishMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePublishMutation, BusinessProfilePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePublishMutation, BusinessProfilePublishMutationVariables>(BusinessProfilePublishDocument, options);
      }
export type BusinessProfilePublishMutationHookResult = ReturnType<typeof useBusinessProfilePublishMutation>;
export type BusinessProfilePublishMutationResult = Apollo.MutationResult<BusinessProfilePublishMutation>;
export type BusinessProfilePublishMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePublishMutation, BusinessProfilePublishMutationVariables>;
export const BusinessProfileCompanySavedStreamsDocument = gql`
    query businessProfileCompanySavedStreams($filters: StreamsQueryFilter!, $pagination: StreamsQueryPagination!, $sort: StreamsQuerySort!) {
  streamsPaginationQuery(filters: $filters, pagination: $pagination, sort: $sort) {
    result {
      id
      title
      description
      poster {
        id
        miniatureFilename
        miniatureUri
      }
      points {
        id
        playingStatus {
          code
          title
        }
      }
      mediafilesCount
    }
  }
}
    `;

/**
 * __useBusinessProfileCompanySavedStreamsQuery__
 *
 * To run a query within a React component, call `useBusinessProfileCompanySavedStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileCompanySavedStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessProfileCompanySavedStreamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useBusinessProfileCompanySavedStreamsQuery(baseOptions: Apollo.QueryHookOptions<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables> & ({ variables: BusinessProfileCompanySavedStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>(BusinessProfileCompanySavedStreamsDocument, options);
      }
export function useBusinessProfileCompanySavedStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>(BusinessProfileCompanySavedStreamsDocument, options);
        }
// @ts-ignore
export function useBusinessProfileCompanySavedStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>;
export function useBusinessProfileCompanySavedStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<BusinessProfileCompanySavedStreamsQuery | undefined, BusinessProfileCompanySavedStreamsQueryVariables>;
export function useBusinessProfileCompanySavedStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>(BusinessProfileCompanySavedStreamsDocument, options);
        }
export type BusinessProfileCompanySavedStreamsQueryHookResult = ReturnType<typeof useBusinessProfileCompanySavedStreamsQuery>;
export type BusinessProfileCompanySavedStreamsLazyQueryHookResult = ReturnType<typeof useBusinessProfileCompanySavedStreamsLazyQuery>;
export type BusinessProfileCompanySavedStreamsSuspenseQueryHookResult = ReturnType<typeof useBusinessProfileCompanySavedStreamsSuspenseQuery>;
export type BusinessProfileCompanySavedStreamsQueryResult = Apollo.QueryResult<BusinessProfileCompanySavedStreamsQuery, BusinessProfileCompanySavedStreamsQueryVariables>;
export const BusinessProfilePlaylistCreateFromStreamDocument = gql`
    mutation businessProfilePlaylistCreateFromStream($input: ZvukPlaylistCreateFromStreamMutationInput!) {
  zvukPlaylistCreateFromStream(input: $input) {
    ok
    errors {
      field
      messages
    }
    playlist {
      ...BusinessPlaylistType
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistCreateFromStreamMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistCreateFromStreamMutation, BusinessProfilePlaylistCreateFromStreamMutationVariables>;

/**
 * __useBusinessProfilePlaylistCreateFromStreamMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistCreateFromStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistCreateFromStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistCreateFromStreamMutation, { data, loading, error }] = useBusinessProfilePlaylistCreateFromStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistCreateFromStreamMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistCreateFromStreamMutation, BusinessProfilePlaylistCreateFromStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistCreateFromStreamMutation, BusinessProfilePlaylistCreateFromStreamMutationVariables>(BusinessProfilePlaylistCreateFromStreamDocument, options);
      }
export type BusinessProfilePlaylistCreateFromStreamMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistCreateFromStreamMutation>;
export type BusinessProfilePlaylistCreateFromStreamMutationResult = Apollo.MutationResult<BusinessProfilePlaylistCreateFromStreamMutation>;
export type BusinessProfilePlaylistCreateFromStreamMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistCreateFromStreamMutation, BusinessProfilePlaylistCreateFromStreamMutationVariables>;
export const BusinessProfilePlaylistUpdateDocument = gql`
    mutation businessProfilePlaylistUpdate($input: ZvukPlaylistUpdateMutationInput!) {
  zvukPlaylistUpdate(input: $input) {
    ok
    errors {
      field
      messages
    }
    playlist {
      ...BusinessPlaylistType
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistUpdateMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistUpdateMutation, BusinessProfilePlaylistUpdateMutationVariables>;

/**
 * __useBusinessProfilePlaylistUpdateMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistUpdateMutation, { data, loading, error }] = useBusinessProfilePlaylistUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistUpdateMutation, BusinessProfilePlaylistUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistUpdateMutation, BusinessProfilePlaylistUpdateMutationVariables>(BusinessProfilePlaylistUpdateDocument, options);
      }
export type BusinessProfilePlaylistUpdateMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistUpdateMutation>;
export type BusinessProfilePlaylistUpdateMutationResult = Apollo.MutationResult<BusinessProfilePlaylistUpdateMutation>;
export type BusinessProfilePlaylistUpdateMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistUpdateMutation, BusinessProfilePlaylistUpdateMutationVariables>;
export const BusinessProfilePlaylistHideDocument = gql`
    mutation businessProfilePlaylistHide($input: ZvukPlaylistHideMutationInput!) {
  zvukPlaylistHide(input: $input) {
    ok
    errors {
      field
      messages
    }
    playlist {
      ...BusinessPlaylistType
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistHideMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistHideMutation, BusinessProfilePlaylistHideMutationVariables>;

/**
 * __useBusinessProfilePlaylistHideMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistHideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistHideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistHideMutation, { data, loading, error }] = useBusinessProfilePlaylistHideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistHideMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistHideMutation, BusinessProfilePlaylistHideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistHideMutation, BusinessProfilePlaylistHideMutationVariables>(BusinessProfilePlaylistHideDocument, options);
      }
export type BusinessProfilePlaylistHideMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistHideMutation>;
export type BusinessProfilePlaylistHideMutationResult = Apollo.MutationResult<BusinessProfilePlaylistHideMutation>;
export type BusinessProfilePlaylistHideMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistHideMutation, BusinessProfilePlaylistHideMutationVariables>;
export const BusinessProfilePlaylistRemoveDocument = gql`
    mutation businessProfilePlaylistRemove($input: ZvukPlaylistRemoveMutationInput!) {
  zvukPlaylistRemove(input: $input) {
    ok
    errors {
      field
      messages
    }
    playlist {
      ...BusinessPlaylistType
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistRemoveMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistRemoveMutation, BusinessProfilePlaylistRemoveMutationVariables>;

/**
 * __useBusinessProfilePlaylistRemoveMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistRemoveMutation, { data, loading, error }] = useBusinessProfilePlaylistRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistRemoveMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistRemoveMutation, BusinessProfilePlaylistRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistRemoveMutation, BusinessProfilePlaylistRemoveMutationVariables>(BusinessProfilePlaylistRemoveDocument, options);
      }
export type BusinessProfilePlaylistRemoveMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistRemoveMutation>;
export type BusinessProfilePlaylistRemoveMutationResult = Apollo.MutationResult<BusinessProfilePlaylistRemoveMutation>;
export type BusinessProfilePlaylistRemoveMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistRemoveMutation, BusinessProfilePlaylistRemoveMutationVariables>;
export const BusinessProfilePlaylistPublishDocument = gql`
    mutation businessProfilePlaylistPublish($input: ZvukPlaylistPublishMutationInput!) {
  zvukPlaylistPublish(input: $input) {
    ok
    playlist {
      ...BusinessPlaylistType
    }
    errors {
      field
      messages
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistPublishMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistPublishMutation, BusinessProfilePlaylistPublishMutationVariables>;

/**
 * __useBusinessProfilePlaylistPublishMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistPublishMutation, { data, loading, error }] = useBusinessProfilePlaylistPublishMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistPublishMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistPublishMutation, BusinessProfilePlaylistPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistPublishMutation, BusinessProfilePlaylistPublishMutationVariables>(BusinessProfilePlaylistPublishDocument, options);
      }
export type BusinessProfilePlaylistPublishMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistPublishMutation>;
export type BusinessProfilePlaylistPublishMutationResult = Apollo.MutationResult<BusinessProfilePlaylistPublishMutation>;
export type BusinessProfilePlaylistPublishMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistPublishMutation, BusinessProfilePlaylistPublishMutationVariables>;
export const BusinessProfileZvukPlaylistInfoDocument = gql`
    mutation businessProfileZvukPlaylistInfo($input: ZvukPlaylistInfoMutationInput!) {
  zvukPlaylistInfo(input: $input) {
    ok
    playlist {
      id
      name
      description
      isPublic
      trackCount
      imageUrl
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type BusinessProfileZvukPlaylistInfoMutationFn = Apollo.MutationFunction<BusinessProfileZvukPlaylistInfoMutation, BusinessProfileZvukPlaylistInfoMutationVariables>;

/**
 * __useBusinessProfileZvukPlaylistInfoMutation__
 *
 * To run a mutation, you first call `useBusinessProfileZvukPlaylistInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfileZvukPlaylistInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfileZvukPlaylistInfoMutation, { data, loading, error }] = useBusinessProfileZvukPlaylistInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfileZvukPlaylistInfoMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfileZvukPlaylistInfoMutation, BusinessProfileZvukPlaylistInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfileZvukPlaylistInfoMutation, BusinessProfileZvukPlaylistInfoMutationVariables>(BusinessProfileZvukPlaylistInfoDocument, options);
      }
export type BusinessProfileZvukPlaylistInfoMutationHookResult = ReturnType<typeof useBusinessProfileZvukPlaylistInfoMutation>;
export type BusinessProfileZvukPlaylistInfoMutationResult = Apollo.MutationResult<BusinessProfileZvukPlaylistInfoMutation>;
export type BusinessProfileZvukPlaylistInfoMutationOptions = Apollo.BaseMutationOptions<BusinessProfileZvukPlaylistInfoMutation, BusinessProfileZvukPlaylistInfoMutationVariables>;
export const BusinessProfilePlaylistCreateFromZvukDocument = gql`
    mutation businessProfilePlaylistCreateFromZvuk($input: ZvukPlaylistCreateFromZvukMutationInput!) {
  zvukPlaylistCreateFromZvuk(input: $input) {
    ok
    errors {
      field
      messages
    }
    playlist {
      ...BusinessPlaylistType
    }
  }
}
    ${BusinessPlaylistTypeFragmentDoc}`;
export type BusinessProfilePlaylistCreateFromZvukMutationFn = Apollo.MutationFunction<BusinessProfilePlaylistCreateFromZvukMutation, BusinessProfilePlaylistCreateFromZvukMutationVariables>;

/**
 * __useBusinessProfilePlaylistCreateFromZvukMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePlaylistCreateFromZvukMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePlaylistCreateFromZvukMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePlaylistCreateFromZvukMutation, { data, loading, error }] = useBusinessProfilePlaylistCreateFromZvukMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessProfilePlaylistCreateFromZvukMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePlaylistCreateFromZvukMutation, BusinessProfilePlaylistCreateFromZvukMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePlaylistCreateFromZvukMutation, BusinessProfilePlaylistCreateFromZvukMutationVariables>(BusinessProfilePlaylistCreateFromZvukDocument, options);
      }
export type BusinessProfilePlaylistCreateFromZvukMutationHookResult = ReturnType<typeof useBusinessProfilePlaylistCreateFromZvukMutation>;
export type BusinessProfilePlaylistCreateFromZvukMutationResult = Apollo.MutationResult<BusinessProfilePlaylistCreateFromZvukMutation>;
export type BusinessProfilePlaylistCreateFromZvukMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePlaylistCreateFromZvukMutation, BusinessProfilePlaylistCreateFromZvukMutationVariables>;
export const CreateCertificateDocument = gql`
    mutation createCertificate($input: CertLetterForPointMutationInput!) {
  certLetterForPointMutation(input: $input) {
    ok
    errors {
      field
      messages
    }
    downloadLink
  }
}
    `;
export type CreateCertificateMutationFn = Apollo.MutationFunction<CreateCertificateMutation, CreateCertificateMutationVariables>;

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCertificateMutation, CreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCertificateMutation, CreateCertificateMutationVariables>(CreateCertificateDocument, options);
      }
export type CreateCertificateMutationHookResult = ReturnType<typeof useCreateCertificateMutation>;
export type CreateCertificateMutationResult = Apollo.MutationResult<CreateCertificateMutation>;
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<CreateCertificateMutation, CreateCertificateMutationVariables>;
export const MediaCompanyStreamsDocument = gql`
    query mediaCompanyStreams($filters: StreamsQueryFilter!, $pagination: StreamsQueryPagination!, $sort: StreamsQuerySort!) {
  result: streamsPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      ...StreamShortType
      master {
        id
      }
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StreamShortTypeFragmentDoc}`;

/**
 * __useMediaCompanyStreamsQuery__
 *
 * To run a query within a React component, call `useMediaCompanyStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCompanyStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCompanyStreamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMediaCompanyStreamsQuery(baseOptions: Apollo.QueryHookOptions<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables> & ({ variables: MediaCompanyStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>(MediaCompanyStreamsDocument, options);
      }
export function useMediaCompanyStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>(MediaCompanyStreamsDocument, options);
        }
// @ts-ignore
export function useMediaCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>;
export function useMediaCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaCompanyStreamsQuery | undefined, MediaCompanyStreamsQueryVariables>;
export function useMediaCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>(MediaCompanyStreamsDocument, options);
        }
export type MediaCompanyStreamsQueryHookResult = ReturnType<typeof useMediaCompanyStreamsQuery>;
export type MediaCompanyStreamsLazyQueryHookResult = ReturnType<typeof useMediaCompanyStreamsLazyQuery>;
export type MediaCompanyStreamsSuspenseQueryHookResult = ReturnType<typeof useMediaCompanyStreamsSuspenseQuery>;
export type MediaCompanyStreamsQueryResult = Apollo.QueryResult<MediaCompanyStreamsQuery, MediaCompanyStreamsQueryVariables>;
export const MediaStreamTemplateGroupsDocument = gql`
    query mediaStreamTemplateGroups($groupId: ID) {
  result: streamPureTemplateGroups(groupId: $groupId) {
    id
    title
    streams {
      ...StreamShortType
    }
  }
}
    ${StreamShortTypeFragmentDoc}`;

/**
 * __useMediaStreamTemplateGroupsQuery__
 *
 * To run a query within a React component, call `useMediaStreamTemplateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaStreamTemplateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaStreamTemplateGroupsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMediaStreamTemplateGroupsQuery(baseOptions?: Apollo.QueryHookOptions<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>(MediaStreamTemplateGroupsDocument, options);
      }
export function useMediaStreamTemplateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>(MediaStreamTemplateGroupsDocument, options);
        }
// @ts-ignore
export function useMediaStreamTemplateGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>;
export function useMediaStreamTemplateGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaStreamTemplateGroupsQuery | undefined, MediaStreamTemplateGroupsQueryVariables>;
export function useMediaStreamTemplateGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>(MediaStreamTemplateGroupsDocument, options);
        }
export type MediaStreamTemplateGroupsQueryHookResult = ReturnType<typeof useMediaStreamTemplateGroupsQuery>;
export type MediaStreamTemplateGroupsLazyQueryHookResult = ReturnType<typeof useMediaStreamTemplateGroupsLazyQuery>;
export type MediaStreamTemplateGroupsSuspenseQueryHookResult = ReturnType<typeof useMediaStreamTemplateGroupsSuspenseQuery>;
export type MediaStreamTemplateGroupsQueryResult = Apollo.QueryResult<MediaStreamTemplateGroupsQuery, MediaStreamTemplateGroupsQueryVariables>;
export const MediaStreamDocument = gql`
    query mediaStream($id: ID!) {
  result: streamPureQuery(id: $id) {
    ...StreamInfoType
  }
}
    ${StreamInfoTypeFragmentDoc}`;

/**
 * __useMediaStreamQuery__
 *
 * To run a query within a React component, call `useMediaStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaStreamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaStreamQuery(baseOptions: Apollo.QueryHookOptions<MediaStreamQuery, MediaStreamQueryVariables> & ({ variables: MediaStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaStreamQuery, MediaStreamQueryVariables>(MediaStreamDocument, options);
      }
export function useMediaStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaStreamQuery, MediaStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaStreamQuery, MediaStreamQueryVariables>(MediaStreamDocument, options);
        }
// @ts-ignore
export function useMediaStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaStreamQuery, MediaStreamQueryVariables>): Apollo.UseSuspenseQueryResult<MediaStreamQuery, MediaStreamQueryVariables>;
export function useMediaStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaStreamQuery, MediaStreamQueryVariables>): Apollo.UseSuspenseQueryResult<MediaStreamQuery | undefined, MediaStreamQueryVariables>;
export function useMediaStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaStreamQuery, MediaStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaStreamQuery, MediaStreamQueryVariables>(MediaStreamDocument, options);
        }
export type MediaStreamQueryHookResult = ReturnType<typeof useMediaStreamQuery>;
export type MediaStreamLazyQueryHookResult = ReturnType<typeof useMediaStreamLazyQuery>;
export type MediaStreamSuspenseQueryHookResult = ReturnType<typeof useMediaStreamSuspenseQuery>;
export type MediaStreamQueryResult = Apollo.QueryResult<MediaStreamQuery, MediaStreamQueryVariables>;
export const StreamApprovalDocument = gql`
    query streamApproval($id: ID!) {
  result: streamApprovalQuery(id: $id) {
    ...StreamApprovalInfoType
  }
}
    ${StreamApprovalInfoTypeFragmentDoc}`;

/**
 * __useStreamApprovalQuery__
 *
 * To run a query within a React component, call `useStreamApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamApprovalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStreamApprovalQuery(baseOptions: Apollo.QueryHookOptions<StreamApprovalQuery, StreamApprovalQueryVariables> & ({ variables: StreamApprovalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamApprovalQuery, StreamApprovalQueryVariables>(StreamApprovalDocument, options);
      }
export function useStreamApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamApprovalQuery, StreamApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamApprovalQuery, StreamApprovalQueryVariables>(StreamApprovalDocument, options);
        }
// @ts-ignore
export function useStreamApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamApprovalQuery, StreamApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<StreamApprovalQuery, StreamApprovalQueryVariables>;
export function useStreamApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamApprovalQuery, StreamApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<StreamApprovalQuery | undefined, StreamApprovalQueryVariables>;
export function useStreamApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamApprovalQuery, StreamApprovalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamApprovalQuery, StreamApprovalQueryVariables>(StreamApprovalDocument, options);
        }
export type StreamApprovalQueryHookResult = ReturnType<typeof useStreamApprovalQuery>;
export type StreamApprovalLazyQueryHookResult = ReturnType<typeof useStreamApprovalLazyQuery>;
export type StreamApprovalSuspenseQueryHookResult = ReturnType<typeof useStreamApprovalSuspenseQuery>;
export type StreamApprovalQueryResult = Apollo.QueryResult<StreamApprovalQuery, StreamApprovalQueryVariables>;
export const MediaStreamCopyFromTemplateDocument = gql`
    mutation mediaStreamCopyFromTemplate($input: StreamPureCopyFromTemplateMutationInput!) {
  result: streamPureCopyFromTemplate(input: $input) {
    stream {
      id
    }
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type MediaStreamCopyFromTemplateMutationFn = Apollo.MutationFunction<MediaStreamCopyFromTemplateMutation, MediaStreamCopyFromTemplateMutationVariables>;

/**
 * __useMediaStreamCopyFromTemplateMutation__
 *
 * To run a mutation, you first call `useMediaStreamCopyFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaStreamCopyFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaStreamCopyFromTemplateMutation, { data, loading, error }] = useMediaStreamCopyFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaStreamCopyFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MediaStreamCopyFromTemplateMutation, MediaStreamCopyFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaStreamCopyFromTemplateMutation, MediaStreamCopyFromTemplateMutationVariables>(MediaStreamCopyFromTemplateDocument, options);
      }
export type MediaStreamCopyFromTemplateMutationHookResult = ReturnType<typeof useMediaStreamCopyFromTemplateMutation>;
export type MediaStreamCopyFromTemplateMutationResult = Apollo.MutationResult<MediaStreamCopyFromTemplateMutation>;
export type MediaStreamCopyFromTemplateMutationOptions = Apollo.BaseMutationOptions<MediaStreamCopyFromTemplateMutation, MediaStreamCopyFromTemplateMutationVariables>;
export const MediaStreamSetToPointsDocument = gql`
    mutation mediaStreamSetToPoints($input: StreamPureSetToCompanyPointsMutationInput!) {
  result: streamPureSetToCompanyPoints(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type MediaStreamSetToPointsMutationFn = Apollo.MutationFunction<MediaStreamSetToPointsMutation, MediaStreamSetToPointsMutationVariables>;

/**
 * __useMediaStreamSetToPointsMutation__
 *
 * To run a mutation, you first call `useMediaStreamSetToPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaStreamSetToPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaStreamSetToPointsMutation, { data, loading, error }] = useMediaStreamSetToPointsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaStreamSetToPointsMutation(baseOptions?: Apollo.MutationHookOptions<MediaStreamSetToPointsMutation, MediaStreamSetToPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaStreamSetToPointsMutation, MediaStreamSetToPointsMutationVariables>(MediaStreamSetToPointsDocument, options);
      }
export type MediaStreamSetToPointsMutationHookResult = ReturnType<typeof useMediaStreamSetToPointsMutation>;
export type MediaStreamSetToPointsMutationResult = Apollo.MutationResult<MediaStreamSetToPointsMutation>;
export type MediaStreamSetToPointsMutationOptions = Apollo.BaseMutationOptions<MediaStreamSetToPointsMutation, MediaStreamSetToPointsMutationVariables>;
export const MediaStreamRemoveDocument = gql`
    mutation mediaStreamRemove($input: StreamPureRemoveMutationInput!) {
  result: streamPureRemove(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type MediaStreamRemoveMutationFn = Apollo.MutationFunction<MediaStreamRemoveMutation, MediaStreamRemoveMutationVariables>;

/**
 * __useMediaStreamRemoveMutation__
 *
 * To run a mutation, you first call `useMediaStreamRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaStreamRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaStreamRemoveMutation, { data, loading, error }] = useMediaStreamRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaStreamRemoveMutation(baseOptions?: Apollo.MutationHookOptions<MediaStreamRemoveMutation, MediaStreamRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaStreamRemoveMutation, MediaStreamRemoveMutationVariables>(MediaStreamRemoveDocument, options);
      }
export type MediaStreamRemoveMutationHookResult = ReturnType<typeof useMediaStreamRemoveMutation>;
export type MediaStreamRemoveMutationResult = Apollo.MutationResult<MediaStreamRemoveMutation>;
export type MediaStreamRemoveMutationOptions = Apollo.BaseMutationOptions<MediaStreamRemoveMutation, MediaStreamRemoveMutationVariables>;
export const MediaMediafilesRandomDocument = gql`
    query mediaMediafilesRandom($filters: StreamMediafilesRandomPaginationQueryFilter!, $pagination: StreamMediafilesRandomQueryPagination!) {
  streamMediafilesRandomPaginationQuery(
    filters: $filters
    pagination: $pagination
  ) {
    result {
      ...MediaFilesRandomType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MediaFilesRandomTypeFragmentDoc}`;

/**
 * __useMediaMediafilesRandomQuery__
 *
 * To run a query within a React component, call `useMediaMediafilesRandomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaMediafilesRandomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaMediafilesRandomQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMediaMediafilesRandomQuery(baseOptions: Apollo.QueryHookOptions<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables> & ({ variables: MediaMediafilesRandomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>(MediaMediafilesRandomDocument, options);
      }
export function useMediaMediafilesRandomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>(MediaMediafilesRandomDocument, options);
        }
// @ts-ignore
export function useMediaMediafilesRandomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>): Apollo.UseSuspenseQueryResult<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>;
export function useMediaMediafilesRandomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>): Apollo.UseSuspenseQueryResult<MediaMediafilesRandomQuery | undefined, MediaMediafilesRandomQueryVariables>;
export function useMediaMediafilesRandomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>(MediaMediafilesRandomDocument, options);
        }
export type MediaMediafilesRandomQueryHookResult = ReturnType<typeof useMediaMediafilesRandomQuery>;
export type MediaMediafilesRandomLazyQueryHookResult = ReturnType<typeof useMediaMediafilesRandomLazyQuery>;
export type MediaMediafilesRandomSuspenseQueryHookResult = ReturnType<typeof useMediaMediafilesRandomSuspenseQuery>;
export type MediaMediafilesRandomQueryResult = Apollo.QueryResult<MediaMediafilesRandomQuery, MediaMediafilesRandomQueryVariables>;
export const MediaMediafilesDocument = gql`
    query mediaMediafiles($filters: MediafilesQueryFilter!, $pagination: MediafilesQueryPagination!, $sort: MediafilesQuerySort!) {
  mediafilesPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      ...MediafileInfoType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MediafileInfoTypeFragmentDoc}`;

/**
 * __useMediaMediafilesQuery__
 *
 * To run a query within a React component, call `useMediaMediafilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaMediafilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaMediafilesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMediaMediafilesQuery(baseOptions: Apollo.QueryHookOptions<MediaMediafilesQuery, MediaMediafilesQueryVariables> & ({ variables: MediaMediafilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaMediafilesQuery, MediaMediafilesQueryVariables>(MediaMediafilesDocument, options);
      }
export function useMediaMediafilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaMediafilesQuery, MediaMediafilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaMediafilesQuery, MediaMediafilesQueryVariables>(MediaMediafilesDocument, options);
        }
// @ts-ignore
export function useMediaMediafilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaMediafilesQuery, MediaMediafilesQueryVariables>): Apollo.UseSuspenseQueryResult<MediaMediafilesQuery, MediaMediafilesQueryVariables>;
export function useMediaMediafilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaMediafilesQuery, MediaMediafilesQueryVariables>): Apollo.UseSuspenseQueryResult<MediaMediafilesQuery | undefined, MediaMediafilesQueryVariables>;
export function useMediaMediafilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaMediafilesQuery, MediaMediafilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaMediafilesQuery, MediaMediafilesQueryVariables>(MediaMediafilesDocument, options);
        }
export type MediaMediafilesQueryHookResult = ReturnType<typeof useMediaMediafilesQuery>;
export type MediaMediafilesLazyQueryHookResult = ReturnType<typeof useMediaMediafilesLazyQuery>;
export type MediaMediafilesSuspenseQueryHookResult = ReturnType<typeof useMediaMediafilesSuspenseQuery>;
export type MediaMediafilesQueryResult = Apollo.QueryResult<MediaMediafilesQuery, MediaMediafilesQueryVariables>;
export const MediaAdCampaignRenameDocument = gql`
    mutation mediaAdCampaignRename($adCompanyId: ID!, $title: String!) {
  adcampaignRename(input: {adCompanyId: $adCompanyId, title: $title}) {
    adCompany {
      id
      title
    }
  }
}
    `;
export type MediaAdCampaignRenameMutationFn = Apollo.MutationFunction<MediaAdCampaignRenameMutation, MediaAdCampaignRenameMutationVariables>;

/**
 * __useMediaAdCampaignRenameMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignRenameMutation, { data, loading, error }] = useMediaAdCampaignRenameMutation({
 *   variables: {
 *      adCompanyId: // value for 'adCompanyId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useMediaAdCampaignRenameMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignRenameMutation, MediaAdCampaignRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignRenameMutation, MediaAdCampaignRenameMutationVariables>(MediaAdCampaignRenameDocument, options);
      }
export type MediaAdCampaignRenameMutationHookResult = ReturnType<typeof useMediaAdCampaignRenameMutation>;
export type MediaAdCampaignRenameMutationResult = Apollo.MutationResult<MediaAdCampaignRenameMutation>;
export type MediaAdCampaignRenameMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignRenameMutation, MediaAdCampaignRenameMutationVariables>;
export const MediaThematicBlockRemoveFromCompanyDocument = gql`
    mutation mediaThematicBlockRemoveFromCompany($input: ThematicBlockPureRemoveFromCompanyMutationInput!) {
  result: thematicBlockPureRemoveFromCompany(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type MediaThematicBlockRemoveFromCompanyMutationFn = Apollo.MutationFunction<MediaThematicBlockRemoveFromCompanyMutation, MediaThematicBlockRemoveFromCompanyMutationVariables>;

/**
 * __useMediaThematicBlockRemoveFromCompanyMutation__
 *
 * To run a mutation, you first call `useMediaThematicBlockRemoveFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaThematicBlockRemoveFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaThematicBlockRemoveFromCompanyMutation, { data, loading, error }] = useMediaThematicBlockRemoveFromCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaThematicBlockRemoveFromCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MediaThematicBlockRemoveFromCompanyMutation, MediaThematicBlockRemoveFromCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaThematicBlockRemoveFromCompanyMutation, MediaThematicBlockRemoveFromCompanyMutationVariables>(MediaThematicBlockRemoveFromCompanyDocument, options);
      }
export type MediaThematicBlockRemoveFromCompanyMutationHookResult = ReturnType<typeof useMediaThematicBlockRemoveFromCompanyMutation>;
export type MediaThematicBlockRemoveFromCompanyMutationResult = Apollo.MutationResult<MediaThematicBlockRemoveFromCompanyMutation>;
export type MediaThematicBlockRemoveFromCompanyMutationOptions = Apollo.BaseMutationOptions<MediaThematicBlockRemoveFromCompanyMutation, MediaThematicBlockRemoveFromCompanyMutationVariables>;
export const MediaThematicBlockSetToCompanyDocument = gql`
    mutation mediaThematicBlockSetToCompany($input: ThematicBlockPureSetToCompanyMutationInput!) {
  result: thematicBlockPureSetToCompany(input: $input) {
    ok
    errors {
      messages
      field
    }
    companyThematicBlock {
      ...CompanyThematicContentBlockInfoType
    }
  }
}
    ${CompanyThematicContentBlockInfoTypeFragmentDoc}`;
export type MediaThematicBlockSetToCompanyMutationFn = Apollo.MutationFunction<MediaThematicBlockSetToCompanyMutation, MediaThematicBlockSetToCompanyMutationVariables>;

/**
 * __useMediaThematicBlockSetToCompanyMutation__
 *
 * To run a mutation, you first call `useMediaThematicBlockSetToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaThematicBlockSetToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaThematicBlockSetToCompanyMutation, { data, loading, error }] = useMediaThematicBlockSetToCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaThematicBlockSetToCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MediaThematicBlockSetToCompanyMutation, MediaThematicBlockSetToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaThematicBlockSetToCompanyMutation, MediaThematicBlockSetToCompanyMutationVariables>(MediaThematicBlockSetToCompanyDocument, options);
      }
export type MediaThematicBlockSetToCompanyMutationHookResult = ReturnType<typeof useMediaThematicBlockSetToCompanyMutation>;
export type MediaThematicBlockSetToCompanyMutationResult = Apollo.MutationResult<MediaThematicBlockSetToCompanyMutation>;
export type MediaThematicBlockSetToCompanyMutationOptions = Apollo.BaseMutationOptions<MediaThematicBlockSetToCompanyMutation, MediaThematicBlockSetToCompanyMutationVariables>;
export const MediaCompanyThematicBlockUpdateDocument = gql`
    mutation mediaCompanyThematicBlockUpdate($input: CompanyThematicBlockPureUpdateMutationInput!) {
  result: companyThematicBlockPureUpdate(input: $input) {
    ok
    errors {
      messages
      field
    }
    companyThematicBlock {
      ...CompanyThematicContentBlockInfoType
    }
  }
}
    ${CompanyThematicContentBlockInfoTypeFragmentDoc}`;
export type MediaCompanyThematicBlockUpdateMutationFn = Apollo.MutationFunction<MediaCompanyThematicBlockUpdateMutation, MediaCompanyThematicBlockUpdateMutationVariables>;

/**
 * __useMediaCompanyThematicBlockUpdateMutation__
 *
 * To run a mutation, you first call `useMediaCompanyThematicBlockUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaCompanyThematicBlockUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaCompanyThematicBlockUpdateMutation, { data, loading, error }] = useMediaCompanyThematicBlockUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaCompanyThematicBlockUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MediaCompanyThematicBlockUpdateMutation, MediaCompanyThematicBlockUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaCompanyThematicBlockUpdateMutation, MediaCompanyThematicBlockUpdateMutationVariables>(MediaCompanyThematicBlockUpdateDocument, options);
      }
export type MediaCompanyThematicBlockUpdateMutationHookResult = ReturnType<typeof useMediaCompanyThematicBlockUpdateMutation>;
export type MediaCompanyThematicBlockUpdateMutationResult = Apollo.MutationResult<MediaCompanyThematicBlockUpdateMutation>;
export type MediaCompanyThematicBlockUpdateMutationOptions = Apollo.BaseMutationOptions<MediaCompanyThematicBlockUpdateMutation, MediaCompanyThematicBlockUpdateMutationVariables>;
export const MediaCompanyThematicContentBlocksDocument = gql`
    query mediaCompanyThematicContentBlocks($companyId: ID!) {
  result: companyThematicContentBlocksPureQuery(companyId: $companyId) {
    ...CompanyThematicContentBlockInfoType
    streamsIdsWithThematic
  }
}
    ${CompanyThematicContentBlockInfoTypeFragmentDoc}`;

/**
 * __useMediaCompanyThematicContentBlocksQuery__
 *
 * To run a query within a React component, call `useMediaCompanyThematicContentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaCompanyThematicContentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaCompanyThematicContentBlocksQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMediaCompanyThematicContentBlocksQuery(baseOptions: Apollo.QueryHookOptions<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables> & ({ variables: MediaCompanyThematicContentBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>(MediaCompanyThematicContentBlocksDocument, options);
      }
export function useMediaCompanyThematicContentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>(MediaCompanyThematicContentBlocksDocument, options);
        }
// @ts-ignore
export function useMediaCompanyThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>;
export function useMediaCompanyThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<MediaCompanyThematicContentBlocksQuery | undefined, MediaCompanyThematicContentBlocksQueryVariables>;
export function useMediaCompanyThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>(MediaCompanyThematicContentBlocksDocument, options);
        }
export type MediaCompanyThematicContentBlocksQueryHookResult = ReturnType<typeof useMediaCompanyThematicContentBlocksQuery>;
export type MediaCompanyThematicContentBlocksLazyQueryHookResult = ReturnType<typeof useMediaCompanyThematicContentBlocksLazyQuery>;
export type MediaCompanyThematicContentBlocksSuspenseQueryHookResult = ReturnType<typeof useMediaCompanyThematicContentBlocksSuspenseQuery>;
export type MediaCompanyThematicContentBlocksQueryResult = Apollo.QueryResult<MediaCompanyThematicContentBlocksQuery, MediaCompanyThematicContentBlocksQueryVariables>;
export const MediaThematicContentBlocksDocument = gql`
    query mediaThematicContentBlocks($forDate: DateTime!) {
  result: thematicContentBlocksPureQuery(forDate: $forDate) {
    ...ThematicContentBlockInfoType
  }
}
    ${ThematicContentBlockInfoTypeFragmentDoc}`;

/**
 * __useMediaThematicContentBlocksQuery__
 *
 * To run a query within a React component, call `useMediaThematicContentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaThematicContentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaThematicContentBlocksQuery({
 *   variables: {
 *      forDate: // value for 'forDate'
 *   },
 * });
 */
export function useMediaThematicContentBlocksQuery(baseOptions: Apollo.QueryHookOptions<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables> & ({ variables: MediaThematicContentBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>(MediaThematicContentBlocksDocument, options);
      }
export function useMediaThematicContentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>(MediaThematicContentBlocksDocument, options);
        }
// @ts-ignore
export function useMediaThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>;
export function useMediaThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>): Apollo.UseSuspenseQueryResult<MediaThematicContentBlocksQuery | undefined, MediaThematicContentBlocksQueryVariables>;
export function useMediaThematicContentBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>(MediaThematicContentBlocksDocument, options);
        }
export type MediaThematicContentBlocksQueryHookResult = ReturnType<typeof useMediaThematicContentBlocksQuery>;
export type MediaThematicContentBlocksLazyQueryHookResult = ReturnType<typeof useMediaThematicContentBlocksLazyQuery>;
export type MediaThematicContentBlocksSuspenseQueryHookResult = ReturnType<typeof useMediaThematicContentBlocksSuspenseQuery>;
export type MediaThematicContentBlocksQueryResult = Apollo.QueryResult<MediaThematicContentBlocksQuery, MediaThematicContentBlocksQueryVariables>;
export const MediaThematicBlockRandomMediafilesPaginationDocument = gql`
    query mediaThematicBlockRandomMediafilesPagination($filters: ThematicBlockRandomMediafilesPaginationQueryFilter!, $pagination: ThematicBlockRandomMediafilesQueryPagination!) {
  result: thematicBlockRandomMediafilesPaginationQuery(
    filters: $filters
    pagination: $pagination
  ) {
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    result {
      ...MediafileInfoType
    }
  }
}
    ${MediafileInfoTypeFragmentDoc}`;

/**
 * __useMediaThematicBlockRandomMediafilesPaginationQuery__
 *
 * To run a query within a React component, call `useMediaThematicBlockRandomMediafilesPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaThematicBlockRandomMediafilesPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaThematicBlockRandomMediafilesPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMediaThematicBlockRandomMediafilesPaginationQuery(baseOptions: Apollo.QueryHookOptions<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables> & ({ variables: MediaThematicBlockRandomMediafilesPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>(MediaThematicBlockRandomMediafilesPaginationDocument, options);
      }
export function useMediaThematicBlockRandomMediafilesPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>(MediaThematicBlockRandomMediafilesPaginationDocument, options);
        }
// @ts-ignore
export function useMediaThematicBlockRandomMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>;
export function useMediaThematicBlockRandomMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<MediaThematicBlockRandomMediafilesPaginationQuery | undefined, MediaThematicBlockRandomMediafilesPaginationQueryVariables>;
export function useMediaThematicBlockRandomMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>(MediaThematicBlockRandomMediafilesPaginationDocument, options);
        }
export type MediaThematicBlockRandomMediafilesPaginationQueryHookResult = ReturnType<typeof useMediaThematicBlockRandomMediafilesPaginationQuery>;
export type MediaThematicBlockRandomMediafilesPaginationLazyQueryHookResult = ReturnType<typeof useMediaThematicBlockRandomMediafilesPaginationLazyQuery>;
export type MediaThematicBlockRandomMediafilesPaginationSuspenseQueryHookResult = ReturnType<typeof useMediaThematicBlockRandomMediafilesPaginationSuspenseQuery>;
export type MediaThematicBlockRandomMediafilesPaginationQueryResult = Apollo.QueryResult<MediaThematicBlockRandomMediafilesPaginationQuery, MediaThematicBlockRandomMediafilesPaginationQueryVariables>;
export const ExcludeMediafileDocument = gql`
    mutation excludeMediafile($input: StreamPureDislikeMediafileMutationInput!) {
  result: streamPureDislikeMediafile(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type ExcludeMediafileMutationFn = Apollo.MutationFunction<ExcludeMediafileMutation, ExcludeMediafileMutationVariables>;

/**
 * __useExcludeMediafileMutation__
 *
 * To run a mutation, you first call `useExcludeMediafileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeMediafileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeMediafileMutation, { data, loading, error }] = useExcludeMediafileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExcludeMediafileMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeMediafileMutation, ExcludeMediafileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeMediafileMutation, ExcludeMediafileMutationVariables>(ExcludeMediafileDocument, options);
      }
export type ExcludeMediafileMutationHookResult = ReturnType<typeof useExcludeMediafileMutation>;
export type ExcludeMediafileMutationResult = Apollo.MutationResult<ExcludeMediafileMutation>;
export type ExcludeMediafileMutationOptions = Apollo.BaseMutationOptions<ExcludeMediafileMutation, ExcludeMediafileMutationVariables>;
export const RestoreMediafileDocument = gql`
    mutation restoreMediafile($input: StreamPureDislikeMediafileRestoreMutationInput!) {
  result: streamPureDislikeMediafileRestore(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type RestoreMediafileMutationFn = Apollo.MutationFunction<RestoreMediafileMutation, RestoreMediafileMutationVariables>;

/**
 * __useRestoreMediafileMutation__
 *
 * To run a mutation, you first call `useRestoreMediafileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMediafileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMediafileMutation, { data, loading, error }] = useRestoreMediafileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreMediafileMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMediafileMutation, RestoreMediafileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMediafileMutation, RestoreMediafileMutationVariables>(RestoreMediafileDocument, options);
      }
export type RestoreMediafileMutationHookResult = ReturnType<typeof useRestoreMediafileMutation>;
export type RestoreMediafileMutationResult = Apollo.MutationResult<RestoreMediafileMutation>;
export type RestoreMediafileMutationOptions = Apollo.BaseMutationOptions<RestoreMediafileMutation, RestoreMediafileMutationVariables>;
export const MediaDislikedMediafilesPaginationDocument = gql`
    query mediaDislikedMediafilesPagination($filters: StreamMediafilesEventsFilter!, $pagination: StreamMediafilesEventsPagination!, $sort: StreamMediafilesEventsSort!) {
  streamDislikedMediafiles: streamMediafilesEvents(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    result {
      mediafile {
        ...MediafileInfoType
      }
      eventType
    }
  }
}
    ${MediafileInfoTypeFragmentDoc}`;

/**
 * __useMediaDislikedMediafilesPaginationQuery__
 *
 * To run a query within a React component, call `useMediaDislikedMediafilesPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDislikedMediafilesPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDislikedMediafilesPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMediaDislikedMediafilesPaginationQuery(baseOptions: Apollo.QueryHookOptions<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables> & ({ variables: MediaDislikedMediafilesPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>(MediaDislikedMediafilesPaginationDocument, options);
      }
export function useMediaDislikedMediafilesPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>(MediaDislikedMediafilesPaginationDocument, options);
        }
// @ts-ignore
export function useMediaDislikedMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>;
export function useMediaDislikedMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<MediaDislikedMediafilesPaginationQuery | undefined, MediaDislikedMediafilesPaginationQueryVariables>;
export function useMediaDislikedMediafilesPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>(MediaDislikedMediafilesPaginationDocument, options);
        }
export type MediaDislikedMediafilesPaginationQueryHookResult = ReturnType<typeof useMediaDislikedMediafilesPaginationQuery>;
export type MediaDislikedMediafilesPaginationLazyQueryHookResult = ReturnType<typeof useMediaDislikedMediafilesPaginationLazyQuery>;
export type MediaDislikedMediafilesPaginationSuspenseQueryHookResult = ReturnType<typeof useMediaDislikedMediafilesPaginationSuspenseQuery>;
export type MediaDislikedMediafilesPaginationQueryResult = Apollo.QueryResult<MediaDislikedMediafilesPaginationQuery, MediaDislikedMediafilesPaginationQueryVariables>;
export const StreamLibraryDocument = gql`
    query StreamLibrary($companyId: ID!, $libraryId: ID!) {
  result: smartlkStreamLibrary(companyId: $companyId, libraryId: $libraryId) {
    ...StreamLibraryType
  }
}
    ${StreamLibraryTypeFragmentDoc}`;

/**
 * __useStreamLibraryQuery__
 *
 * To run a query within a React component, call `useStreamLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamLibraryQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      libraryId: // value for 'libraryId'
 *   },
 * });
 */
export function useStreamLibraryQuery(baseOptions: Apollo.QueryHookOptions<StreamLibraryQuery, StreamLibraryQueryVariables> & ({ variables: StreamLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamLibraryQuery, StreamLibraryQueryVariables>(StreamLibraryDocument, options);
      }
export function useStreamLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamLibraryQuery, StreamLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamLibraryQuery, StreamLibraryQueryVariables>(StreamLibraryDocument, options);
        }
// @ts-ignore
export function useStreamLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamLibraryQuery, StreamLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<StreamLibraryQuery, StreamLibraryQueryVariables>;
export function useStreamLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamLibraryQuery, StreamLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<StreamLibraryQuery | undefined, StreamLibraryQueryVariables>;
export function useStreamLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamLibraryQuery, StreamLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamLibraryQuery, StreamLibraryQueryVariables>(StreamLibraryDocument, options);
        }
export type StreamLibraryQueryHookResult = ReturnType<typeof useStreamLibraryQuery>;
export type StreamLibraryLazyQueryHookResult = ReturnType<typeof useStreamLibraryLazyQuery>;
export type StreamLibrarySuspenseQueryHookResult = ReturnType<typeof useStreamLibrarySuspenseQuery>;
export type StreamLibraryQueryResult = Apollo.QueryResult<StreamLibraryQuery, StreamLibraryQueryVariables>;
export const LibraryCollectionDocument = gql`
    query LibraryCollection($collectionId: ID!, $companyId: ID!) {
  result: smartlkLibraryCollection(
    collectionId: $collectionId
    companyId: $companyId
  ) {
    id
    title
  }
}
    `;

/**
 * __useLibraryCollectionQuery__
 *
 * To run a query within a React component, call `useLibraryCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useLibraryCollectionQuery(baseOptions: Apollo.QueryHookOptions<LibraryCollectionQuery, LibraryCollectionQueryVariables> & ({ variables: LibraryCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryCollectionQuery, LibraryCollectionQueryVariables>(LibraryCollectionDocument, options);
      }
export function useLibraryCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryCollectionQuery, LibraryCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryCollectionQuery, LibraryCollectionQueryVariables>(LibraryCollectionDocument, options);
        }
// @ts-ignore
export function useLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryCollectionQuery, LibraryCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionQuery, LibraryCollectionQueryVariables>;
export function useLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionQuery, LibraryCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionQuery | undefined, LibraryCollectionQueryVariables>;
export function useLibraryCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionQuery, LibraryCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryCollectionQuery, LibraryCollectionQueryVariables>(LibraryCollectionDocument, options);
        }
export type LibraryCollectionQueryHookResult = ReturnType<typeof useLibraryCollectionQuery>;
export type LibraryCollectionLazyQueryHookResult = ReturnType<typeof useLibraryCollectionLazyQuery>;
export type LibraryCollectionSuspenseQueryHookResult = ReturnType<typeof useLibraryCollectionSuspenseQuery>;
export type LibraryCollectionQueryResult = Apollo.QueryResult<LibraryCollectionQuery, LibraryCollectionQueryVariables>;
export const LibrarySubCollectionDocument = gql`
    query LibrarySubCollection($collectionId: ID!, $companyId: ID!) {
  result: smartlkLibraryCollection(
    collectionId: $collectionId
    companyId: $companyId
  ) {
    id
    title
    subcollections {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useLibrarySubCollectionQuery__
 *
 * To run a query within a React component, call `useLibrarySubCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibrarySubCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibrarySubCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useLibrarySubCollectionQuery(baseOptions: Apollo.QueryHookOptions<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables> & ({ variables: LibrarySubCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>(LibrarySubCollectionDocument, options);
      }
export function useLibrarySubCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>(LibrarySubCollectionDocument, options);
        }
// @ts-ignore
export function useLibrarySubCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>;
export function useLibrarySubCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySubCollectionQuery | undefined, LibrarySubCollectionQueryVariables>;
export function useLibrarySubCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>(LibrarySubCollectionDocument, options);
        }
export type LibrarySubCollectionQueryHookResult = ReturnType<typeof useLibrarySubCollectionQuery>;
export type LibrarySubCollectionLazyQueryHookResult = ReturnType<typeof useLibrarySubCollectionLazyQuery>;
export type LibrarySubCollectionSuspenseQueryHookResult = ReturnType<typeof useLibrarySubCollectionSuspenseQuery>;
export type LibrarySubCollectionQueryResult = Apollo.QueryResult<LibrarySubCollectionQuery, LibrarySubCollectionQueryVariables>;
export const StreamLibrarySubcollectionTitleDocument = gql`
    query StreamLibrarySubcollectionTitle($companyId: ID!, $subcollectionId: ID!) {
  result: smartlkLibrarySubcollection(
    companyId: $companyId
    subcollectionId: $subcollectionId
  ) {
    title
  }
}
    `;

/**
 * __useStreamLibrarySubcollectionTitleQuery__
 *
 * To run a query within a React component, call `useStreamLibrarySubcollectionTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamLibrarySubcollectionTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamLibrarySubcollectionTitleQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      subcollectionId: // value for 'subcollectionId'
 *   },
 * });
 */
export function useStreamLibrarySubcollectionTitleQuery(baseOptions: Apollo.QueryHookOptions<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables> & ({ variables: StreamLibrarySubcollectionTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>(StreamLibrarySubcollectionTitleDocument, options);
      }
export function useStreamLibrarySubcollectionTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>(StreamLibrarySubcollectionTitleDocument, options);
        }
// @ts-ignore
export function useStreamLibrarySubcollectionTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>): Apollo.UseSuspenseQueryResult<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>;
export function useStreamLibrarySubcollectionTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>): Apollo.UseSuspenseQueryResult<StreamLibrarySubcollectionTitleQuery | undefined, StreamLibrarySubcollectionTitleQueryVariables>;
export function useStreamLibrarySubcollectionTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>(StreamLibrarySubcollectionTitleDocument, options);
        }
export type StreamLibrarySubcollectionTitleQueryHookResult = ReturnType<typeof useStreamLibrarySubcollectionTitleQuery>;
export type StreamLibrarySubcollectionTitleLazyQueryHookResult = ReturnType<typeof useStreamLibrarySubcollectionTitleLazyQuery>;
export type StreamLibrarySubcollectionTitleSuspenseQueryHookResult = ReturnType<typeof useStreamLibrarySubcollectionTitleSuspenseQuery>;
export type StreamLibrarySubcollectionTitleQueryResult = Apollo.QueryResult<StreamLibrarySubcollectionTitleQuery, StreamLibrarySubcollectionTitleQueryVariables>;
export const LibrarySubCollectionStreamsWithPaginationDocument = gql`
    query LibrarySubCollectionStreamsWithPagination($filters: SmartLkLibraryStreamQueryFilter!, $pagination: SmartLkLibraryStreamQueryPagination!, $sort: SmartLkLibraryStreamQuerySort!) {
  result: smartlkLibraryStream(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      stream {
        ...StreamShortType
      }
    }
  }
}
    ${StreamShortTypeFragmentDoc}`;

/**
 * __useLibrarySubCollectionStreamsWithPaginationQuery__
 *
 * To run a query within a React component, call `useLibrarySubCollectionStreamsWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibrarySubCollectionStreamsWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibrarySubCollectionStreamsWithPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLibrarySubCollectionStreamsWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables> & ({ variables: LibrarySubCollectionStreamsWithPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>(LibrarySubCollectionStreamsWithPaginationDocument, options);
      }
export function useLibrarySubCollectionStreamsWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>(LibrarySubCollectionStreamsWithPaginationDocument, options);
        }
// @ts-ignore
export function useLibrarySubCollectionStreamsWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>;
export function useLibrarySubCollectionStreamsWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<LibrarySubCollectionStreamsWithPaginationQuery | undefined, LibrarySubCollectionStreamsWithPaginationQueryVariables>;
export function useLibrarySubCollectionStreamsWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>(LibrarySubCollectionStreamsWithPaginationDocument, options);
        }
export type LibrarySubCollectionStreamsWithPaginationQueryHookResult = ReturnType<typeof useLibrarySubCollectionStreamsWithPaginationQuery>;
export type LibrarySubCollectionStreamsWithPaginationLazyQueryHookResult = ReturnType<typeof useLibrarySubCollectionStreamsWithPaginationLazyQuery>;
export type LibrarySubCollectionStreamsWithPaginationSuspenseQueryHookResult = ReturnType<typeof useLibrarySubCollectionStreamsWithPaginationSuspenseQuery>;
export type LibrarySubCollectionStreamsWithPaginationQueryResult = Apollo.QueryResult<LibrarySubCollectionStreamsWithPaginationQuery, LibrarySubCollectionStreamsWithPaginationQueryVariables>;
export const LibraryCollectionWithPaginationDocument = gql`
    query LibraryCollectionWithPagination($filters: SmartLkLibraryStreamQueryFilter!, $pagination: SmartLkLibraryStreamQueryPagination!, $sort: SmartLkLibraryStreamQuerySort!) {
  result: smartlkLibraryStream(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    result {
      id
      stream {
        ...StreamShortType
      }
    }
  }
}
    ${StreamShortTypeFragmentDoc}`;

/**
 * __useLibraryCollectionWithPaginationQuery__
 *
 * To run a query within a React component, call `useLibraryCollectionWithPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCollectionWithPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCollectionWithPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useLibraryCollectionWithPaginationQuery(baseOptions: Apollo.QueryHookOptions<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables> & ({ variables: LibraryCollectionWithPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>(LibraryCollectionWithPaginationDocument, options);
      }
export function useLibraryCollectionWithPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>(LibraryCollectionWithPaginationDocument, options);
        }
// @ts-ignore
export function useLibraryCollectionWithPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>;
export function useLibraryCollectionWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionWithPaginationQuery | undefined, LibraryCollectionWithPaginationQueryVariables>;
export function useLibraryCollectionWithPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>(LibraryCollectionWithPaginationDocument, options);
        }
export type LibraryCollectionWithPaginationQueryHookResult = ReturnType<typeof useLibraryCollectionWithPaginationQuery>;
export type LibraryCollectionWithPaginationLazyQueryHookResult = ReturnType<typeof useLibraryCollectionWithPaginationLazyQuery>;
export type LibraryCollectionWithPaginationSuspenseQueryHookResult = ReturnType<typeof useLibraryCollectionWithPaginationSuspenseQuery>;
export type LibraryCollectionWithPaginationQueryResult = Apollo.QueryResult<LibraryCollectionWithPaginationQuery, LibraryCollectionWithPaginationQueryVariables>;
export const LibraryRecommendedSubCollectionsDocument = gql`
    query LibraryRecommendedSubCollections($filters: SmartLkLibraryRecommendedSubCollectionsFilter!, $pagination: SmartLkLibraryRecommendedSubCollectionsPagination!) {
  result: smartlkLibraryRecommendedSubcollections(
    filters: $filters
    pagination: $pagination
  ) {
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    result {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useLibraryRecommendedSubCollectionsQuery__
 *
 * To run a query within a React component, call `useLibraryRecommendedSubCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryRecommendedSubCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryRecommendedSubCollectionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLibraryRecommendedSubCollectionsQuery(baseOptions: Apollo.QueryHookOptions<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables> & ({ variables: LibraryRecommendedSubCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>(LibraryRecommendedSubCollectionsDocument, options);
      }
export function useLibraryRecommendedSubCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>(LibraryRecommendedSubCollectionsDocument, options);
        }
// @ts-ignore
export function useLibraryRecommendedSubCollectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>;
export function useLibraryRecommendedSubCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryRecommendedSubCollectionsQuery | undefined, LibraryRecommendedSubCollectionsQueryVariables>;
export function useLibraryRecommendedSubCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>(LibraryRecommendedSubCollectionsDocument, options);
        }
export type LibraryRecommendedSubCollectionsQueryHookResult = ReturnType<typeof useLibraryRecommendedSubCollectionsQuery>;
export type LibraryRecommendedSubCollectionsLazyQueryHookResult = ReturnType<typeof useLibraryRecommendedSubCollectionsLazyQuery>;
export type LibraryRecommendedSubCollectionsSuspenseQueryHookResult = ReturnType<typeof useLibraryRecommendedSubCollectionsSuspenseQuery>;
export type LibraryRecommendedSubCollectionsQueryResult = Apollo.QueryResult<LibraryRecommendedSubCollectionsQuery, LibraryRecommendedSubCollectionsQueryVariables>;
export const CompanyPlaybackReportSettingDocument = gql`
    query CompanyPlaybackReportSetting($companyId: ID!) {
  result: companyPlaybackReportSettings(companyId: $companyId) {
    ...CompanyPlaybackReportSettingType
  }
}
    ${CompanyPlaybackReportSettingTypeFragmentDoc}`;

/**
 * __useCompanyPlaybackReportSettingQuery__
 *
 * To run a query within a React component, call `useCompanyPlaybackReportSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPlaybackReportSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPlaybackReportSettingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyPlaybackReportSettingQuery(baseOptions: Apollo.QueryHookOptions<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables> & ({ variables: CompanyPlaybackReportSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>(CompanyPlaybackReportSettingDocument, options);
      }
export function useCompanyPlaybackReportSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>(CompanyPlaybackReportSettingDocument, options);
        }
// @ts-ignore
export function useCompanyPlaybackReportSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>;
export function useCompanyPlaybackReportSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyPlaybackReportSettingQuery | undefined, CompanyPlaybackReportSettingQueryVariables>;
export function useCompanyPlaybackReportSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>(CompanyPlaybackReportSettingDocument, options);
        }
export type CompanyPlaybackReportSettingQueryHookResult = ReturnType<typeof useCompanyPlaybackReportSettingQuery>;
export type CompanyPlaybackReportSettingLazyQueryHookResult = ReturnType<typeof useCompanyPlaybackReportSettingLazyQuery>;
export type CompanyPlaybackReportSettingSuspenseQueryHookResult = ReturnType<typeof useCompanyPlaybackReportSettingSuspenseQuery>;
export type CompanyPlaybackReportSettingQueryResult = Apollo.QueryResult<CompanyPlaybackReportSettingQuery, CompanyPlaybackReportSettingQueryVariables>;
export const CompanyPlaybackReportsDocument = gql`
    query CompanyPlaybackReports($companyId: ID!, $filters: CompanyPlaybackReportsQueryFilter!) {
  result: companyPlaybackReports(companyId: $companyId, filters: $filters) {
    ...CompanyReportType
  }
}
    ${CompanyReportTypeFragmentDoc}`;

/**
 * __useCompanyPlaybackReportsQuery__
 *
 * To run a query within a React component, call `useCompanyPlaybackReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyPlaybackReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyPlaybackReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCompanyPlaybackReportsQuery(baseOptions: Apollo.QueryHookOptions<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables> & ({ variables: CompanyPlaybackReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>(CompanyPlaybackReportsDocument, options);
      }
export function useCompanyPlaybackReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>(CompanyPlaybackReportsDocument, options);
        }
// @ts-ignore
export function useCompanyPlaybackReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>;
export function useCompanyPlaybackReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyPlaybackReportsQuery | undefined, CompanyPlaybackReportsQueryVariables>;
export function useCompanyPlaybackReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>(CompanyPlaybackReportsDocument, options);
        }
export type CompanyPlaybackReportsQueryHookResult = ReturnType<typeof useCompanyPlaybackReportsQuery>;
export type CompanyPlaybackReportsLazyQueryHookResult = ReturnType<typeof useCompanyPlaybackReportsLazyQuery>;
export type CompanyPlaybackReportsSuspenseQueryHookResult = ReturnType<typeof useCompanyPlaybackReportsSuspenseQuery>;
export type CompanyPlaybackReportsQueryResult = Apollo.QueryResult<CompanyPlaybackReportsQuery, CompanyPlaybackReportsQueryVariables>;
export const RequestCompanyPlaybackEarlyReportDocument = gql`
    mutation RequestCompanyPlaybackEarlyReport($input: CompanyPlaybackEarlyReportMutationInput!) {
  result: companyPlaybackEarlyReport(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type RequestCompanyPlaybackEarlyReportMutationFn = Apollo.MutationFunction<RequestCompanyPlaybackEarlyReportMutation, RequestCompanyPlaybackEarlyReportMutationVariables>;

/**
 * __useRequestCompanyPlaybackEarlyReportMutation__
 *
 * To run a mutation, you first call `useRequestCompanyPlaybackEarlyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCompanyPlaybackEarlyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCompanyPlaybackEarlyReportMutation, { data, loading, error }] = useRequestCompanyPlaybackEarlyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCompanyPlaybackEarlyReportMutation(baseOptions?: Apollo.MutationHookOptions<RequestCompanyPlaybackEarlyReportMutation, RequestCompanyPlaybackEarlyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCompanyPlaybackEarlyReportMutation, RequestCompanyPlaybackEarlyReportMutationVariables>(RequestCompanyPlaybackEarlyReportDocument, options);
      }
export type RequestCompanyPlaybackEarlyReportMutationHookResult = ReturnType<typeof useRequestCompanyPlaybackEarlyReportMutation>;
export type RequestCompanyPlaybackEarlyReportMutationResult = Apollo.MutationResult<RequestCompanyPlaybackEarlyReportMutation>;
export type RequestCompanyPlaybackEarlyReportMutationOptions = Apollo.BaseMutationOptions<RequestCompanyPlaybackEarlyReportMutation, RequestCompanyPlaybackEarlyReportMutationVariables>;
export const MediaCompanyAdCampaignsEarlyReportDocument = gql`
    mutation mediaCompanyAdCampaignsEarlyReport($input: CompanyAdCampaignsEarlyReportInput!) {
  result: companyAdCampaignsEarlyReport(input: $input) {
    ok
    isCreated
    errors {
      field
      messages
    }
  }
}
    `;
export type MediaCompanyAdCampaignsEarlyReportMutationFn = Apollo.MutationFunction<MediaCompanyAdCampaignsEarlyReportMutation, MediaCompanyAdCampaignsEarlyReportMutationVariables>;

/**
 * __useMediaCompanyAdCampaignsEarlyReportMutation__
 *
 * To run a mutation, you first call `useMediaCompanyAdCampaignsEarlyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaCompanyAdCampaignsEarlyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaCompanyAdCampaignsEarlyReportMutation, { data, loading, error }] = useMediaCompanyAdCampaignsEarlyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaCompanyAdCampaignsEarlyReportMutation(baseOptions?: Apollo.MutationHookOptions<MediaCompanyAdCampaignsEarlyReportMutation, MediaCompanyAdCampaignsEarlyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaCompanyAdCampaignsEarlyReportMutation, MediaCompanyAdCampaignsEarlyReportMutationVariables>(MediaCompanyAdCampaignsEarlyReportDocument, options);
      }
export type MediaCompanyAdCampaignsEarlyReportMutationHookResult = ReturnType<typeof useMediaCompanyAdCampaignsEarlyReportMutation>;
export type MediaCompanyAdCampaignsEarlyReportMutationResult = Apollo.MutationResult<MediaCompanyAdCampaignsEarlyReportMutation>;
export type MediaCompanyAdCampaignsEarlyReportMutationOptions = Apollo.BaseMutationOptions<MediaCompanyAdCampaignsEarlyReportMutation, MediaCompanyAdCampaignsEarlyReportMutationVariables>;
export const UserFeaturesOnboardingQueryDocument = gql`
    query UserFeaturesOnboardingQuery($filters: UserFeaturesOnboardingFilter!) {
  result: userFeaturesOnboardingQuery(filters: $filters) {
    ...UserFeatureOnboarding
  }
}
    ${UserFeatureOnboardingFragmentDoc}`;

/**
 * __useUserFeaturesOnboardingQueryQuery__
 *
 * To run a query within a React component, call `useUserFeaturesOnboardingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeaturesOnboardingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeaturesOnboardingQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserFeaturesOnboardingQueryQuery(baseOptions: Apollo.QueryHookOptions<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables> & ({ variables: UserFeaturesOnboardingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>(UserFeaturesOnboardingQueryDocument, options);
      }
export function useUserFeaturesOnboardingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>(UserFeaturesOnboardingQueryDocument, options);
        }
// @ts-ignore
export function useUserFeaturesOnboardingQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>): Apollo.UseSuspenseQueryResult<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>;
export function useUserFeaturesOnboardingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>): Apollo.UseSuspenseQueryResult<UserFeaturesOnboardingQueryQuery | undefined, UserFeaturesOnboardingQueryQueryVariables>;
export function useUserFeaturesOnboardingQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>(UserFeaturesOnboardingQueryDocument, options);
        }
export type UserFeaturesOnboardingQueryQueryHookResult = ReturnType<typeof useUserFeaturesOnboardingQueryQuery>;
export type UserFeaturesOnboardingQueryLazyQueryHookResult = ReturnType<typeof useUserFeaturesOnboardingQueryLazyQuery>;
export type UserFeaturesOnboardingQuerySuspenseQueryHookResult = ReturnType<typeof useUserFeaturesOnboardingQuerySuspenseQuery>;
export type UserFeaturesOnboardingQueryQueryResult = Apollo.QueryResult<UserFeaturesOnboardingQueryQuery, UserFeaturesOnboardingQueryQueryVariables>;
export const FeaturesOnboardingPassDocument = gql`
    mutation FeaturesOnboardingPass($input: UserFeaturesOnboardingPassMutationInput!) {
  result: userFeaturesOnboardingPass(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type FeaturesOnboardingPassMutationFn = Apollo.MutationFunction<FeaturesOnboardingPassMutation, FeaturesOnboardingPassMutationVariables>;

/**
 * __useFeaturesOnboardingPassMutation__
 *
 * To run a mutation, you first call `useFeaturesOnboardingPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeaturesOnboardingPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featuresOnboardingPassMutation, { data, loading, error }] = useFeaturesOnboardingPassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeaturesOnboardingPassMutation(baseOptions?: Apollo.MutationHookOptions<FeaturesOnboardingPassMutation, FeaturesOnboardingPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeaturesOnboardingPassMutation, FeaturesOnboardingPassMutationVariables>(FeaturesOnboardingPassDocument, options);
      }
export type FeaturesOnboardingPassMutationHookResult = ReturnType<typeof useFeaturesOnboardingPassMutation>;
export type FeaturesOnboardingPassMutationResult = Apollo.MutationResult<FeaturesOnboardingPassMutation>;
export type FeaturesOnboardingPassMutationOptions = Apollo.BaseMutationOptions<FeaturesOnboardingPassMutation, FeaturesOnboardingPassMutationVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  result: notificationsQuery {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const SetNotificationSetViewedDocument = gql`
    mutation SetNotificationSetViewed($input: ViewNotificationMutationInput!) {
  result: viewNotification(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type SetNotificationSetViewedMutationFn = Apollo.MutationFunction<SetNotificationSetViewedMutation, SetNotificationSetViewedMutationVariables>;

/**
 * __useSetNotificationSetViewedMutation__
 *
 * To run a mutation, you first call `useSetNotificationSetViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationSetViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationSetViewedMutation, { data, loading, error }] = useSetNotificationSetViewedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetNotificationSetViewedMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationSetViewedMutation, SetNotificationSetViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationSetViewedMutation, SetNotificationSetViewedMutationVariables>(SetNotificationSetViewedDocument, options);
      }
export type SetNotificationSetViewedMutationHookResult = ReturnType<typeof useSetNotificationSetViewedMutation>;
export type SetNotificationSetViewedMutationResult = Apollo.MutationResult<SetNotificationSetViewedMutation>;
export type SetNotificationSetViewedMutationOptions = Apollo.BaseMutationOptions<SetNotificationSetViewedMutation, SetNotificationSetViewedMutationVariables>;
export const LibraryStreamsSearchDocument = gql`
    query libraryStreamsSearch($filters: LibraryStreamsSearchQueryFilter!, $pagination: LibraryStreamsSearchQueryPagination!) {
  result: libraryStreamsSearch(filters: $filters, pagination: $pagination) {
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    result {
      ...StreamShortType
    }
  }
}
    ${StreamShortTypeFragmentDoc}`;

/**
 * __useLibraryStreamsSearchQuery__
 *
 * To run a query within a React component, call `useLibraryStreamsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryStreamsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryStreamsSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLibraryStreamsSearchQuery(baseOptions: Apollo.QueryHookOptions<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables> & ({ variables: LibraryStreamsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>(LibraryStreamsSearchDocument, options);
      }
export function useLibraryStreamsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>(LibraryStreamsSearchDocument, options);
        }
// @ts-ignore
export function useLibraryStreamsSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>;
export function useLibraryStreamsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryStreamsSearchQuery | undefined, LibraryStreamsSearchQueryVariables>;
export function useLibraryStreamsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>(LibraryStreamsSearchDocument, options);
        }
export type LibraryStreamsSearchQueryHookResult = ReturnType<typeof useLibraryStreamsSearchQuery>;
export type LibraryStreamsSearchLazyQueryHookResult = ReturnType<typeof useLibraryStreamsSearchLazyQuery>;
export type LibraryStreamsSearchSuspenseQueryHookResult = ReturnType<typeof useLibraryStreamsSearchSuspenseQuery>;
export type LibraryStreamsSearchQueryResult = Apollo.QueryResult<LibraryStreamsSearchQuery, LibraryStreamsSearchQueryVariables>;
export const LibraryCollectionsSearchDocument = gql`
    query libraryCollectionsSearch($filters: LibraryCollectionsSearchQueryFilter!, $pagination: LibraryCollectionsSearchQueryPagination!) {
  result: libraryCollectionsSearch(filters: $filters, pagination: $pagination) {
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    result {
      ...CollectionShortType
    }
  }
}
    ${CollectionShortTypeFragmentDoc}`;

/**
 * __useLibraryCollectionsSearchQuery__
 *
 * To run a query within a React component, call `useLibraryCollectionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCollectionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCollectionsSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useLibraryCollectionsSearchQuery(baseOptions: Apollo.QueryHookOptions<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables> & ({ variables: LibraryCollectionsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>(LibraryCollectionsSearchDocument, options);
      }
export function useLibraryCollectionsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>(LibraryCollectionsSearchDocument, options);
        }
// @ts-ignore
export function useLibraryCollectionsSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>;
export function useLibraryCollectionsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<LibraryCollectionsSearchQuery | undefined, LibraryCollectionsSearchQueryVariables>;
export function useLibraryCollectionsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>(LibraryCollectionsSearchDocument, options);
        }
export type LibraryCollectionsSearchQueryHookResult = ReturnType<typeof useLibraryCollectionsSearchQuery>;
export type LibraryCollectionsSearchLazyQueryHookResult = ReturnType<typeof useLibraryCollectionsSearchLazyQuery>;
export type LibraryCollectionsSearchSuspenseQueryHookResult = ReturnType<typeof useLibraryCollectionsSearchSuspenseQuery>;
export type LibraryCollectionsSearchQueryResult = Apollo.QueryResult<LibraryCollectionsSearchQuery, LibraryCollectionsSearchQueryVariables>;
export const StreamSearchTagsQueryDocument = gql`
    query streamSearchTagsQuery {
  result: streamSearchTagsQuery {
    tags {
      id
      title
      children {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useStreamSearchTagsQueryQuery__
 *
 * To run a query within a React component, call `useStreamSearchTagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStreamSearchTagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreamSearchTagsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useStreamSearchTagsQueryQuery(baseOptions?: Apollo.QueryHookOptions<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>(StreamSearchTagsQueryDocument, options);
      }
export function useStreamSearchTagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>(StreamSearchTagsQueryDocument, options);
        }
// @ts-ignore
export function useStreamSearchTagsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>;
export function useStreamSearchTagsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<StreamSearchTagsQueryQuery | undefined, StreamSearchTagsQueryQueryVariables>;
export function useStreamSearchTagsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>(StreamSearchTagsQueryDocument, options);
        }
export type StreamSearchTagsQueryQueryHookResult = ReturnType<typeof useStreamSearchTagsQueryQuery>;
export type StreamSearchTagsQueryLazyQueryHookResult = ReturnType<typeof useStreamSearchTagsQueryLazyQuery>;
export type StreamSearchTagsQuerySuspenseQueryHookResult = ReturnType<typeof useStreamSearchTagsQuerySuspenseQuery>;
export type StreamSearchTagsQueryQueryResult = Apollo.QueryResult<StreamSearchTagsQueryQuery, StreamSearchTagsQueryQueryVariables>;
export const MediaLikeMediafileDocument = gql`
    mutation mediaLikeMediafile($input: StreamLikeMediafileInput!) {
  result: streamLikeMediafile(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type MediaLikeMediafileMutationFn = Apollo.MutationFunction<MediaLikeMediafileMutation, MediaLikeMediafileMutationVariables>;

/**
 * __useMediaLikeMediafileMutation__
 *
 * To run a mutation, you first call `useMediaLikeMediafileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaLikeMediafileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaLikeMediafileMutation, { data, loading, error }] = useMediaLikeMediafileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaLikeMediafileMutation(baseOptions?: Apollo.MutationHookOptions<MediaLikeMediafileMutation, MediaLikeMediafileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaLikeMediafileMutation, MediaLikeMediafileMutationVariables>(MediaLikeMediafileDocument, options);
      }
export type MediaLikeMediafileMutationHookResult = ReturnType<typeof useMediaLikeMediafileMutation>;
export type MediaLikeMediafileMutationResult = Apollo.MutationResult<MediaLikeMediafileMutation>;
export type MediaLikeMediafileMutationOptions = Apollo.BaseMutationOptions<MediaLikeMediafileMutation, MediaLikeMediafileMutationVariables>;
export const MediaUnLikeMediafileDocument = gql`
    mutation mediaUnLikeMediafile($input: StreamUnLikeMediafileInput!) {
  result: streamUnLikeMediafile(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type MediaUnLikeMediafileMutationFn = Apollo.MutationFunction<MediaUnLikeMediafileMutation, MediaUnLikeMediafileMutationVariables>;

/**
 * __useMediaUnLikeMediafileMutation__
 *
 * To run a mutation, you first call `useMediaUnLikeMediafileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaUnLikeMediafileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaUnLikeMediafileMutation, { data, loading, error }] = useMediaUnLikeMediafileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaUnLikeMediafileMutation(baseOptions?: Apollo.MutationHookOptions<MediaUnLikeMediafileMutation, MediaUnLikeMediafileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaUnLikeMediafileMutation, MediaUnLikeMediafileMutationVariables>(MediaUnLikeMediafileDocument, options);
      }
export type MediaUnLikeMediafileMutationHookResult = ReturnType<typeof useMediaUnLikeMediafileMutation>;
export type MediaUnLikeMediafileMutationResult = Apollo.MutationResult<MediaUnLikeMediafileMutation>;
export type MediaUnLikeMediafileMutationOptions = Apollo.BaseMutationOptions<MediaUnLikeMediafileMutation, MediaUnLikeMediafileMutationVariables>;
export const MediafilesApprovalDocument = gql`
    query mediafilesApproval($filters: StreamMediafilesApprovalFilter!, $pagination: StreamMediafilesApprovalPagination!) {
  streamMediafilesApproval(filters: $filters, pagination: $pagination) {
    result {
      ...MediafileApprovalFragment
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MediafileApprovalFragmentFragmentDoc}`;

/**
 * __useMediafilesApprovalQuery__
 *
 * To run a query within a React component, call `useMediafilesApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediafilesApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediafilesApprovalQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMediafilesApprovalQuery(baseOptions: Apollo.QueryHookOptions<MediafilesApprovalQuery, MediafilesApprovalQueryVariables> & ({ variables: MediafilesApprovalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>(MediafilesApprovalDocument, options);
      }
export function useMediafilesApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>(MediafilesApprovalDocument, options);
        }
// @ts-ignore
export function useMediafilesApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>;
export function useMediafilesApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<MediafilesApprovalQuery | undefined, MediafilesApprovalQueryVariables>;
export function useMediafilesApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>(MediafilesApprovalDocument, options);
        }
export type MediafilesApprovalQueryHookResult = ReturnType<typeof useMediafilesApprovalQuery>;
export type MediafilesApprovalLazyQueryHookResult = ReturnType<typeof useMediafilesApprovalLazyQuery>;
export type MediafilesApprovalSuspenseQueryHookResult = ReturnType<typeof useMediafilesApprovalSuspenseQuery>;
export type MediafilesApprovalQueryResult = Apollo.QueryResult<MediafilesApprovalQuery, MediafilesApprovalQueryVariables>;
export const MediafilesStreamDocument = gql`
    query mediafilesStream($filters: StreamMediafilesFilter!, $pagination: StreamMediafilesPagination!, $sort: StreamMediafilesSort!) {
  streamMediafiles(filters: $filters, pagination: $pagination, sort: $sort) {
    result {
      ...MediafileInfoType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MediafileInfoTypeFragmentDoc}`;

/**
 * __useMediafilesStreamQuery__
 *
 * To run a query within a React component, call `useMediafilesStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediafilesStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediafilesStreamQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMediafilesStreamQuery(baseOptions: Apollo.QueryHookOptions<MediafilesStreamQuery, MediafilesStreamQueryVariables> & ({ variables: MediafilesStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediafilesStreamQuery, MediafilesStreamQueryVariables>(MediafilesStreamDocument, options);
      }
export function useMediafilesStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediafilesStreamQuery, MediafilesStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediafilesStreamQuery, MediafilesStreamQueryVariables>(MediafilesStreamDocument, options);
        }
// @ts-ignore
export function useMediafilesStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediafilesStreamQuery, MediafilesStreamQueryVariables>): Apollo.UseSuspenseQueryResult<MediafilesStreamQuery, MediafilesStreamQueryVariables>;
export function useMediafilesStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediafilesStreamQuery, MediafilesStreamQueryVariables>): Apollo.UseSuspenseQueryResult<MediafilesStreamQuery | undefined, MediafilesStreamQueryVariables>;
export function useMediafilesStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediafilesStreamQuery, MediafilesStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediafilesStreamQuery, MediafilesStreamQueryVariables>(MediafilesStreamDocument, options);
        }
export type MediafilesStreamQueryHookResult = ReturnType<typeof useMediafilesStreamQuery>;
export type MediafilesStreamLazyQueryHookResult = ReturnType<typeof useMediafilesStreamLazyQuery>;
export type MediafilesStreamSuspenseQueryHookResult = ReturnType<typeof useMediafilesStreamSuspenseQuery>;
export type MediafilesStreamQueryResult = Apollo.QueryResult<MediafilesStreamQuery, MediafilesStreamQueryVariables>;
export const GetCompanyStreamsDocument = gql`
    query getCompanyStreams($filters: StreamsQueryFilter!, $pagination: StreamsQueryPagination!, $sort: StreamsQuerySort!) {
  streamsPaginationQuery(filters: $filters, pagination: $pagination, sort: $sort) {
    result {
      id
      title
      pointsNum
      cover {
        miniatureUri
      }
      hasThematicBlock
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetCompanyStreamsQuery__
 *
 * To run a query within a React component, call `useGetCompanyStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyStreamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCompanyStreamsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables> & ({ variables: GetCompanyStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>(GetCompanyStreamsDocument, options);
      }
export function useGetCompanyStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>(GetCompanyStreamsDocument, options);
        }
// @ts-ignore
export function useGetCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>;
export function useGetCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyStreamsQuery | undefined, GetCompanyStreamsQueryVariables>;
export function useGetCompanyStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>(GetCompanyStreamsDocument, options);
        }
export type GetCompanyStreamsQueryHookResult = ReturnType<typeof useGetCompanyStreamsQuery>;
export type GetCompanyStreamsLazyQueryHookResult = ReturnType<typeof useGetCompanyStreamsLazyQuery>;
export type GetCompanyStreamsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyStreamsSuspenseQuery>;
export type GetCompanyStreamsQueryResult = Apollo.QueryResult<GetCompanyStreamsQuery, GetCompanyStreamsQueryVariables>;
export const GetCompanyVideoStreamsDocument = gql`
    query getCompanyVideoStreams($filters: SmartLkVideoStreamsQueryFilter!, $pagination: SmartLkVideoStreamsQueryPagination!, $sort: SmartLkVideoStreamsQuerySort!) {
  smartlkVideoStreamsPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      title
      previewUrl
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetCompanyVideoStreamsQuery__
 *
 * To run a query within a React component, call `useGetCompanyVideoStreamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyVideoStreamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyVideoStreamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCompanyVideoStreamsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables> & ({ variables: GetCompanyVideoStreamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>(GetCompanyVideoStreamsDocument, options);
      }
export function useGetCompanyVideoStreamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>(GetCompanyVideoStreamsDocument, options);
        }
// @ts-ignore
export function useGetCompanyVideoStreamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>;
export function useGetCompanyVideoStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyVideoStreamsQuery | undefined, GetCompanyVideoStreamsQueryVariables>;
export function useGetCompanyVideoStreamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>(GetCompanyVideoStreamsDocument, options);
        }
export type GetCompanyVideoStreamsQueryHookResult = ReturnType<typeof useGetCompanyVideoStreamsQuery>;
export type GetCompanyVideoStreamsLazyQueryHookResult = ReturnType<typeof useGetCompanyVideoStreamsLazyQuery>;
export type GetCompanyVideoStreamsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyVideoStreamsSuspenseQuery>;
export type GetCompanyVideoStreamsQueryResult = Apollo.QueryResult<GetCompanyVideoStreamsQuery, GetCompanyVideoStreamsQueryVariables>;
export const VideoStreamDocument = gql`
    query videoStream($companyId: ID!, $id: ID!) {
  result: smartlkVideoStreamQuery(companyId: $companyId, id: $id) {
    id
    title
    description
    isDefault
    size
    duration
    devicesGroup {
      id
      title
      schedulerMode
      isValid
      validationError
      masterVideoStream {
        id
        title
      }
    }
    videoMediafiles {
      id
      order
      title
      previewUrl
      playDuration
      mediafile {
        id
        type
        duration
        uri
        sourcefiles {
          extension
        }
      }
    }
    emenuMediafiles {
      id
      order
      playDuration
      playCount
      title
      emenuMediafile {
        id
        generationDuration
      }
    }
    points {
      id
    }
    tags {
      id
      title
    }
  }
}
    `;

/**
 * __useVideoStreamQuery__
 *
 * To run a query within a React component, call `useVideoStreamQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoStreamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoStreamQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoStreamQuery(baseOptions: Apollo.QueryHookOptions<VideoStreamQuery, VideoStreamQueryVariables> & ({ variables: VideoStreamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoStreamQuery, VideoStreamQueryVariables>(VideoStreamDocument, options);
      }
export function useVideoStreamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoStreamQuery, VideoStreamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoStreamQuery, VideoStreamQueryVariables>(VideoStreamDocument, options);
        }
// @ts-ignore
export function useVideoStreamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VideoStreamQuery, VideoStreamQueryVariables>): Apollo.UseSuspenseQueryResult<VideoStreamQuery, VideoStreamQueryVariables>;
export function useVideoStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoStreamQuery, VideoStreamQueryVariables>): Apollo.UseSuspenseQueryResult<VideoStreamQuery | undefined, VideoStreamQueryVariables>;
export function useVideoStreamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoStreamQuery, VideoStreamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoStreamQuery, VideoStreamQueryVariables>(VideoStreamDocument, options);
        }
export type VideoStreamQueryHookResult = ReturnType<typeof useVideoStreamQuery>;
export type VideoStreamLazyQueryHookResult = ReturnType<typeof useVideoStreamLazyQuery>;
export type VideoStreamSuspenseQueryHookResult = ReturnType<typeof useVideoStreamSuspenseQuery>;
export type VideoStreamQueryResult = Apollo.QueryResult<VideoStreamQuery, VideoStreamQueryVariables>;
export const PointsBindVideoStreamDocument = gql`
    mutation pointsBindVideoStream($input: SmartLkPointsBindVideoStreamMutationInput!) {
  result: smartlkPointsBindVideoStream(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type PointsBindVideoStreamMutationFn = Apollo.MutationFunction<PointsBindVideoStreamMutation, PointsBindVideoStreamMutationVariables>;

/**
 * __usePointsBindVideoStreamMutation__
 *
 * To run a mutation, you first call `usePointsBindVideoStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointsBindVideoStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointsBindVideoStreamMutation, { data, loading, error }] = usePointsBindVideoStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointsBindVideoStreamMutation(baseOptions?: Apollo.MutationHookOptions<PointsBindVideoStreamMutation, PointsBindVideoStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointsBindVideoStreamMutation, PointsBindVideoStreamMutationVariables>(PointsBindVideoStreamDocument, options);
      }
export type PointsBindVideoStreamMutationHookResult = ReturnType<typeof usePointsBindVideoStreamMutation>;
export type PointsBindVideoStreamMutationResult = Apollo.MutationResult<PointsBindVideoStreamMutation>;
export type PointsBindVideoStreamMutationOptions = Apollo.BaseMutationOptions<PointsBindVideoStreamMutation, PointsBindVideoStreamMutationVariables>;
export const GetCompanyMediafilesDocument = gql`
    query getCompanyMediafiles($filters: SmartlkCompanyMediafilesQueryFilter!, $pagination: SmartlkCompanyMediafilesPagination!) {
  smartlkCompanyMediafilesQuery(filters: $filters, pagination: $pagination) {
    result {
      id
      title
      previewUrl
      duration
      sourcefiles {
        extension
      }
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useGetCompanyMediafilesQuery__
 *
 * To run a query within a React component, call `useGetCompanyMediafilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyMediafilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyMediafilesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyMediafilesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables> & ({ variables: GetCompanyMediafilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>(GetCompanyMediafilesDocument, options);
      }
export function useGetCompanyMediafilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>(GetCompanyMediafilesDocument, options);
        }
// @ts-ignore
export function useGetCompanyMediafilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>;
export function useGetCompanyMediafilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyMediafilesQuery | undefined, GetCompanyMediafilesQueryVariables>;
export function useGetCompanyMediafilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>(GetCompanyMediafilesDocument, options);
        }
export type GetCompanyMediafilesQueryHookResult = ReturnType<typeof useGetCompanyMediafilesQuery>;
export type GetCompanyMediafilesLazyQueryHookResult = ReturnType<typeof useGetCompanyMediafilesLazyQuery>;
export type GetCompanyMediafilesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyMediafilesSuspenseQuery>;
export type GetCompanyMediafilesQueryResult = Apollo.QueryResult<GetCompanyMediafilesQuery, GetCompanyMediafilesQueryVariables>;
export const UploadMediaFilesDocument = gql`
    mutation uploadMediaFiles($input: SmartlkVideoOrImageUploadMutationInput!) {
  result: smartlkVideoOrImageMediafileUpload(input: $input) {
    file {
      id
      title
      duration
      previewUrl
    }
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type UploadMediaFilesMutationFn = Apollo.MutationFunction<UploadMediaFilesMutation, UploadMediaFilesMutationVariables>;

/**
 * __useUploadMediaFilesMutation__
 *
 * To run a mutation, you first call `useUploadMediaFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaFilesMutation, { data, loading, error }] = useUploadMediaFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadMediaFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaFilesMutation, UploadMediaFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaFilesMutation, UploadMediaFilesMutationVariables>(UploadMediaFilesDocument, options);
      }
export type UploadMediaFilesMutationHookResult = ReturnType<typeof useUploadMediaFilesMutation>;
export type UploadMediaFilesMutationResult = Apollo.MutationResult<UploadMediaFilesMutation>;
export type UploadMediaFilesMutationOptions = Apollo.BaseMutationOptions<UploadMediaFilesMutation, UploadMediaFilesMutationVariables>;
export const CreateVideoStreamDocument = gql`
    mutation createVideoStream($input: SmartlkVideoStreamCreateMutationInput!) {
  result: smartlkVideoStreamCreate(input: $input) {
    ok
    errors {
      field
      messages
    }
    videoStream {
      id
    }
  }
}
    `;
export type CreateVideoStreamMutationFn = Apollo.MutationFunction<CreateVideoStreamMutation, CreateVideoStreamMutationVariables>;

/**
 * __useCreateVideoStreamMutation__
 *
 * To run a mutation, you first call `useCreateVideoStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoStreamMutation, { data, loading, error }] = useCreateVideoStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoStreamMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoStreamMutation, CreateVideoStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoStreamMutation, CreateVideoStreamMutationVariables>(CreateVideoStreamDocument, options);
      }
export type CreateVideoStreamMutationHookResult = ReturnType<typeof useCreateVideoStreamMutation>;
export type CreateVideoStreamMutationResult = Apollo.MutationResult<CreateVideoStreamMutation>;
export type CreateVideoStreamMutationOptions = Apollo.BaseMutationOptions<CreateVideoStreamMutation, CreateVideoStreamMutationVariables>;
export const UpdateVideoStreamDocument = gql`
    mutation updateVideoStream($input: SmartlkVideoStreamUpdateMutationInput!) {
  result: smartlkVideoStreamUpdate(input: $input) {
    ok
    errors {
      field
      messages
    }
    videoStream {
      id
    }
  }
}
    `;
export type UpdateVideoStreamMutationFn = Apollo.MutationFunction<UpdateVideoStreamMutation, UpdateVideoStreamMutationVariables>;

/**
 * __useUpdateVideoStreamMutation__
 *
 * To run a mutation, you first call `useUpdateVideoStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoStreamMutation, { data, loading, error }] = useUpdateVideoStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoStreamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoStreamMutation, UpdateVideoStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoStreamMutation, UpdateVideoStreamMutationVariables>(UpdateVideoStreamDocument, options);
      }
export type UpdateVideoStreamMutationHookResult = ReturnType<typeof useUpdateVideoStreamMutation>;
export type UpdateVideoStreamMutationResult = Apollo.MutationResult<UpdateVideoStreamMutation>;
export type UpdateVideoStreamMutationOptions = Apollo.BaseMutationOptions<UpdateVideoStreamMutation, UpdateVideoStreamMutationVariables>;
export const CopyVideoStreamFromTemplateDocument = gql`
    mutation copyVideoStreamFromTemplate($input: SmartlkVideoStreamCopyFromTemplateMutationInput!) {
  result: smartlkVideoStreamCopyFromTemplate(input: $input) {
    ok
    errors {
      field
      messages
    }
    videoStream {
      id
    }
  }
}
    `;
export type CopyVideoStreamFromTemplateMutationFn = Apollo.MutationFunction<CopyVideoStreamFromTemplateMutation, CopyVideoStreamFromTemplateMutationVariables>;

/**
 * __useCopyVideoStreamFromTemplateMutation__
 *
 * To run a mutation, you first call `useCopyVideoStreamFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyVideoStreamFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyVideoStreamFromTemplateMutation, { data, loading, error }] = useCopyVideoStreamFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyVideoStreamFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CopyVideoStreamFromTemplateMutation, CopyVideoStreamFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyVideoStreamFromTemplateMutation, CopyVideoStreamFromTemplateMutationVariables>(CopyVideoStreamFromTemplateDocument, options);
      }
export type CopyVideoStreamFromTemplateMutationHookResult = ReturnType<typeof useCopyVideoStreamFromTemplateMutation>;
export type CopyVideoStreamFromTemplateMutationResult = Apollo.MutationResult<CopyVideoStreamFromTemplateMutation>;
export type CopyVideoStreamFromTemplateMutationOptions = Apollo.BaseMutationOptions<CopyVideoStreamFromTemplateMutation, CopyVideoStreamFromTemplateMutationVariables>;
export const VideoStreamSetCompanyTagsDocument = gql`
    mutation videoStreamSetCompanyTags($input: SmartLkVideoStreamPureSetCompanyTagsInput!) {
  smartlkVideoStreamPureSetCompanyTags(input: $input) {
    ok
    errors {
      field
      messages
    }
    videoStream {
      id
      tags {
        id
        title
      }
    }
  }
}
    `;
export type VideoStreamSetCompanyTagsMutationFn = Apollo.MutationFunction<VideoStreamSetCompanyTagsMutation, VideoStreamSetCompanyTagsMutationVariables>;

/**
 * __useVideoStreamSetCompanyTagsMutation__
 *
 * To run a mutation, you first call `useVideoStreamSetCompanyTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoStreamSetCompanyTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoStreamSetCompanyTagsMutation, { data, loading, error }] = useVideoStreamSetCompanyTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoStreamSetCompanyTagsMutation(baseOptions?: Apollo.MutationHookOptions<VideoStreamSetCompanyTagsMutation, VideoStreamSetCompanyTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoStreamSetCompanyTagsMutation, VideoStreamSetCompanyTagsMutationVariables>(VideoStreamSetCompanyTagsDocument, options);
      }
export type VideoStreamSetCompanyTagsMutationHookResult = ReturnType<typeof useVideoStreamSetCompanyTagsMutation>;
export type VideoStreamSetCompanyTagsMutationResult = Apollo.MutationResult<VideoStreamSetCompanyTagsMutation>;
export type VideoStreamSetCompanyTagsMutationOptions = Apollo.BaseMutationOptions<VideoStreamSetCompanyTagsMutation, VideoStreamSetCompanyTagsMutationVariables>;
export const PointDocument = gql`
    query point($id: ID!) {
  pointPure(id: $id) {
    ...PointInfoType
  }
}
    ${PointInfoTypeFragmentDoc}`;

/**
 * __usePointQuery__
 *
 * To run a query within a React component, call `usePointQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePointQuery(baseOptions: Apollo.QueryHookOptions<PointQuery, PointQueryVariables> & ({ variables: PointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointQuery, PointQueryVariables>(PointDocument, options);
      }
export function usePointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointQuery, PointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointQuery, PointQueryVariables>(PointDocument, options);
        }
// @ts-ignore
export function usePointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointQuery, PointQueryVariables>): Apollo.UseSuspenseQueryResult<PointQuery, PointQueryVariables>;
export function usePointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointQuery, PointQueryVariables>): Apollo.UseSuspenseQueryResult<PointQuery | undefined, PointQueryVariables>;
export function usePointSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointQuery, PointQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointQuery, PointQueryVariables>(PointDocument, options);
        }
export type PointQueryHookResult = ReturnType<typeof usePointQuery>;
export type PointLazyQueryHookResult = ReturnType<typeof usePointLazyQuery>;
export type PointSuspenseQueryHookResult = ReturnType<typeof usePointSuspenseQuery>;
export type PointQueryResult = Apollo.QueryResult<PointQuery, PointQueryVariables>;
export const PointListDocument = gql`
    query pointList($filters: PointQueryFilter!, $pagination: PointQueryPagination!, $sort: PointQuerySort!) {
  pointsPaginationQuery(filters: $filters, pagination: $pagination, sort: $sort) {
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    result {
      ...PointShortType
    }
    statusesInfo {
      playing
      sleep
      notPlaying
      mbNoConnection
      playerDisabled
      notGeneration
      stop
      mbPlaying
    }
  }
}
    ${PointShortTypeFragmentDoc}`;

/**
 * __usePointListQuery__
 *
 * To run a query within a React component, call `usePointListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointListQuery(baseOptions: Apollo.QueryHookOptions<PointListQuery, PointListQueryVariables> & ({ variables: PointListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointListQuery, PointListQueryVariables>(PointListDocument, options);
      }
export function usePointListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointListQuery, PointListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointListQuery, PointListQueryVariables>(PointListDocument, options);
        }
// @ts-ignore
export function usePointListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointListQuery, PointListQueryVariables>): Apollo.UseSuspenseQueryResult<PointListQuery, PointListQueryVariables>;
export function usePointListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointListQuery, PointListQueryVariables>): Apollo.UseSuspenseQueryResult<PointListQuery | undefined, PointListQueryVariables>;
export function usePointListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointListQuery, PointListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointListQuery, PointListQueryVariables>(PointListDocument, options);
        }
export type PointListQueryHookResult = ReturnType<typeof usePointListQuery>;
export type PointListLazyQueryHookResult = ReturnType<typeof usePointListLazyQuery>;
export type PointListSuspenseQueryHookResult = ReturnType<typeof usePointListSuspenseQuery>;
export type PointListQueryResult = Apollo.QueryResult<PointListQuery, PointListQueryVariables>;
export const PointListMetadataDocument = gql`
    query pointListMetadata($filters: PointQueryFilter!, $pagination: PointQueryPagination!, $sort: PointQuerySort!) {
  pointsPaginationQuery(filters: $filters, pagination: $pagination, sort: $sort) {
    result {
      ...PointMetadataType
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    statusesInfo {
      playing
      sleep
      notPlaying
      mbNoConnection
      playerDisabled
      notGeneration
      stop
      mbPlaying
    }
  }
}
    ${PointMetadataTypeFragmentDoc}`;

/**
 * __usePointListMetadataQuery__
 *
 * To run a query within a React component, call `usePointListMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointListMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointListMetadataQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointListMetadataQuery(baseOptions: Apollo.QueryHookOptions<PointListMetadataQuery, PointListMetadataQueryVariables> & ({ variables: PointListMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointListMetadataQuery, PointListMetadataQueryVariables>(PointListMetadataDocument, options);
      }
export function usePointListMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointListMetadataQuery, PointListMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointListMetadataQuery, PointListMetadataQueryVariables>(PointListMetadataDocument, options);
        }
// @ts-ignore
export function usePointListMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointListMetadataQuery, PointListMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<PointListMetadataQuery, PointListMetadataQueryVariables>;
export function usePointListMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointListMetadataQuery, PointListMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<PointListMetadataQuery | undefined, PointListMetadataQueryVariables>;
export function usePointListMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointListMetadataQuery, PointListMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointListMetadataQuery, PointListMetadataQueryVariables>(PointListMetadataDocument, options);
        }
export type PointListMetadataQueryHookResult = ReturnType<typeof usePointListMetadataQuery>;
export type PointListMetadataLazyQueryHookResult = ReturnType<typeof usePointListMetadataLazyQuery>;
export type PointListMetadataSuspenseQueryHookResult = ReturnType<typeof usePointListMetadataSuspenseQuery>;
export type PointListMetadataQueryResult = Apollo.QueryResult<PointListMetadataQuery, PointListMetadataQueryVariables>;
export const PointCerttificateListDocument = gql`
    query pointCerttificateList($filters: CertificatePointsQueryFilter!, $pagination: CertificatePointsQueryPagination!) {
  certificatePointsQuery(filters: $filters, pagination: $pagination) {
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    result {
      ...PointShortType
    }
    certificatePointsCount
  }
}
    ${PointShortTypeFragmentDoc}`;

/**
 * __usePointCerttificateListQuery__
 *
 * To run a query within a React component, call `usePointCerttificateListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointCerttificateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointCerttificateListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePointCerttificateListQuery(baseOptions: Apollo.QueryHookOptions<PointCerttificateListQuery, PointCerttificateListQueryVariables> & ({ variables: PointCerttificateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointCerttificateListQuery, PointCerttificateListQueryVariables>(PointCerttificateListDocument, options);
      }
export function usePointCerttificateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointCerttificateListQuery, PointCerttificateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointCerttificateListQuery, PointCerttificateListQueryVariables>(PointCerttificateListDocument, options);
        }
// @ts-ignore
export function usePointCerttificateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointCerttificateListQuery, PointCerttificateListQueryVariables>): Apollo.UseSuspenseQueryResult<PointCerttificateListQuery, PointCerttificateListQueryVariables>;
export function usePointCerttificateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointCerttificateListQuery, PointCerttificateListQueryVariables>): Apollo.UseSuspenseQueryResult<PointCerttificateListQuery | undefined, PointCerttificateListQueryVariables>;
export function usePointCerttificateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointCerttificateListQuery, PointCerttificateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointCerttificateListQuery, PointCerttificateListQueryVariables>(PointCerttificateListDocument, options);
        }
export type PointCerttificateListQueryHookResult = ReturnType<typeof usePointCerttificateListQuery>;
export type PointCerttificateListLazyQueryHookResult = ReturnType<typeof usePointCerttificateListLazyQuery>;
export type PointCerttificateListSuspenseQueryHookResult = ReturnType<typeof usePointCerttificateListSuspenseQuery>;
export type PointCerttificateListQueryResult = Apollo.QueryResult<PointCerttificateListQuery, PointCerttificateListQueryVariables>;
export const PointList_SpecialDocument = gql`
    query pointList_Special($filters: PointQueryFilter!, $pagination: PointQueryPagination!, $sort: PointQuerySort!) {
  pointsPaginationQuery(filters: $filters, pagination: $pagination, sort: $sort) {
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    result {
      ...PointSpecialType
    }
  }
}
    ${PointSpecialTypeFragmentDoc}`;

/**
 * __usePointList_SpecialQuery__
 *
 * To run a query within a React component, call `usePointList_SpecialQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointList_SpecialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointList_SpecialQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointList_SpecialQuery(baseOptions: Apollo.QueryHookOptions<PointList_SpecialQuery, PointList_SpecialQueryVariables> & ({ variables: PointList_SpecialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointList_SpecialQuery, PointList_SpecialQueryVariables>(PointList_SpecialDocument, options);
      }
export function usePointList_SpecialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointList_SpecialQuery, PointList_SpecialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointList_SpecialQuery, PointList_SpecialQueryVariables>(PointList_SpecialDocument, options);
        }
// @ts-ignore
export function usePointList_SpecialSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointList_SpecialQuery, PointList_SpecialQueryVariables>): Apollo.UseSuspenseQueryResult<PointList_SpecialQuery, PointList_SpecialQueryVariables>;
export function usePointList_SpecialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointList_SpecialQuery, PointList_SpecialQueryVariables>): Apollo.UseSuspenseQueryResult<PointList_SpecialQuery | undefined, PointList_SpecialQueryVariables>;
export function usePointList_SpecialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointList_SpecialQuery, PointList_SpecialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointList_SpecialQuery, PointList_SpecialQueryVariables>(PointList_SpecialDocument, options);
        }
export type PointList_SpecialQueryHookResult = ReturnType<typeof usePointList_SpecialQuery>;
export type PointList_SpecialLazyQueryHookResult = ReturnType<typeof usePointList_SpecialLazyQuery>;
export type PointList_SpecialSuspenseQueryHookResult = ReturnType<typeof usePointList_SpecialSuspenseQuery>;
export type PointList_SpecialQueryResult = Apollo.QueryResult<PointList_SpecialQuery, PointList_SpecialQueryVariables>;
export const PointCreateDocument = gql`
    mutation pointCreate($input: PointPureCreateMutationInput!) {
  pointPureCreate(input: $input) {
    ok
    point {
      ...PointInfoType
    }
    errors {
      field
      messages
    }
  }
}
    ${PointInfoTypeFragmentDoc}`;
export type PointCreateMutationFn = Apollo.MutationFunction<PointCreateMutation, PointCreateMutationVariables>;

/**
 * __usePointCreateMutation__
 *
 * To run a mutation, you first call `usePointCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointCreateMutation, { data, loading, error }] = usePointCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointCreateMutation(baseOptions?: Apollo.MutationHookOptions<PointCreateMutation, PointCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointCreateMutation, PointCreateMutationVariables>(PointCreateDocument, options);
      }
export type PointCreateMutationHookResult = ReturnType<typeof usePointCreateMutation>;
export type PointCreateMutationResult = Apollo.MutationResult<PointCreateMutation>;
export type PointCreateMutationOptions = Apollo.BaseMutationOptions<PointCreateMutation, PointCreateMutationVariables>;
export const PointSmartLkCreateDocument = gql`
    mutation pointSmartLkCreate($input: SmartlkPointCreateMutationInput!) {
  smartlkPointCreate(input: $input) {
    ok
    point {
      ...PointInfoType
    }
    errors {
      field
      messages
    }
  }
}
    ${PointInfoTypeFragmentDoc}`;
export type PointSmartLkCreateMutationFn = Apollo.MutationFunction<PointSmartLkCreateMutation, PointSmartLkCreateMutationVariables>;

/**
 * __usePointSmartLkCreateMutation__
 *
 * To run a mutation, you first call `usePointSmartLkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointSmartLkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointSmartLkCreateMutation, { data, loading, error }] = usePointSmartLkCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointSmartLkCreateMutation(baseOptions?: Apollo.MutationHookOptions<PointSmartLkCreateMutation, PointSmartLkCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointSmartLkCreateMutation, PointSmartLkCreateMutationVariables>(PointSmartLkCreateDocument, options);
      }
export type PointSmartLkCreateMutationHookResult = ReturnType<typeof usePointSmartLkCreateMutation>;
export type PointSmartLkCreateMutationResult = Apollo.MutationResult<PointSmartLkCreateMutation>;
export type PointSmartLkCreateMutationOptions = Apollo.BaseMutationOptions<PointSmartLkCreateMutation, PointSmartLkCreateMutationVariables>;
export const PointUpdateDocument = gql`
    mutation pointUpdate($input: PointPureUpdateMutationInput!) {
  pointPureUpdate(input: $input) {
    ok
    errors {
      messages
    }
    point {
      id
      comment
      withMusicCut
      cutDuration
      adOverlapResolution
    }
  }
}
    `;
export type PointUpdateMutationFn = Apollo.MutationFunction<PointUpdateMutation, PointUpdateMutationVariables>;

/**
 * __usePointUpdateMutation__
 *
 * To run a mutation, you first call `usePointUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointUpdateMutation, { data, loading, error }] = usePointUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PointUpdateMutation, PointUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointUpdateMutation, PointUpdateMutationVariables>(PointUpdateDocument, options);
      }
export type PointUpdateMutationHookResult = ReturnType<typeof usePointUpdateMutation>;
export type PointUpdateMutationResult = Apollo.MutationResult<PointUpdateMutation>;
export type PointUpdateMutationOptions = Apollo.BaseMutationOptions<PointUpdateMutation, PointUpdateMutationVariables>;
export const PointRemoveDocument = gql`
    mutation pointRemove($input: PointPureRemoveMutationInput!) {
  pointPureRemove(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type PointRemoveMutationFn = Apollo.MutationFunction<PointRemoveMutation, PointRemoveMutationVariables>;

/**
 * __usePointRemoveMutation__
 *
 * To run a mutation, you first call `usePointRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointRemoveMutation, { data, loading, error }] = usePointRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointRemoveMutation(baseOptions?: Apollo.MutationHookOptions<PointRemoveMutation, PointRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointRemoveMutation, PointRemoveMutationVariables>(PointRemoveDocument, options);
      }
export type PointRemoveMutationHookResult = ReturnType<typeof usePointRemoveMutation>;
export type PointRemoveMutationResult = Apollo.MutationResult<PointRemoveMutation>;
export type PointRemoveMutationOptions = Apollo.BaseMutationOptions<PointRemoveMutation, PointRemoveMutationVariables>;
export const PointChangeStreamDocument = gql`
    mutation pointChangeStream($input: PointPureChangeStreamMutationInput!) {
  pointPureChangeStream(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type PointChangeStreamMutationFn = Apollo.MutationFunction<PointChangeStreamMutation, PointChangeStreamMutationVariables>;

/**
 * __usePointChangeStreamMutation__
 *
 * To run a mutation, you first call `usePointChangeStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointChangeStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointChangeStreamMutation, { data, loading, error }] = usePointChangeStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointChangeStreamMutation(baseOptions?: Apollo.MutationHookOptions<PointChangeStreamMutation, PointChangeStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointChangeStreamMutation, PointChangeStreamMutationVariables>(PointChangeStreamDocument, options);
      }
export type PointChangeStreamMutationHookResult = ReturnType<typeof usePointChangeStreamMutation>;
export type PointChangeStreamMutationResult = Apollo.MutationResult<PointChangeStreamMutation>;
export type PointChangeStreamMutationOptions = Apollo.BaseMutationOptions<PointChangeStreamMutation, PointChangeStreamMutationVariables>;
export const PointUnbindStreamDocument = gql`
    mutation pointUnbindStream($input: SmartlkPointUnbindStreamMutationInput!) {
  smartlkPointUnbindStream(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type PointUnbindStreamMutationFn = Apollo.MutationFunction<PointUnbindStreamMutation, PointUnbindStreamMutationVariables>;

/**
 * __usePointUnbindStreamMutation__
 *
 * To run a mutation, you first call `usePointUnbindStreamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointUnbindStreamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointUnbindStreamMutation, { data, loading, error }] = usePointUnbindStreamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointUnbindStreamMutation(baseOptions?: Apollo.MutationHookOptions<PointUnbindStreamMutation, PointUnbindStreamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointUnbindStreamMutation, PointUnbindStreamMutationVariables>(PointUnbindStreamDocument, options);
      }
export type PointUnbindStreamMutationHookResult = ReturnType<typeof usePointUnbindStreamMutation>;
export type PointUnbindStreamMutationResult = Apollo.MutationResult<PointUnbindStreamMutation>;
export type PointUnbindStreamMutationOptions = Apollo.BaseMutationOptions<PointUnbindStreamMutation, PointUnbindStreamMutationVariables>;
export const PointChangeSleepSettingsDocument = gql`
    mutation pointChangeSleepSettings($input: PointPureSleepSettingsMutationInput!) {
  pointPureSleepSettings(input: $input) {
    ok
    errors {
      messages
    }
    point {
      ...PointInfoType
    }
  }
}
    ${PointInfoTypeFragmentDoc}`;
export type PointChangeSleepSettingsMutationFn = Apollo.MutationFunction<PointChangeSleepSettingsMutation, PointChangeSleepSettingsMutationVariables>;

/**
 * __usePointChangeSleepSettingsMutation__
 *
 * To run a mutation, you first call `usePointChangeSleepSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointChangeSleepSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointChangeSleepSettingsMutation, { data, loading, error }] = usePointChangeSleepSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointChangeSleepSettingsMutation(baseOptions?: Apollo.MutationHookOptions<PointChangeSleepSettingsMutation, PointChangeSleepSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointChangeSleepSettingsMutation, PointChangeSleepSettingsMutationVariables>(PointChangeSleepSettingsDocument, options);
      }
export type PointChangeSleepSettingsMutationHookResult = ReturnType<typeof usePointChangeSleepSettingsMutation>;
export type PointChangeSleepSettingsMutationResult = Apollo.MutationResult<PointChangeSleepSettingsMutation>;
export type PointChangeSleepSettingsMutationOptions = Apollo.BaseMutationOptions<PointChangeSleepSettingsMutation, PointChangeSleepSettingsMutationVariables>;
export const PointChangeDeviceDocument = gql`
    mutation pointChangeDevice($input: PointSwitchDeviceMutationInput!) {
  pointPureSwitchDevice(input: $input) {
    ok
    errors {
      messages
    }
    point {
      ...PointInfoType
    }
  }
}
    ${PointInfoTypeFragmentDoc}`;
export type PointChangeDeviceMutationFn = Apollo.MutationFunction<PointChangeDeviceMutation, PointChangeDeviceMutationVariables>;

/**
 * __usePointChangeDeviceMutation__
 *
 * To run a mutation, you first call `usePointChangeDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointChangeDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointChangeDeviceMutation, { data, loading, error }] = usePointChangeDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointChangeDeviceMutation(baseOptions?: Apollo.MutationHookOptions<PointChangeDeviceMutation, PointChangeDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointChangeDeviceMutation, PointChangeDeviceMutationVariables>(PointChangeDeviceDocument, options);
      }
export type PointChangeDeviceMutationHookResult = ReturnType<typeof usePointChangeDeviceMutation>;
export type PointChangeDeviceMutationResult = Apollo.MutationResult<PointChangeDeviceMutation>;
export type PointChangeDeviceMutationOptions = Apollo.BaseMutationOptions<PointChangeDeviceMutation, PointChangeDeviceMutationVariables>;
export const DesktopDownloadLinkDocument = gql`
    query desktopDownloadLink {
  link: desktopPlayerDownloadLinkPureQuery
}
    `;

/**
 * __useDesktopDownloadLinkQuery__
 *
 * To run a query within a React component, call `useDesktopDownloadLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesktopDownloadLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesktopDownloadLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesktopDownloadLinkQuery(baseOptions?: Apollo.QueryHookOptions<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>(DesktopDownloadLinkDocument, options);
      }
export function useDesktopDownloadLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>(DesktopDownloadLinkDocument, options);
        }
// @ts-ignore
export function useDesktopDownloadLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>): Apollo.UseSuspenseQueryResult<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>;
export function useDesktopDownloadLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>): Apollo.UseSuspenseQueryResult<DesktopDownloadLinkQuery | undefined, DesktopDownloadLinkQueryVariables>;
export function useDesktopDownloadLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>(DesktopDownloadLinkDocument, options);
        }
export type DesktopDownloadLinkQueryHookResult = ReturnType<typeof useDesktopDownloadLinkQuery>;
export type DesktopDownloadLinkLazyQueryHookResult = ReturnType<typeof useDesktopDownloadLinkLazyQuery>;
export type DesktopDownloadLinkSuspenseQueryHookResult = ReturnType<typeof useDesktopDownloadLinkSuspenseQuery>;
export type DesktopDownloadLinkQueryResult = Apollo.QueryResult<DesktopDownloadLinkQuery, DesktopDownloadLinkQueryVariables>;
export const PointHistoryDocument = gql`
    query pointHistory($filters: PointHistoryQueryFilter!, $pagination: PointHistoryQueryPagination!, $sort: PointHistoryQuerySort!) {
  pointHistoryPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      playtime
      streamId
      mediafileId
      mediafilePerformerTitle
      mediafileTitle
      mediafileType
      mediafileFilename
      mediafileIsDisliked
      mediafileIsLiked
      mediafile {
        ...MediafileInfoType
      }
      onAir
      onAirWithLocalTimezone
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MediafileInfoTypeFragmentDoc}`;

/**
 * __usePointHistoryQuery__
 *
 * To run a query within a React component, call `usePointHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointHistoryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointHistoryQuery(baseOptions: Apollo.QueryHookOptions<PointHistoryQuery, PointHistoryQueryVariables> & ({ variables: PointHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointHistoryQuery, PointHistoryQueryVariables>(PointHistoryDocument, options);
      }
export function usePointHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointHistoryQuery, PointHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointHistoryQuery, PointHistoryQueryVariables>(PointHistoryDocument, options);
        }
// @ts-ignore
export function usePointHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointHistoryQuery, PointHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PointHistoryQuery, PointHistoryQueryVariables>;
export function usePointHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointHistoryQuery, PointHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PointHistoryQuery | undefined, PointHistoryQueryVariables>;
export function usePointHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointHistoryQuery, PointHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointHistoryQuery, PointHistoryQueryVariables>(PointHistoryDocument, options);
        }
export type PointHistoryQueryHookResult = ReturnType<typeof usePointHistoryQuery>;
export type PointHistoryLazyQueryHookResult = ReturnType<typeof usePointHistoryLazyQuery>;
export type PointHistorySuspenseQueryHookResult = ReturnType<typeof usePointHistorySuspenseQuery>;
export type PointHistoryQueryResult = Apollo.QueryResult<PointHistoryQuery, PointHistoryQueryVariables>;
export const PointVideoHistoryDocument = gql`
    query pointVideoHistory($filters: PointVideoHistoryQueryFilter!, $pagination: PointVideoHistoryQueryPagination!, $sort: PointVideoHistoryQuerySort!) {
  pointVideoHistoryPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      start
      onAir
      end
      mediafileId
      mediafileType
      mediafileFilename
      rotationId
      mediafile {
        previewUrl
        id
        title
        type
        uri
        sourcefiles {
          url
          extension
        }
      }
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __usePointVideoHistoryQuery__
 *
 * To run a query within a React component, call `usePointVideoHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointVideoHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointVideoHistoryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointVideoHistoryQuery(baseOptions: Apollo.QueryHookOptions<PointVideoHistoryQuery, PointVideoHistoryQueryVariables> & ({ variables: PointVideoHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>(PointVideoHistoryDocument, options);
      }
export function usePointVideoHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>(PointVideoHistoryDocument, options);
        }
// @ts-ignore
export function usePointVideoHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>;
export function usePointVideoHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PointVideoHistoryQuery | undefined, PointVideoHistoryQueryVariables>;
export function usePointVideoHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>(PointVideoHistoryDocument, options);
        }
export type PointVideoHistoryQueryHookResult = ReturnType<typeof usePointVideoHistoryQuery>;
export type PointVideoHistoryLazyQueryHookResult = ReturnType<typeof usePointVideoHistoryLazyQuery>;
export type PointVideoHistorySuspenseQueryHookResult = ReturnType<typeof usePointVideoHistorySuspenseQuery>;
export type PointVideoHistoryQueryResult = Apollo.QueryResult<PointVideoHistoryQuery, PointVideoHistoryQueryVariables>;
export const PointHistoryReportCreateDocument = gql`
    mutation pointHistoryReportCreate($input: PointPlaybackAudioReportCreateMutationInput!) {
  pointPlaybackReportCreateMutation(input: $input) {
    ok
    errors {
      field
      messages
    }
    downloadLink
  }
}
    `;
export type PointHistoryReportCreateMutationFn = Apollo.MutationFunction<PointHistoryReportCreateMutation, PointHistoryReportCreateMutationVariables>;

/**
 * __usePointHistoryReportCreateMutation__
 *
 * To run a mutation, you first call `usePointHistoryReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointHistoryReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointHistoryReportCreateMutation, { data, loading, error }] = usePointHistoryReportCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointHistoryReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<PointHistoryReportCreateMutation, PointHistoryReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointHistoryReportCreateMutation, PointHistoryReportCreateMutationVariables>(PointHistoryReportCreateDocument, options);
      }
export type PointHistoryReportCreateMutationHookResult = ReturnType<typeof usePointHistoryReportCreateMutation>;
export type PointHistoryReportCreateMutationResult = Apollo.MutationResult<PointHistoryReportCreateMutation>;
export type PointHistoryReportCreateMutationOptions = Apollo.BaseMutationOptions<PointHistoryReportCreateMutation, PointHistoryReportCreateMutationVariables>;
export const PointVideoHistoryReportCreateDocument = gql`
    mutation pointVideoHistoryReportCreate($input: PointPlaybackVideoReportCreateMutationInput!) {
  pointPlaybackVideoReportCreateMutation(input: $input) {
    ok
    errors {
      field
      messages
    }
    downloadLink
  }
}
    `;
export type PointVideoHistoryReportCreateMutationFn = Apollo.MutationFunction<PointVideoHistoryReportCreateMutation, PointVideoHistoryReportCreateMutationVariables>;

/**
 * __usePointVideoHistoryReportCreateMutation__
 *
 * To run a mutation, you first call `usePointVideoHistoryReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointVideoHistoryReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointVideoHistoryReportCreateMutation, { data, loading, error }] = usePointVideoHistoryReportCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointVideoHistoryReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<PointVideoHistoryReportCreateMutation, PointVideoHistoryReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointVideoHistoryReportCreateMutation, PointVideoHistoryReportCreateMutationVariables>(PointVideoHistoryReportCreateDocument, options);
      }
export type PointVideoHistoryReportCreateMutationHookResult = ReturnType<typeof usePointVideoHistoryReportCreateMutation>;
export type PointVideoHistoryReportCreateMutationResult = Apollo.MutationResult<PointVideoHistoryReportCreateMutation>;
export type PointVideoHistoryReportCreateMutationOptions = Apollo.BaseMutationOptions<PointVideoHistoryReportCreateMutation, PointVideoHistoryReportCreateMutationVariables>;
export const SpeakerCreateAndSetPointDocument = gql`
    mutation speakerCreateAndSetPoint($input: SmartSpeakerCreateAndSetPointInput!) {
  speakerCreateAndSetPoint(input: $input) {
    ok
    smartSpeakerInfo {
      deviceType
      deviceToken
      deviceUuid
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SpeakerCreateAndSetPointMutationFn = Apollo.MutationFunction<SpeakerCreateAndSetPointMutation, SpeakerCreateAndSetPointMutationVariables>;

/**
 * __useSpeakerCreateAndSetPointMutation__
 *
 * To run a mutation, you first call `useSpeakerCreateAndSetPointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpeakerCreateAndSetPointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [speakerCreateAndSetPointMutation, { data, loading, error }] = useSpeakerCreateAndSetPointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpeakerCreateAndSetPointMutation(baseOptions?: Apollo.MutationHookOptions<SpeakerCreateAndSetPointMutation, SpeakerCreateAndSetPointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpeakerCreateAndSetPointMutation, SpeakerCreateAndSetPointMutationVariables>(SpeakerCreateAndSetPointDocument, options);
      }
export type SpeakerCreateAndSetPointMutationHookResult = ReturnType<typeof useSpeakerCreateAndSetPointMutation>;
export type SpeakerCreateAndSetPointMutationResult = Apollo.MutationResult<SpeakerCreateAndSetPointMutation>;
export type SpeakerCreateAndSetPointMutationOptions = Apollo.BaseMutationOptions<SpeakerCreateAndSetPointMutation, SpeakerCreateAndSetPointMutationVariables>;
export const PointSetAdCampaignsDocument = gql`
    mutation pointSetAdCampaigns($input: PointPureSetAdCampaignsMutationInput!) {
  pointPureSetAdcampaigns(input: $input) {
    ok
    errors {
      field
      messages
    }
    point {
      id
    }
  }
}
    `;
export type PointSetAdCampaignsMutationFn = Apollo.MutationFunction<PointSetAdCampaignsMutation, PointSetAdCampaignsMutationVariables>;

/**
 * __usePointSetAdCampaignsMutation__
 *
 * To run a mutation, you first call `usePointSetAdCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointSetAdCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointSetAdCampaignsMutation, { data, loading, error }] = usePointSetAdCampaignsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointSetAdCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<PointSetAdCampaignsMutation, PointSetAdCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointSetAdCampaignsMutation, PointSetAdCampaignsMutationVariables>(PointSetAdCampaignsDocument, options);
      }
export type PointSetAdCampaignsMutationHookResult = ReturnType<typeof usePointSetAdCampaignsMutation>;
export type PointSetAdCampaignsMutationResult = Apollo.MutationResult<PointSetAdCampaignsMutation>;
export type PointSetAdCampaignsMutationOptions = Apollo.BaseMutationOptions<PointSetAdCampaignsMutation, PointSetAdCampaignsMutationVariables>;
export const StandardizedAddressDocument = gql`
    query standardizedAddress($input: StandardizedAddressQueryPureType!) {
  standardizedAddressPureQuery(input: $input) {
    result {
      address
      timezone
      street
      city
      region
      country
      postalCode
      latitude
      longitude
      fiasId
    }
  }
}
    `;

/**
 * __useStandardizedAddressQuery__
 *
 * To run a query within a React component, call `useStandardizedAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardizedAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardizedAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStandardizedAddressQuery(baseOptions: Apollo.QueryHookOptions<StandardizedAddressQuery, StandardizedAddressQueryVariables> & ({ variables: StandardizedAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardizedAddressQuery, StandardizedAddressQueryVariables>(StandardizedAddressDocument, options);
      }
export function useStandardizedAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardizedAddressQuery, StandardizedAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardizedAddressQuery, StandardizedAddressQueryVariables>(StandardizedAddressDocument, options);
        }
// @ts-ignore
export function useStandardizedAddressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StandardizedAddressQuery, StandardizedAddressQueryVariables>): Apollo.UseSuspenseQueryResult<StandardizedAddressQuery, StandardizedAddressQueryVariables>;
export function useStandardizedAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardizedAddressQuery, StandardizedAddressQueryVariables>): Apollo.UseSuspenseQueryResult<StandardizedAddressQuery | undefined, StandardizedAddressQueryVariables>;
export function useStandardizedAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardizedAddressQuery, StandardizedAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StandardizedAddressQuery, StandardizedAddressQueryVariables>(StandardizedAddressDocument, options);
        }
export type StandardizedAddressQueryHookResult = ReturnType<typeof useStandardizedAddressQuery>;
export type StandardizedAddressLazyQueryHookResult = ReturnType<typeof useStandardizedAddressLazyQuery>;
export type StandardizedAddressSuspenseQueryHookResult = ReturnType<typeof useStandardizedAddressSuspenseQuery>;
export type StandardizedAddressQueryResult = Apollo.QueryResult<StandardizedAddressQuery, StandardizedAddressQueryVariables>;
export const TimezonesDocument = gql`
    query timezones {
  timezones {
    timezone
    title
  }
}
    `;

/**
 * __useTimezonesQuery__
 *
 * To run a query within a React component, call `useTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
      }
export function useTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
        }
// @ts-ignore
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>): Apollo.UseSuspenseQueryResult<TimezonesQuery, TimezonesQueryVariables>;
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>): Apollo.UseSuspenseQueryResult<TimezonesQuery | undefined, TimezonesQueryVariables>;
export function useTimezonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
        }
export type TimezonesQueryHookResult = ReturnType<typeof useTimezonesQuery>;
export type TimezonesLazyQueryHookResult = ReturnType<typeof useTimezonesLazyQuery>;
export type TimezonesSuspenseQueryHookResult = ReturnType<typeof useTimezonesSuspenseQuery>;
export type TimezonesQueryResult = Apollo.QueryResult<TimezonesQuery, TimezonesQueryVariables>;
export const PointSetCompanyTagsDocument = gql`
    mutation pointSetCompanyTags($input: PointPureSetCompanyTagsMutationInput!) {
  pointPureSetCompanyTags(input: $input) {
    ok
    errors {
      field
      messages
    }
    point {
      id
    }
  }
}
    `;
export type PointSetCompanyTagsMutationFn = Apollo.MutationFunction<PointSetCompanyTagsMutation, PointSetCompanyTagsMutationVariables>;

/**
 * __usePointSetCompanyTagsMutation__
 *
 * To run a mutation, you first call `usePointSetCompanyTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointSetCompanyTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointSetCompanyTagsMutation, { data, loading, error }] = usePointSetCompanyTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointSetCompanyTagsMutation(baseOptions?: Apollo.MutationHookOptions<PointSetCompanyTagsMutation, PointSetCompanyTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointSetCompanyTagsMutation, PointSetCompanyTagsMutationVariables>(PointSetCompanyTagsDocument, options);
      }
export type PointSetCompanyTagsMutationHookResult = ReturnType<typeof usePointSetCompanyTagsMutation>;
export type PointSetCompanyTagsMutationResult = Apollo.MutationResult<PointSetCompanyTagsMutation>;
export type PointSetCompanyTagsMutationOptions = Apollo.BaseMutationOptions<PointSetCompanyTagsMutation, PointSetCompanyTagsMutationVariables>;
export const PointGenerationSettingsDocument = gql`
    query pointGenerationSettings($pointId: ID!) {
  pointGenerationSettingsPureQuery(pointId: $pointId) {
    settings
    lastUpdated
    mediafiles {
      id
      filename
      title
      performerTitle
      type
    }
  }
}
    `;

/**
 * __usePointGenerationSettingsQuery__
 *
 * To run a query within a React component, call `usePointGenerationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointGenerationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointGenerationSettingsQuery({
 *   variables: {
 *      pointId: // value for 'pointId'
 *   },
 * });
 */
export function usePointGenerationSettingsQuery(baseOptions: Apollo.QueryHookOptions<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables> & ({ variables: PointGenerationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>(PointGenerationSettingsDocument, options);
      }
export function usePointGenerationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>(PointGenerationSettingsDocument, options);
        }
// @ts-ignore
export function usePointGenerationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>;
export function usePointGenerationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PointGenerationSettingsQuery | undefined, PointGenerationSettingsQueryVariables>;
export function usePointGenerationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>(PointGenerationSettingsDocument, options);
        }
export type PointGenerationSettingsQueryHookResult = ReturnType<typeof usePointGenerationSettingsQuery>;
export type PointGenerationSettingsLazyQueryHookResult = ReturnType<typeof usePointGenerationSettingsLazyQuery>;
export type PointGenerationSettingsSuspenseQueryHookResult = ReturnType<typeof usePointGenerationSettingsSuspenseQuery>;
export type PointGenerationSettingsQueryResult = Apollo.QueryResult<PointGenerationSettingsQuery, PointGenerationSettingsQueryVariables>;
export const MultiroomGetMultiroomDocument = gql`
    query MultiroomGetMultiroom($input: SberMultiroomGetMultiroomQueryInput!) {
  result: sberMultiroomGetMultiroomQuery(input: $input) {
    devices {
      bindingCode
    }
  }
}
    `;

/**
 * __useMultiroomGetMultiroomQuery__
 *
 * To run a query within a React component, call `useMultiroomGetMultiroomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiroomGetMultiroomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiroomGetMultiroomQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMultiroomGetMultiroomQuery(baseOptions: Apollo.QueryHookOptions<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables> & ({ variables: MultiroomGetMultiroomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>(MultiroomGetMultiroomDocument, options);
      }
export function useMultiroomGetMultiroomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>(MultiroomGetMultiroomDocument, options);
        }
// @ts-ignore
export function useMultiroomGetMultiroomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>): Apollo.UseSuspenseQueryResult<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>;
export function useMultiroomGetMultiroomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>): Apollo.UseSuspenseQueryResult<MultiroomGetMultiroomQuery | undefined, MultiroomGetMultiroomQueryVariables>;
export function useMultiroomGetMultiroomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>(MultiroomGetMultiroomDocument, options);
        }
export type MultiroomGetMultiroomQueryHookResult = ReturnType<typeof useMultiroomGetMultiroomQuery>;
export type MultiroomGetMultiroomLazyQueryHookResult = ReturnType<typeof useMultiroomGetMultiroomLazyQuery>;
export type MultiroomGetMultiroomSuspenseQueryHookResult = ReturnType<typeof useMultiroomGetMultiroomSuspenseQuery>;
export type MultiroomGetMultiroomQueryResult = Apollo.QueryResult<MultiroomGetMultiroomQuery, MultiroomGetMultiroomQueryVariables>;
export const PointsGroupsDocument = gql`
    query pointsGroups($filters: SmartlkDevicesGroupQueryFilter!, $pagination: SmartlkDevicesGroupQueryPagination!, $sort: SmartlkDevicesGroupQuerySort!) {
  smartlkDevicesGroupPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      title
      isValid
      validationError
      devices {
        id
      }
      masterVideoStream {
        id
        title
      }
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
    statusesInfo {
      valid
      invalid
    }
  }
}
    `;

/**
 * __usePointsGroupsQuery__
 *
 * To run a query within a React component, call `usePointsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointsGroupsQuery(baseOptions: Apollo.QueryHookOptions<PointsGroupsQuery, PointsGroupsQueryVariables> & ({ variables: PointsGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointsGroupsQuery, PointsGroupsQueryVariables>(PointsGroupsDocument, options);
      }
export function usePointsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointsGroupsQuery, PointsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointsGroupsQuery, PointsGroupsQueryVariables>(PointsGroupsDocument, options);
        }
// @ts-ignore
export function usePointsGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointsGroupsQuery, PointsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupsQuery, PointsGroupsQueryVariables>;
export function usePointsGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupsQuery, PointsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupsQuery | undefined, PointsGroupsQueryVariables>;
export function usePointsGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupsQuery, PointsGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointsGroupsQuery, PointsGroupsQueryVariables>(PointsGroupsDocument, options);
        }
export type PointsGroupsQueryHookResult = ReturnType<typeof usePointsGroupsQuery>;
export type PointsGroupsLazyQueryHookResult = ReturnType<typeof usePointsGroupsLazyQuery>;
export type PointsGroupsSuspenseQueryHookResult = ReturnType<typeof usePointsGroupsSuspenseQuery>;
export type PointsGroupsQueryResult = Apollo.QueryResult<PointsGroupsQuery, PointsGroupsQueryVariables>;
export const PointsGroupsStatusesDocument = gql`
    query pointsGroupsStatuses($filters: SmartlkDevicesGroupQueryFilter!, $pagination: SmartlkDevicesGroupQueryPagination!, $sort: SmartlkDevicesGroupQuerySort!) {
  smartlkDevicesGroupPaginationQuery(
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    statusesInfo {
      valid
      invalid
    }
  }
}
    `;

/**
 * __usePointsGroupsStatusesQuery__
 *
 * To run a query within a React component, call `usePointsGroupsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsGroupsStatusesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePointsGroupsStatusesQuery(baseOptions: Apollo.QueryHookOptions<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables> & ({ variables: PointsGroupsStatusesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>(PointsGroupsStatusesDocument, options);
      }
export function usePointsGroupsStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>(PointsGroupsStatusesDocument, options);
        }
// @ts-ignore
export function usePointsGroupsStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>;
export function usePointsGroupsStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupsStatusesQuery | undefined, PointsGroupsStatusesQueryVariables>;
export function usePointsGroupsStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>(PointsGroupsStatusesDocument, options);
        }
export type PointsGroupsStatusesQueryHookResult = ReturnType<typeof usePointsGroupsStatusesQuery>;
export type PointsGroupsStatusesLazyQueryHookResult = ReturnType<typeof usePointsGroupsStatusesLazyQuery>;
export type PointsGroupsStatusesSuspenseQueryHookResult = ReturnType<typeof usePointsGroupsStatusesSuspenseQuery>;
export type PointsGroupsStatusesQueryResult = Apollo.QueryResult<PointsGroupsStatusesQuery, PointsGroupsStatusesQueryVariables>;
export const PointsGroupDocument = gql`
    query pointsGroup($id: ID!) {
  smartlkDevicesGroupQuery(id: $id) {
    id
    title
    isValid
    validationError
    devices {
      id
      point {
        id
        address
        isActive
        isEnabled
        tags {
          id
          title
        }
        videoStream {
          id
          title
          description
          previewUrl
          duration
          videoMediafiles {
            id
            mediafile {
              id
              type
            }
          }
        }
      }
    }
    masterVideoStream {
      id
      title
      description
      previewUrl
      duration
      videoMediafiles {
        id
      }
    }
  }
}
    `;

/**
 * __usePointsGroupQuery__
 *
 * To run a query within a React component, call `usePointsGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointsGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePointsGroupQuery(baseOptions: Apollo.QueryHookOptions<PointsGroupQuery, PointsGroupQueryVariables> & ({ variables: PointsGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointsGroupQuery, PointsGroupQueryVariables>(PointsGroupDocument, options);
      }
export function usePointsGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointsGroupQuery, PointsGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointsGroupQuery, PointsGroupQueryVariables>(PointsGroupDocument, options);
        }
// @ts-ignore
export function usePointsGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PointsGroupQuery, PointsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupQuery, PointsGroupQueryVariables>;
export function usePointsGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupQuery, PointsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<PointsGroupQuery | undefined, PointsGroupQueryVariables>;
export function usePointsGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointsGroupQuery, PointsGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointsGroupQuery, PointsGroupQueryVariables>(PointsGroupDocument, options);
        }
export type PointsGroupQueryHookResult = ReturnType<typeof usePointsGroupQuery>;
export type PointsGroupLazyQueryHookResult = ReturnType<typeof usePointsGroupLazyQuery>;
export type PointsGroupSuspenseQueryHookResult = ReturnType<typeof usePointsGroupSuspenseQuery>;
export type PointsGroupQueryResult = Apollo.QueryResult<PointsGroupQuery, PointsGroupQueryVariables>;
export const PointsGroupUpdateDocument = gql`
    mutation pointsGroupUpdate($input: SmartlkDevicesGroupUpdateMutationInput!) {
  smartlkDevicesGroupUpdate(input: $input) {
    ok
    errors {
      messages
    }
    devicesGroup {
      id
      title
      isValid
      devices {
        id
        point {
          id
          address
          videoStream {
            id
            title
            description
            previewUrl
            duration
            videoMediafiles {
              id
            }
          }
        }
      }
      masterVideoStream {
        id
        title
        description
        previewUrl
        duration
        videoMediafiles {
          id
        }
      }
    }
  }
}
    `;
export type PointsGroupUpdateMutationFn = Apollo.MutationFunction<PointsGroupUpdateMutation, PointsGroupUpdateMutationVariables>;

/**
 * __usePointsGroupUpdateMutation__
 *
 * To run a mutation, you first call `usePointsGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointsGroupUpdateMutation, { data, loading, error }] = usePointsGroupUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointsGroupUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PointsGroupUpdateMutation, PointsGroupUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointsGroupUpdateMutation, PointsGroupUpdateMutationVariables>(PointsGroupUpdateDocument, options);
      }
export type PointsGroupUpdateMutationHookResult = ReturnType<typeof usePointsGroupUpdateMutation>;
export type PointsGroupUpdateMutationResult = Apollo.MutationResult<PointsGroupUpdateMutation>;
export type PointsGroupUpdateMutationOptions = Apollo.BaseMutationOptions<PointsGroupUpdateMutation, PointsGroupUpdateMutationVariables>;
export const PointsGroupDeleteDocument = gql`
    mutation pointsGroupDelete($input: SmartlkDevicesGroupDeleteMutationInput!) {
  smartlkDevicesGroupDelete(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type PointsGroupDeleteMutationFn = Apollo.MutationFunction<PointsGroupDeleteMutation, PointsGroupDeleteMutationVariables>;

/**
 * __usePointsGroupDeleteMutation__
 *
 * To run a mutation, you first call `usePointsGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointsGroupDeleteMutation, { data, loading, error }] = usePointsGroupDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointsGroupDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PointsGroupDeleteMutation, PointsGroupDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointsGroupDeleteMutation, PointsGroupDeleteMutationVariables>(PointsGroupDeleteDocument, options);
      }
export type PointsGroupDeleteMutationHookResult = ReturnType<typeof usePointsGroupDeleteMutation>;
export type PointsGroupDeleteMutationResult = Apollo.MutationResult<PointsGroupDeleteMutation>;
export type PointsGroupDeleteMutationOptions = Apollo.BaseMutationOptions<PointsGroupDeleteMutation, PointsGroupDeleteMutationVariables>;
export const PointsGroupCreateDocument = gql`
    mutation pointsGroupCreate($input: SmartlkDevicesGroupCreateMutationInput!) {
  smartlkDevicesGroupCreate(input: $input) {
    ok
    errors {
      messages
    }
    devicesGroup {
      id
      title
      isValid
      validationError
      devices {
        id
        point {
          id
          address
          videoStream {
            id
            title
            description
            previewUrl
            duration
            videoMediafiles {
              id
            }
          }
        }
      }
      masterVideoStream {
        id
        title
        description
        previewUrl
        duration
        videoMediafiles {
          id
        }
      }
    }
  }
}
    `;
export type PointsGroupCreateMutationFn = Apollo.MutationFunction<PointsGroupCreateMutation, PointsGroupCreateMutationVariables>;

/**
 * __usePointsGroupCreateMutation__
 *
 * To run a mutation, you first call `usePointsGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointsGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointsGroupCreateMutation, { data, loading, error }] = usePointsGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointsGroupCreateMutation(baseOptions?: Apollo.MutationHookOptions<PointsGroupCreateMutation, PointsGroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointsGroupCreateMutation, PointsGroupCreateMutationVariables>(PointsGroupCreateDocument, options);
      }
export type PointsGroupCreateMutationHookResult = ReturnType<typeof usePointsGroupCreateMutation>;
export type PointsGroupCreateMutationResult = Apollo.MutationResult<PointsGroupCreateMutation>;
export type PointsGroupCreateMutationOptions = Apollo.BaseMutationOptions<PointsGroupCreateMutation, PointsGroupCreateMutationVariables>;
export const MediaAdCampaignsPaginationQueryDocument = gql`
    query mediaAdCampaignsPaginationQuery($filters: AdCampaignQueryFilter!, $sort: AdCampaignQuerySort!, $pagination: AdCampaignQueryPagination!) {
  adcampaignsPaginationQuery(
    filters: $filters
    sort: $sort
    pagination: $pagination
  ) {
    result {
      ...AdCampaignShortType
    }
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    statusesInfo {
      active
      planned
      passed
      stopped
    }
  }
}
    ${AdCampaignShortTypeFragmentDoc}`;

/**
 * __useMediaAdCampaignsPaginationQueryQuery__
 *
 * To run a query within a React component, call `useMediaAdCampaignsPaginationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignsPaginationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAdCampaignsPaginationQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMediaAdCampaignsPaginationQueryQuery(baseOptions: Apollo.QueryHookOptions<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables> & ({ variables: MediaAdCampaignsPaginationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>(MediaAdCampaignsPaginationQueryDocument, options);
      }
export function useMediaAdCampaignsPaginationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>(MediaAdCampaignsPaginationQueryDocument, options);
        }
// @ts-ignore
export function useMediaAdCampaignsPaginationQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>;
export function useMediaAdCampaignsPaginationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignsPaginationQueryQuery | undefined, MediaAdCampaignsPaginationQueryQueryVariables>;
export function useMediaAdCampaignsPaginationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>(MediaAdCampaignsPaginationQueryDocument, options);
        }
export type MediaAdCampaignsPaginationQueryQueryHookResult = ReturnType<typeof useMediaAdCampaignsPaginationQueryQuery>;
export type MediaAdCampaignsPaginationQueryLazyQueryHookResult = ReturnType<typeof useMediaAdCampaignsPaginationQueryLazyQuery>;
export type MediaAdCampaignsPaginationQuerySuspenseQueryHookResult = ReturnType<typeof useMediaAdCampaignsPaginationQuerySuspenseQuery>;
export type MediaAdCampaignsPaginationQueryQueryResult = Apollo.QueryResult<MediaAdCampaignsPaginationQueryQuery, MediaAdCampaignsPaginationQueryQueryVariables>;
export const MediaAdCampaignsMetadataPaginationQueryDocument = gql`
    query mediaAdCampaignsMetadataPaginationQuery($filters: AdCampaignQueryFilter!, $sort: AdCampaignQuerySort!, $pagination: AdCampaignQueryPagination!) {
  adcampaignsPaginationQuery(
    filters: $filters
    sort: $sort
    pagination: $pagination
  ) {
    result {
      ...AdCampaignMetadataType
    }
    paginationInfo {
      page
      pageSize
      totalCount
      hasNextPage
      hasPreviousPage
      totalPages
    }
    statusesInfo {
      active
      planned
      passed
      stopped
    }
  }
}
    ${AdCampaignMetadataTypeFragmentDoc}`;

/**
 * __useMediaAdCampaignsMetadataPaginationQueryQuery__
 *
 * To run a query within a React component, call `useMediaAdCampaignsMetadataPaginationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignsMetadataPaginationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAdCampaignsMetadataPaginationQueryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMediaAdCampaignsMetadataPaginationQueryQuery(baseOptions: Apollo.QueryHookOptions<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables> & ({ variables: MediaAdCampaignsMetadataPaginationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>(MediaAdCampaignsMetadataPaginationQueryDocument, options);
      }
export function useMediaAdCampaignsMetadataPaginationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>(MediaAdCampaignsMetadataPaginationQueryDocument, options);
        }
// @ts-ignore
export function useMediaAdCampaignsMetadataPaginationQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>;
export function useMediaAdCampaignsMetadataPaginationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignsMetadataPaginationQueryQuery | undefined, MediaAdCampaignsMetadataPaginationQueryQueryVariables>;
export function useMediaAdCampaignsMetadataPaginationQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>(MediaAdCampaignsMetadataPaginationQueryDocument, options);
        }
export type MediaAdCampaignsMetadataPaginationQueryQueryHookResult = ReturnType<typeof useMediaAdCampaignsMetadataPaginationQueryQuery>;
export type MediaAdCampaignsMetadataPaginationQueryLazyQueryHookResult = ReturnType<typeof useMediaAdCampaignsMetadataPaginationQueryLazyQuery>;
export type MediaAdCampaignsMetadataPaginationQuerySuspenseQueryHookResult = ReturnType<typeof useMediaAdCampaignsMetadataPaginationQuerySuspenseQuery>;
export type MediaAdCampaignsMetadataPaginationQueryQueryResult = Apollo.QueryResult<MediaAdCampaignsMetadataPaginationQueryQuery, MediaAdCampaignsMetadataPaginationQueryQueryVariables>;
export const MediaAdCampaignDocument = gql`
    query mediaAdCampaign($adCampaignId: ID!) {
  adCampaignPure(id: $adCampaignId) {
    ...AdCampaignInfoType
  }
}
    ${AdCampaignInfoTypeFragmentDoc}`;

/**
 * __useMediaAdCampaignQuery__
 *
 * To run a query within a React component, call `useMediaAdCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAdCampaignQuery({
 *   variables: {
 *      adCampaignId: // value for 'adCampaignId'
 *   },
 * });
 */
export function useMediaAdCampaignQuery(baseOptions: Apollo.QueryHookOptions<MediaAdCampaignQuery, MediaAdCampaignQueryVariables> & ({ variables: MediaAdCampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>(MediaAdCampaignDocument, options);
      }
export function useMediaAdCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>(MediaAdCampaignDocument, options);
        }
// @ts-ignore
export function useMediaAdCampaignSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>;
export function useMediaAdCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>): Apollo.UseSuspenseQueryResult<MediaAdCampaignQuery | undefined, MediaAdCampaignQueryVariables>;
export function useMediaAdCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>(MediaAdCampaignDocument, options);
        }
export type MediaAdCampaignQueryHookResult = ReturnType<typeof useMediaAdCampaignQuery>;
export type MediaAdCampaignLazyQueryHookResult = ReturnType<typeof useMediaAdCampaignLazyQuery>;
export type MediaAdCampaignSuspenseQueryHookResult = ReturnType<typeof useMediaAdCampaignSuspenseQuery>;
export type MediaAdCampaignQueryResult = Apollo.QueryResult<MediaAdCampaignQuery, MediaAdCampaignQueryVariables>;
export const MediaPromoUploadDocument = gql`
    mutation mediaPromoUpload($input: PromoUploadPureMutationInput!) {
  result: promoPureUpload(input: $input) {
    ok
    promo {
      id
      filename
      duration
      previewUrl
      sourcefiles {
        ...SourcefileTypeFragment
      }
    }
  }
}
    ${SourcefileTypeFragmentFragmentDoc}`;
export type MediaPromoUploadMutationFn = Apollo.MutationFunction<MediaPromoUploadMutation, MediaPromoUploadMutationVariables>;

/**
 * __useMediaPromoUploadMutation__
 *
 * To run a mutation, you first call `useMediaPromoUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaPromoUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaPromoUploadMutation, { data, loading, error }] = useMediaPromoUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaPromoUploadMutation(baseOptions?: Apollo.MutationHookOptions<MediaPromoUploadMutation, MediaPromoUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaPromoUploadMutation, MediaPromoUploadMutationVariables>(MediaPromoUploadDocument, options);
      }
export type MediaPromoUploadMutationHookResult = ReturnType<typeof useMediaPromoUploadMutation>;
export type MediaPromoUploadMutationResult = Apollo.MutationResult<MediaPromoUploadMutation>;
export type MediaPromoUploadMutationOptions = Apollo.BaseMutationOptions<MediaPromoUploadMutation, MediaPromoUploadMutationVariables>;
export const MediaAdCampaignCreateDocument = gql`
    mutation mediaAdCampaignCreate($input: AdCampaignPureCreateMutationInput!) {
  result: adcampaignPureCreate(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCompany {
      ...AdCampaignInfoType
    }
  }
}
    ${AdCampaignInfoTypeFragmentDoc}`;
export type MediaAdCampaignCreateMutationFn = Apollo.MutationFunction<MediaAdCampaignCreateMutation, MediaAdCampaignCreateMutationVariables>;

/**
 * __useMediaAdCampaignCreateMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignCreateMutation, { data, loading, error }] = useMediaAdCampaignCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignCreateMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignCreateMutation, MediaAdCampaignCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignCreateMutation, MediaAdCampaignCreateMutationVariables>(MediaAdCampaignCreateDocument, options);
      }
export type MediaAdCampaignCreateMutationHookResult = ReturnType<typeof useMediaAdCampaignCreateMutation>;
export type MediaAdCampaignCreateMutationResult = Apollo.MutationResult<MediaAdCampaignCreateMutation>;
export type MediaAdCampaignCreateMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignCreateMutation, MediaAdCampaignCreateMutationVariables>;
export const MediaAdCampaignUpdateDocument = gql`
    mutation mediaAdCampaignUpdate($input: AdCampaignPureUpdateMutationInput!) {
  result: adcampaignPureUpdate(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCompany {
      ...AdCampaignInfoType
    }
  }
}
    ${AdCampaignInfoTypeFragmentDoc}`;
export type MediaAdCampaignUpdateMutationFn = Apollo.MutationFunction<MediaAdCampaignUpdateMutation, MediaAdCampaignUpdateMutationVariables>;

/**
 * __useMediaAdCampaignUpdateMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignUpdateMutation, { data, loading, error }] = useMediaAdCampaignUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignUpdateMutation, MediaAdCampaignUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignUpdateMutation, MediaAdCampaignUpdateMutationVariables>(MediaAdCampaignUpdateDocument, options);
      }
export type MediaAdCampaignUpdateMutationHookResult = ReturnType<typeof useMediaAdCampaignUpdateMutation>;
export type MediaAdCampaignUpdateMutationResult = Apollo.MutationResult<MediaAdCampaignUpdateMutation>;
export type MediaAdCampaignUpdateMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignUpdateMutation, MediaAdCampaignUpdateMutationVariables>;
export const MediaAdCampaignPromosUpdateDocument = gql`
    mutation mediaAdCampaignPromosUpdate($input: AdCampaignPureChangePromosMutationInput!) {
  result: adcampaignPureChangePromos(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCompany {
      ...AdCampaignInfoType
    }
  }
}
    ${AdCampaignInfoTypeFragmentDoc}`;
export type MediaAdCampaignPromosUpdateMutationFn = Apollo.MutationFunction<MediaAdCampaignPromosUpdateMutation, MediaAdCampaignPromosUpdateMutationVariables>;

/**
 * __useMediaAdCampaignPromosUpdateMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignPromosUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignPromosUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignPromosUpdateMutation, { data, loading, error }] = useMediaAdCampaignPromosUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignPromosUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignPromosUpdateMutation, MediaAdCampaignPromosUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignPromosUpdateMutation, MediaAdCampaignPromosUpdateMutationVariables>(MediaAdCampaignPromosUpdateDocument, options);
      }
export type MediaAdCampaignPromosUpdateMutationHookResult = ReturnType<typeof useMediaAdCampaignPromosUpdateMutation>;
export type MediaAdCampaignPromosUpdateMutationResult = Apollo.MutationResult<MediaAdCampaignPromosUpdateMutation>;
export type MediaAdCampaignPromosUpdateMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignPromosUpdateMutation, MediaAdCampaignPromosUpdateMutationVariables>;
export const MediaPromoClipsDocument = gql`
    query mediaPromoClips($companyId: ID!, $draftId: ID, $filters: PromoClipsQueryFilter, $pagination: PromoClipsQueryPagination!, $sort: PromoClipsQuerySort!) {
  result: promoClipsPaginationQuery(
    companyId: $companyId
    promoSelectionDraftId: $draftId
    filters: $filters
    pagination: $pagination
    sort: $sort
  ) {
    result {
      id
      promo {
        id
        title
        uri
      }
      adcampaignTitle
      adcampaignStatus
      isSelected
    }
    statusesInfo {
      active
      planned
      passed
      stopped
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useMediaPromoClipsQuery__
 *
 * To run a query within a React component, call `useMediaPromoClipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaPromoClipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaPromoClipsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      draftId: // value for 'draftId'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMediaPromoClipsQuery(baseOptions: Apollo.QueryHookOptions<MediaPromoClipsQuery, MediaPromoClipsQueryVariables> & ({ variables: MediaPromoClipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>(MediaPromoClipsDocument, options);
      }
export function useMediaPromoClipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>(MediaPromoClipsDocument, options);
        }
// @ts-ignore
export function useMediaPromoClipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>;
export function useMediaPromoClipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>): Apollo.UseSuspenseQueryResult<MediaPromoClipsQuery | undefined, MediaPromoClipsQueryVariables>;
export function useMediaPromoClipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>(MediaPromoClipsDocument, options);
        }
export type MediaPromoClipsQueryHookResult = ReturnType<typeof useMediaPromoClipsQuery>;
export type MediaPromoClipsLazyQueryHookResult = ReturnType<typeof useMediaPromoClipsLazyQuery>;
export type MediaPromoClipsSuspenseQueryHookResult = ReturnType<typeof useMediaPromoClipsSuspenseQuery>;
export type MediaPromoClipsQueryResult = Apollo.QueryResult<MediaPromoClipsQuery, MediaPromoClipsQueryVariables>;
export const MediaPromoSelectionDraftDocument = gql`
    mutation mediaPromoSelectionDraft($input: PromoSelectionDraftInput!) {
  result: promoSelectionDraft(input: $input) {
    ok
    errors {
      field
      messages
    }
    promoSelectionDraftId
    selectedCount
    totalCount
  }
}
    `;
export type MediaPromoSelectionDraftMutationFn = Apollo.MutationFunction<MediaPromoSelectionDraftMutation, MediaPromoSelectionDraftMutationVariables>;

/**
 * __useMediaPromoSelectionDraftMutation__
 *
 * To run a mutation, you first call `useMediaPromoSelectionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaPromoSelectionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaPromoSelectionDraftMutation, { data, loading, error }] = useMediaPromoSelectionDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaPromoSelectionDraftMutation(baseOptions?: Apollo.MutationHookOptions<MediaPromoSelectionDraftMutation, MediaPromoSelectionDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaPromoSelectionDraftMutation, MediaPromoSelectionDraftMutationVariables>(MediaPromoSelectionDraftDocument, options);
      }
export type MediaPromoSelectionDraftMutationHookResult = ReturnType<typeof useMediaPromoSelectionDraftMutation>;
export type MediaPromoSelectionDraftMutationResult = Apollo.MutationResult<MediaPromoSelectionDraftMutation>;
export type MediaPromoSelectionDraftMutationOptions = Apollo.BaseMutationOptions<MediaPromoSelectionDraftMutation, MediaPromoSelectionDraftMutationVariables>;
export const MediaAdCampaignEnableDocument = gql`
    mutation mediaAdCampaignEnable($input: AdCampaignPureEnableMutationInput!) {
  result: adcampaignPureEnable(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCompany {
      ...AdCampaignInfoType
    }
  }
}
    ${AdCampaignInfoTypeFragmentDoc}`;
export type MediaAdCampaignEnableMutationFn = Apollo.MutationFunction<MediaAdCampaignEnableMutation, MediaAdCampaignEnableMutationVariables>;

/**
 * __useMediaAdCampaignEnableMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignEnableMutation, { data, loading, error }] = useMediaAdCampaignEnableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignEnableMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignEnableMutation, MediaAdCampaignEnableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignEnableMutation, MediaAdCampaignEnableMutationVariables>(MediaAdCampaignEnableDocument, options);
      }
export type MediaAdCampaignEnableMutationHookResult = ReturnType<typeof useMediaAdCampaignEnableMutation>;
export type MediaAdCampaignEnableMutationResult = Apollo.MutationResult<MediaAdCampaignEnableMutation>;
export type MediaAdCampaignEnableMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignEnableMutation, MediaAdCampaignEnableMutationVariables>;
export const MediaAdCampaignRemoveDocument = gql`
    mutation mediaAdCampaignRemove($input: AdCampaignPureRemoveMutationInput!) {
  result: adcampaignPureRemove(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type MediaAdCampaignRemoveMutationFn = Apollo.MutationFunction<MediaAdCampaignRemoveMutation, MediaAdCampaignRemoveMutationVariables>;

/**
 * __useMediaAdCampaignRemoveMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignRemoveMutation, { data, loading, error }] = useMediaAdCampaignRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignRemoveMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignRemoveMutation, MediaAdCampaignRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignRemoveMutation, MediaAdCampaignRemoveMutationVariables>(MediaAdCampaignRemoveDocument, options);
      }
export type MediaAdCampaignRemoveMutationHookResult = ReturnType<typeof useMediaAdCampaignRemoveMutation>;
export type MediaAdCampaignRemoveMutationResult = Apollo.MutationResult<MediaAdCampaignRemoveMutation>;
export type MediaAdCampaignRemoveMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignRemoveMutation, MediaAdCampaignRemoveMutationVariables>;
export const MediaAdCampaignReportCreateDocument = gql`
    mutation mediaAdCampaignReportCreate($input: AdCampaignReportPureMutationInput!) {
  result: adcampaignReportPureCreate(input: $input) {
    ok
    errors {
      messages
      field
    }
  }
}
    `;
export type MediaAdCampaignReportCreateMutationFn = Apollo.MutationFunction<MediaAdCampaignReportCreateMutation, MediaAdCampaignReportCreateMutationVariables>;

/**
 * __useMediaAdCampaignReportCreateMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignReportCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignReportCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignReportCreateMutation, { data, loading, error }] = useMediaAdCampaignReportCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignReportCreateMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignReportCreateMutation, MediaAdCampaignReportCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignReportCreateMutation, MediaAdCampaignReportCreateMutationVariables>(MediaAdCampaignReportCreateDocument, options);
      }
export type MediaAdCampaignReportCreateMutationHookResult = ReturnType<typeof useMediaAdCampaignReportCreateMutation>;
export type MediaAdCampaignReportCreateMutationResult = Apollo.MutationResult<MediaAdCampaignReportCreateMutation>;
export type MediaAdCampaignReportCreateMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignReportCreateMutation, MediaAdCampaignReportCreateMutationVariables>;
export const MediaAdCampaignSetCompanyTagsDocument = gql`
    mutation mediaAdCampaignSetCompanyTags($input: AdCampaignPureSetCompanyTagsMutationInput!) {
  adcampaignSetCompanyTags(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCampaign {
      id
    }
  }
}
    `;
export type MediaAdCampaignSetCompanyTagsMutationFn = Apollo.MutationFunction<MediaAdCampaignSetCompanyTagsMutation, MediaAdCampaignSetCompanyTagsMutationVariables>;

/**
 * __useMediaAdCampaignSetCompanyTagsMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignSetCompanyTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignSetCompanyTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignSetCompanyTagsMutation, { data, loading, error }] = useMediaAdCampaignSetCompanyTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignSetCompanyTagsMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignSetCompanyTagsMutation, MediaAdCampaignSetCompanyTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignSetCompanyTagsMutation, MediaAdCampaignSetCompanyTagsMutationVariables>(MediaAdCampaignSetCompanyTagsDocument, options);
      }
export type MediaAdCampaignSetCompanyTagsMutationHookResult = ReturnType<typeof useMediaAdCampaignSetCompanyTagsMutation>;
export type MediaAdCampaignSetCompanyTagsMutationResult = Apollo.MutationResult<MediaAdCampaignSetCompanyTagsMutation>;
export type MediaAdCampaignSetCompanyTagsMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignSetCompanyTagsMutation, MediaAdCampaignSetCompanyTagsMutationVariables>;
export const MediaAdCampaignInstantLaunchDocument = gql`
    mutation mediaAdCampaignInstantLaunch($input: PlayInstantAdcampaignMutationInput!) {
  playInstantAdcampaign(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type MediaAdCampaignInstantLaunchMutationFn = Apollo.MutationFunction<MediaAdCampaignInstantLaunchMutation, MediaAdCampaignInstantLaunchMutationVariables>;

/**
 * __useMediaAdCampaignInstantLaunchMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignInstantLaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignInstantLaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignInstantLaunchMutation, { data, loading, error }] = useMediaAdCampaignInstantLaunchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignInstantLaunchMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignInstantLaunchMutation, MediaAdCampaignInstantLaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignInstantLaunchMutation, MediaAdCampaignInstantLaunchMutationVariables>(MediaAdCampaignInstantLaunchDocument, options);
      }
export type MediaAdCampaignInstantLaunchMutationHookResult = ReturnType<typeof useMediaAdCampaignInstantLaunchMutation>;
export type MediaAdCampaignInstantLaunchMutationResult = Apollo.MutationResult<MediaAdCampaignInstantLaunchMutation>;
export type MediaAdCampaignInstantLaunchMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignInstantLaunchMutation, MediaAdCampaignInstantLaunchMutationVariables>;
export const MediaAdCampaignSetPointsDocument = gql`
    mutation mediaAdCampaignSetPoints($input: AdCampaignPureSetPointsMutationInput!) {
  adcampaignSetPointsMutation(input: $input) {
    ok
    errors {
      field
      messages
    }
    adCampaign {
      id
      points {
        id
      }
    }
  }
}
    `;
export type MediaAdCampaignSetPointsMutationFn = Apollo.MutationFunction<MediaAdCampaignSetPointsMutation, MediaAdCampaignSetPointsMutationVariables>;

/**
 * __useMediaAdCampaignSetPointsMutation__
 *
 * To run a mutation, you first call `useMediaAdCampaignSetPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAdCampaignSetPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAdCampaignSetPointsMutation, { data, loading, error }] = useMediaAdCampaignSetPointsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAdCampaignSetPointsMutation(baseOptions?: Apollo.MutationHookOptions<MediaAdCampaignSetPointsMutation, MediaAdCampaignSetPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaAdCampaignSetPointsMutation, MediaAdCampaignSetPointsMutationVariables>(MediaAdCampaignSetPointsDocument, options);
      }
export type MediaAdCampaignSetPointsMutationHookResult = ReturnType<typeof useMediaAdCampaignSetPointsMutation>;
export type MediaAdCampaignSetPointsMutationResult = Apollo.MutationResult<MediaAdCampaignSetPointsMutation>;
export type MediaAdCampaignSetPointsMutationOptions = Apollo.BaseMutationOptions<MediaAdCampaignSetPointsMutation, MediaAdCampaignSetPointsMutationVariables>;
export const CompanyUserCompanyTagsDocument = gql`
    query companyUserCompanyTags($filters: CompanyTagQueryFilter!, $pagination: CompanyTagQueryPagination!) {
  companyTagPaginationQuery(filters: $filters, pagination: $pagination) {
    result {
      id
      title
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useCompanyUserCompanyTagsQuery__
 *
 * To run a query within a React component, call `useCompanyUserCompanyTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUserCompanyTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUserCompanyTagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompanyUserCompanyTagsQuery(baseOptions: Apollo.QueryHookOptions<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables> & ({ variables: CompanyUserCompanyTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>(CompanyUserCompanyTagsDocument, options);
      }
export function useCompanyUserCompanyTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>(CompanyUserCompanyTagsDocument, options);
        }
// @ts-ignore
export function useCompanyUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>;
export function useCompanyUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyUserCompanyTagsQuery | undefined, CompanyUserCompanyTagsQueryVariables>;
export function useCompanyUserCompanyTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>(CompanyUserCompanyTagsDocument, options);
        }
export type CompanyUserCompanyTagsQueryHookResult = ReturnType<typeof useCompanyUserCompanyTagsQuery>;
export type CompanyUserCompanyTagsLazyQueryHookResult = ReturnType<typeof useCompanyUserCompanyTagsLazyQuery>;
export type CompanyUserCompanyTagsSuspenseQueryHookResult = ReturnType<typeof useCompanyUserCompanyTagsSuspenseQuery>;
export type CompanyUserCompanyTagsQueryResult = Apollo.QueryResult<CompanyUserCompanyTagsQuery, CompanyUserCompanyTagsQueryVariables>;
export const CompanyDeviceRequestDocument = gql`
    mutation companyDeviceRequest($input: CompanyCreateDeviceRequestPureMutationInput!) {
  companyCreateDeviceRequest(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type CompanyDeviceRequestMutationFn = Apollo.MutationFunction<CompanyDeviceRequestMutation, CompanyDeviceRequestMutationVariables>;

/**
 * __useCompanyDeviceRequestMutation__
 *
 * To run a mutation, you first call `useCompanyDeviceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDeviceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDeviceRequestMutation, { data, loading, error }] = useCompanyDeviceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyDeviceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanyDeviceRequestMutation, CompanyDeviceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyDeviceRequestMutation, CompanyDeviceRequestMutationVariables>(CompanyDeviceRequestDocument, options);
      }
export type CompanyDeviceRequestMutationHookResult = ReturnType<typeof useCompanyDeviceRequestMutation>;
export type CompanyDeviceRequestMutationResult = Apollo.MutationResult<CompanyDeviceRequestMutation>;
export type CompanyDeviceRequestMutationOptions = Apollo.BaseMutationOptions<CompanyDeviceRequestMutation, CompanyDeviceRequestMutationVariables>;
export const CompanyAudioDeviceRequestDocument = gql`
    mutation companyAudioDeviceRequest($input: CompanyCreateDeviceRequestPureMutationInput!) {
  companyCreateAudioDeviceRequest(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type CompanyAudioDeviceRequestMutationFn = Apollo.MutationFunction<CompanyAudioDeviceRequestMutation, CompanyAudioDeviceRequestMutationVariables>;

/**
 * __useCompanyAudioDeviceRequestMutation__
 *
 * To run a mutation, you first call `useCompanyAudioDeviceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyAudioDeviceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyAudioDeviceRequestMutation, { data, loading, error }] = useCompanyAudioDeviceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyAudioDeviceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanyAudioDeviceRequestMutation, CompanyAudioDeviceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyAudioDeviceRequestMutation, CompanyAudioDeviceRequestMutationVariables>(CompanyAudioDeviceRequestDocument, options);
      }
export type CompanyAudioDeviceRequestMutationHookResult = ReturnType<typeof useCompanyAudioDeviceRequestMutation>;
export type CompanyAudioDeviceRequestMutationResult = Apollo.MutationResult<CompanyAudioDeviceRequestMutation>;
export type CompanyAudioDeviceRequestMutationOptions = Apollo.BaseMutationOptions<CompanyAudioDeviceRequestMutation, CompanyAudioDeviceRequestMutationVariables>;
export const CompanyVideoDeviceRequestDocument = gql`
    mutation companyVideoDeviceRequest($input: CompanyCreateDeviceRequestPureMutationInput!) {
  companyCreateVideoDeviceRequest(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type CompanyVideoDeviceRequestMutationFn = Apollo.MutationFunction<CompanyVideoDeviceRequestMutation, CompanyVideoDeviceRequestMutationVariables>;

/**
 * __useCompanyVideoDeviceRequestMutation__
 *
 * To run a mutation, you first call `useCompanyVideoDeviceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyVideoDeviceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyVideoDeviceRequestMutation, { data, loading, error }] = useCompanyVideoDeviceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyVideoDeviceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CompanyVideoDeviceRequestMutation, CompanyVideoDeviceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyVideoDeviceRequestMutation, CompanyVideoDeviceRequestMutationVariables>(CompanyVideoDeviceRequestDocument, options);
      }
export type CompanyVideoDeviceRequestMutationHookResult = ReturnType<typeof useCompanyVideoDeviceRequestMutation>;
export type CompanyVideoDeviceRequestMutationResult = Apollo.MutationResult<CompanyVideoDeviceRequestMutation>;
export type CompanyVideoDeviceRequestMutationOptions = Apollo.BaseMutationOptions<CompanyVideoDeviceRequestMutation, CompanyVideoDeviceRequestMutationVariables>;
export const CompanySmartlkStartVideoDemoPeriodDocument = gql`
    mutation companySmartlkStartVideoDemoPeriod($input: SmartLkStartVideoDemoPeriodMutationInput!) {
  smartlkStartVideoDemoPeriod(input: $input) {
    ok
    errors {
      field
      messages
    }
    point {
      id
      address
      videoStream {
        id
        title
      }
      device {
        id
        type
      }
      isEnabled
    }
  }
}
    `;
export type CompanySmartlkStartVideoDemoPeriodMutationFn = Apollo.MutationFunction<CompanySmartlkStartVideoDemoPeriodMutation, CompanySmartlkStartVideoDemoPeriodMutationVariables>;

/**
 * __useCompanySmartlkStartVideoDemoPeriodMutation__
 *
 * To run a mutation, you first call `useCompanySmartlkStartVideoDemoPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanySmartlkStartVideoDemoPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companySmartlkStartVideoDemoPeriodMutation, { data, loading, error }] = useCompanySmartlkStartVideoDemoPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanySmartlkStartVideoDemoPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CompanySmartlkStartVideoDemoPeriodMutation, CompanySmartlkStartVideoDemoPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanySmartlkStartVideoDemoPeriodMutation, CompanySmartlkStartVideoDemoPeriodMutationVariables>(CompanySmartlkStartVideoDemoPeriodDocument, options);
      }
export type CompanySmartlkStartVideoDemoPeriodMutationHookResult = ReturnType<typeof useCompanySmartlkStartVideoDemoPeriodMutation>;
export type CompanySmartlkStartVideoDemoPeriodMutationResult = Apollo.MutationResult<CompanySmartlkStartVideoDemoPeriodMutation>;
export type CompanySmartlkStartVideoDemoPeriodMutationOptions = Apollo.BaseMutationOptions<CompanySmartlkStartVideoDemoPeriodMutation, CompanySmartlkStartVideoDemoPeriodMutationVariables>;
export const BillingPaymentMethodDocument = gql`
    query billingPaymentMethod($companyId: ID!) {
  paymentMethodPureQuery(companyId: $companyId) {
    paymentMethod {
      ...PaymentMethodInfoType
    }
    isLinkingInProcess
  }
}
    ${PaymentMethodInfoTypeFragmentDoc}`;

/**
 * __useBillingPaymentMethodQuery__
 *
 * To run a query within a React component, call `useBillingPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPaymentMethodQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBillingPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables> & ({ variables: BillingPaymentMethodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>(BillingPaymentMethodDocument, options);
      }
export function useBillingPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>(BillingPaymentMethodDocument, options);
        }
// @ts-ignore
export function useBillingPaymentMethodSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>): Apollo.UseSuspenseQueryResult<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>;
export function useBillingPaymentMethodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>): Apollo.UseSuspenseQueryResult<BillingPaymentMethodQuery | undefined, BillingPaymentMethodQueryVariables>;
export function useBillingPaymentMethodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>(BillingPaymentMethodDocument, options);
        }
export type BillingPaymentMethodQueryHookResult = ReturnType<typeof useBillingPaymentMethodQuery>;
export type BillingPaymentMethodLazyQueryHookResult = ReturnType<typeof useBillingPaymentMethodLazyQuery>;
export type BillingPaymentMethodSuspenseQueryHookResult = ReturnType<typeof useBillingPaymentMethodSuspenseQuery>;
export type BillingPaymentMethodQueryResult = Apollo.QueryResult<BillingPaymentMethodQuery, BillingPaymentMethodQueryVariables>;
export const BillingStartLinkCardDocument = gql`
    mutation billingStartLinkCard($input: StartLinkCardMutationInput!) {
  startLinkCard(input: $input) {
    confirmLink
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingStartLinkCardMutationFn = Apollo.MutationFunction<BillingStartLinkCardMutation, BillingStartLinkCardMutationVariables>;

/**
 * __useBillingStartLinkCardMutation__
 *
 * To run a mutation, you first call `useBillingStartLinkCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingStartLinkCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingStartLinkCardMutation, { data, loading, error }] = useBillingStartLinkCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingStartLinkCardMutation(baseOptions?: Apollo.MutationHookOptions<BillingStartLinkCardMutation, BillingStartLinkCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingStartLinkCardMutation, BillingStartLinkCardMutationVariables>(BillingStartLinkCardDocument, options);
      }
export type BillingStartLinkCardMutationHookResult = ReturnType<typeof useBillingStartLinkCardMutation>;
export type BillingStartLinkCardMutationResult = Apollo.MutationResult<BillingStartLinkCardMutation>;
export type BillingStartLinkCardMutationOptions = Apollo.BaseMutationOptions<BillingStartLinkCardMutation, BillingStartLinkCardMutationVariables>;
export const BillingRemoveCardDocument = gql`
    mutation billingRemoveCard($input: CompanyRemoveCardMutationInput!) {
  companyRemoveCard(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingRemoveCardMutationFn = Apollo.MutationFunction<BillingRemoveCardMutation, BillingRemoveCardMutationVariables>;

/**
 * __useBillingRemoveCardMutation__
 *
 * To run a mutation, you first call `useBillingRemoveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingRemoveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingRemoveCardMutation, { data, loading, error }] = useBillingRemoveCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingRemoveCardMutation(baseOptions?: Apollo.MutationHookOptions<BillingRemoveCardMutation, BillingRemoveCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingRemoveCardMutation, BillingRemoveCardMutationVariables>(BillingRemoveCardDocument, options);
      }
export type BillingRemoveCardMutationHookResult = ReturnType<typeof useBillingRemoveCardMutation>;
export type BillingRemoveCardMutationResult = Apollo.MutationResult<BillingRemoveCardMutation>;
export type BillingRemoveCardMutationOptions = Apollo.BaseMutationOptions<BillingRemoveCardMutation, BillingRemoveCardMutationVariables>;
export const BillingLaunchSubscriptionWithConfirmDocument = gql`
    mutation billingLaunchSubscriptionWithConfirm($input: LaunchSubscriptionWithConfirmMutationInput!) {
  launchSubscriptionWithConfirm(input: $input) {
    confirmLink
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingLaunchSubscriptionWithConfirmMutationFn = Apollo.MutationFunction<BillingLaunchSubscriptionWithConfirmMutation, BillingLaunchSubscriptionWithConfirmMutationVariables>;

/**
 * __useBillingLaunchSubscriptionWithConfirmMutation__
 *
 * To run a mutation, you first call `useBillingLaunchSubscriptionWithConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingLaunchSubscriptionWithConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingLaunchSubscriptionWithConfirmMutation, { data, loading, error }] = useBillingLaunchSubscriptionWithConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingLaunchSubscriptionWithConfirmMutation(baseOptions?: Apollo.MutationHookOptions<BillingLaunchSubscriptionWithConfirmMutation, BillingLaunchSubscriptionWithConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingLaunchSubscriptionWithConfirmMutation, BillingLaunchSubscriptionWithConfirmMutationVariables>(BillingLaunchSubscriptionWithConfirmDocument, options);
      }
export type BillingLaunchSubscriptionWithConfirmMutationHookResult = ReturnType<typeof useBillingLaunchSubscriptionWithConfirmMutation>;
export type BillingLaunchSubscriptionWithConfirmMutationResult = Apollo.MutationResult<BillingLaunchSubscriptionWithConfirmMutation>;
export type BillingLaunchSubscriptionWithConfirmMutationOptions = Apollo.BaseMutationOptions<BillingLaunchSubscriptionWithConfirmMutation, BillingLaunchSubscriptionWithConfirmMutationVariables>;
export const BillingPricePlansDocument = gql`
    query billingPricePlans($organizationId: ID!, $usersOnly: Boolean) {
  organizationPricePlansCanMigrateToQuery(
    organizationId: $organizationId
    usersOnly: $usersOnly
  ) {
    ...PricePlanInfoType
  }
}
    ${PricePlanInfoTypeFragmentDoc}`;

/**
 * __useBillingPricePlansQuery__
 *
 * To run a query within a React component, call `useBillingPricePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPricePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPricePlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      usersOnly: // value for 'usersOnly'
 *   },
 * });
 */
export function useBillingPricePlansQuery(baseOptions: Apollo.QueryHookOptions<BillingPricePlansQuery, BillingPricePlansQueryVariables> & ({ variables: BillingPricePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPricePlansQuery, BillingPricePlansQueryVariables>(BillingPricePlansDocument, options);
      }
export function useBillingPricePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPricePlansQuery, BillingPricePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPricePlansQuery, BillingPricePlansQueryVariables>(BillingPricePlansDocument, options);
        }
// @ts-ignore
export function useBillingPricePlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingPricePlansQuery, BillingPricePlansQueryVariables>): Apollo.UseSuspenseQueryResult<BillingPricePlansQuery, BillingPricePlansQueryVariables>;
export function useBillingPricePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingPricePlansQuery, BillingPricePlansQueryVariables>): Apollo.UseSuspenseQueryResult<BillingPricePlansQuery | undefined, BillingPricePlansQueryVariables>;
export function useBillingPricePlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingPricePlansQuery, BillingPricePlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingPricePlansQuery, BillingPricePlansQueryVariables>(BillingPricePlansDocument, options);
        }
export type BillingPricePlansQueryHookResult = ReturnType<typeof useBillingPricePlansQuery>;
export type BillingPricePlansLazyQueryHookResult = ReturnType<typeof useBillingPricePlansLazyQuery>;
export type BillingPricePlansSuspenseQueryHookResult = ReturnType<typeof useBillingPricePlansSuspenseQuery>;
export type BillingPricePlansQueryResult = Apollo.QueryResult<BillingPricePlansQuery, BillingPricePlansQueryVariables>;
export const BillingOrganizationCurrentPricePlanDocument = gql`
    query billingOrganizationCurrentPricePlan($organizationId: ID!) {
  result: organizationCurrentPricePlanQuery(organizationId: $organizationId) {
    organizationId
    pricePlan {
      ...PricePlanInfoType
    }
    pricePlanPeriod {
      id
      title
      payFrequencyMonth
      rows {
        ...PricePlanRowInfoType
      }
    }
  }
}
    ${PricePlanInfoTypeFragmentDoc}
${PricePlanRowInfoTypeFragmentDoc}`;

/**
 * __useBillingOrganizationCurrentPricePlanQuery__
 *
 * To run a query within a React component, call `useBillingOrganizationCurrentPricePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingOrganizationCurrentPricePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingOrganizationCurrentPricePlanQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useBillingOrganizationCurrentPricePlanQuery(baseOptions: Apollo.QueryHookOptions<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables> & ({ variables: BillingOrganizationCurrentPricePlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>(BillingOrganizationCurrentPricePlanDocument, options);
      }
export function useBillingOrganizationCurrentPricePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>(BillingOrganizationCurrentPricePlanDocument, options);
        }
// @ts-ignore
export function useBillingOrganizationCurrentPricePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>): Apollo.UseSuspenseQueryResult<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>;
export function useBillingOrganizationCurrentPricePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>): Apollo.UseSuspenseQueryResult<BillingOrganizationCurrentPricePlanQuery | undefined, BillingOrganizationCurrentPricePlanQueryVariables>;
export function useBillingOrganizationCurrentPricePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>(BillingOrganizationCurrentPricePlanDocument, options);
        }
export type BillingOrganizationCurrentPricePlanQueryHookResult = ReturnType<typeof useBillingOrganizationCurrentPricePlanQuery>;
export type BillingOrganizationCurrentPricePlanLazyQueryHookResult = ReturnType<typeof useBillingOrganizationCurrentPricePlanLazyQuery>;
export type BillingOrganizationCurrentPricePlanSuspenseQueryHookResult = ReturnType<typeof useBillingOrganizationCurrentPricePlanSuspenseQuery>;
export type BillingOrganizationCurrentPricePlanQueryResult = Apollo.QueryResult<BillingOrganizationCurrentPricePlanQuery, BillingOrganizationCurrentPricePlanQueryVariables>;
export const BillingCompanySetPricePlanPeriodDocument = gql`
    mutation billingCompanySetPricePlanPeriod($input: CompanySetPricePlanPeriodMutationInput!) {
  result: companySetPricePlanPeriod(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingCompanySetPricePlanPeriodMutationFn = Apollo.MutationFunction<BillingCompanySetPricePlanPeriodMutation, BillingCompanySetPricePlanPeriodMutationVariables>;

/**
 * __useBillingCompanySetPricePlanPeriodMutation__
 *
 * To run a mutation, you first call `useBillingCompanySetPricePlanPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingCompanySetPricePlanPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingCompanySetPricePlanPeriodMutation, { data, loading, error }] = useBillingCompanySetPricePlanPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingCompanySetPricePlanPeriodMutation(baseOptions?: Apollo.MutationHookOptions<BillingCompanySetPricePlanPeriodMutation, BillingCompanySetPricePlanPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingCompanySetPricePlanPeriodMutation, BillingCompanySetPricePlanPeriodMutationVariables>(BillingCompanySetPricePlanPeriodDocument, options);
      }
export type BillingCompanySetPricePlanPeriodMutationHookResult = ReturnType<typeof useBillingCompanySetPricePlanPeriodMutation>;
export type BillingCompanySetPricePlanPeriodMutationResult = Apollo.MutationResult<BillingCompanySetPricePlanPeriodMutation>;
export type BillingCompanySetPricePlanPeriodMutationOptions = Apollo.BaseMutationOptions<BillingCompanySetPricePlanPeriodMutation, BillingCompanySetPricePlanPeriodMutationVariables>;
export const BillingCompanySetPricePlanDocument = gql`
    mutation billingCompanySetPricePlan($input: CompanySetPricePlanMutationInput!) {
  result: companySetPricePlan(input: $input) {
    ok
    errors {
      messages
    }
  }
}
    `;
export type BillingCompanySetPricePlanMutationFn = Apollo.MutationFunction<BillingCompanySetPricePlanMutation, BillingCompanySetPricePlanMutationVariables>;

/**
 * __useBillingCompanySetPricePlanMutation__
 *
 * To run a mutation, you first call `useBillingCompanySetPricePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBillingCompanySetPricePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [billingCompanySetPricePlanMutation, { data, loading, error }] = useBillingCompanySetPricePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingCompanySetPricePlanMutation(baseOptions?: Apollo.MutationHookOptions<BillingCompanySetPricePlanMutation, BillingCompanySetPricePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BillingCompanySetPricePlanMutation, BillingCompanySetPricePlanMutationVariables>(BillingCompanySetPricePlanDocument, options);
      }
export type BillingCompanySetPricePlanMutationHookResult = ReturnType<typeof useBillingCompanySetPricePlanMutation>;
export type BillingCompanySetPricePlanMutationResult = Apollo.MutationResult<BillingCompanySetPricePlanMutation>;
export type BillingCompanySetPricePlanMutationOptions = Apollo.BaseMutationOptions<BillingCompanySetPricePlanMutation, BillingCompanySetPricePlanMutationVariables>;
export const PromoRollSynthBackgroundsDocument = gql`
    query promoRollSynthBackgrounds {
  promoRollSynthBackgrounds {
    id
    backgroundId
    title
    fileUrl
  }
}
    `;

/**
 * __usePromoRollSynthBackgroundsQuery__
 *
 * To run a query within a React component, call `usePromoRollSynthBackgroundsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthBackgroundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoRollSynthBackgroundsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromoRollSynthBackgroundsQuery(baseOptions?: Apollo.QueryHookOptions<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>(PromoRollSynthBackgroundsDocument, options);
      }
export function usePromoRollSynthBackgroundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>(PromoRollSynthBackgroundsDocument, options);
        }
// @ts-ignore
export function usePromoRollSynthBackgroundsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>;
export function usePromoRollSynthBackgroundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthBackgroundsQuery | undefined, PromoRollSynthBackgroundsQueryVariables>;
export function usePromoRollSynthBackgroundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>(PromoRollSynthBackgroundsDocument, options);
        }
export type PromoRollSynthBackgroundsQueryHookResult = ReturnType<typeof usePromoRollSynthBackgroundsQuery>;
export type PromoRollSynthBackgroundsLazyQueryHookResult = ReturnType<typeof usePromoRollSynthBackgroundsLazyQuery>;
export type PromoRollSynthBackgroundsSuspenseQueryHookResult = ReturnType<typeof usePromoRollSynthBackgroundsSuspenseQuery>;
export type PromoRollSynthBackgroundsQueryResult = Apollo.QueryResult<PromoRollSynthBackgroundsQuery, PromoRollSynthBackgroundsQueryVariables>;
export const PromoRollSynthCompanySettingsDocument = gql`
    query promoRollSynthCompanySettings($companyId: ID!) {
  promoRollSynthCompanySettings(companyId: $companyId) {
    isEnabled
    maxTextLength
    dailyLimit
    remainingToday
  }
}
    `;

/**
 * __usePromoRollSynthCompanySettingsQuery__
 *
 * To run a query within a React component, call `usePromoRollSynthCompanySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthCompanySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoRollSynthCompanySettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePromoRollSynthCompanySettingsQuery(baseOptions: Apollo.QueryHookOptions<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables> & ({ variables: PromoRollSynthCompanySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>(PromoRollSynthCompanySettingsDocument, options);
      }
export function usePromoRollSynthCompanySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>(PromoRollSynthCompanySettingsDocument, options);
        }
// @ts-ignore
export function usePromoRollSynthCompanySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>;
export function usePromoRollSynthCompanySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthCompanySettingsQuery | undefined, PromoRollSynthCompanySettingsQueryVariables>;
export function usePromoRollSynthCompanySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>(PromoRollSynthCompanySettingsDocument, options);
        }
export type PromoRollSynthCompanySettingsQueryHookResult = ReturnType<typeof usePromoRollSynthCompanySettingsQuery>;
export type PromoRollSynthCompanySettingsLazyQueryHookResult = ReturnType<typeof usePromoRollSynthCompanySettingsLazyQuery>;
export type PromoRollSynthCompanySettingsSuspenseQueryHookResult = ReturnType<typeof usePromoRollSynthCompanySettingsSuspenseQuery>;
export type PromoRollSynthCompanySettingsQueryResult = Apollo.QueryResult<PromoRollSynthCompanySettingsQuery, PromoRollSynthCompanySettingsQueryVariables>;
export const PromoRollSynthJobsDocument = gql`
    query promoRollSynthJobs($filters: PromoRollSynthJobsQueryFilter!, $pagination: PromoRollSynthJobsQueryPagination!) {
  promoRollSynthJobs(filters: $filters, pagination: $pagination) {
    result {
      ...PromoRollSynthJobFields
    }
    paginationInfo {
      page
      pageSize
      totalPages
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${PromoRollSynthJobFieldsFragmentDoc}`;

/**
 * __usePromoRollSynthJobsQuery__
 *
 * To run a query within a React component, call `usePromoRollSynthJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoRollSynthJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePromoRollSynthJobsQuery(baseOptions: Apollo.QueryHookOptions<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables> & ({ variables: PromoRollSynthJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>(PromoRollSynthJobsDocument, options);
      }
export function usePromoRollSynthJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>(PromoRollSynthJobsDocument, options);
        }
// @ts-ignore
export function usePromoRollSynthJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>;
export function usePromoRollSynthJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthJobsQuery | undefined, PromoRollSynthJobsQueryVariables>;
export function usePromoRollSynthJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>(PromoRollSynthJobsDocument, options);
        }
export type PromoRollSynthJobsQueryHookResult = ReturnType<typeof usePromoRollSynthJobsQuery>;
export type PromoRollSynthJobsLazyQueryHookResult = ReturnType<typeof usePromoRollSynthJobsLazyQuery>;
export type PromoRollSynthJobsSuspenseQueryHookResult = ReturnType<typeof usePromoRollSynthJobsSuspenseQuery>;
export type PromoRollSynthJobsQueryResult = Apollo.QueryResult<PromoRollSynthJobsQuery, PromoRollSynthJobsQueryVariables>;
export const PromoRollSynthVoicesDocument = gql`
    query promoRollSynthVoices {
  promoRollSynthVoices {
    id
    voiceId
    title
    fileUrl
  }
}
    `;

/**
 * __usePromoRollSynthVoicesQuery__
 *
 * To run a query within a React component, call `usePromoRollSynthVoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthVoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoRollSynthVoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePromoRollSynthVoicesQuery(baseOptions?: Apollo.QueryHookOptions<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>(PromoRollSynthVoicesDocument, options);
      }
export function usePromoRollSynthVoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>(PromoRollSynthVoicesDocument, options);
        }
// @ts-ignore
export function usePromoRollSynthVoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>;
export function usePromoRollSynthVoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>): Apollo.UseSuspenseQueryResult<PromoRollSynthVoicesQuery | undefined, PromoRollSynthVoicesQueryVariables>;
export function usePromoRollSynthVoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>(PromoRollSynthVoicesDocument, options);
        }
export type PromoRollSynthVoicesQueryHookResult = ReturnType<typeof usePromoRollSynthVoicesQuery>;
export type PromoRollSynthVoicesLazyQueryHookResult = ReturnType<typeof usePromoRollSynthVoicesLazyQuery>;
export type PromoRollSynthVoicesSuspenseQueryHookResult = ReturnType<typeof usePromoRollSynthVoicesSuspenseQuery>;
export type PromoRollSynthVoicesQueryResult = Apollo.QueryResult<PromoRollSynthVoicesQuery, PromoRollSynthVoicesQueryVariables>;
export const PromoRollSynthCreateJobDocument = gql`
    mutation promoRollSynthCreateJob($input: PromoRollSynthCreateMutationInput!) {
  promoRollSynthCreate(input: $input) {
    ok
    errors {
      field
      messages
    }
    job {
      ...PromoRollSynthJobFields
    }
  }
}
    ${PromoRollSynthJobFieldsFragmentDoc}`;
export type PromoRollSynthCreateJobMutationFn = Apollo.MutationFunction<PromoRollSynthCreateJobMutation, PromoRollSynthCreateJobMutationVariables>;

/**
 * __usePromoRollSynthCreateJobMutation__
 *
 * To run a mutation, you first call `usePromoRollSynthCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoRollSynthCreateJobMutation, { data, loading, error }] = usePromoRollSynthCreateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoRollSynthCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<PromoRollSynthCreateJobMutation, PromoRollSynthCreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoRollSynthCreateJobMutation, PromoRollSynthCreateJobMutationVariables>(PromoRollSynthCreateJobDocument, options);
      }
export type PromoRollSynthCreateJobMutationHookResult = ReturnType<typeof usePromoRollSynthCreateJobMutation>;
export type PromoRollSynthCreateJobMutationResult = Apollo.MutationResult<PromoRollSynthCreateJobMutation>;
export type PromoRollSynthCreateJobMutationOptions = Apollo.BaseMutationOptions<PromoRollSynthCreateJobMutation, PromoRollSynthCreateJobMutationVariables>;
export const PromoRollSynthDeleteJobDocument = gql`
    mutation promoRollSynthDeleteJob($input: PromoRollSynthDeleteMutationInput!) {
  promoRollSynthDelete(input: $input) {
    ok
    errors {
      field
      messages
    }
  }
}
    `;
export type PromoRollSynthDeleteJobMutationFn = Apollo.MutationFunction<PromoRollSynthDeleteJobMutation, PromoRollSynthDeleteJobMutationVariables>;

/**
 * __usePromoRollSynthDeleteJobMutation__
 *
 * To run a mutation, you first call `usePromoRollSynthDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoRollSynthDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoRollSynthDeleteJobMutation, { data, loading, error }] = usePromoRollSynthDeleteJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoRollSynthDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<PromoRollSynthDeleteJobMutation, PromoRollSynthDeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoRollSynthDeleteJobMutation, PromoRollSynthDeleteJobMutationVariables>(PromoRollSynthDeleteJobDocument, options);
      }
export type PromoRollSynthDeleteJobMutationHookResult = ReturnType<typeof usePromoRollSynthDeleteJobMutation>;
export type PromoRollSynthDeleteJobMutationResult = Apollo.MutationResult<PromoRollSynthDeleteJobMutation>;
export type PromoRollSynthDeleteJobMutationOptions = Apollo.BaseMutationOptions<PromoRollSynthDeleteJobMutation, PromoRollSynthDeleteJobMutationVariables>;
export const AppInitializationDocument = gql`
    query appInitialization($companyId: ID!) {
  currentUserPureQuery {
    ...UserInfoType
  }
  organizationCurrentPricePlanQuery(organizationId: $companyId) {
    organizationId
    pricePlan {
      id
    }
  }
  companyBillingInfoQuery(companyId: $companyId) {
    status
    firstPaidAt
    nextBillingDate
    nextBillingAmount
    nextBillingPriceAmount
    renewableLicenses {
      ...LicenseInfoType
    }
    nonRenewableLicenses {
      ...LicenseInfoType
    }
    unpaidLicenses {
      ...LicenseInfoType
    }
    discount {
      ...CompanyDiscountInfoType
    }
    selectedPaymentKind
    isBillingEnabled @client
    hasTrialLicenses @client
    hasActiveLicenses @client
    hasInactiveLicenses @client
    hasWaitPaymentLicenses @client
    hasGraceLicenses @client
    expiresLicenseDate @client
    nextBillingLicenses @client {
      ...LicenseInfoType
    }
    totalLicenses @client {
      ...LicenseInfoType
    }
    isLastInvoiceHasZeroAmount @client
    isWaitPaymentLicense @client
    isGraceLicense @client
    paymentMethod @client {
      ...PaymentMethodInfoType
    }
    canRealizeBillingOperation @client
    canRealizeBillingOperationWithPayment @client
    hasRenewableLicenses @client
    hasNonRenewableLicenses @client
  }
  paymentMethodPureQuery(companyId: $companyId) {
    paymentMethod {
      ...PaymentMethodInfoType
    }
    isLinkingInProcess
  }
  acceptanceAdvancedQuery(companyId: $companyId) {
    status
    payerAccount
  }
}
    ${UserInfoTypeFragmentDoc}
${LicenseInfoTypeFragmentDoc}
${CompanyDiscountInfoTypeFragmentDoc}
${PaymentMethodInfoTypeFragmentDoc}`;

/**
 * __useAppInitializationQuery__
 *
 * To run a query within a React component, call `useAppInitializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInitializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInitializationQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAppInitializationQuery(baseOptions: Apollo.QueryHookOptions<AppInitializationQuery, AppInitializationQueryVariables> & ({ variables: AppInitializationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppInitializationQuery, AppInitializationQueryVariables>(AppInitializationDocument, options);
      }
export function useAppInitializationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppInitializationQuery, AppInitializationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppInitializationQuery, AppInitializationQueryVariables>(AppInitializationDocument, options);
        }
// @ts-ignore
export function useAppInitializationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AppInitializationQuery, AppInitializationQueryVariables>): Apollo.UseSuspenseQueryResult<AppInitializationQuery, AppInitializationQueryVariables>;
export function useAppInitializationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInitializationQuery, AppInitializationQueryVariables>): Apollo.UseSuspenseQueryResult<AppInitializationQuery | undefined, AppInitializationQueryVariables>;
export function useAppInitializationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInitializationQuery, AppInitializationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppInitializationQuery, AppInitializationQueryVariables>(AppInitializationDocument, options);
        }
export type AppInitializationQueryHookResult = ReturnType<typeof useAppInitializationQuery>;
export type AppInitializationLazyQueryHookResult = ReturnType<typeof useAppInitializationLazyQuery>;
export type AppInitializationSuspenseQueryHookResult = ReturnType<typeof useAppInitializationSuspenseQuery>;
export type AppInitializationQueryResult = Apollo.QueryResult<AppInitializationQuery, AppInitializationQueryVariables>;